import React, {
  Component,
  useState,
  useEffect,
  useContext,
  createRef,
  useTransition,
  useRef,
  useCallback,
} from "react";
import JSZip from "jszip";
import { Row, Col, Container } from "react-bootstrap";
import style from "./IFormDesignerLayout.module.css";
import Header from "./IFormDesignerComponents/DesignerHeader/DesignerHeader";
import PagesSubForms from "../PagesSubForms/PagesSubForms";
import _ from 'lodash-es';
import useAutosave from "../../useAutoSave";
import {
  findFrameEnableOrNot,
  findFrameReadOnlyOrNot,
  getFormId,
  getGdToken,
  getColumnLayout,
  getWIToken,
  findDataObjectListView,
  getReduxContexts,
  getGridStates,
  setMandatoryControls,
  getSubFormStateJsonFromStore,
  getAdvanceListViewFormJsonFromStore,
  fetchGridStates,
  addKeyInJson,
  resetRedux,
  getContainerId,
  getStepName,
  getSubStepName,
  getCurrentDataObjectsContent,
  setCurrentDataObjectsContent,
  getDevice,
  getTabActiveIndex,
  setMandatoryControls1,
  updatePartialJSON,
  fetchAndUpdateJSON,
  getSubFormMetaData,
  getSubStepIndex,
  getSubChildMenuIndex,
  getStepIndex,
  isControlDroppedUnderTabColumn,
  getNonceValue,
  businessFunctionDataObjects,
  swapControlsInListview,
  getFormJsonMetaData,
} from "./IFormDesignerLogic";

// import Canvas2 from './IFormDesignerComponents/CanvasSupport'
// import {ClickContext,UpdateComponentInJsonContext,Context} from '../../Resources/AllContextFile'
// import functions from './AppApi/AppApi';
// import {switchToControlsAfterDeletion} from '../LeftNavigation/DesignerControls/BasicControls'
// import { ConeStriped } from 'react-bootstrap-icons';
import Canvas from "./IFormDesignerComponents/Canvas";
import LeftNavigation from "../LeftNavigation/LeftNavigation";
// import PASSWORD from '../../UI/BasicFormControls/PASSWORD';
// import {AppContext,Context} from '../../Resources/CanvasContextFile'
// import {AppContextMain,ContextMain} from '../../Resources/AllContextFile'
// import formdata from '../../Resources/formdata';
import "../../UI/css/Canvas.css";
import {
  functions,
  checkForAllNonFilledMandatoryFields,
  renderExecuteServerEventAPIData,
} from "./ApplicationAPI/applicationApi.js";
import axios from "../../axios";
import {focusElement, dragAndDropThroughMDM, checkEmpty} from "../../Resources/globalFunctions"
import {
  test,
  createSmartFormState,
  recurseJson,
  sendRequestForControl,
  createUniqueId,
  addToAlreadyCreatedId,
  addIdsFromJsonToExistingIDs,
  addColumnObject,
  addRowObject,
  isChildrenPresent,
  findJson,
  updateRowNColumn,
  findIfRowIsEmpty,
  getFormJsonFromStore
} from "./IFormDesignerLogic";
import {
  changeLayout,
  changeLayoutOfElements,
  updateFormStateStructure,
  changeColumnWidth,
  updateComponentInJson,
  removeAndUpdateComponentInJson,
  controlFoundFalseMaker,
  updateFormStateStructureByElemType,
  repopulateFrameIndex,
  resetRepopulateFrameIndexVars,
  removeAndUpdateIndex,
  relocateControls,
  updatePositionInform,
  updateFrameIndex,
  addFrameInBetween,
  findFrame,
  replaceJSONStucture,
  updateTileIndex,
  findAndDeleteControlSet,
  findFrameColumnLayout,
} from "./SectionLayoutLogic";

import LOADER from "../../UI/General/LOADER";
import {
  jsonElementOperation,
  generateJsonToSend,
  saveSubForm,
  saveAdvanceListview,
  fetchProcessModularData,
  removeMapping,
  fetchProcessTaskTemplate,
  fetchProcessGlobalTemplate,
  mappingExistOrNot,
} from "./RequestLogic";
import { ThemeJSON } from "./Theme/ThemeJSON";
import RightNavigation from "./../RightNavigation/RightNavigation";
import $ from "jquery";
import { htmlElemsFallingBtwCords } from "./Logic/CordinateLogic";
import CustomizedAlert from "../../ReusableComponents/Alert/CustomizedAlert";
import {
  downloadButtonJson,
  sanitizeJson,
  sanitizeStringToJson,
  sanitizeStringToString,
  isObjectEmpty,
  replaceElementsId,
} from "../../Resources/globalFunctions";
import SimpleLoader from "../../UI/General/SimpleLoader";
import { useTranslation } from "react-i18next";
import {
  useDispatch,
  addContexts,
  updateContexts,
  updateFormState,
  useSelector,
  updateStore,
  updateStateInRedux
} from "../../Redux";
import { useLocation } from "react-router";
import { findSuccessAndErrorMessageControlsBasedOnAttribute } from "./SectionLayoutLogic";
import GlobalTimer from "../GlobalTimer";
import SessionExpired from "../SessionExpired";
import ErrorPage from "../IFormDesignerLayout/IFormDesignerComponents/ErrorPage";
import InvalidAuthentication from "../IFormDesignerLayout/IFormDesignerComponents/InvalidAuthentication";
import { conditionalExpression } from "@babel/types";
import {
  getRecursiveParent,
  checkForAllowedFormStructure,
} from "./ReUsableLogics";
import { ErrorOutlineOutlined } from "@material-ui/icons";
import { defaultBuffer } from "../../Resources/defaultBuffer.js";
import ControlLabel from "../../ReusableComponents/ControlLabel/ControlLabel";
import axios1 from "axios";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
// import { setAppScreenshotSavedDetails } from "../../Redux/Actions/AppActions";
import { formStateStore } from "../../Redux/Store/store";
import { isMobile } from "react-device-detect";
import secureLocalStorage from "react-secure-storage";
import cloneDeep from "lodash-es/cloneDeep";
import ReusableBusinessFunction from "../../ReusableComponents/BusinessFunctions/ReusableBusinessFunction";
import { reset, updateFormStateContextWithoutRender, updateGridContexts, updateMarvinContexts } from "../../Redux/Actions/FormStateActions.js";
import { GetState } from "../CustomHooks/CustomHooks.js";
import MarvinInputForm from "./IFormDesignerComponents/Marvin/MarvinInputForm/index.jsx";
import uuid from "react-uuid";
import stylesDoc from "../../UI/BasicFormControls/DocList/DocList.module.css"
import secureSessionStorage from "../../utils/secureSessionStorage.js";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const IFormDesignerLayout = (props) => {
  const { renderCanvas, templateLoaded}  = GetState("renderCanvas", "templateLoaded");
  const currentDeviceOnApp = getDevice()
  const [transactionId, setTransactionId] = useState(0);
  const [auth_iform_app , setAuth_iform_app] = useState(); 

  const [selectionPage, setSelectionPage] = useState();
  const explictLogoutRef = useRef(null);
  const [themeOpen, setThemeOpen] = useState(false);
  const [themeResetDone,setThemeResetDone]=useState(false);
  const [themeResetValDone,setThemeResetValDone]=useState(false);
  const [alert2, setAlert] = useState({
    open: false,
    severity: "",
    severityMessage: "",
  });
  const [alert1, setAlert1] = useState({
    open: false,
    severity: "",
    severityMessage: "",
  });
  const [openDrawer, setOpenDrawer] = useState(false);
  const [drawerPinned, setDrawerPinned] = useState(false);
  const [propertyPinned, setPropertyPinned] = useState(false);
  const [subformStack, setSubformStack] = useState([false]);
  const [customColumnLayout, setCustomColumnLayout] = useState(6);
  const [openProperties, setOpenProperties] = useState(false);
  const [currentSubFormInWizard, setCurrentSubFormInWizard] = useState("");
  const [activeMenuId, setActiveMenuId] = useState(null);
  const [fixedFooter,setFixedFooter] = useState(false);
  const listviewFrameLayoutJsonClone_listviewMap = useRef(new Map());
  // const setFixedFooter = (val) => {
  //   fixedFooter.current = val;
  // } 
  const [alertData, setAlertData] = useState({
    open: false,
    showConfirm: "showNotification",
  });
  window.isListViewChanges = true
  const [fromQuickProps, setfromQuickProps] = useState(false);
  // const [devicePreview, setDevicePreview] = useState();
  const [toggleProperty, setToggleProperty] = useState(false);
  const [showPagesSubForms, setShowPagesSubForms] = useState(false);
  const [globalLoading, setGlobalLoading] = useState(false);
  const [globalLoadingMessage, setGlobalLoadingMessage] = useState(false);
  const [valueForConditionalVisibility, setValueForConditionalVisibility] = useState({});
  const [data, setData] = useState([]);
  const [device, setDeviceNew] = useState(props?.mfProps?.data?.device || "web");
  const [isSSO, setIsSSO] = useState(false);
  const setDevice = (val) => {
    setDeviceNew(val);
    setDeviceWrapper(val);
    window.selectedControlId_function({});
  }
  const [dragging, setDragging] = useState(false);
  const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";
  const [emptyScreen, setEmptyScreen]=useState(true);

  const DocList_INI_Vars = useRef({
    EnableCloudUploadScan: "N",
    FileInspectorApiUrl: "",
    MinSizeForLargeFileUploadInMB: 4
  });
  //const [dragCounter, setDragCounter] = useState(0);
  // const [controlSelected, setControlSelected] = useState(false);

  const {
    setActiveSubForm,
    activeSubForm,
    setCurrentListviewForSubformWrapper,
    setActivePage,
    activePage,
    appId,
    setOpenCanvasForSubformWrapper,
    setFormStateWrapper,
    setSubFormStateWrapper,
    formMataData,
    childComp,
    appname,
    formDefId,
    processId,
    formId,
    formPageType,
    selectedPage,
    selectedSubform,
    componentType,
    microFrontendData,
    statusType,
    setShowDataAdditionSectionWrapper,
    setDeviceWrapper,
    containerId,
    renderChild
  } = props;

  let applicationNameObj = {
    applicationName:
      microFrontendData?.processName ||
      microFrontendData?.newApplicationName ||
      microFrontendData?.applicationName ||
      microFrontendData?.processDefId ||
      appname ||
      "",
    formName:
      microFrontendData?.taskId ||
      microFrontendData?.formName ||
      activePage?.formName ||
      activeSubForm?.fragmentName ||
      microFrontendData?.formId ||
      microFrontendData?.formDefId ||
      "",
  };

  if(window.location.href.includes("interfaceDesigner")) {
    const secureAutherization = secureSessionStorage.getItem("Authorization");
    const secureAutherization1 = window.isPortalLive
      ? secureLocalStorage.getItem(`launchpadKey_${window.applicationName}`) ||  secureLocalStorage.getItem("launchpadKey")
      : secureLocalStorage.getItem("launchpadKey");
    microFrontendData.token = secureAutherization || JSON.parse(secureAutherization1)?.token || secureSessionStorage.getItem("Authorization") || undefined;
  }

  if(applicationNameObj?.applicationName)
    window.applicationName = applicationNameObj.applicationName;

  const loading = (open, message = "Loading...", displayBackdrop = true, displayLoader = true) => {
    const isOpen = open === true || open === 'true';
    dispatch(updateStateInRedux({name: "loadingState", value:{
      open: open,
      message: isOpen ? message : "",
      displayBackdrop: isOpen ? displayBackdrop : false,
      displayLoader: isOpen ? displayLoader : false,
    }}))
    if(isOpen)
      setGlobalLoading(false)
    else {
      if (window.formBuilderCheck) window?.formBuilderCheck();
    }
  };

  // window.selectedControlId_function = (
  //   controlSelectedPassed,
  //   controlSelectedId
  // ) => {
  //   if (controlSelectedPassed?.elem_type === "CustomControl" && controlSelectedPassed.controlName !== "slider") {
  //     const newControl = {
  //       ...controlSelectedPassed,
  //       elem_type: controlSelectedPassed.controlName,
  //     };
  //     dispatch(updateStateInRedux({name: "controlSelected", key: containerId, value: newControl}));
  //     // setControlSelected((prev) => newControl);
  //   } else {
  //     dispatch(updateStateInRedux({name: "controlSelected", key: containerId, value: controlSelectedPassed}));
  //     // setControlSelected((prev) => controlSelectedPassed);
  //   }
  // };
  const isPortalLive = childComp === "application" && appname ? true: false;
  const callHomePage = useSelector((state) => state["callHomePage"]);
  const afterFormLoad = useSelector((state) => state["afterFormLoad"]);
  const postChangeFormLang_samepage = useSelector((state) => state["postChangeFormLang_samepage"]);
  // const appSavedDetails=useSelector((state)=>state.appScreenshotSavedDetails)
  const openDoclistViewerMicro = useSelector((state) => state["openDoclistViewerMicro"]);
  // const openDoclistUploadMicro = useSelector((state) => state["openDoclistUploadMicro"]);  

  var useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  var query = useQuery();
  var QueryString = query.get("QueryString" || "");
  var ExtendSession = query.get("ExtendSession" || "");
  
  var UserDBId = query.get("UserDBId" || "");
  var ExtendUserIndex = query.get("ExtendUserIndex" || "");
  var referencekey = query.get("PTId" || "");
  var navigationformname = query.get("navigationPage" || "");

  const [homePage, setHomePage] = useState();
  const [isMicroSerciceChecks, setisMicroSerciceChecks] = useState({
    IsMicroserviceMode: "N",
    MicroAuthParam: null,
    MicroAuthToken: null,
  });

  const includeTheme = (cabinet_name, resolution, locale, auth_token, callHomePage = false) => {
    if (!document.getElementById("OAP_AFB_THEME_CSS") || callHomePage) {
      var themeURL =
        "/oap-rest/app/theme/" + cabinet_name + `/${resolution}` + `/${locale}`;
      if (auth_token && auth_token.trim().length > 0) {
        themeURL += `/${auth_token}`;
      }
      var link = document.createElement("link");
      link.rel = "stylesheet";
      link.type = "text/css";
      link.id = "OAP_AFB_THEME_CSS";
      link.href = themeURL;
      document.head.appendChild(link);
    }
  };

  const globalTime = useRef({});
  const [cabinetName, setCabinetName] = useState("");
  const [openingAsApplication, setOpeningAsApplication] = useState({});
  const [applicationData, setApplicationData] = useState(
    props.applicationData || {}
  );
  function setGlobalTime(obj) {
    globalTime.current = obj;
  }
  const isLoginPortal = useRef(false)

  function getGeneralDataJSON(){
    // to get general Data
          const getGeneralDataJSON_url = "/viewform/getGeneralDataJSON";
          const getGeneralDataJSON_payload = {
            gdtoken: formMataData.gdToken || formMataData.gdtoken,
            token: formMataData?.token,
          };

          const keyValue = JSON.stringify({
            token: formMataData?.token || "",
          });
          // secureLocalStorage.setItem("launchpadKey", keyValue);
          secureLocalStorage.setItem(isPortalLive ?  `launchpadKey_${applicationNameObj.applicationName}` : "launchpadKey", keyValue);
          // axios.defaults.headers.common["Authorization"] =
          //   formMataData?.token || "";
          // secureLocalStorage.setItem("Authorization",formMataData?.token || "");
          if(formMataData) {
            axios.defaults.headers.common["Authorization"] =
              formMataData?.token || "";
            secureSessionStorage.setItem("Authorization",formMataData?.token || "");
          }
    axios
            .post(getGeneralDataJSON_url, getGeneralDataJSON_payload, {
              headers: {
                Authorization: `${formMataData?.token}`,
              },
              withCredentials: true,
            })
            .then((res) => {
              //changed on 11-11-2022=>res.data is the general data
              // setTimeout(() => {
                var value = res.data;
                dispatch(
                  updateStore({ name: "generalData", value, key: containerId })
                );
                value = res.data?.processinstanceid;
                dispatch(updateStateInRedux({name:"generalDataCall",value: new Date()}));
                dispatch(updateStore({ name: "pid", value, key: containerId }));
                window.formBuilder_pid_generalData = res.data?.processinstanceid;
                window.activeCabinet_formbuilder= res.data?.cabinetname;
              // }, 0)
              
            })
            .catch((err) => {
              console.log("error faced");
            });
  } 

  function kuchBhi(json, view = "web"){
    updateFormStateStructureByElemType(
      json,
      2,
      "tablet",
      props?.mfProps?.data?.device,
    );
  }

  function changeJSONLayout(json, view = "web"){
    updateFormStateStructureByElemType(
      json,
      3,
      view,
      props?.mfProps?.data?.device,
    );
  }

  const getHomePage = () => {
    
    console.log("getINIConfig 409", );

    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang'); // Changes done for loading locale on the basis of queryparam's locale
    const localeKey = localStorage?.getItem("locale")
    const url = new URL(window.location.href);
    const authorization = url.searchParams.get('authorization');
    if(authorization && ExtendSession === 'Y') {
      axios.defaults.headers.common["Authorization"] = authorization;   
      const keyValue = JSON.stringify({
        token: authorization || "",
      });
      secureLocalStorage.setItem(isPortalLive ?  `launchpadKey_${applicationNameObj.applicationName}` : "launchpadKey", keyValue);
    }

    console.log("getINIConfig 409",urlParams, lang, localeKey, isPortalLive );

    axios.get(`/interface/homePage/${appname}`,{
      headers: {
        mode: 'V',
        extendSession: ExtendSession,
        queryString: QueryString,
        referencekey : referencekey,
        Authorization : ExtendSession==="Y" ? authorization : null,
        localeKey: localeKey ? localeKey : "en",
        originURL: window?.parent?.location?.href,
        clientGMTOffset: Math.abs(new Date().getTimezoneOffset()),
      },
    })
    .then((res) => {
      if(res.data.status === "1") {
        showAlertConfirmNotifications({
          'open':true,
          'showConfirm':'showNotification',
          'alertType':'error',
          'alertContentKey': res?.data?.err_msg_description || "some error occured"
        });
      }
      else if(res?.status === "401") {
        showAlertConfirmNotifications({
          'open':true,
          'showConfirm':'showNotification',
          'alertType':'error',
          'alertContentKey': "Invalid_Operation"
        });        
      }
      else if(res?.data?.err_Msg && res?.data?.status==="-2"){
        showAlertConfirmNotifications({
          'open':true,
          'showConfirm':'showNotification',
          'alertType':'error',
          'alertContentKey': res?.data?.err_Msg || "some error occured"
        });
      }
      else if(res?.data?.info_msg){
        showAlertConfirmNotifications({
          'open':true,
          'showConfirm':'showNotification',
          'alertType':'info',
          'alertContentKey': res?.data?.info_msg || "some error occured"
        });
      }
      else {
        const response= res?.data ? res : {};
        const responseData= response?.data ? response.data : {}
        // const cookie = response?.headers?.[""];
        // if(responseData?.isSSO === true || responseData?.isSSO === false) {
          setIsSSO(responseData?.isSSO);
        // }
        if (responseData?.isSSO) {
          setLoggedInUserData({
            ...loggedInUserData,
            loggedInUserName:
              responseData?.personalName,
            lastLoggedInTime: res?.data?.lastLoginTime,
          });
        }
        var formBuffer = responseData?.formJson ? responseData?.formJson :{}
        window[`authorizationtokenNotsecure`] = res?.data?.Authorization;
        setAuth_iform_app(res?.data?.Authorization);
        // var formBuffer = res.data.formJson;
        // var existingFormId_in=res.data.existingFormId;
        // setExistingFormId(existingFormId_in);
        if(referencekey){
          window.wizard_stage_fromOpenTransaction = response?.Stage || res?.data?.Stage || "" ;
        }

        const keyValue = JSON.stringify({
          token: res?.data?.authorizationBypass || res?.data?.Authorization || "",
        });
       if(window.refreshWizard_clbk){
         window.refreshWizard_clbk()
       }
        window.gdtoken_portal= res?.data?.gdtoken;
        window.formBuilder_transactionid_generalData= res?.data?.TransactionId;
        // secureLocalStorage.setItem("launchpadKey", keyValue);
        // if(res?.data?.authorizationBypass){
        //   secureLocalStorage.setItem(isPortalLive ?  `launchpadKey_bypass_${applicationNameObj.applicationName}` : "launchpadKey", keyValue);
        //   axios.defaults.headers.common["Authorization"] = res?.data?.authorizationBypass || res?.data?.Authorization || "";
        // }
        // else{
          secureLocalStorage.setItem(isPortalLive ?  `launchpadKey_${applicationNameObj.applicationName}` : "launchpadKey", keyValue);
          secureSessionStorage.setItem("Authorization" , res?.data?.authorizationBypass || res?.data?.Authorization || "");
          axios.defaults.headers.common["Authorization"] = res?.data?.authorizationBypass || res?.data?.Authorization || "";
  
        // }
        if(isPortalLive){
            if(isPortalLive && res?.headers?.ngsmtoken){
              secureLocalStorage.setItem("ngsmtoken" , res?.headers?.ngsmtoken);
              axios.defaults.headers.common["ngsmtoken"] =res?.headers?.ngsmtoken || "";
            }
        }
        // }
        if(lang && !window.langChange){
          functions.changeFormLocale(lang)
          window.langChange = true;
          return;
        }
        const cabinetName_fromIni = secureLocalStorage.getItem("cabinet") || localStorage.getItem("cabinet") || window?.activeCabinet_formbuilder ;
        changeJSONLayout(formBuffer, currentDeviceOnApp)
        if(currentDeviceOnApp)
          formBuffer.currentDeviceOnApp = currentDeviceOnApp
        var value = "";
        
        value = res.data.witoken;
        
        dispatch(
          updateStore({
            name: "witoken",
            value,
            key: containerId,
          })
        );
        
        value = res.data.gdtoken;
        
        dispatch(
          updateStore({
            name: "gdtoken",
            value,
            key: containerId,
          })
        );
        if(responseData?.APIData) {
          renderExecuteServerEventAPIData({outputArray: responseData.APIData, sync: true, renderFlag: true, json: formBuffer});
        }
        setFormState2(formBuffer);
        setisMicroSerciceChecks({
          IsMicroserviceMode: res?.data?.isMicroserviceMode || "N",
          MicroAuthParam: res?.data?.MicroAuthParam,
          MicroAuthUser:res?.data?.MicroAuthUser,
          MicroAuthToken: res?.data?.MicroAuthToken,
          cabinetName: cabinetName_fromIni
        })

        // setFormState2(formBuffer);
        setHomePage(formBuffer?.formName);
        
        let SessionExpireWarnTime =
          res.data?.SessionExpireWarnTime;
        let SessionExpireWarnTimeMin;
        let SessionExpireWarnTimeSec;
        if (SessionExpireWarnTime) {
          SessionExpireWarnTime = parseInt(SessionExpireWarnTime);
          if (typeof SessionExpireWarnTime === "number") {
            SessionExpireWarnTimeMin = Math.round(
              SessionExpireWarnTime / 60
            );
            SessionExpireWarnTimeSec = SessionExpireWarnTime % 60;
          }
        }
        
        setSessionPopupTime({
          min: SessionExpireWarnTimeMin,
          sec: SessionExpireWarnTimeSec,
        });
        
        setFormBuillderMode("preview");

        dispatch(updateStateInRedux({name:"generalDataCall",value: new Date()}));

        setOpeningAsApplication(() => {
          return {
            applicationName: appname,
            applicationId: res.data.existingFormId,
            defaultFormId: res.data.formId,
            ...res.data,
          };
        });

        setActivePage(res?.data?.formJson);
        setActiveSubForm(null);

        setApplicationData((prev) => {
          return {
            ...prev,
            ...res.data,
            defaultFormId: res.data.formId,
          };
        });
        const formBufferParsed=JSON.parse(res.data.formBuffer);
        var parentTable=[...formBufferParsed?.TableList?.filter(item => Object.keys(item)[0]==="parenttable")][0];
        var tableList=[...formBufferParsed?.TableList?.filter(item => Object.keys(item)[0]!=="parenttable")];

        var viewformJson = {
          isApp: "true",
          DeviceType: "W",
          isGeneralDataCreated: "false",
          isWIModelCreated: "false",
          gdtoken: "",
          witoken: "",
          // "pid":"TestProcess-0000000003-process",
          pid: "Emp001",
          wid: "1",
          tid: "",
          fid: "Emp001_1",
          sessionInfo: "pre_1308210909-0000000014-process_sessionInfo",
          formJson: res.data.formBuffer,
          isPreview: "false",
          applicationName: appname,
          applicationId: res.data.existingFormId,
          parentTable:JSON.stringify(parentTable),
          tableList:JSON.stringify(tableList),
          isNewSession: "true",
          isLogin:
            props?.applicationData?.islogin || res?.data?.islogin || "N",
        };
        // EXTEND SESSION
        if (
          ExtendSession &&
          ExtendSession !== "" &&
          UserDBId &&
          UserDBId !== "" &&
          ExtendUserIndex &&
          ExtendUserIndex !== ""
        ) {
          viewformJson = {
            ...viewformJson,
            // "QueryString":QueryString,
            ExtendSession: ExtendSession,
            UserDBId: UserDBId,
            ExtendUserIndex: ExtendUserIndex,
            generalDataKey: "TestProcess-0000000003-process_GeneralData",
          };
        }
        // QUERY STRING
        else if (QueryString && QueryString !== "") {
          viewformJson = { ...viewformJson, QueryString: QueryString };
        }
        // const wizardJson=res.data.formBuffer.children[1].children[1];
        const formBufferWizard = JSON.parse(res.data.formBuffer);
        var wizardJson = findJson(formBufferWizard, "wizard_h");
        if (wizardJson === undefined) {
          wizardJson = findJson(formBufferWizard, "wizard_v");
        }

        const isSubstepPresent = isChildrenPresent(
          wizardJson?.children?.[0],
          "substep"
        );
        var subformIdPresent = false;
        var subformid = undefined;

        {
          isSubstepPresent
            ? (subformid =
                wizardJson?.children?.[0]?.children?.[0]?.subformId)
            : (subformid = wizardJson?.children?.[0]?.subformId);
        }

        if (subformid) {
          setFormState2(formBuffer);
        } else {
          
        }
      }
      setGlobalLoading(false)
      setGlobalLoadingMessage("")
      loading(false);
    })
    .catch((err) => {
      console.log(err);
      if(err?.response?.data?.err_msg){
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: `${err?.response?.data?.err_msg}`,
        });
      }
      else if(err?.response?.data?.Error === "Issue in Portal Data Fetching. Please check Portal configuration."){
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "Issue_in_Portal_Data_Fetching",
        });
      }
      setGlobalLoading(false)
      setGlobalLoadingMessage("")
      loading(false);
    }); 
  }

  // window.parent_auth_iforms = () =>{
  //   return auth_iform_app;
  // }

  // window.setParent_auth_iforms = (value) =>{
  //   window[`authorizationtokenNotsecure`] = value;
  //   setAuth_iform_app( value );
  // }

  function createEfficientElementMapOriginal(formState) {
    const elementMap = new Map();  // Stores elements with primary `id`
    const aliasMap = new Map();    // Stores alias mappings for `customId` & `dataClass`
    // const allPrimitiveControlList = [
    //   "textbox",
    //   "password",
    //   "textarea",
    //   "richtexteditor",
    //   "datepick",
    //   "slider",
    //   "listbox",
    //   "combo",
    //   "radio",
    //   "checkbox",
    //   "toggle",
    //   "tile",
    //   "doclist",
    //   "picklist",
    //   "button",
    //   "link",
    //   "label",
    //   "paragraph",
    //   "table",
    //   "listview",
    //   "advancelistview",
    //   "image",
    //   "imagecarousel",
    //   "report",
    //   "iframe",
    //   "captcha",
    //   "sheet",
    //   "CustomControl",
    //   "column",
    //   "row",
    //   "wizard_h",
    //   "wizard_v",
    //   "sidenavigation",
    //   "menu",
    //   "frame",
    //   "section",
    //   "tab",
    // ];

    function traverse(node) {
        if (!node) return; // Ignore invalid nodes
        if(!node.id) return; // Ignore invalid nodes

        // ✅ Store element using its `id`
        elementMap.set(node.id, node);

        // ✅ Store aliases mapping them to the primary `id`
        if (node?.dataclass) aliasMap.set(node?.dataclass, node.id);
        if (node?.style?.CustomId) aliasMap.set(node?.style?.CustomId, node.id);

        // ✅ Recursively traverse nested elements
        if (node.children) {
            for (let i = 0; i < node.children.length; i++) {
                traverse(node.children[i]);
            }
        }
        if (node.subform && node.elem_type === "button") {
            traverse(node.subform);
        }
        if ((node.elem_type?.toLowerCase() === "advancelistview" || node.elem_type?.toLowerCase() === "listview") && node.listviewFrameLayoutJson) {
            traverse(node.listviewFrameLayoutJson);
        }
    }

    traverse(formState); // Build Maps

    return { elementMap, aliasMap };
}

  useEffect(() => {
    if(childComp === "preview"){
      if (formMataData) {
        // loadIformClient();
        console.log("formMataData", formMataData);
        //*********** WHEN PREVIEW/APPVIEWER OPENS THROUGH A PROCESS AS A WORKITEM ***********/
        if (formMataData?.DeviceType === "M") {
          // setFormState2(sanitizeJson(formMataData?.formJson));
          const containerId = getContainerId()
          const formJson = getFormJsonMetaData();
          let parsedJson = JSON.parse(formJson)
          var value = "";
          value = formMataData.gdToken || formMataData.gdtoken;
          // var key=containerId;
          dispatch(updateStore({ name: "gdtoken", value, key: containerId }));

          value = formMataData.witoken || formMataData.wiToken;
          dispatch(updateStore({ name: "witoken", value, key: containerId }));

          value = formMataData.pid;
          dispatch(updateStore({ name: "pid", value, key: containerId }));

          value = "true";
          dispatch(
            updateStore({ name: "isWorkItem", value, key: containerId })
          );

          value = formMataData;
          dispatch(
            updateStore({ name: "formMataData", value, key: containerId })
          );
          if(formMataData?.APIData) {
            renderExecuteServerEventAPIData({outputArray: formMataData?.APIData, sync: true, renderFlag: true, json: parsedJson});
            loading(false);
          }
          // kuchBhi(parsedJson)
          // const device = getDevice()
          let widthOfContainer;
          let currentDeviceContainer = "web";
          if(containerId){
            widthOfContainer = document.getElementById(containerId)?.clientWidth
            if(widthOfContainer > 1025){
              currentDeviceContainer = "web"
            }
            else if(widthOfContainer > 481 && widthOfContainer <= 1024){
              currentDeviceContainer = "tablet"
            }
            else{
              currentDeviceContainer = "mobile"
            }
            console.log("workspaceheight", document.getElementById(containerId)?.clientWidth, document.getElementById(containerId)?.offsetWidth, document.getElementById(containerId)?.getBoundingClientRect().width)
          }
          changeJSONLayout(parsedJson, currentDeviceContainer)
          if(currentDeviceContainer)
          parsedJson.currentDeviceOnApp = currentDeviceContainer
          setFormState2(() => parsedJson);
          setFormBuillderMode("preview");
          // setFormState2(JSON.parse(formMataData?.formJson));
          // setFormStateOnOpen(parsedJson);
          setFormstateChangedByUser(false);
          getGeneralDataJSON();
          // setCallGdFunction(!callGdFunction)


          // if(props?.appDesignerCallback){
          //     props?.appDesignerCallback({
          //         "gdtoken":formMataData.gdtoken,
          //         "witoken":formMataData.witoken
          //     })
          // }
          var sessionInfo = formMataData?.sessionInfo;
          var jwtToken = formMataData?.token;

          // axios1
          //   .get(
          //     `/HazelcastServer/hazelcast/get/${sessionInfo}`,
          //     {
          //       headers: {
          //         Authorization: `Bearer ${jwtToken}`,
          //       },
          //     },
          //     { withCredentials: true }
          //   )
          //   .then((res) => {
          //     window.activeCabinet_formbuilder = res.data?.value?.CabinetName;
          //     axios.defaults.headers.common["cabinetName"] =
          //       res.data?.value?.CabinetName;
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //   });
          setGlobalLoading(false)
          setGlobalLoadingMessage("")
          loading(false);
        } else {
          // to get general Data
          const getGeneralDataJSON_url = "/viewform/getGeneralDataJSON";
          const getGeneralDataJSON_payload = {
            gdtoken: formMataData.gdToken || formMataData.gdtoken,
            token: formMataData?.token,
          };
          axios
            .post(getGeneralDataJSON_url, getGeneralDataJSON_payload, {
              headers: {
                Authorization: `${formMataData?.token}`,
              },
              withCredentials: true,
            })
            .then((res) => {
              var value = "";
              //changed on 11-11-2022=>res.data is the general data
              value = res.data;
              dispatch(
                updateStore({ name: "generalData", value, key: containerId })
              );
              dispatch(updateStateInRedux({name:"generalDataCall",value: new Date()}));
            })
            .catch((err) => {
              console.log("error faced");
            });

          const formMataData_json = {
            ProcessDefId: formMataData.ProcessDefId,
            formName: formMataData.formName,
            sessionInfo: formMataData.sessionInfo,
          };

          axios
            .post(`/viewform/getFormJson`, formMataData_json, {
              headers: {
                Authorization: `${formMataData?.token}`,
              },
              withCredentials: true,
            })
            .then((response) => {
              const viewformJson = {
                isApp: formMataData.isApp,
                DeviceType: formMataData.DeviceType,
                isGeneralDataCreated: formMataData.isGeneralDataCreated,
                isWIModelCreated: formMataData.isWIModelCreated,
                gdtoken: formMataData.gdtoken,
                witoken: formMataData.witoken,
                pid: formMataData.pid,
                wid: formMataData.wid,
                tid: formMataData.tid,
                fid: formMataData.fid,
                sessionInfo: formMataData.sessionInfo,
                formJson: JSON.stringify(response.data),
                isPreview: formMataData?.isPreview,
                jwtToken: formMataData?.token,
              };

              axios
                .post("/viewform/", viewformJson, { withCredentials: true })
                .then((resp) => {
                  setFormBuillderMode("preview");
                  // setFormState2(sanitizeJson(resp.data.formJson));
                  setFormStateOnOpen(sanitizeJson(resp.data.formJson));
                  
                  var value = "";
                  value = resp.data.witoken;
                  dispatch(
                    updateStore({ name: "witoken", value, key: containerId })
                  );

                  value = resp.data.gdtoken;
                  dispatch(
                    updateStore({ name: "gdtoken", value, key: containerId })
                  );

                  if (props?.appDesignerCallback) {
                    props?.appDesignerCallback({
                      gdtoken: resp.data.gdtoken,
                      witoken: resp.data.witoken,
                    });
                  }
                  setGlobalLoading(false)
                  setGlobalLoadingMessage("")
                  loading(false);
                  // dispatch(setFormState1(sanitizeJson(resp.data.formJson)));
                })
                .catch((err) => {
                  console.log(err);
                  setGlobalLoading(false)
                  setGlobalLoadingMessage("")
                  loading(false);
                });
            })
            .catch((err) => {
              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: err,
              });
            });
        }
      }
    }
  }, [childComp])
  useEffect(()=>{
if(openDoclistViewerMicro){
  functions.openDoclistFunction();
}
  },[openDoclistViewerMicro])

  // useEffect(()=>{
  //   console.log("openDoclistUploadMicro", openDoclistUploadMicro);
  //   if(openDoclistUploadMicro){
  //     functions.uploadDocumentWindowFunction();
  //   }
  //   },[openDoclistUploadMicro])

  // **************** CALLS TO LOAD APPLICATION ********************************//
  const currentUrl = window.location.href
  useEffect(() => {
    if (appname && childComp === "application") {
      setGlobalTime({ min: sessionTime, sec: 0 });
      const configJson = {
        configFileName: "appconf",
        applicationName: appname,
      };
      axios.defaults.headers.common["Authorization"] = undefined;
      if(axios.defaults.headers.common["ngsmtoken"])
      axios.defaults.headers.common["ngsmtoken"] = undefined;
      if(secureLocalStorage.getItem("ngsmtoken"))
      secureLocalStorage.removeItem("ngsmtoken");
      console.log("getINIConfig ngsmtoken queryparameter", isPortalLive, window?.location?.search);
      axios
        .post("/viewform/getINIConfig", configJson, {
          withCredentials: true
        })
        .then((resp) => {
          if(resp?.data?.Error === "Cabinet associated with Portal is not registered."){
            showAlertConfirmNotifications({
              'open':true,
              'showConfirm':'showNotification',
              'alertType':'error',
              'alertContentKey': 'Cabinet_Not_Registered_Portal'
            });
          }{
          console.log("getINIConfig 1015", resp);

          const cabinetName_fromIni = resp.data?.CabinetName;
          if(DocList_INI_Vars.current) {
            DocList_INI_Vars.current.EnableCloudUploadScan = resp?.data?.EnableCloudUploadScan || "N";
            DocList_INI_Vars.current.FileInspectorApiUrl = resp?.data?.FileInspectorApiUrl || "";
            DocList_INI_Vars.current.MinSizeForLargeFileUploadInMB = resp?.data?.MinSizeForLargeFileUploadInMB || 4;
          }
          axios.defaults.headers.common["cabinetName"] = cabinetName_fromIni;
          window.activeCabinet_formbuilder= cabinetName_fromIni;
          setCabinetName(cabinetName_fromIni);
          const width = window.screen.width;
          const height = window.screen.height;
          const language = window?.psh_configs?.selectedLanguage;

          console.log("getINIConfig 1032", "cabinetName_fromIni", cabinetName_fromIni , " language", language, "jwtToken", jwtToken , "appname", appname);

          includeTheme(
              cabinetName_fromIni,
              `${width}_${height}`,
              language,
              jwtToken
            );

          const secConfigJson = {
            configFileName: "iformsconf",
            applicationName: appname,
          };

          console.log("getINIConfig 1039", "----------appname : ", appname, "---------referencekey : " , referencekey, "  --------- navigationformname : ", navigationformname);



          // axios
          //   .post("/viewform/getINIConfig", secConfigJson, { withCredentials: true })
          //   .then((secRes) => {
          //     setisMicroSerciceChecks(prev => ({ ...prev, IsMicroserviceMode: secRes?.data?.IsMicroserviceMode || "N"}))
          //   }).catch((err) => {
          //     console.log(err);
          //   });

          console.log("getINIConfig 1044", QueryString);
  
            if(!QueryString) {
              QueryString = '%20';
            }
            else {
              QueryString = encodeURIComponent(QueryString);
            }
            console.log("getINIConfig 1029", "---------referencekey : ", referencekey, "  --------- navigationformname : ", navigationformname);
  
            if(referencekey && navigationformname){
  
              axios.get(`/interfacebyappname/${appname}/${navigationformname}`,{
                headers: {
                  mode: 'V',
                  extendSession: ExtendSession,
                  queryString: QueryString,
                  referencekey : referencekey
                },
              })
              .then((res) => {
                if(res.data.status === "1") {
                  showAlertConfirmNotifications({
                    'open':true,
                    'showConfirm':'showNotification',
                    'alertType':'error',
                    'alertContentKey': res?.data?.err_msg_description || "some error occured"
                  });
                }
                else {
                  const response= res?.data ? res : {};
                  window.wizard_stage_fromOpenTransaction = response?.Stage || res?.data?.Stage || "" ;
                  const responseData= response?.data ? response.data : {}
                  var formBuffer = responseData?.formJson ? responseData?.formJson :{}
                  // var formBuffer = res.data.formJson;
                  // var existingFormId_in=res.data.existingFormId;
                  // setExistingFormId(existingFormId_in);
    
                  const keyValue = JSON.stringify({
                    token: res?.data?.Authorization || "",
                  });
  
                  window.gdtoken_portal= res?.data?.gdtoken;
                  window.formBuilder_transactionid_generalData= res?.data?.TransactionId;
                  // secureLocalStorage.setItem("launchpadKey", keyValue);
                  secureLocalStorage.setItem(isPortalLive ?  `launchpadKey_${applicationNameObj.applicationName}` : "launchpadKey", keyValue);
                  axios.defaults.headers.common["Authorization"] =res?.data?.Authorization || "";
                  // }
                  changeJSONLayout(formBuffer, currentDeviceOnApp)
                  if(currentDeviceOnApp)
                  formBuffer.currentDeviceOnApp = currentDeviceOnApp
                  var value = "";
                  
                  value = res.data.witoken;
                  
                  dispatch(
                    updateStore({
                      name: "witoken",
                      value,
                      key: containerId,
                    })
                  );
                  
                  value = res.data.gdtoken;
                  
                  dispatch(
                    updateStore({
                      name: "gdtoken",
                      value,
                      key: containerId,
                    })
                  );
                  if(responseData?.APIData) {
                    renderExecuteServerEventAPIData({outputArray: responseData.APIData, sync: true, renderFlag: true, json: formBuffer});
                  }
                  setFormState2(formBuffer);
                  setisMicroSerciceChecks({
                    IsMicroserviceMode: res?.data?.isMicroserviceMode || "N",
                    MicroAuthParam: res?.data?.MicroAuthParam,
                    MicroAuthUser:res?.data?.MicroAuthUser,
                    MicroAuthToken: res?.data?.MicroAuthToken,
                    cabinetName: cabinetName_fromIni
                  })
    
                  // setFormState2(formBuffer);
                  setHomePage(formBuffer?.formName);
                  
                  let SessionExpireWarnTime =
                    res.data?.SessionExpireWarnTime;
                  let SessionExpireWarnTimeMin;
                  let SessionExpireWarnTimeSec;
                  if (SessionExpireWarnTime) {
                    SessionExpireWarnTime = parseInt(SessionExpireWarnTime);
                    if (typeof SessionExpireWarnTime === "number") {
                      SessionExpireWarnTimeMin = Math.round(
                        SessionExpireWarnTime / 60
                      );
                      SessionExpireWarnTimeSec = SessionExpireWarnTime % 60;
                    }
                  }
                  
                  setSessionPopupTime({
                    min: SessionExpireWarnTimeMin,
                    sec: SessionExpireWarnTimeSec,
                  });
                  
                  setFormBuillderMode("preview");
                    
                  dispatch(updateStateInRedux({name:"generalDataCall",value: new Date()}));
    
                  setOpeningAsApplication(() => {
                    return {
                      applicationName: appname,
                      applicationId: res.data.existingFormId,
                      defaultFormId: res.data.formId,
                      ...res.data,
                    };
                  });
    
                  setActivePage(res?.data?.formJson);
                  setActiveSubForm(null);
    
                  setApplicationData((prev) => {
                    return {
                      ...prev,
                      ...res.data,
                      defaultFormId: res.data.formId,
                    };
                  });
                  const formBufferParsed=JSON.parse(res.data.formBuffer);
                  var parentTable=[...formBufferParsed?.TableList?.filter(item => Object.keys(item)[0]==="parenttable")][0];
                  var tableList=[...formBufferParsed?.TableList?.filter(item => Object.keys(item)[0]!=="parenttable")];
          
                  var viewformJson = {
                    isApp: "true",
                    DeviceType: "W",
                    isGeneralDataCreated: "false",
                    isWIModelCreated: "false",
                    gdtoken: "",
                    witoken: "",
                    // "pid":"TestProcess-0000000003-process",
                    pid: "Emp001",
                    wid: "1",
                    tid: "",
                    fid: "Emp001_1",
                    sessionInfo: "pre_1308210909-0000000014-process_sessionInfo",
                    formJson: res.data.formBuffer,
                    isPreview: "false",
                    applicationName: appname,
                    applicationId: res.data.existingFormId,
                    parentTable:JSON.stringify(parentTable),
                    tableList:JSON.stringify(tableList),
                    isNewSession: "true",
                    isLogin:
                      props?.applicationData?.islogin || res?.data?.islogin || "N",
                  };
                  // EXTEND SESSION
                  if (
                    ExtendSession &&
                    ExtendSession !== "" &&
                    UserDBId &&
                    UserDBId !== "" &&
                    ExtendUserIndex &&
                    ExtendUserIndex !== ""
                  ) {
                    viewformJson = {
                      ...viewformJson,
                      // "QueryString":QueryString,
                      ExtendSession: ExtendSession,
                      UserDBId: UserDBId,
                      ExtendUserIndex: ExtendUserIndex,
                      generalDataKey: "TestProcess-0000000003-process_GeneralData",
                    };
                  }
                  // QUERY STRING
                  else if (QueryString && QueryString !== "") {
                    viewformJson = { ...viewformJson, QueryString: QueryString };
                  }
                  // const wizardJson=res.data.formBuffer.children[1].children[1];
                  const formBufferWizard = JSON.parse(res.data.formBuffer);
                  var wizardJson = findJson(formBufferWizard, "wizard_h");
                  if (wizardJson === undefined) {
                    wizardJson = findJson(formBufferWizard, "wizard_v");
                  }
    
                  const isSubstepPresent = isChildrenPresent(
                    wizardJson?.children?.[0],
                    "substep"
                  );
                  var subformIdPresent = false;
                  var subformid = undefined;
    
                  {
                    isSubstepPresent
                      ? (subformid =
                          wizardJson?.children?.[0]?.children?.[0]?.subformId)
                      : (subformid = wizardJson?.children?.[0]?.subformId);
                  }
    
                  if (subformid) {
                    setFormState2(formBuffer);
                  } else {
                    
                  }
                }
                setGlobalLoading(false)
                setGlobalLoadingMessage("")
                loading(false);
              })
              .catch((err) => {
                console.log(err);
                if(err?.response?.data?.err_msg){
                  showAlertConfirmNotifications({
                    open: true,
                    showConfirm: "showNotification",
                    alertType: "error",
                    alertContentKey: `${err?.response?.data?.err_msg}`,
                  });
                }
                setGlobalLoading(false)
                setGlobalLoadingMessage("")
                loading(false);
              });
  
            } else if(currentUrl.includes("openExtInterface")){
              window?.openExternalFormbuffer()
            } else {
              console.log("getINIConfig 1249", referencekey, navigationformname);
  
              getHomePage();
            }
          }
        })
        .catch((err) => {});
    }
  }, []);

  const [wizard_type_step, set_wizard_type_step] = useState("-1");
  const [wizard_type_subStepIndex, set_wizard_type_subStepIndex] = useState("-1");
  const wizard_type_subChildMenuIndex = useRef("-1");

  useEffect(() => {
    if (
      window.interfaceLoader &&
      (props.childComp === "application" ||
        props.childComp === "preview" ||
        props.childComp === "app" || 
        formMataData)
    ) {
      // setTimeout(() => {
        if(afterFormLoad && (formState2?.containerControl !== "sidenavigation" || formState2?.containerControl !== "wizard_h" || formState2?.containerControl !== "wizard_v"))
        requestAnimationFrame(() => {
          window.interfaceLoader(applicationNameObj?.formName);
          functions.updateJSON();
        })
      // }, 1000);
    }
    if(getStepName() && !window.isDesigner) {
      (async () => {
        try {
          await axios.post("/viewform/setStepName", {stepName: getStepName(), subStepName: getSubStepName()}, {withCredentials: true});
          console.log("stepname updated on backend");
        } catch(err) {
          console.log(err);
        }
      })();
    }
  }, [wizard_type_step, wizard_type_subStepIndex, afterFormLoad]);

  useEffect(()=>{
    if(childComp === "app")
      document.getElementById("propertiesId")?.focus();
   },[toggleProperty])

  const [applicationScreenshot, setApplicationScreenshot] = useState();
  // const applicationScreenshot = useRef();

  // function setApplicationScreenshot(image) {
  //   applicationScreenshot.current = image;
  // }
  // const [latestChangesSaved , setLatestChangesSaved] = useState(true);

  const latestChangesSaved = useRef(true);

  
  function setLatestChangesSaved(val) {
    latestChangesSaved.current = val;
    window.appform_latestChangesSaved = val;
  }
  
  const [externalFormOpen, setExternalFormOpen] = useState(false)

  // function set_wizard_type_step(val) {
  //   wizard_type_step.current = val;
  // }

  // function set_wizard_type_subStepIndex(val) {
  //   wizard_type_subStepIndex.current = val;
  // }

  function set_wizard_type_subChildMenuIndex(val) {
    wizard_type_subChildMenuIndex.current = val;
  }

  useEffect(() => {
    if(childComp === "preview")
    setMandatoryControls([]);
  },[containerId])
  
  const [reRender, setReRender] = useState(false);

  // const [selectedDataObject, setSelectedDataObject] = useState({});
  // const [formState, setFormState] = useState([]);
  // const [currElemState.current, setCurrElem] = useState('');
  const subFormStateJson = useRef();
  const setSubFormState = (val) => {
    subFormStateJson.current = val;
    if(childComp === "app"){
      // updatedComponentInFormState()
      var latestJson = JSON.parse(JSON.stringify(formState2));
      fetchAndUpdateJSON(latestJson, val?.id, val, "buttonsubform")
      console.log("wow8", formState2, latestJson)
        
        setFormState2((prevState) => {
          return { ...latestJson };
        });

    }
    if(childComp === "preview"){
      setReRender(prev => !prev)
    }
    if(childComp === "app")
      setSubFormStateWrapper(val);
  };
  const [spareSubForm, setSpareSubForm] = useState()
  const [subform_obj, setSubform_obj] = useState();
  // const [advListviewFromScratchJson, setAdvListviewFromScratchJson] =
  //   useState();
  const [headerJSON, setHeaderJSON] = useState({
    id: "LoginHeader",
    elem_type: "LoginHeader",
    style: {},
  });
  // const [currentButtonForSubform.current, setCurrentButtonForSubform] = useState(undefined);
  const currentButtonForSubform = useRef(undefined);

  const setCurrentButtonForSubform = (val) => {
    currentButtonForSubform.current = val;
  };

  const [currentListviewForSubform, setCurrentListviewForSubform1] =
  useState(undefined);

const setCurrentListviewForSubform = (data) => {
  if(data){
    setCurrentListviewForSubformWrapper({...data})
    setCurrentListviewForSubform1({...data})
  }
  else{
    setCurrentListviewForSubformWrapper(data)
    setCurrentListviewForSubform1(data)
  }
}
  const [allNonFilledMandatoryFields, setAllNonFilledMandatoryFields] =
    useState([]);
    // const [tempCanWidth, setTempCanWidth] = useState(0);
    // const [tempCanHeight, setTempCanHeight] = useState(0);
    const loginHeaderHeight = useRef(0);
    const setLoginHeaderHeight = (val) => {
      loginHeaderHeight.current = val;
    }
    const [canvasTop, setCanvasTop] = useState(0);
  const sectionInitiallyCollapsedState = useRef({});

  const setSectionInitiallyCollapsedState = (obj) => {
    sectionInitiallyCollapsedState.current = obj;
  };

  // const [advanceListviewStateJson, setAdvanceListviewStateJson] = useState();
  // const [spareAdvanceListviewStateJson, setSpareAdvanceListviewStateJson] = useState()
  const [spareListviewStateJson, setSpareListviewStateJson] = useState()

  // const [currentAdvanceListviewStateJson, setcurrentAdvanceListviewStateJson] =
  //   useState();

  const [subAdvacnceListID, setSubAdvacnceListID] = useState();
  // const [advSaveAndContinue, setAdvSaveAndContinue] = useState(false);

  const [openCanvasForSubform, setOpenCanvasForSubformNew] = useState(false);
  const setOpenCanvasForSubform = (val) => {
    setOpenCanvasForSubformNew(val);
    if(childComp === "app")
      setOpenCanvasForSubformWrapper(val);
  }
  // const [isAboveSection, setIsAboveSection] = useState(false);
  const [listviewInfoUpdated, setListviewInfoUpdated] = useState(false);
  // const [listviewModifyMode, setListviewModifyMode] = useState(false);
  const [subFormID, setSubFormID] = useState();
  const [showDataAdditionSection, setShowDataAdditionSectionNew] = useState(false);

  const setShowDataAdditionSection = (val) => {
    setShowDataAdditionSectionNew(val);
    setShowDataAdditionSectionWrapper(val);
  }

  // const [subFormListviewJson, setSubFormListviewJson] = useState();
  // const [listViewAddRecordFrom, setListViewAddRecordFrom] = useState(false);

  // const [openCanvasForPreview, setOpenCanvasForPreview] = useState();

  // const [openCanvasForPreviewAdvance, setOpenCanvasForPreviewAdvance] =
  //   useState();

  // const [doclistRerenderCount, setDoclistRerenderCount] = useState(0);
  const [selectedDataObject, setSelectedDataObject] = useState();
  const [subformElementIndex, setSubformElementIndex] = useState();
  const oldControl = useRef({});
  const setOldControl = (val) => {
    oldControl.current = val;
  }
  // const [currentDataObjectJson, setCurrentDataObjectJson] = useState({});

  const currentadvanceListview = useRef(undefined);

  function setCurrentadvanceListview(val) {
    currentadvanceListview.current = val;
  }

  axios.interceptors.request.use((config) => {
    let currentSubformParentJson = {};
    let isSubFormOpened = false;

    if (openCanvasForSubform === "advanceListviewFromScratch") {
      currentSubformParentJson = currentadvanceListview.current;
      isSubFormOpened = true;
    } else if (openCanvasForSubform === "subform") {
      currentSubformParentJson = currentButtonForSubform.current;
      isSubFormOpened = true;
    }

    const isMenu = currentSubformParentJson?.containerControl === "Menu";

    const isWizard =
      currentSubformParentJson?.containerControl === "wizard_v" ||
      currentSubformParentJson?.containerControl === "sidenavigation" ||
      currentSubformParentJson?.containerControl === "wizard_h";

    if (
      !isSubFormOpened &&
      (isMenu || isWizard) &&
      !(config?.data?.stepIndex || config?.data?.stepIndex === 0)
    ) {
      const menuIndexes = {
        stepIndex: "-1",
        subStepIndex: "-1",
        subChildMenuIndex: "-1",
      };

      menuIndexes.stepIndex =
        currentSubformParentJson?.stepIndex ||
        currentSubformParentJson?.stepIndex === 0
          ? currentSubformParentJson?.stepIndex
          : "-1";

      menuIndexes.subStepIndex =
        currentSubformParentJson?.subStepIndex ||
        currentSubformParentJson?.subStepIndex === 0
          ? currentSubformParentJson?.subStepIndex
          : "-1";

      menuIndexes.subChildMenuIndex =
        currentSubformParentJson?.subChildMenuIndex ||
        currentSubformParentJson?.subChildMenuIndex === 0
          ? currentSubformParentJson?.subChildMenuIndex
          : "-1";

      config.data = { ...config.data, ...menuIndexes };
    }
    return config;
  });
 
  const currentDataObjectJson = useRef({});

  function setCurrentDataObjectJson(obj) {
    currentDataObjectJson.current = obj;
  }

  // const [controlLabel, setControlLabel] = useState('');

  const controlLabel = useRef("");

  function setControlLabel(str) {
    controlLabel.current = str;
  }

  // const [openQuickToolFor , setOpenQuickToolFor] = useState(undefined);

  const openQuickToolFor = useRef(undefined);

  function setOpenQuickToolFor(obj) {
    openQuickToolFor.current = obj;
    dispatch(updateFormStateContextWithoutRender({name: "openQuickToolFor", value: obj, key: containerId}));
  }

  // const countRef = useRef(0);
  // useEffect(() => {
  //   countRef.current = countRef.current + 1;
  // });

  // const [currElemState.current, setCurrElem] = useState('');

  const currElemState = useRef(null);

  function setCurrElem(obj) {
    currElemState.current = obj;
  }

  function setAllNonFilledMandatoryFieldsFunc(arr) {
    setAllNonFilledMandatoryFields(arr);
  }
  // function fetchingChildren(event, dataC) {
  //   loading(true)
  //   //    async function fetchingChildren(data){
  //   // setSelectedDataObject(dataC)

  //   var treeName = "";

  //   if (dataC?.treeName) {
  //     treeName = dataC?.treeName;
  //   }

  //   // setChildVisiblity(!childVisible);
  //   // setShowMapButton(false);

  //   var ab = 1;

  //   // if(childVisible===false && ab === 0 )

  //   var currName = dataC.VariableName;
  //   var pName = dataC?.parentName ? dataC?.parentName + "." : "";

  //   // var parentname= pName + currName;

  //   var parentname = currName;

  //   var jsonToSend = {
  //     tableName: parentname,
  //     tableid: dataC.VariableId,
  //   };
  //   // var jsonToSend={"tableName":data.VariableName,"tableid":data.VariableId,  "parentName": (currName+pName)};
  //   // var jsonToSend={"tableName":"SanityTable"};

  //   //   fetchTableChildren(jsonToSend).then((response)=>{
  //   //     data.children=response.data["children"];
  //   //      setRenderInstant(data);
  //   // })

    
  //   axios1.post("/mdm-rest/app/gettabledefinition", {
  //     id: dataC ? (dataC.VariableId ? dataC.VariableId : "") : "",
  //     name: parentname || "",
  //     status: "1",
  //   }, {
  //     headers: {
  //       "Content-Type": "application/json",
  //     }
  //   })
  //     // .then(function (response) {
  //     //   return response.json();
  //     // })
  //     .then(function (content) {
  //       var data = JSON.stringify(content?.data?.data);
  //       let formId = getFormId();
  //       const jsonData = {
  //         formId: activePage?.formId || formId.toString(),
  //         data: `${data}`,
  //         treeName: treeName,
  //       };

  //       axios
  //         .post("/idesign/gettableDefinition", jsonData, {
  //           withCredentials: true,
  //         })
  //         .then((response) => {
  //           var childArray = [];

  //           dataC.children = response.data.children;

  //           if (response.data.children) {
  //             for (let child of response.data.children) {
  //               if (child?.MappingInfo) {
  //                 fetchingChildren("", child);
  //               }
  //             }
  //           }

  //           // setRenderInstant(dataC);
  //         })
  //         .catch(function (error) {
  //           if (error.response) {
  //           }
  //           //   alert(error);
  //           console.log("error is", error);
  //         });
  //         loading(false)
  //     })
  //     .catch((err) => {
  //       console.log("error is", err);
  //       loading(false)
  //     });
  // }

  const fetchingAllDataObjects = async (dataC) => {
    loading(true)
    const parentname = dataC?.VariableName

    const jsonData = {
      parentTableId: dataC ? (dataC?.VariableId ? dataC?.VariableId : "") : "",
      treeName: parentname || "",
      status: "1",
      formId: getFormId().toString()
    }

    let finalDataObjects = await axios
    .post("/idesign/gettableDefinition", jsonData, {
      withCredentials: true,
    })
    .then((response) => {
      console.log(response)
      return response?.data || {}
    })
    .catch((error) => {
      if(error.response){
      }
      console.log("error", error)
    })
    loading(false)
    return [finalDataObjects]
  }

    function navOnWizByArrowsKeys(){
      if(!window.navOnWizByArrowsKeysHook){
        return true
      }
      else if( window.navOnWizByArrowsKeysHook() === false ){
        return false
      }
      else{
        return true
      }
    }
  
  

  function fetchProcessDataObject(fromMarvin) {
    if (Object.keys(dataObjectsContent).length === 0 || fromMarvin) {
      if (microFrontendData?.componentType === "TF") {
        //  if(dataObjectsContent  && Object.keys(dataObjectsContent)?.length === 0)
        //{
        // setIsLoading(true)
        var jsonForProcess = {
          taskId: microFrontendData?.taskId,
          processdefId: microFrontendData?.processDefId,
          processState: microFrontendData?.statusType || "L",
          // "processName":microFrontendData?.processName
        };

        // fetchProcessTaskTemplate(jsonForProcess)
        // .then((response) => {

        //   setDataObjectsContent(response.data['children']);
        //   setfilteredDataObject(response.data['children']);
        //   setfilteredDataObjectCopy(response.data['children'])
        //     // setIsLoading(false)
        // })
        // .catch(
        //     function(error){
        //         console.log('Error :: ',error);
        //     }
        // )

        // }
      } else if (microFrontendData?.componentType === "GT") {
        // if(dataObjectsContent  && Object.keys(dataObjectsContent).length === 0)
        // {
        // setIsLoading(true)
        var jsonForProcess = {
          globalTemplateId: microFrontendData?.templateId,
        };

        // fetchProcessGlobalTemplate(jsonForProcess)
        // .then((response) => {

        //   setDataObjectsContent(response.data['children']);
        //   setfilteredDataObject(response.data['children']);
        //   setfilteredDataObjectCopy(response.data['children'])
        //     // setIsLoading(false)
        // })
        // .catch(
        //     function(error){
        //         console.log('Error :: ',error);
        //     }
        // )

        //  }
      } else {
        // if(dataObjectsContent  && Object.keys(dataObjectsContent).length === 0){
        // setIsLoading(true)
        var jsonForProcess = {
          processdefId: microFrontendData?.processId,
          processState: microFrontendData?.statusType,
          formId: microFrontendData?.formDefId,

          processName: microFrontendData?.processName,
        };

        fetchProcessModularData(jsonForProcess)
          .then((response) => {
            var processData = response.data;
            setCurrentDataObjectsContent(processData["children"])
            setDataObjectsContent(processData["children"]);
            setfilteredDataObject(processData["children"]);
            setfilteredDataObjectCopy(processData["children"]);
            props.setSearch("");
            //  setIsLoading(false)
          })
          .catch(function (error) {
            console.log("Error :: ", error);
          });
        //}
      }
    }
  }

  function updateDataObjectAfterCreate(DO,parentName,newObj){
    for(let item of DO){
      if(item.VariableName === parentName){
        item.children.push(newObj)
        return
      }
      if(item.children) { 
        return updateDataObjectAfterCreate(item.children,parentName,newObj)
      }
    }
  }

  function fetchDataObject(fromDoclist, fromReusable, fromMarvin) {
    if (
      (dataObjectsContent && Object.keys(dataObjectsContent).length === 0) ||
      window.updateDataObject || fromDoclist || fromReusable || fromMarvin
    ) {

      const jwtToken =
          JSON.parse(secureLocalStorage.getItem(isPortalLive ?  `launchpadKey_${applicationNameObj.applicationName}` || `launchpadKey_bypass_${applicationNameObj.applicationName}`  || "launchpadKey" : "launchpadKey"))?.token ||
        secureSessionStorage.getItem("Authorization") ||
        undefined;
      // const secureAutherization = secureLocalStorage.getItem("Authorization");
      // const secureAutherization1 = secureLocalStorage.getItem("launchpadKey");
      // const jwtToken = secureAutherization || JSON.parse(secureAutherization1)?.token || undefined;
      fetch("/mdm-rest/app/dataobjects", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          "Authorization": jwtToken,
        },
        body: JSON.stringify({
          // "parent_id":'29104',
          // "parent_id": `${props.appId}`,
          // "parent_id": `${props.appId}`,
          parent_id: childComp === "reusableFunction" ? props?.microFrontendData?.parentId : appId,
          type: "AP",
          sort_order: "A",
          order_by: "1",
          records_to_fetch: "30",
          mode: "tree",
        }),
      })
        .then(function (response) {
          if(response &&  response.setHeader){
            response.setHeader("Strict-Transport-Security", "max-age=31536000; includeSubDomains");
          }
          return response.json();
        })
        .then(function (content) {
          if (content.status.subject === "No Data Objects found.") {
            setCurrentDataObjectsContent([])
            setDataObjectsContent([]);
            setfilteredDataObject([]);
            setfilteredDataObjectCopy([]);
          } else {
            if (content.data.data_objects !== undefined) {
              var jsonDataSend = {
                data: content.data.data_objects,
              };
              var data = JSON.stringify(content.data.data_objects);
              let formId = getFormId();
              const jsonData = {
                formId:
                  activePage?.formId ||
                  activeSubForm?.fragementId ||
                  formId.toString(),
                data: `${data}`,
              };
              axios
                .post("/idesign/getDataObjectsforMapping", jsonData, {
                  withCredentials: true,
                })
                .then( async (response) => {
                  // setDataObjectsState(response.data);
                  // setDataObjectsContent(response.data);
                  const responseCheck1 = response?.data ? response : {};
                  const responseCheck2 = responseCheck1 ? (responseCheck1.data ?  responseCheck1.data : {}) : {};
                  let newDataResponseChildren = responseCheck2 ? (responseCheck2?.["children"] ?  responseCheck2?.["children"] : []) : [];

                  if (newDataResponseChildren) {
                    if(newDataResponseChildren?.length > 1){
                      showAlertConfirmNotifications({
                        'open':true,
                        'showConfirm':'showNotification',
                        'alertType':'error',
                        'alertContentKey': "Only one parent table is allowed. Please define the parent-child relation with the system-generated parent table."
                      });
                    } else {
                      for (let child of newDataResponseChildren) {
                        newDataResponseChildren = await fetchingAllDataObjects(child)
                        // fetchingChildren("", child);
                        setDataObjectsContent(newDataResponseChildren);
                        setfilteredDataObject(newDataResponseChildren);
                        setfilteredDataObjectCopy(newDataResponseChildren);
                        setCurrentDataObjectsContent(newDataResponseChildren)
                        // setDataLoaded(true);
                        window.updateDataObject = false;
                      }
                    }
                  }
                  // setDataObjectsContent(newDataResponseChildren);
                  // setfilteredDataObject(newDataResponseChildren);
                  // setfilteredDataObjectCopy(newDataResponseChildren);
                  // // setDataLoaded(true);
                  // window.updateDataObject = false;
                })
                .catch(function (error) {
                  if (error.response) {
                  }
                  // alert(error);
                  console.log("error is", error);
                });
            }
          }
        })
        .catch((err) => {
          console.log("error is", err);
        });
    }
  }
  // useEffect(() => {
  // }, [currentButtonForSubform.current]);

  // const [currentadvanceListview.current, setCurrentadvanceListview] =
  //   useState(undefined);

  const [loggedInUserData, setLoggedInUserData] = useState({
    loggedInUserName: "",
    lastLoggedInTime: "",
  });

  // useEffect(() => {
  //     var loginHeaderStructure = {
  //       id: "LoginHeader",
  //       elem_type: "LoginHeader",
  //       style: {},
  //     };
  //     // setLoginHeaderState(loginHeaderStructure);
  //     // if()
  //     setApplicationData((prev)=>{
  //       return {...prev,
  //       headerJSON: JSON.stringify(loginHeaderStructure)}
  //     });
  //     setHeaderJSON(loginHeaderStructure);
  // // },[applicationData]);
  // },[]);

  const gridStoreStates = {
    listViewAddRecordFrom: false, // if true - popup opened when clicked on add record button (new record mode), if false - popup opened when row is clicked (edit record mode); used to show/hode next/previous button on popup
    advanceListviewStateJson: undefined,  // used to store the current advance listview subform json in designer when advance listview detailed page is opened
    currentAdvanceListviewStateJson: undefined, // used to store the current advance listview json in preview when advance listview popup is opened
    subFormListviewJson: undefined,
    openCanvasForPreview: false, // used to check if advance Listview/button subform/listview popup is opened or not in preview mode
    openCanvasForPreviewAdvance: false, // used to check if advance Listview popup is opened or not in preview mode
    listviewClearState: false, // used to clear the local state of the listview controls
    advSaveAndContinue: false, // used to render table when "save and continue" button is clicked on advance listview
    selectedTableRow: {}, // used in open-transaction to get selected table and listview rows
    globalError: { isError: false, message: "" }, // used to display error message when table has duplicate value error and user tries to save workitem
    dataOfAdvFrom: new Map(), // used to disable the advanced listview popup buttons when child table has duplicate value error
    selectedRowIndex: -1, // used to get selected row index of listview
    selectedRowIndexAdvance: -1, // used to get selected row index of advance listview
    spareAdvanceListviewStateJson: undefined,
    spareAdvListviewPopupStyle: undefined, // used to store advanced listview popup style in designer of exact time when detailed page is opened.
    spareListviewPopupStyle: undefined, // used to store listview popupstyle in designer of exact time when subform is opened.
    showListviewPopupProperties: false,
    showAdvListviewPopupProperties: false, // used to store advanced listview state in designer of exact time when detailed page is opened.
    // currentadvanceListview: undefined // used to store the current advance listview json in designer when advance listview detailed page is opened
  }


  const initialState = {
    "containerInfo":{
        containerId:"default",
        containerIndex:0,
    },
    "data":[
        {
            key:"default",
            generalData:{},
            formstate:{},
            routeJourneySelectionPage:"",
            contexts:{
              mandatoryControls: [],
              activeStepName: '',
              activeSubStepName: '',
              updateJson: {},
              formState2: {},
              imageBaseURL: "",
              populateFormStateFromJsonOnAction: function(){},
              applicationNameObj: {
                  applicationName: "",
                  formName: ""
              },
              activeMenuId: null,
              setActiveMenuId: function(){},
              subformStack: [false],
              setSubformStack: function(){},
              currentListviewForSubform: undefined,
              setCurrentListviewForSubform: function(){},
              isTableBackdropOpen: false,
              setIsTableBackdropOpen: function(){},
              listviewFrameLayoutJsonClone_listviewMap: "",
              onDragStartOfSubform: function(){},
              elementToCreate: function(){},
              targetElemState: {
                  targetId: "",
                  targetClass: "",
                  targetElemType: "",
                  frameIndex: "",
                  targetRowId: "",
                  targetColId: "",
                  targetColParentId: "",
                  elementIndex: "",
                  sheetIndex: "",
                  sheetElementIndex: "",
              },
              onDragOfSubform: function(){},
              testClick: function(){},
              targetForDrop: function(){},
              drop: function(){},
              applyChanges: function(){},
              dragging: false,
              setDragging: function(){},
              deleteControl: function(){},
              changeSectionLayout: function(){},
              showProperties: false,
              setShowProperties: function(){},
              formState2: {},
              updateColumnWidth: function(){},
              handleReorderStart: function(){},
              handleReorderDrop: function(){},
              selected: {
                  id: "",
                  tempStatus: "",
              },
              setSelected: function(){},
              addColumn: function(){},
              device: "web",
              updateJson: {
                  updatedComponentInFormState: function(){},
                  removeAndUpdateComponentInFormState: function(){},
                  saveFormState: function(){},
              },
              showDataAdditionSection: false,
              setShowDataAdditionSection: function(){},
              draggedObjType: "",
              customControlIdList: [],
              setCustomControlIdList: function(){},
              setCurrElem: function(){},
              setSubFormState: function(){},
              setFormState2: function(){},
              isPortal: false,
              handleCustomControlId: function(){},
              changeCanvasLayout: function(){},
              changeCanvasLayoutforlistview : function(){},
              selectedControl: { elem_type: "" },
              setSelectedControl: function(){},
              draggedFrom: "",
              setDraggedFrom: function(){},
              openDrawer: false,
              setOpenDrawer: function(){},
              drawerPinned: false,
              setDrawerPinned: function(){},
              propertyPinned: false,
              setPropertyPinned: function(){},
              openProperties: false,
              setOpenProperties: function(){},
              showAlertConfirmNotifications: function(){},
              alertResponseMessage: function(){},
              setAlertResponseMessage: function(){},
              widthOfCanvasArea: "",
              setWidthOfCanvas: function(){},
              isMenuSubMenuAdded: false,
              setIsMenuSubMenuAdded: function(){},
              dataObjectJson: {},
              setDataObjectJson: function(){},
              dataObjects: {},
              setDataObjects: function(){},
              isMicroSerciceChecks: {
                  IsMicroserviceMode: "N",
                  MicroAuthParam: null,
                  MicroAuthToken: null,
              },
              setisMicroSerciceChecks: function(){},
              templateForm: false,
              setFormTemplate: function(){},
              activePage: "",
              setActivePage: function(){},
              activeSubForm: "",
              setActiveSubForm: function(){},
              activeApplication: undefined,
              showPagesSubForms: false,
              setShowPagesSubForms: function(){},
              allPages: [],
              setAllPages: function(){},
              allSubForms: [],
              setSubForms: function(){},
              setApplicationScreenshot: function(){},
              setActiveApplication: function(){},
              mappingDataObjectsMap: new Map(),
              DataObjectsArray: [],
              handleValueForConditionalVisibility: function(){},
              valueForConditionalVisibility: {},
              openLoader: false,
              setOpenLoader: function(){},
              toggleProperty: false,
              setToggleProperty: function(){},
              loginErrorPage: false,
              setLoginErrorPage: function(){},
              globalTime: {},
              setGlobalTime: function(){},
              sessionPopupTime: {},
              setSessionPopupTime: function(){},
              sessionTime: "",
              setSessionTime: function(){},
              formBuillderMode: "",
              successAndErrorMessageControlsListBasedOnAttribute:
                {},
              handleSuccessAndErrorMessageControlsListBasedOnAttribute:
                function(){},
              builderMode: "",
              setFormBuillderMode: function(){},
              applicationData: {},
              setApplicationData: function(){},
              getElementJson: function(){},
              headerJSON: {
                  id: "LoginHeader",
                  elem_type: "LoginHeader",
                  style: {},
              },
              setHeaderJSON: function(){},
              loggedInUserData: {
                  loggedInUserName: "",
                  lastLoggedInTime: "",
              },
              setLoggedInUserData: function(){},
              setMapValue: function(){},
              MapValue: "",
              MapId: "",
              setMapId: function(){},
              mappingControlsMap: new Set(),
              mappingControlsIdMap: new Set(),
              dataObjectsContent: {},
              setDataObjectsContent: function(){},
              recursiveJsonForImportSection: function(){},
              addColsToControlsForDataObjects: function(){},
              addColumnObj: function(){},
              addRowObj: function(){},
              currentButtonForSubform: undefined,
              setCurrentButtonForSubform: function(){},
              currentadvanceListview: undefined,
              getDeviceFromProps_mf: false,
              setCurrentadvanceListview: function(){},
              latestChangesSaved: true,
              setLatestChangesSaved: function(){},
              listviewColumnInfo: new Map([]),
              setlistviewColumnInfo: function(){},
              containerId: "default",
              openQuickToolFor: undefined,
              setOpenQuickToolFor: function(){},
              handleSubForm: function(){},
              openCanvasForSubform: false,
              showSubForm: false,
              setShowSubForm: function(){},
              allNonFilledMandatoryFields: [],
              setAllNonFilledMandatoryFields: function(){},
              setAllNonFilledMandatoryFieldsFunc: function(){},
              sectionInitiallyCollapsedState: {},
              setSectionInitiallyCollapsedState: function(){},
              allGridControlsIds: new Map(),
              setOpenMF: function(){},
              openMF: false,
              loginHeaderHeight: 0,
              setLoginHeaderHeight: function(){},
              canvasTop: 0,
              setCanvasTop:function(){},
              spareListviewStateJson: "",
              setSpareListviewStateJson: function(){},
              modeReadOrWrite: "W",
              maskingData: new Map(),
              maskingKeys: [],
              parentChildCustom: "",
              setParentChildCustom: "",
              dataClassAdvacnceListview: "",
              setDataClassAdvacnceListview: function(){},
              recursiveJsonForMapping: function(){},
              MapType: "",
              setMapType: function(){},
              subFormStateJson: "",
              spareSubForm: "",
              setSpareSubForm: function(){},
              setSubform_obj: function(){},
              setCurrentDataObjectJson: function(){},
              microFrontendComponentType: "",
              microFrontendData: {},
              appId: "",
              formMataData: {},
              isApp: function(){},
              processId: "",
              statusType: "",
              openingAsApplication: {},
              setSelectedDataObject: function(){},
              selectedDataObject: '',
              setSelectedItem: function(){},
              selectedItem: "",
              setCurrentMappedDO: function(){},
              currentMappedDO: [],
              webServiceResponse: "",
              setwebServiceResponse: function(){},
              filteredDataObject: [],
              setfilteredDataObject: function(){},
              setOpen1: function(){},
              setSeverity: function(){},
              setSeverityMessage: function(){},
              transactionId: 0,
              setTransactionId: function(){},
              setIsStep: function(){},
              isStep: {},
              setEventList: function(){},
              eventList: 0,
              setSelectedButtonEventId: function(){},
              selectedButtonEventId: "",
              setSubformElementIndex: function(){},
              setfromQuickProps: function(){},
              fromQuickProps: false,
              setCopyElement: function(){},
              copyElement: {},
              setfilteredDataObjectCopy: function(){},
              filteredDataObjectCopy: [],
              setRecordCount: function(){},
              recordCount: new Map(),
              appname: "",
              setTableRowData: function(){},
              tableRowData: {},
              recursiveJsonReaderForSubForm: function(){},
              max_ColumnValue: window.max_ColumnValue,
              max_RowValue: window.max_RowValue,
              setMax_controlIdValue: function(){},
              setUpdateDataObject: function(){},
              updateDataObject: false,
              fetchDataObject: function(){},
              setIsButtonSubformOpen: function(){},
              isButtonSubformOpen: false,
              cabinetName: "",
              setAlertData: function(){},
              setCurrentSubFormInWizard: function(){},
              setGlobalLoading: function(){},
              globalLoading: false,
              wizard_type_step: "-1",
              wizard_type_subStepIndex: "-1",
              wizard_type_subChildMenuIndex: "-1",
              set_wizard_type_step: function(){},
              set_wizard_type_subStepIndex: function(){},
              set_wizard_type_subChildMenuIndex: function(){},
              setGlobalLoadingMessage: function(){},
              globalLoadingMessage: false,
              setListviewInfoUpdated: function(){},
              listviewInfoUpdated: false,
              // setListviewModifyMode: function(){},
              // listviewModifyMode: false,
              parentWizardCheck: function(){},
              parentTab: function(){},
              parentMenuCheck:function(){},
              isTaskForm: false,
              QueryString: "",
              themeOpen: false,
              setThemeOpen: function(){},
              themeResetDone:false,
              setThemeResetDone:function(){},
              fixedFooter:false,
              setFixedFooter: function(){},
              setThemeResetValDone:function(){},
              themeResetValDone:false,
              isLoginTypeVar: false,
              setSelectionPage: function(){},
              selectionPage: "",
              updateDataObjectAfterCreate:function(){},
              landscapeView : "",
              homePage: "",
              t : function(){}
          },
            gdtoken:"",
            wizard_stage:"",
            witoken:"",
            isWorkItem:"",
            pid:"",
            formMataData:{},
        }
    ],
    "data2": [
        {
            key: "default",
            gridStates: gridStoreStates,
        }
    ],
    controlSelected: false,
    hoverColumn: false,
    noOfRows: 0,
    tempCanWidth: 0,
    displaySheets: undefined,
    renderAdvanceListView: false,
    tempCanWidthDesignPage: 0,
    tempCanHeightDesignPage: 0,
    devicePreview:'',
    doclistRerenderCount: false,
    renderListView: false,
    mandatoryControls: [],
    mandatoryControls1:[],
    renderCanvas: false,
    tempCanHeight: 0,
    appScreenshotSavedDetails:[],
    renderSection: false,
    isDesigner: false
};

useEffect(() => {
  if (!window?.loadMicroFrontend) {
    window?.loadIntegrator();
  }
  return(() => {
    if(!externalIformUrl?.includes("afb_subform") && (window.isDesigner || isPortalLive)) {
      resetRedux(containerId,{},true);
    }

    const { windowScreenObjects } = getReduxContexts();
      for(let i = 0 ; windowScreenObjects[i] ; i++){
        const win = windowScreenObjects[i];
        if(win.close)
          win.close();
      }      

    if(window?.temporaryVariables){
      delete window?.temporaryVariables
    }
    if(window?.tabIndex) {
      delete window?.tabIndex;
    }
  })
}, []);

  

  useEffect(() => {
    var loginHeaderStructure = {
      id: "LoginHeader",
      elem_type: "LoginHeader",
      style: {},
    };

    if (
      applicationData?.headerJSON !== undefined &&
      applicationData?.headerJSON !== null
    ) {
      setHeaderJSON(JSON.parse(applicationData?.headerJSON));
    }
    // setLoginHeaderState(loginHeaderStructure);
    // if()
    // setApplicationData({
    //   ...applicationData,
    //   headerJSON: JSON.stringify(loginHeaderStructure),
    // });
  }, [applicationData]);

  const { t } = useTranslation(["styles", "translation"]);

  function handleValueForConditionalVisibility(id, value) {
    setValueForConditionalVisibility((prev) => {
      return { ...prev, [id]: value };
    });
  }

  function handleDragStart(e) {
    e.preventDefault();
    const draggedItem = e.target.id;
    // setDragging(draggedItem);
  }

  function checkForMutation(node, callback, config) {
    const targetNode = document.querySelector(node);

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  // observer.disconnect();

  // const targetNode = document.getElementById("some-id");

  // Options for the observer (which mutations to observe)
  // const config = { attributes: true, childList: true, subtree: true };

  // const callback = (mutationList, observer) => {
  //   for (const mutation of mutationList) {
  //     if (mutation.type === "childList") {
  //       console.log("A child node has been added or removed.");
  //     } else if (mutation.type === "attributes") {
  //       console.log(`The ${mutation.attributeName} attribute was modified.`);
  //     }
  //   }
  // };

  function handleDragging() {
    // setDragging(!dragging);
  }

  function handleRemoveGrid() {
    // setDragging(false);
  }

  function handleDragOver(e) {
    e.preventDefault();
  }

  function handleItemDrop(e) {
    e.preventDefault();
    // const dropedOn=e.target.name;
    const dropedOn = e.target.getAttribute("name");

    if (data.length === 0) {
      setData([...data, dragging]);
    } else if (data.length !== 0 && dropedOn !== undefined) {
      setData([...data, dragging]);
    } else {
    }
  }

  var targetElemState = {
    targetId: "",
    targetClass: "",
    targetElemType: "",
    frameIndex: "",
    targetRowId: "",
    targetColId: "",
    targetColParentId: "",
    elementIndex: "",
    sheetIndex: "",
    sheetElementIndex: "",
  };

  var activeForDrop = {
    isDropActive: false,
    dropped: false,
  };

  var externalIformUrl = "";
   
  // if(document && ( document?.URL || document?.baseURI || document?.documentURI ) ){
  //   externalIformUrl = document?.URL || document?.baseURI || document?.documentURI;
  // }
  // else{
    externalIformUrl = window.location.href;
  // }
  
  //stores form state
  const [formState2, setFormStateNew] = useState({});

  const setFormState2 = (val) => {
    setFormStateNew(val);
    setFormStateWrapper(val);
  }
  // const [themeDetails, setThemeDetails] =  useState({
  //     'systemDefinedThemes' : [],
  //     'userDefinedThemes' : [],
  //     'appliedTheme' : {}
  // });

  const themeDetails = useRef({
    systemDefinedThemes: [],
    userDefinedThemes: [],
    appliedTheme: {},
  });

  function setThemeDetails(obj) {
    themeDetails.current = obj;
  }

  const [dropState, setDropState] = useState({
    droppedOn: "",
    droppedElemType: "",
    droppedStatus: false,
  });

  var i = 0;

  useEffect(() => {
    if (i === 0) {
      if (dropState.droppedStatus) {
        setCurrentDataObjectJson(cloneDeep({}));
        //customalert
        // alert('Dropped '+dropState.droppedElemType+' on '+dropState.droppedOn);
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: `Dropped ${dropState.droppedElemType} on ${dropState.droppedOn}`,
        });
      } else {
        //alert('Coldn\'t drop '+dropState.droppedElemType+' on '+dropState.droppedOn);
      }
    }
    i++;
  }, [dropState.droppedStatus]);

  const undoList = useRef([]);

  function setUndoList(arr) {
    undoList.current = arr;
  }

  function resetUndoList (){
    undoList.current = [];
  }

  // const [redoList, setRedoList] = useState([]);

  const redoList = useRef([]);

  function setRedoList(arr) {
    redoList.current = arr;
  }

  function resetRedoList (){
    redoList.current = [];
  }

  const [presentState, setPresentState] = useState(formState2);
  const [toBePushed, setToBePushed] = useState(true);
  const [undoRedoListMaxSize] = useState(200);

  const [dataObjectJson, setDataObjectJson] = useState({});
  const [dataObjects, setDataObjects] = useState({});
  const [dataObjectJsonCheck, setDataObjectJsonCheck] = useState({});
  const [tableRowData, setTableRowData] = useState({});
  const [updateDataObject, setUpdateDataObject] = useState(false);
  const [dataObjectsContent, setDataObjectsContent] = useState({});
  const [filteredDataObjectCopy, setfilteredDataObjectCopy] = useState([]);
  const [mappingDataObjectsMap, setMappingDataObjectsMap] = useState(new Map());
  const [DataObjectsArray, setDataObjectsArray] = useState([]);

  const [mappingControlsMap, setMappingControlsMap] = useState(new Set());

  const [mappingControlsIdMap, setMappingControlsIdMap] = useState(new Set());

  const [listviewColumnInfo, setlistviewColumnInfo] = useState(new Map([]));

  const [MapValue, setMapValue] = useState("");

  const [MapType, setMapType] = useState("");

  const [MapId, setMapId] = useState("");

  // const [listviewClearState, setListviewClearState] = useState(false);
  const [isMenuSubMenuAdded, setIsMenuSubMenuAdded] = useState(false);

  // const [selectedRowIndex, setSelectedRowIndex] = useState(-1);
  // const [selectedRowIndexAdvance, setSelectedRowIndexAdvance] = useState(-1);

  const [allGridControlsIds, setAllGridControlsIds] = useState(new Map());

  // const [currentAdvanceListview, setCurrentAdvanceListview] = useState();

  const [maskingData, setMaskingData] = useState(new Map());
  const [maskingKeys, setMaskingKeys] = useState([]);
  const [parentChildCustom, setParentChildCustom] = useState("");
  const [isTableBackdropOpen, setIsTableBackdropOpen] = useState(false);

  const [dataClassAdvacnceListview, setDataClassAdvacnceListview] = useState();

  const [selectedButtonEventId, setSelectedButtonEventId] = useState("");
  // const [existingFormId,setExistingFormId]=useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [mappedWSList, setMappedWSList] = useState([]);
  const [currentMappedDO, setCurrentMappedDO] = useState([]);
  const [webServiceResponse, setwebServiceResponse] = useState();
  const [filteredDataObject, setfilteredDataObject] = useState([]);
  const [open1, setOpen1] = useState(false);
  const [severity, setSeverity] = useState({ type: "", message: "" });
  const [severityMessage, setSeverityMessage] = useState("");
  // const [hoverColumn, setHoverColumn] = useState(false);
  // const [mandatoryControls, setMandatoryControls] = useState([]);
  const [isButtonSubformOpen, setIsButtonSubformOpen] = useState(false);
  // const [listviewMandatoryControls, setListviewMandatoryControls] = useState(
    // []
  // );
  // const [currentAdvanceListviewJSON, setCurrentAdvanceListviewJSON] =
  //   useState();
  const [isStep, setIsStep] = useState(
    formState2?.isStep ? formState2?.isStep : {}
  );
  // const [recordCount, setRecordCount] = useState(0);
  const recordCount = useRef(new Map());
  const headerJsonNew = useRef({});

  function setRecordCount(controlId, check) {
    recordCount.current.set(controlId, { isUpdated: check });
  }

  const handleUndoRedo = (event) => {
    var value = event.target.value || event.target.getAttribute("value");

    if (value === "undo" && undoList.current.length > 0) {
      if (undoList.current.length < undoRedoListMaxSize) {
        return handleUndo();
      } 
      else {
        //customalert
        setCurrentDataObjectJson(cloneDeep({}));
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "REACH_BEGIN_FORM",
        });
        // alert("You reached to beginning of designing form.")
      }
    } 
    else if (value === "redo" && redoList.current.length > 0) {
      if (undoList.current.length < undoRedoListMaxSize) {
        return handleRedo();
      } else {
        //customalert
        setCurrentDataObjectJson(cloneDeep({}));
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "REACH_END_FORM",
        });
        // alert("You reached to end of designed form. Add more controls to design.")
      }
    }
  };

  // const handleUndo = () => {
  //   var temp_undoList = [];
  //   temp_undoList.push(...undoList.current);
  //   var futureState = temp_undoList.pop();
  //   var currentState = temp_undoList[temp_undoList.length - 1];
  //   if (typeof currentState !== "undefined") {
  //     var temp_redoList = [];
  //     temp_redoList.push(...redoList.current);
  //     temp_redoList.unshift(futureState);
  //     setToBePushed(false);
  //     setUndoList(temp_undoList);
  //     setRedoList(temp_redoList);
  //     setPresentState(currentState);
  //     setFormState2(Object.assign({}, JSON.parse(currentState)));
  //     // return {'undoList.currentLength':temp_undoList.current.length,'redoListLength':temp_redoList.length};
  //   }
  // };

  const handleUndo = async () => {
    var temp_undoList = [...undoList.current];
    // temp_undoList.push(...undoList.current);

    var currentState = temp_undoList[temp_undoList.length - 2];

    console.log("currentState", currentState);

    const performAction = await populateFormStateFromJsonOnAction(currentState);
    if(performAction){
      var futureState = temp_undoList.pop();

      if (typeof currentState !== "undefined") {
        var temp_redoList = [...redoList.current];
          temp_redoList.push(futureState);

          setToBePushed(false);
          setUndoList(temp_undoList);
          setRedoList(temp_redoList);
          setPresentState(currentState);
          // populateFormStateFromJsonOnUndoRedo(currentState);
          // setFormState2(Object.assign({}, JSON.parse(currentState)));
          // setToBePushed(true);

      }
    }
  }

  const handleRedo = async () => {
    var temp_redoList = [...redoList.current];
    // temp_redoList.push(...redoList.current);
    var currentState = temp_redoList[temp_redoList.length - 1];
    const performAction= await populateFormStateFromJsonOnAction(currentState);
    if(performAction){
      var futureState = temp_redoList.pop();
      
      if (typeof currentState !== "undefined") {
      var temp_undoList = [...undoList.current];

      temp_undoList.push(futureState);

      setUndoList(temp_undoList);
      setRedoList(temp_redoList);
      setPresentState(futureState);
      // setFormState2(Object.assign({}, JSON.parse(currentState)));
      setToBePushed(true);
      }
    }
  };

  async function populateFormStateFromJsonOnAction(newFormBuffer, str = ""){
    const formId= getFormId();
    const id= `${JSON.parse(newFormBuffer).formId}`;

    const repopulateJson = {
      formId: formId || id,
      formJson: newFormBuffer
    };

    const callResponse =  await axios
      .post(
        "/idesign/populateFormStateFromJson",
        sanitizeJson(repopulateJson),
        { withCredentials: true }
      )
      .then((response) => {
        fetchProcessVariables(str);
        setFormstateChangedByUser(false);
        setFormState2(Object.assign({}, JSON.parse(newFormBuffer) ));
        return true;
      })
      .catch((err) => {
        console.log(err);
        setAlertData({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentMsg: "There is some issue at server end",
          autoHideDuration: 6000,
        });
        return false;
      });
    return callResponse;
  }

  const [updatedCol, setUpdatedCol] = useState(false);

  // const formStateChangeCount = useRef(0);

  // const selectedTableRow = useRef({});

  // function setselectedTableRow(val){
  //   selectedTableRow.current=val;
  // }

  // const [selectedTableRow, setselectedTableRow]= useState({});

  // function setselectedTableRowfunction(value, key){
  //   var temp_selectedTableRow = {...setselectedTableRow};
  //   temp_selectedTableRow[key]=value;

  //   setselectedTableRow(prev => {
  //     // return {...prev, [key]: value} 
  //     return temp_selectedTableRow
  //   });
  // }

  // function increaseFormStateChangeCount(){
  //   formStateChangeCount.current = formStateChangeCount.current+1;
  // }

  // const formstate1 = useRef({});

  // function setformstate1(val){
  //   formstate1.current = val;
  // }

  const [openMF, setOpenMF] = useState(false);

  function setFormStateOnOpen(value){

    setFormstateChangedByUser(false);

    var temp_formdataonload = Object.assign({}, value);
    temp_formdataonload = JSON.stringify(temp_formdataonload);

    setUndoList([...undoList.current, temp_formdataonload]);

    setFormState2(()=>value);
  }

  function setFormStateByUser(value){

    setFormstateChangedByUser(true);

    var temp_formdataonload = Object.assign({}, value);
    temp_formdataonload = JSON.stringify(temp_formdataonload);

    setUndoList([...undoList.current, temp_formdataonload]);

    setFormState2(()=>value);
  }


  const formstateChangedByUser = useRef(false);

  function setFormstateChangedByUser(val){
    formstateChangedByUser.current = val;
  }

  useEffect(() => {
    //for undo redo on user actions
    if(formstateChangedByUser.current===true && childComp === "app"){

      if (toBePushed === true) {
        var temp_formdata = Object.assign({}, formState2);
        temp_formdata = JSON.stringify(temp_formdata);

        if (!undoList.current.includes(temp_formdata) && temp_formdata !== "{}"){
          setUndoList([...undoList.current, temp_formdata]);
          setRedoList([]);
        }
      } 
      else if (
        toBePushed === false &&
        presentState !== JSON.stringify(formState2)
      ) {
        // setRedoList((prev) => []);
        var temp_formdata = Object.assign({}, formState2);
        temp_formdata = JSON.stringify(temp_formdata);
        if (!undoList.current.includes(temp_formdata) && temp_formdata !== "{}"){
          // setUndoList(prev=> [...prev, temp_formdata]);
          setUndoList([...undoList.current, temp_formdata]);
          setRedoList([]);
          setToBePushed(true);
        }
      }
    }
  }, [formState2, updatedCol]);

  console.log("undoRedoList", undoList.current, redoList.current);

  //stores the classname that need to remove the highlight class for before and after row indicator
  var toBeClearedClassName;


  useEffect(() => {
  dispatch(updateStateInRedux({name: "isDesigner", key: containerId, value: (childComp === "app" || childComp === "application" || activePage || activeSubForm) && !getGdToken() && !getWIToken()}));
  if(childComp === "subForm") {
    setContextOnSubFormLoad();
  }
},[childComp, activePage, activeSubForm ])
  //finds the target for drop and sets id, class and elemType to be created
  const targetForDrop = (ev,addContainer,generatePage) => {
    // if(drawerPinned===false){
    //     setOpenDrawer(false);
    // }
    //implementing new near indicator thing concept
    // setHoverColumn(true);
    // if(addContainer || generatePage){
    //   if(document.getElementById("emptyScreen")){
    //     document.getElementById("emptyScreen").style.display="none"
    //   }
    // } 
    // setDragCounter(prevCounter => prevCounter + 1);
    // dragCounter.current += 1;
    // setEmptyScreen(false)
    // dispatch(updateStateInRedux({name: "emptyScreen", key: containerId, value: false}));
    if(window.changeEmptyScreen && window.emptyScreen1 === true)
    window.changeEmptyScreen(false);
    console.log('Drop:', 0);
    // dispatch(updateStateInRedux({name: "hoverColumn", key: containerId, value: true}));
    window.changeDrawer("close");

    window.containerSizesOnDrop.column_size_web = ev.target
      .closest("[elem_type=frame]")
      ?.getAttribute("w");
    window.containerSizesOnDrop.column_size_tablet = ev.target
      .closest("[elem_type=frame]")
      ?.getAttribute("sm");
    window.containerSizesOnDrop.column_size_mobile = ev.target
      .closest("[elem_type=frame]")
      ?.getAttribute("xs");

    var x1, y1, x2, y2;
    y1 = ev.clientY - 10; //x1 = ev.clientX-5;
    y2 = ev.clientY + 10; //x2 = ev.clientX+5;

    var classOrId = ".dropzone";
    var htmlElement = document;
    var returnedVal = htmlElemsFallingBtwCords(
      htmlElement,
      x1,
      y1,
      x2,
      y2,
      classOrId
    );

    if (returnedVal) {
      let Id = returnedVal.getAttribute("id");
      let parentId = ev?.target?.parentNode?.getAttribute("id")
      let parentElemType = ev?.target?.parentNode?.getAttribute("elem_type")
      targetElemState.targetRowId = "";
      targetElemState.targetColId = "";
      if (Id === null || Id.endsWith("_highlight_me")) {
        Id = $(returnedVal).attr("control_id");
      }
      if (
        Id !== null &&
        Id !== undefined &&
        (Id.startsWith("after_") || Id.startsWith("before_"))
      ) {
        if(Id.includes("after_column") || Id.includes("before_column")){
          targetElemState.targetColId = Id;
          targetElemState.targetId = parentId;
          targetElemState.targetColParentId = parentId;
          targetElemState.targetElemType = parentElemType;
        }else if(Id.includes("after_row") || Id.includes("before_row")){
          targetElemState.targetRowId = Id;
        }
        if ($(ev.target).attr("elem_type") === "row") {
          Id = $(ev.target).attr("row_id");
        } else if($(ev.target).attr("elem_type") === "column") {
          Id = $(ev.target).attr("col_id");
        } else {
          Id = $(returnedVal).attr("parent_id");
        }
      }
      let Class = returnedVal.getAttribute("class");
      if (Class === null || Class === undefined) {
        Class = "";
      }
      let ElemType = returnedVal.getAttribute("elem_type");
      if (ElemType === null || ElemType === undefined) {
        ElemType = "";
      }
      let frameIndex = returnedVal.getAttribute("frameindex");
      if (!targetElemState.targetId.match(Id)) {
        targetElemState.targetId = Id;
        targetElemState.targetClass = Class;
        targetElemState.targetElemType = ElemType;
        targetElemState.frameIndex = frameIndex;
        toBeClearedClassName = Class;
        // con
        if (
          ev.target.getAttribute("elementindex") !== null &&
          ev.target.getAttribute("sheetindex") !== null
        ) {
          targetElemState.elementIndex = ev.target.getAttribute("elementindex");
          targetElemState.sheetIndex = ev.target.getAttribute("sheetindex");
        } else {
          delete targetElemState.sheetIndex;
        }

        if (
          ev.target.getAttribute("sheetelementindex") &&
          ev.target.getAttribute("sheetelementindex") !== null
        ) {
          targetElemState.sheetElementIndex =
            ev.target.getAttribute("sheetelementindex");
        } else {
          delete targetElemState.sheetElementIndex;
        }
      }
    } else {
      let Id = ev?.target?.getAttribute("id");
      let parentId = ev?.target?.parentNode?.parentNode?.getAttribute("id")
      let parentElemType = ev?.target?.parentNode?.parentNode?.getAttribute("elem_type")
      targetElemState.targetRowId = "";

      if (Id === null || Id.endsWith("_highlight_me")) {
        Id = $(ev.target).attr("control_id");
      }
      if (
        Id !== null &&
        Id !== undefined &&
        (Id.startsWith("after_") || Id.startsWith("before_"))
      ) {
        if(Id.includes("after_column") || Id.includes("before_column")){
          targetElemState.targetColId = Id;
          targetElemState.targetColParentId = parentId;
          targetElemState.targetId = parentId;
          targetElemState.targetElemType = parentElemType;
        }else if(Id.includes("after_row") || Id.includes("before_row")){
          targetElemState.targetRowId = Id;
        }
        if ($(ev.target).attr("elem_type") === "row") {
          Id = $(ev.target).attr("row_id");
        } else if($(ev.target).attr("elem_type") === "column") {
          Id = $(ev.target).attr("col_id");
        } else {
          Id = $(ev.target).attr("parent_id");
        }
      }
      let Class = ev.target.getAttribute("class");
      if (Class === null || Class === undefined) {
        Class = "";
      }
      let ElemType = ev.target.getAttribute("elem_type");
      if (ElemType === null || ElemType === undefined) {
        ElemType = "";
      }
      let frameIndex = ev.target.getAttribute("frameindex");
      if (frameIndex === null) {
        frameIndex =
          ev.currentTarget
            ?.closest(`[elem_type=frame]`)
            ?.getAttribute("frameindex") ||
          ev.currentTarget
            ?.closest(`[elem_type=section]`)
            ?.getAttribute("frameindex");
      }
      // if(oldFrameIndex!==undefined && oldFrameIndex!==null && (frameIndex===null || frameIndex===undefined || frameIndex==="")){
      //     oldFrameIndex=ev.currentTarget?.closest(`[elem_type=frame]`)?.getAttribute("frameindex") || ev.currentTarget?.closest(`[elem_type=section]`)?.getAttribute("frameindex");
      // }
      // if(frameIndex===null || frameIndex===undefined || frameIndex===""){
      // }

      // targetElemState.frameIndex= frameIndex;

      if (Id !== null && Id !== undefined) {
        // cons
        // if(!targetElemState.targetId.match(Id)){
        targetElemState.targetId = Id;
        targetElemState.targetClass = Class;
        targetElemState.targetElemType = ElemType;
        // if(frameIndex!==null || frameIndex!==undefined ){
        targetElemState.frameIndex = frameIndex;
        // }
        if (!activeForDrop.isDropActive) {
          activeForDrop.isDropActive = true;
        }
        if (
          ev.target.getAttribute("elementindex") !== null &&
          ev.target.getAttribute("sheetindex") !== null
        ) {
          targetElemState.elementIndex = ev.target.getAttribute("elementindex");
          targetElemState.sheetIndex = ev.target.getAttribute("sheetindex");
        } else {
          delete targetElemState.sheetIndex;
        }
        if (
          ev.target.getAttribute("sheetelementindex") &&
          ev.target.getAttribute("sheetelementindex") !== null
        ) {
          targetElemState.sheetElementIndex =
            ev.target.getAttribute("sheetelementindex");
        } else {
          delete targetElemState.sheetElementIndex;
        }
        // }
      } else {
        if (activeForDrop.isDropActive) {
          activeForDrop.isDropActive = true;
        }
      }
    }

    if(openCanvasForSubform && targetElemState.targetId?.includes('button')) {
      targetElemState.targetId = "design_page";
      targetElemState.targetElemType = "Design Page";
    }
    if (ev.target.id) {
      ev.preventDefault();
    }
  };

  //stores the value in formdata
  const elementToCreate = (event, inptype, headerJson = "") => {
    const elem1 = event.target.getAttribute("inptype");
    const elem2 = event.target.getAttribute("controlLabel");

    try {
      event?.dataTransfer?.setData("text/plain", event?.currentTarget?.id);
    } catch (e) {
      console.log("It's browser issue", e)
    }
    

    if (headerJson !== undefined)
      if (headerJson !== "") {
        headerJsonNew.current = { ...headerJson };
      }
    if (inptype !== undefined) {
      if (inptype === "section") setCurrElem(inptype);
    } else {
      // currElemState = event.target.getAttribute('inptype');
      setCurrElem(elem1);
    }

    setControlLabel(elem2);
    if (elem1 === "dataObject") {
    }
  };

  const handleClose2 = (event) => {
    setAlert({ open: false });
  };

  const newCurrentChildren = () => {
    let newElement = {}; // crating the new component to be dropped
    newElement.id = createUniqueId(currElemState.current);
    newElement.style = {};
    newElement.class = {};
    newElement.children = [];
    newElement.elementType = currElemState.current;
    return newElement;
  };

  //creates new element entry in formState2
  const createNewElement2 = () => {
    ///getting current elemType to create element and set it's properties

    //getting target element info to find the way upto the target children to save data there
    // const targetId= targetElem.targetId;
    // const targetClass= targetElem.targetClass;
    // const targetElemType= targetElem.targetElemType;

    //getting the form state from hook
    var newFormState2Formdata = {
      ...formState2.formdata,
    };

    let newElement = newCurrentChildren(); // crating the new component to be dropped
    if (targetElemState.targetId === "targetCanvas") {
      //looking first inside parent container
      //pushing into absolute parent's children
      //wrapper
      newFormState2Formdata.children.push(newElement);
      setFormState2({ formdata: newFormState2Formdata });
    } else {
      if (newFormState2Formdata.children.length === 0) {
        //if parent container have no children
        //     newFormState2Formdata.children.push(newElement);
        // setFormState2({formdata:newFormState2Formdata});
      } else {
        //if parent component have children
        //also we will check for the parent id, if it was dropped in
        //we need to find where it needs to go using targetId and targetType, to check if the target type is droppable or not
        if (targetElemState.targetId.match("targetCanvas")) {
          newFormState2Formdata.children.push(newElement);
        } else {
          newFormState2Formdata.children.map((insideElem, index) => {});
        }
        setFormState2({ formdata: newFormState2Formdata });
      }
    }
  };

  const drag = (ev) => {
    const elem = ev.target.getAttribute("type");
    const targetId = ev.target.getAttribute("id");
    let element = document.getElementById(targetId);
    if (element !== undefined) {
      element.classList.add("mystyle");
    }
  };

  const dragLeaveFunction = (ev) => {
    const targetId = ev.target.getAttribute("id");
    let element = document.getElementById(targetId);
    if (element !== undefined) {
      element.classList.add("mystyle");
    }
    element.classList.remove("mystyle");
  };

  var undoRedoArr = [];

  function convertElementIndex(jsonData) {
    if (Array.isArray(jsonData)) {
      jsonData.map((item, index) => {
        if (
          item["elem_type"] === "textbox" ||
          item["elem_type"] === "textarea" ||
          item["elem_type"] === "radio" ||
          item["elem_type"] === "combo" ||
          item["elem_type"] === "checkbox" ||
          item["elem_type"] === "datepick" ||
          item["elem_type"] === "listbox" ||
          item["elem_type"] === "slider" ||
          item["elem_type"] === "toggle" ||
          item["elem_type"] === "CustomControl" ||
          item["elem_type"] === "button" ||
          item["elem_type"] === "label" ||
          item["elem_type"] === "paragraph" ||
          item["elem_type"] === "table" ||
          item["elem_type"] === "listview" ||
          item["elem_type"] === "advancelistView" ||
          item["elem_type"] === "image" ||
          item["elem_type"] === "imagecarousel" ||
          item["elem_type"] === "tab" ||
          item["elem_type"] === "iframe"
        ) {
          let elemtIndexItem = item.elementIndex.toString();
          item.elementIndex = elemtIndexItem;

          let frameIndexItem = item.frameIndex.toString();
          item.frameIndex = frameIndexItem;
        }

        if (Object.keys(item).includes("children")) {
          convertElementIndex(item);
        }
      });
    } else {
      convertElementIndex(jsonData["children"]);
    }

    return jsonData;
  }

  var foundjson = [];
  function findJsonNew(formStatejson, activeId) {
    if (
      formStatejson !== undefined &&
      formStatejson !== null &&
      activeId !== "" &&
      activeId !== undefined &&
      activeId !== null
    ) {
      if (
        formStatejson.children !== undefined &&
        formStatejson.children !== null
      ) {
        formStatejson.children.map((child) => {
          if (child !== null && child !== undefined) {
            // if(child.elem_type !== undefined){
            if (child.elem_type === activeId) {
              // if(child.children)
              //   if(child.children.length === 0 && flag === 0){
              foundjson.push(child.id);
              //   flag = 1
              //   }
            }
            // }
            else if (child.children) {
              findJsonNew(child, activeId);
            }
          }
        });
      }
      // else {
      //   formStatejson &&
      //     formStatejson.map((item) => {
      //       if (item.elem_type === activeId) {
      //         foundjson.push(item.id);
      //       }
      //     });
      // }
    }
    return foundjson;
  }

  const eventList = useRef(0);

  function setEventList(obj) {
    eventList.current = obj;
  }

  // function moveArrayItemToNewIndex(arr, old_index, new_index) {
  //     if (new_index >= arr.length) {
  //         var k = new_index - arr.length + 1;
  //         while (k--) {
  //             arr.push(undefined);
  //         }
  //     }
  //     arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  //     return arr;
  // };

  var foundjson1 = [];
  function findJsonNew1(formStatejson, activeId, currFrameId) {
    if (
      formStatejson !== undefined &&
      formStatejson !== null &&
      activeId !== "" &&
      activeId !== undefined &&
      activeId !== null
    ) {
      if (
        formStatejson.children !== undefined &&
        formStatejson.children !== null
      ) {
        formStatejson.children.map((child) => {
          if (child !== null && child !== undefined) {
            // if(child.elem_type !== undefined){
            if (child.elem_type === activeId && child.id !== currFrameId) {
              // if(child.children)
              //   if(child.children.length === 0 && flag === 0){
              if (child.frameIndex && child.id !== currFrameId) {
                child.frameIndex = parseInt(child.frameIndex) + 1;
                child.frameIndex += "";
              }
              if (child.children) {
                findJsonNew1(child.children, activeId, currFrameId);
              }
              if (child.tileContents) {
                findJsonNew1(child.tileContents, activeId, currFrameId);
              }
              //   flag = 1
              //   }
            }
            // }
            else if (child.frameIndex && child.id !== currFrameId) {
              child.frameIndex = parseInt(child.frameIndex) + 1;
              child.frameIndex += "";
              if (child.children) {
                findJsonNew1(child.children, activeId, currFrameId);
              }
              if (child.tileContents) {
                findJsonNew1(child.tileContents, activeId, currFrameId);
              }
            } else if (child.children && child.id !== currFrameId) {
              findJsonNew1(child.children, activeId, currFrameId);
            } else if (child.tileContents && child.id !== currFrameId) {
              findJsonNew1(child.tileContents, activeId, currFrameId);
            }
          }
        });
      } else {
        formStatejson &&
          formStatejson.map((item) => {
            if (item.elem_type === activeId && item.id !== currFrameId) {
              if (item.frameIndex) {
                item.frameIndex = parseInt(item.frameIndex) + 1;
                item.frameIndex += "";
              }
              if (item.children) {
                findJsonNew1(item.children, activeId, currFrameId);
              }
              if (item.tileContents) {
                findJsonNew1(item.tileContents, activeId, currFrameId);
              }
            } else if (item.frameIndex && item.id !== currFrameId) {
              item.frameIndex = parseInt(item.frameIndex) + 1;
              item.frameIndex += "";
              if (item.children) {
                findJsonNew1(item.children, activeId, currFrameId);
              }
              if (item.tileContents) {
                findJsonNew1(item.tileContents, activeId, currFrameId);
              }
            } else if (item.children && item.id !== currFrameId) {
              findJsonNew1(item.children, activeId, currFrameId);
            } else if (item.tileContents) {
              findJsonNew1(item.tileContents, activeId, currFrameId);
            }
          });
      }
    }
    return formStatejson;
  }

  function findJsonNew2(formStatejson, activeId, currFrameId, frameNo) {
    if (
      formStatejson !== undefined &&
      formStatejson !== null &&
      activeId !== "" &&
      activeId !== undefined &&
      activeId !== null
    ) {
      if (
        formStatejson.children !== undefined &&
        formStatejson.children !== null
      ) {
        formStatejson.children.map((child) => {
          if (child !== null && child !== undefined) {
            // if(child.elem_type !== undefined){
            if (child.elem_type === activeId && child.id !== currFrameId) {
              // if(child.children)
              //   if(child.children.length === 0 && flag === 0){
              if (
                child.frameIndex &&
                child.id !== currFrameId &&
                child.frameIndex >= frameNo
              ) {
                child.frameIndex = parseInt(child.frameIndex) + 1;
                child.frameIndex += "";
              }
              if (child.children) {
                findJsonNew2(child.children, activeId, currFrameId, frameNo);
              }
              if (child.tileContents) {
                findJsonNew2(
                  child.tileContents,
                  activeId,
                  currFrameId,
                  frameNo
                );
              }
              //   flag = 1
              //   }
            }
            // }
            else if (
              child.frameIndex &&
              child.id !== currFrameId &&
              child.frameIndex >= frameNo
            ) {
              child.frameIndex = parseInt(child.frameIndex) + 1;
              child.frameIndex += "";
              if (child.children) {
                findJsonNew2(child.children, activeId, currFrameId, frameNo);
              }
              if (child.tileContents) {
                findJsonNew2(
                  child.tileContents,
                  activeId,
                  currFrameId,
                  frameNo
                );
              }
            } else if (child.children && child.id !== currFrameId) {
              findJsonNew2(child.children, activeId, currFrameId, frameNo);
            } else if (child.tileContents && child.id !== currFrameId) {
              findJsonNew2(child.tileContents, activeId, currFrameId, frameNo);
            }
          }
        });
      } else {
        formStatejson &&
          formStatejson.map((item) => {
            if (item.elem_type === activeId && item.id !== currFrameId) {
              if (item.frameIndex && item.frameIndex >= frameNo) {
                item.frameIndex = parseInt(item.frameIndex) + 1;
                item.frameIndex += "";
              }
              if (item.children) {
                findJsonNew2(item.children, activeId, currFrameId, frameNo);
              }
              if (item.tileContents) {
                findJsonNew2(item.tileContents, activeId, currFrameId, frameNo);
              }
            } else if (
              item.frameIndex &&
              item.id !== currFrameId &&
              item.frameIndex >= frameNo
            ) {
              item.frameIndex = parseInt(item.frameIndex) + 1;
              item.frameIndex += "";
              if (item.children) {
                findJsonNew2(item.children, activeId, currFrameId, frameNo);
              }
              if (item.tileContents) {
                findJsonNew2(item.tileContents, activeId, currFrameId, frameNo);
              }
            } else if (item.children && item.id !== currFrameId) {
              findJsonNew2(item.children, activeId, currFrameId, frameNo);
            } else if (item.tileContents) {
              findJsonNew2(item.tileContents, activeId, currFrameId, frameNo);
            }
          });
      }
    }
    return formStatejson;
  }

  function appendSectionAboveWizard(formJson,sectionJson){
    addKeyInJson("isWizardHeader", true, sectionJson);

    sectionJson.isAboveWizard = true;
    // sectionJson.idNew = sectionJson.id + "_header";
    formJson.children[1].children.splice(1,0,sectionJson)
    if(formJson.children[1].children.length === 4){
      formJson.children[1].children.pop()
    }
    formJson.children[1]?.children[2]?.children?.pop()
    formJson.isAboveWizard = true;
    formJson.sectionAboveWizard = sectionJson.id;
    return true
  }
  
  //ondrop update the dom by injecting the formdata from state
    const drop = async(
    ev,
    flag4 = 0,
    checkTabParentSection = 0,
    flag37 = 0,
    frameNo = "",
    isAboveWizard
  ) => {
    ev.preventDefault();
    ev.stopPropagation();
    if(isAboveWizard){
      targetElemState.targetId = "wizard"
      targetElemState.targetElemType = formState2.containerControl;
    }
    // if(ev.currentTarget || ev.currentTarget===null || ev.currentTarget==="null" ){
    //   ev.currentTarget = ev.target; 
    // }
    if(targetElemState?.targetElemType==="tabChild" && currElemState?.current==="tab"){
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: `${t("This operation is not allowed inside the Tab")}`,
      });
    return  
    }    
    if (
      targetElemState?.targetId?.includes("column") &&
      targetElemState?.targetId?.includes("ResizerLabel")
    ) {
      targetElemState.targetId = targetElemState?.targetId?.replace(
        "ResizerLabel",
        ""
      );
    }
    if (flag37 === 1 && ev?.target?.id?.includes("before_frame")) {
      targetElemState.targetElemType = "section";
    }
    if (flag4 === 1 && ev?.target?.id?.includes("before_frame")) {
      targetElemState.targetElemType = "section";
    }
    setEventList(eventList.current + 1);
    if (drawerPinned === false) {
      // setOpenDrawer(true);
      window.changeDrawer("open");
    }

    const parentSection = (childId) => {
      if (childId)
        return document.getElementById(childId)?.closest(`[elem_type=section]`)
          ? true
          : false;
      return ev.target?.closest(`[elem_type=frame]`) ? true : false;
    };

    const parentTab = (childId) => {
      if (childId)
        return document.getElementById(childId)?.closest(`[elem_type=tab]`)
          ? true
          : false;
      return ev.target?.closest(`[elem_type=tab]`) ? true : false;
    };

    const findTabId = () => {
      if (parentTab())
        return ev.target?.closest(`[elem_type=tab]`)?.getAttribute("id");
    };

    const findSectionId = (childId) => {
      if (childId) {
        if (parentSection(childId)) {
          return document
            .getElementById(childId)
            ?.closest(`[elem_type=section]`)
            .getAttribute("id");
        }
      }
      if (parentSection(childId))
        return ev.target?.closest(`[elem_type=frame]`)?.getAttribute("id");
    };

    const parentWizard = () => {
      if (
        ev?.currentTarget?.closest(`[elem_type=wizard_v]`) ||
        ev?.currentTarget?.closest(`[elem_type=wizard_h]`) ||
        (ev?.currentTarget?.closest(`[elem_type=sidenavigation]`) &&
          !ev?.currentTarge?.closest(`[elem_type=tab]`)) ||
        (openCanvasForSubform === "subform" &&
          currentButtonForSubform.current?.containerControl === "wizard_h") ||
        (openCanvasForSubform === "subform" &&
          currentButtonForSubform.current?.containerControl === "wizard_v") ||
        (openCanvasForSubform === "subform" &&
          currentButtonForSubform.current?.containerControl ===
            "sidenavigation")
      ) {
        return true;
      } else {
        return false;
      }
    };

    const parentWizardCheck = () => {
      if (
        ev.target.closest(`[elem_type=wizard_v]`) ||
        ev.target.closest(`[elem_type=wizard_h]`) ||
        ev.target.closest(`[elem_type=sidenavigation]`) ||
        (openCanvasForSubform === "subform" &&
          currentButtonForSubform.current?.containerControl === "wizard_h") ||
        (openCanvasForSubform === "subform" &&
          currentButtonForSubform.current?.containerControl === "wizard_v") ||
        (openCanvasForSubform === "subform" &&
          currentButtonForSubform.current?.containerControl ===
            "sidenavigation")
      ) {
        return true;
      } else {
        return false;
      }
    };

    const parentMenu = () => {
      if (
        (ev?.currentTarget?.closest(`[elem_type=Menu]`) &&
          !ev?.currentTarget?.closest(`[elem_type=tab]`)) ||
        (openCanvasForSubform === "subform" &&
          currentButtonForSubform.current?.containerControl === "Menu")
      ) {
        return true;
      } else {
        return false;
      }
    };

    const parentMenuCheck = () => {
      if (
        ev.target.closest(`[elem_type=Menu]`) ||
        (openCanvasForSubform === "subform" &&
          currentButtonForSubform.current?.containerControl === "Menu")
      ) {
        return true;
      } else {
        return false;
      }
    };

    let parentsSoFar = getRecursiveParent(targetElemState.targetId);
    let familyPathElemType = parentsSoFar?.familyPathElemType;
    let shouldBeDropped = true;
    if (familyPathElemType !== null && familyPathElemType !== undefined) {
      shouldBeDropped = checkForAllowedFormStructure(
        currElemState.current,
        familyPathElemType
      );
    }
    setLatestChangesSaved(false);

    const isAdvanceListviewCheck = (node) => {
      if (
        node.Unbounded === "Y" &&
        node?.children &&
        node?.children?.length > 1
      ) {
        for (let item of node?.children) {
          if (item?.children && item?.children?.length > 1) {
            return true;
          }
        }
        return false;
      }
    };

    const appendChildInSection = async(controlElemToAdd,targetElemState,jsonObj,child,index) => {
      const response = await sendRequestForControl(
        controlElemToAdd.frameIndex,
        "add",
        currElemState.current,
        targetElemState,
        extraDetails
      );
      if(response.data.status === 0) {
          var controlElemToAdd2 = response.data;
          // if(Object.keys(headerJsonNew).length !== 0){
          //     if(headerJsonNew.frameIndex && headerJsonNew.id){
          //         headerJsonNew.frameIndex = response.data.frameIndex
          //         headerJsonNew.id = response.data.id
          //         controlElemToAdd2 = headerJsonNew
          //     }
  
          // }
          // else{
  
            if (
              targetElemState?.targetId?.includes("column") &&
              targetElemState?.targetElemType === "column_tabChild" && currElemState.current === "section"
            ) {
              response.data["insideTabColumn"] = true;
            }
          if (controlElemToAdd2 && controlElemToAdd2?.elem_type !== "frame") {
            controlElemToAdd2.marvin = "false";
          }
          if (controlElemToAdd2?.elem_type === "radio") {
            controlElemToAdd2.options = [
              {
                label: "Option1", value: "Option1",tooltip:"", FE_id: '1'
              },
              
            ];
          }
          if (controlElemToAdd2?.elem_type === "button") {
            if(!controlElemToAdd2?.eventSource || controlElemToAdd2?.eventSource===undefined ){
              const controlJson= {...controlElemToAdd2};
              controlJson.eventSource = uuid();
              controlElemToAdd2.eventSource = controlJson.eventSource;
            }
          }
          if (controlElemToAdd2?.elem_type === "combo") {
            controlElemToAdd2.options = [
              {
                label:`${t("translation:Select")}`,
                value: "",
                FE_id: "1",
              },
            ];
          }
          if (controlElemToAdd2?.elem_type === "listbox") {
            controlElemToAdd2.options = [
              {
                label: "Default",
                value: "Default",
                FE_id: "1",
              },
            ];
            // controlElemToAdd2.value = ["Default"];
          }
  
  
          if (
            child &&
            child["treeName"]
          ) {
            let dataClassMap;
  
            dataClassMap = child["treeName"];
  
            mappingControlsIdMap.add(
              child["treeName"]
            );
  
            // var treeName = data.treeName;
            var treeName = child?.treeName;
            let currentDataObjectsContent = getCurrentDataObjectsContent()
            var hasChild;
            let dataObj = findDataObjectListView(
              currentDataObjectsContent || dataObjectsContent,
              child?.treeName,
              "children"
            );
            if (dataObj && dataObj.children && dataObj.children.length > 0) {
              hasChild = true;
            } else {
              hasChild = false;
            }
            
            if(!(child?.["Unbounded"] === "N" && child?.children?.length > 0)) {
              var jsonToSend = {
                mappedField: treeName,
                unbounded: child?.Unbounded,
                isProcessVar:
                child?.dataObjectType === "M"
                    ? false
                    : child?.dataObjectType === "P"
                    ? true
                    : "",
                hasChild: hasChild,
                formId:
                  microFrontendData?.formDefId ||
                  activePage?.formId ||
                  activeSubForm?.fragmentId ||
                  microFrontendData?.processDefId ||
                  microFrontendData?.templateId,
              };
              try{
                mappingExistOrNot(jsonToSend).then((response) => {
                  if (response.data.status === "-1") {
                    showAlertConfirmNotifications({
                      open: true,
                      showConfirm: "showNotification",
                      alertType: "error",
                      alertContentKey: `mappingError`
                    });
                  }
                })
              }catch(e){
                console.log(e)
              }
              controlElemToAdd2["TypeOfValue"] =
                child?.["VariableType"];
              controlElemToAdd2["dataclass"] = dataClassMap;
              controlElemToAdd2["unBounded"] = child?.["Unbounded"]
              controlElemToAdd2.style["ListviewLabel"] =
              child?.["treeName"];
              controlElemToAdd2.style.Mapping = dataClassMap;
              controlElemToAdd2.style.MappingId =
              child?.["treeName"];
            }
            currentDataObjectJson.current.children[index]["isMapped"] = true;
            setCurrentMappedDO((prev) => {
              return [...prev, currentDataObjectJson.current.children[index]["treeName"]];
            });
          }
  
          
          // }
          currentDataObjectJson.current.children[index][
            "isMapped"
          ] = true;
          // setOpenQuickToolFor(controlElemToAdd2?.id);
          controlElemToAdd2["style"] = {
            ...ThemeJSON[currElemState.current],
            PickerType: child?.["VariableType"] ? child?.["VariableType"] === "Date" ? "2" : "1" : undefined,
            Label:
              child?.["treeName"],
          };
          if (controlElemToAdd2?.elem_type === "image") {
            if (controlElemToAdd2.style["imageStyle"] === undefined || controlElemToAdd2.style["imageStyle"] === null) {
              controlElemToAdd2.style.imageStyle = {
                ...controlElemToAdd2.style?.imageStyle,
                height: controlElemToAdd2.style.height,
                width: controlElemToAdd2.style.width,
                defaultWidth: controlElemToAdd2.style.defaultWidth,
                defaultHeight: controlElemToAdd2.style.defaultHeight,
                size: controlElemToAdd2.style.size,
                scale: "1",
                resize: controlElemToAdd2.style.resize,
                widthType: controlElemToAdd2.style.scale === "pixels" ? "px" : "%",
                aspectRatio: "auto",
                transform: "rotate(0deg) scale(1,1)",
                degree: 0,
                scaleX: 1,
                scaleY: 1
              };
            }
          }
          // if(currElemState.current === "textbox" || currElemState.current === "textarea" || currElemState.current === "password"){
          //   controlElemToAdd2["style"]["TextAlignment"] = translationStyles1 ? "right" : "left"
          // }
          if(controlElemToAdd2.elem_type !== 'frame') {
            controlElemToAdd2.datamapVariableType =
              child?.["VariableType"];
            controlElemToAdd2.datamapVariableLength =
              child?.[
                "VariableLength"
              ];
            controlElemToAdd2.datamapPercision =
              child?.["VarPrecision"];
          }
          
          if (
            controlElemToAdd2.controlName === "doclist"
          ) {
            const handleDocuments = () => {
              //alert('Document click handler')
            };
            var docData = {
              documents: [],
              available_doc_types: [],
              available_owners: ["arj", "badmin"],
              doc_upload_options: {
                google_drive: false,
                camera: true,
                scan: false,
                omnidocs: false,
                system: true,
              },
              upload_doc_as: {
                new: true,
                new_version: true,
                overwrite: true,
              },
              docEventHandler: handleDocuments,
              docviewer_info: {
                viewer_location: "inline", //inline, popup, window
                ContainerId: "rdDIv", //Optional, Required in case viewer_location is Inline //Optional, Required in case viewer_location is Inline,
                view_annotation: true,
                view_stamps: true,
                show_opall_menu: true,
                opall_params: {
                  printOption: "false",
                  TransformOption: "",
                },
              },
              enable_next: true,
              enable_prev: false,
              enable_search: false,
              enable_upload: true,
              enable_filter: false,
              enable_sorting: false,
              source: "APPLICATION",
              pid: "",
              wid: "",
              ext_data: {},
            };
            controlElemToAdd2.json = docData;
          }
          if (
            controlElemToAdd2?.controlName ===
              "password" &&
            controlElemToAdd2?.elem_type === "textbox"
          )
            controlElemToAdd2["style"] = {
              isPassword: true,
              Placeholder: "Enter Password",
              ShowPasswordIcon: "true",
              Mapping: "",
              ...Object.assign({}, ThemeJSON.textbox),
            };
  
          if (
            controlElemToAdd2.elem_type === "iframe" &&
            controlLabel.current === "Survey"
          ) {
            controlElemToAdd2 = {
              ...controlElemToAdd2,
              controlName: "Survey",
            };
          }
  
          if (
            child &&
            Object.keys(child)
              .length === 0
          ) {
          } else {
            if (
              child &&
              child?.[
                "VariableName"
              ]
            ) {
              let dataClassMap;
  
              if (
                child?.[
                  "parentName"
                ] &&
                child?.[
                  "parentName"
                ] !== ""
              ) {
                dataClassMap =
                  child?.[
                    "treeName"
                  ];
              } else {
                dataClassMap =
                  child?.[
                    "VariableName"
                  ];
              }
  
              mappingControlsIdMap.add(
                child?.["treeName"]
              );
              
              if(!(child?.["Unbounded"] === "N" && child?.children?.length > 0)) {
                controlElemToAdd2["TypeOfValue"] =
                  child?.[
                    "VariableType"
                  ];
                controlElemToAdd2["dataclass"] =
                  dataClassMap;
                controlElemToAdd2["style"] = {
                  ...controlElemToAdd2.style,
                  Label:
                    child?.[
                      "treeName"
                    ],
                  Mapping: dataClassMap,
                  MappingId:
                    child?.[
                      "treeName"
                    ],
                  Enable: "true",
                  Visible: "true",
                  
                };
              }
            }
          }
  
          if (
            (controlElemToAdd2?.elem_type !== "frame" &&
              controlElemToAdd2?.elem_type !== "wizard") ||
            parentTab() ||
            parentWizardCheck() ||
            parentMenuCheck()
          ) {
            let frameEnableValue = true;
            var framereadValue = false;
            console.log(framereadValue);
            let frameReadOnlyValue = false;
            const parenttabVal = parentTab();
            const parentWizardCheckVal =
              parentWizardCheck();
            const parentMenuCheckVal = parentMenuCheck();
            const parentSectionVal = parentSection();
            const tabId = findTabId();
            const sectionId = findSectionId();
            const parentSectionCheck =
              parentSection(tabId);
            const parentTabCheck = parentTab(sectionId);
            const parentSectionId = findSectionId(tabId);
  
            if (
              parenttabVal &&
              !parentWizardCheckVal &&
              !parentMenuCheckVal
            ) {
              if (parentSectionCheck) {
                if (
                  document
                    .getElementById(parentSectionId)
                    ?.getAttribute("enable") ===
                    "false" ||
                  document
                    .getElementById(parentSectionId)
                    ?.getAttribute("enable") === false
                )
                  frameEnableValue = false;
                else frameEnableValue = true;
                if (
                  document
                    .getElementById(parentSectionId)
                    ?.getAttribute("readonly") ===
                    "true" ||
                  document
                    .getElementById(parentSectionId)
                    ?.getAttribute("readonly") === true
                )
                  frameReadOnlyValue = true;
                else frameReadOnlyValue = false;
                if (
                  document
                    .getElementById(parentSectionId)
                    ?.getAttribute("readOnlyValue") ===
                    "true" ||
                  document
                    .getElementById(parentSectionId)
                    ?.getAttribute("readOnlyValue") ===
                    true
                )
                  framereadValue = true;
                else framereadValue = false;
                if (
                  document
                    .getElementById(tabId)
                    ?.getAttribute("readonly") ===
                    "true" ||
                  document
                    .getElementById(tabId)
                    ?.getAttribute("readonly") === true
                )
                  frameReadOnlyValue = true;
                else frameReadOnlyValue = false;
                if (
                  document
                    .getElementById(tabId)
                    ?.getAttribute("readOnlyValue") ===
                    "true" ||
                  document
                    .getElementById(tabId)
                    ?.getAttribute("readOnlyValue") ===
                    true
                )
                  framereadValue = true;
                else framereadValue = false;
                console.log(
                  "tabId",
                  document.getElementById(findTabId())
                );
                console.log(
                  "TabEnable",
                  document
                    .getElementById(findTabId())
                    ?.getAttribute("enable")
                );
                if (
                  document
                    .getElementById(tabId)
                    ?.getAttribute("enable") === "true" ||
                  document
                    .getElementById(tabId)
                    ?.getAttribute("enable") === true
                )
                  frameEnableValue = true;
                else frameEnableValue = false;
                if (parentTabCheck) {
                  if (
                    document
                      .getElementById(sectionId)
                      ?.getAttribute("enable") ===
                      "true" ||
                    document
                      .getElementById(sectionId)
                      ?.getAttribute("enable") === true
                  )
                    frameEnableValue = true;
                  else frameEnableValue = false;
                  if (
                    document
                      .getElementById(sectionId)
                      ?.getAttribute("readonly") ===
                      "true" ||
                    document
                      .getElementById(sectionId)
                      ?.getAttribute("readonly") === true
                  )
                    frameReadOnlyValue = true;
                  else frameReadOnlyValue = false;
                  if (
                    document
                      .getElementById(sectionId)
                      ?.getAttribute("readOnlyValue") ===
                      "true" ||
                    document
                      .getElementById(sectionId)
                      ?.getAttribute("readOnlyValue") ===
                      true
                  )
                    framereadValue = true;
                  else framereadValue = false;
                }
              } else {
                if (
                  document
                    .getElementById(tabId)
                    ?.getAttribute("enable") ===
                    "false" ||
                  document
                    .getElementById(tabId)
                    ?.getAttribute("enable") === false
                )
                  frameEnableValue = false;
                else frameEnableValue = true;
                if (
                  document
                    .getElementById(tabId)
                    ?.getAttribute("readonly") ===
                    "true" ||
                  document
                    .getElementById(tabId)
                    ?.getAttribute("readonly") === true
                )
                  frameReadOnlyValue = true;
                else frameReadOnlyValue = false;
                if (
                  document
                    .getElementById(tabId)
                    ?.getAttribute("readOnlyValue") ===
                    "true" ||
                  document
                    .getElementById(tabId)
                    ?.getAttribute("readOnlyValue") ===
                    true
                )
                  framereadValue = true;
                else framereadValue = false;
                if (parentSectionVal) {
                  if (
                    document
                      .getElementById(sectionId)
                      ?.getAttribute("enable") ===
                      "false" ||
                    document
                      .getElementById(sectionId)
                      ?.getAttribute("enable") === false
                  ) {
                    frameEnableValue = false;
                  } else frameEnableValue = true;
                  if (
                    document
                      .getElementById(sectionId)
                      ?.getAttribute("readonly") ===
                      "true" ||
                    document
                      .getElementById(sectionId)
                      ?.getAttribute("readonly") === true
                  )
                    frameReadOnlyValue = true;
                  else frameReadOnlyValue = false;
                  if (
                    document
                      .getElementById(sectionId)
                      ?.getAttribute("readOnlyValue") ===
                      "true" ||
                    document
                      .getElementById(sectionId)
                      ?.getAttribute("readOnlyValue") ===
                      true
                  )
                    framereadValue = true;
                  else framereadValue = false;
                }
              }
            } else if (
              parentSectionVal &&
              !parentTabCheck &&
              !parenttabVal &&
              !parentWizardCheckVal &&
              !parentMenuCheckVal
            ) {
              frameEnableValue = document
                .getElementById(findSectionId())
                ?.getAttribute("enable");
              frameReadOnlyValue = document
                .getElementById(findSectionId())
                ?.getAttribute("readonly");
              framereadValue = document
                .getElementById(findSectionId())
                ?.getAttribute("readOnlyValue");
            } else if (parentWizardCheckVal) {
              if (
                document
                  .getElementById("wizard")
                  ?.getAttribute("readonly") === "true" ||
                document
                  .getElementById("wizard")
                  ?.getAttribute("readOnly") === true
              )
                frameReadOnlyValue = true;
              else frameReadOnlyValue = false;
              if (sectionId) {
                if (
                  document
                    .getElementById(sectionId)
                    ?.getAttribute("enable") ===
                    "false" ||
                  document
                    .getElementById(sectionId)
                    ?.getAttribute("enable") === false
                )
                  frameEnableValue = false;
                else frameEnableValue = true;
                if (
                  document
                    .getElementById(sectionId)
                    ?.getAttribute("readonly") ===
                    "true" ||
                  document
                    .getElementById(sectionId)
                    ?.getAttribute("readonly") === true
                )
                  frameReadOnlyValue = true;
                else frameReadOnlyValue = false;
                if (
                  document
                    .getElementById(sectionId)
                    ?.getAttribute("readOnlyValue") ===
                    "true" ||
                  document
                    .getElementById(sectionId)
                    ?.getAttribute("readOnlyValue") ===
                    true
                )
                  framereadValue = true;
                else framereadValue = false;
              }
            } else if (parentMenuCheckVal) {
              if (
                document
                  .getElementById("wizard")
                  ?.getAttribute("readOnlyValue") ===
                  "true" ||
                document
                  .getElementById(findTabId())
                  ?.getAttribute("readonlyvalue") === true
              )
                framereadValue = true;
              if (
                document
                  .getElementById("wizard")
                  ?.getAttribute("readonly") === "true" ||
                document
                  .getElementById("wizard")
                  ?.getAttribute("readOnly") === true
              )
                frameReadOnlyValue = true;
              if (sectionId) {
                if (
                  document
                    .getElementById(sectionId)
                    ?.getAttribute("enable") ===
                    "false" ||
                  document
                    .getElementById(sectionId)
                    ?.getAttribute("enable") === false
                )
                  frameEnableValue = false;
                else frameEnableValue = true;
                if (
                  document
                    .getElementById(sectionId)
                    ?.getAttribute("readonly") ===
                    "true" ||
                  document
                    .getElementById(sectionId)
                    ?.getAttribute("readonly") === true
                )
                  frameReadOnlyValue = true;
                else frameReadOnlyValue = false;
                if (
                  document
                    .getElementById(sectionId)
                    ?.getAttribute("readOnlyValue") ===
                    "true" ||
                  document
                    .getElementById(sectionId)
                    ?.getAttribute("readOnlyValue") ===
                    true
                )
                  framereadValue = true;
                else framereadValue = false;
              }
            }
            if (
              frameEnableValue === true ||
              frameEnableValue === "true"
            )
              controlElemToAdd2["style"].Enable = "true";
            else
              controlElemToAdd2["style"].Enable = "false";
            if (
              frameReadOnlyValue === true ||
              frameReadOnlyValue === "true"
            )
              controlElemToAdd2["style"].ReadOnlyStyle =
                "true";
            else
              controlElemToAdd2["style"].ReadOnlyStyle =
                "false";
            if (
              framereadValue === true ||
              framereadValue === "true"
            )
              controlElemToAdd2["style"].ReadOnly = "true";
            else
              controlElemToAdd2["style"].ReadOnly =
                "false";
          }
  
          var jsonObj2 = {};
          if (openCanvasForSubform === "subform") {
            jsonObj2 = createSmartFormState(
              subFormStateJson.current,
              targetElemState.targetId,
              targetElemState.targetElemType,
              controlElemToAdd2.controlName ===
                "password" &&
                controlElemToAdd2.elem_type === "textbox"
                ? "textbox"
                : currElemState.current,
              0,
              targetElemState.frameIndex,
              controlElemToAdd2,
              targetElemState.targetRowId,
              targetElemState.targetColId,
              device,
              child?.["Unbounded"] === "N" && child?.children?.length > 0 ? {"dataObjectDrop" : true, count: child?.children?.length} : "",
            );
          } else if (
            openCanvasForSubform ===
            "advanceListviewFromScratch"
          ) {
            jsonObj2 = createSmartFormState(
              fetchGridStates().advanceListviewStateJson,
              targetElemState.targetId,
              targetElemState.targetElemType,
              controlElemToAdd2.controlName ===
                "password" &&
                controlElemToAdd2.elem_type === "textbox"
                ? "textbox"
                : currElemState.current,
              0,
              targetElemState.frameIndex,
              controlElemToAdd2,
              targetElemState.targetRowId,
              targetElemState.targetColId,
              device,
              child?.["Unbounded"] === "N" && child?.children?.length > 0 ? {"dataObjectDrop" : true, count: child?.children?.length} : "",
            );
          } else {
            if (
              currElemState.current.includes(
                "template"
              ) &&
              controlElemToAdd2.populatedJson
            ) {
              delete controlElemToAdd2["style"];
              targetElemState.targetId = "design_page";
              targetElemState.targetElemType =
                "Design Page";
              targetElemState.frameIndex = null;
              targetElemState.targetRowId = null;
              jsonObj2 = createSmartFormState(
                jsonObj,
                targetElemState.targetId,
                targetElemState.targetElemType,
                "section",
                0,
                targetElemState.frameIndex,
                controlElemToAdd2.populatedJson,
                targetElemState.targetRowId,
                targetElemState.targetColId,
                device,
                {
                  notCreateRow: "true",
                  position: "start",
                }
              );
            } else {
              if (
                targetElemState?.targetElemType ===
                  "section" &&
                !targetElemState?.targetId?.includes(
                  "frame"
                )
              ) {
                var targetId_incoming =
                  targetElemState.targetId;
                targetElemState.targetId = document
                  .querySelector(
                    `#${targetElemState.targetRowId}`
                  )
                  ?.closest(`[elem_type=frame]`)
                  ?.getAttribute("id");
  
                if (
                  targetElemState.targetId === undefined
                ) {
                  targetElemState.targetId =
                    targetId_incoming;
                }
              }
              jsonObj2 = createSmartFormState(
                jsonObj,
                targetElemState.targetId,
                targetElemState.targetElemType,
                controlElemToAdd2.controlName ===
                  "password" &&
                  controlElemToAdd2.elem_type === "textbox"
                  ? "textbox"
                  : currElemState.current,
                0,
                targetElemState.frameIndex,
                controlElemToAdd2,
                targetElemState?.targetElemType ===
                  "tabChild" &&
                  targetElemState?.targetRowId.includes(
                    "after_row"
                  )
                  ? ""
                  : targetElemState.targetRowId,
                  targetElemState.targetColId,
                // targetElemState.targetRowId,
                device,
                child?.["Unbounded"] === "N" && child?.children?.length > 0 ? {"dataObjectDrop" : true, count: child?.children?.length} : "",
              );
            }
          }
          if(currElemState.current === "listview"){
            for (let columns = 0; columns < child?.children?.length;columns++) {
              loading(true)
              const columnNameDataObject = child?.children?.[columns]?.VariableName;
              const columnData = child?.children?.[columns];
              if(!controlElemToAdd2?.columnList)
              controlElemToAdd2.columnList = [];
              if(columnData?.VariableType?.toLowerCase() === "shortdate" || columns?.VariableType?.toLowerCase() === "short date"){
                extraDetails["ColumnType"] = "datepick";
              }else if(columnData?.VariableType?.toLowerCase() === "date") {
                extraDetails["ColumnType"] = "datepick";
                extraDetails["PickerType"] = "2";
              }else if(columns?.VariableType?.toLowerCase() === "boolean"){
                extraDetails["ColumnType"] = "toggle";
                extraDetails["ToggleState1"] = "No";
                extraDetails["ToggleState2"] = "Yes";
                extraDetails["ToggleStates"] = "Yes/No";
                extraDetails["complexFieldType"] = "Boolean";
              } else {
                extraDetails["ColumnType"] = "textbox";
                extraDetails?.["PickerType"] && delete extraDetails["PickerType"];
                extraDetails?.["ToggleState1"] && delete extraDetails["ToggleState1"];
                extraDetails?.["ToggleState2"] && delete extraDetails["ToggleState2"];
                extraDetails?.["ToggleStates"] && delete extraDetails["ToggleStates"]
                extraDetails?.["complexFieldType"] && delete extraDetails["complexFieldType"]
              }
              await sendRequestForControl(
                controlElemToAdd2.frameIndex,
                "add",
                "tableColumn",
                extraDetails,
                microFrontendData,
                "",
                "",
                targetElemState,
                controlElemToAdd2,
                columnNameDataObject
              ).then((response) => {
                if (response.data.status === 0) {
                  var column = {};
                  column.frameIndex = response.data.frameIndex;
                  column.columnIndex = response.data.columnIndex;
                  column.elementIndex = response.data.elementIndex;
                  column.parent = "frame";
                  column.elementJson = response.data.elementJson;
                  column.style = Object.assign(
                    {},
                    ThemeJSON.tableColumn1
                  );
                  if(columnData?.VariableType?.toLowerCase() === "shortdate" || columns?.VariableType?.toLowerCase() === "short date") {
                    column.style["ColumnType"] = "datepick";
                    column.style["DateFormat"] = "1";
                  }else if(columnData?.VariableType?.toLowerCase() === "date") {
                    column.style["ColumnType"] = "datetimepick";
                    column.style["PickerType"] = "2";
                    column.style["DateFormat"] = "5";
                  }else if(columns?.VariableType?.toLowerCase() === "boolean"){
                    column.style["ColumnType"] = "toggle";
                    column.style["ToggleState1"] = "No";
                    column.style["ToggleState2"] = "Yes";
                    column.style["ToggleStates"] = "Yes/No";
                    column.style["complexFieldType"] = "Boolean";
                  }else {
                    column.style["ColumnType"] = "textbox";
                    column.style?.["PickerType"] && delete column.style["PickerType"];
                    column.style?.["ToggleState1"] && delete column.style["ToggleState1"];
                    column.style?.["ToggleState2"] && delete column.style["ToggleState2"];
                    column.style?.["ToggleStates"] && delete column.style["ToggleStates"]
                    column.style?.["complexFieldType"] && delete column.style["complexFieldType"]
                  }
                  const defaultColumnWidth = 100/child.children.length
                  column.style["ColumnWidth"] = child.children.length > 10 ? `${defaultColumnWidth.toFixed(2)}%` : "10%";
                  column.style.ColumnName = columnNameDataObject;
                  column.style.complexFieldName =
                    columnNameDataObject;
                  column.style.complexFieldType =
                  child?.children?.[columns]?.VariableType;
                  column.style.complexFieldVariableLength =
                  child?.children?.[columns]?.VariableLength;
                  column.style.complexFieldVariablePrecision =
                  child?.children?.[columns]?.VarPrecision;
                  // column.style.controlid = response?.data?.id;
                  if(controlElemToAdd2.columnList)
                    controlElemToAdd2.columnList.push(column);
                  else {
                    controlElemToAdd2.columnList = [];
                    controlElemToAdd2.columnList.push(column);
                  }
                  controlElemToAdd2.initialColumnLength = child?.children?.length;
                  controlElemToAdd2.style = {
                    ...controlElemToAdd2.style,
                    ...JSON.parse(
                      JSON.stringify(ThemeJSON.listview)
                    ),
                  };                  
                  targetElemState.targetId = "";
                  targetElemState.targetClass = "";
                  targetElemState.targetElemType = "";
                  setCurrElem("");
                } else if (response.data.status === 1) {
                  showAlertConfirmNotifications({
                    open: true,
                    showConfirm: "showNotification",
                    alertType: "error",
                    alertContentKey: `${t("Reopen_Form")}`,
                  });
                }
              })
              .catch((error) => {
                loading(false)
              })
            }
          }
          if(currElemState.current === "advancelistview") {
            extraDetails.isSubForm = isSubForm;
            extraDetails.isAdvanceListview = isAdvanceListview;
            if (controlElemToAdd2?.id)
              extraDetails["id"] = controlElemToAdd2?.id;
            if(!controlElemToAdd2?.columnList)
              controlElemToAdd2.columnList = [];
            await sendRequestForControl(
              controlElemToAdd2.frameIndex,
              "add",
              "tableColumn",
              extraDetails,
              microFrontendData,
              activePage,
              activeSubForm,
              targetElemState
            ).then((response) => {
              if (response.data.status === 0) {
                var column = {};
                column.frameIndex = response.data.frameIndex;
                column.columnIndex = response.data.columnIndex;
                column.elementIndex = response.data.elementIndex;
                column.parent = "frame";
                column.style = Object.assign(
                  {},
                  ThemeJSON.tableColumn1
                );
                if(controlElemToAdd2.columnList)
                  controlElemToAdd2.columnList.push(column);
                else {
                  controlElemToAdd2.columnList = [];
                  controlElemToAdd2.columnList.push(column);
                }
                controlElemToAdd2.style = {...controlElemToAdd2.style,
                  ...JSON.parse(
                  JSON.stringify(ThemeJSON.advancelistview)
                )
              };
              //   currentDataObjectJson.current[
              //     "isMapped"
              //   ] = true;
              //   mappingControlsIdMap.add(
              //     currentDataObjectJson.current["treeName"]
              //   );
              //   controlElemToAdd["TypeOfValue"] =
              //   currentDataObjectJson["VariableType"];
              //   controlElemToAdd["dataclass"] = currentDataObjectJson.current["treeName"];
              //   controlElemToAdd["style"] = {
              //   ...ThemeJSON.advancelistview,
              //   Label: currentDataObjectJson.current["treeName"] || controlElemToAdd?.id,
              //   Mapping:  currentDataObjectJson.current["treeName"],
              //   MappingId:
              //     currentDataObjectJson.current["treeName"],
              //   Enable: "true",
              //   Visible: "true",
              // };
                targetElemState.targetId = "";
                targetElemState.targetClass = "";
                targetElemState.targetElemType = "";
                setCurrElem("");
              } else if (response.data.status === 1) {
                showAlertConfirmNotifications({
                  open: true,
                  showConfirm: "showNotification",
                  alertType: "error",
                  alertContentKey: `${t("Reopen_Form")}`,
                });
              }
            })
            .catch((error) => {
              loading(false)
            })
          }

          targetElemState.targetId = "";
          targetElemState.targetClass = "";
          targetElemState.targetElemType = "";
          setCurrElem("");
          if(child &&
            child?.[
              "VariableName"
            ]){
              controlElemToAdd2=dragAndDropThroughMDM(child,controlElemToAdd2);              
            }
          
          // if (openCanvasForSubform === "subform") {
          //   setSubFormState({ ...jsonObj2 });
          //   // updatedComponentInFormState();
          // } else if (
          //   openCanvasForSubform ===
          //   "advanceListviewFromScratch"
          // ) {
          //   dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj2 }, renderCanvas:true}));
          //   // updatedComponentInFormState();
          // } else {
          //   setFormStateByUser(cloneDeep(jsonObj2));
          //   // updatedComponentInFormState();
          // }
        }
        else if (response.data.status === 1) {
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: `${t("Reopen_Form")}`,
          });
        }
    }

    // const inmenu=ev.currentTarget.closest(`[elem_type=Menu]`);
    if (
      ev?.currentTarget?.closest(`[elem_type=Menu]`) ||
      (openCanvasForSubform === "subform" &&
        currentButtonForSubform.current?.containerControl === "Menu")
    ) {
      targetElemState.insideMenu = parentMenu();

      if (
        openCanvasForSubform === "subform" &&
        currentButtonForSubform.current?.containerControl === "Menu"
      ) {
        targetElemState.stepIndex =
          currentButtonForSubform.current?.stepIndex ||
          currentButtonForSubform.current?.stepIndex === 0
            ? currentButtonForSubform.current?.stepIndex
            : "-1";
        targetElemState.substepIndex =
          currentButtonForSubform.current?.subStepIndex ||
          currentButtonForSubform.current?.subStepIndex === 0
            ? currentButtonForSubform.current?.subStepIndex
            : "-1";
        targetElemState.subChildMenuIndex =
          currentButtonForSubform.current?.subChildMenuIndex ||
          currentButtonForSubform.current?.subChildMenuIndex === 0
            ? currentButtonForSubform.current?.subChildMenuIndex
            : "-1";
      } else {
        const activeJsonString = document
          .querySelector(".menuMain_Id")
          .getAttribute("activeJson");
        const activeJson = activeJsonString
          ? JSON.parse(activeJsonString || null)
          : {};

        targetElemState.stepIndex =
          activeJson.MainMenuIndex || activeJson.MainMenuIndex === 0
            ? activeJson.MainMenuIndex
            : "-1";
        targetElemState.substepIndex =
          activeJson.SubMenuIndex || activeJson.SubMenuIndex === 0
            ? activeJson.SubMenuIndex
            : "-1";
        targetElemState.subChildMenuIndex =
          activeJson.subChildMenuIndex || activeJson.subChildMenuIndex === 0
            ? activeJson.subChildMenuIndex
            : "-1";
      }

      if (targetElemState.frameIndex === null) {
        targetElemState["frameIndex"] =
          ev?.currentTarget
            ?.closest(`[elem_type=frame]`)
            ?.getAttribute("frameindex") ||
          ev?.currentTarget
            ?.closest(`[elem_type=section]`)
            ?.getAttribute("frameindex");
      }
      // targetElemState.extraDetails=ev.currentTarget.closest(`[id=menuMain_Id]`) && ev.currentTarget.closest(`[id=menuMain_Id]`).getAttribute("extraDetails")
    } else {
      targetElemState.insideWizard = parentWizard();
      targetElemState.parentStep =
        (ev?.currentTarget?.closest(`[elem_type=Step]`) &&
          ev?.currentTarget
            ?.closest(`[elem_type=Step]`)
            .getAttribute("frameindex")) ||
        (ev?.currentTarget?.closest(`[elem_type=SubStep]`) &&
          ev?.currentTarget?.closest(`[elem_type=SubStep]`).getAttribute("frameindex")) ||
        "";

      targetElemState.parentSubStep =
        (ev?.currentTarget?.closest(`[elem_type=SubStep]`) &&
          ev?.currentTarget?.closest(`[elem_type=SubStep]`)?.getAttribute("elementindex")) ||
        "";
    }

    const elemToAdd = currElemState.current;

    var addElemTo = ev.target.getAttribute("id");
    if (addElemTo === null) {
      addElemTo = $(ev.target).attr("control_id");
    }

    var jsonObj = {};
    let isSubForm = false;
    if (openCanvasForSubform === "subform") {
      isSubForm = true;
    }

    let isAdvanceListview = false;
    if (openCanvasForSubform === "advanceListviewFromScratch") {
      isAdvanceListview = true;
    }

    if (addElemTo !== null && addElemTo !== undefined && addElemTo !== "") {
      if (elemToAdd !== "row" && elemToAdd !== "column") {
        const Id = addElemTo;
        const elemType = currElemState.current;
        // var jsonObj = addElemToFormData(formState2, addElemTo, currElemState.current, 0);

        var remainingURL = "";
        var jsonToSend = {};
        if (currElemState.current !== "tab") {
          if (
            targetElemState.targetElemType.toLowerCase() !== "step" &&
            targetElemState.targetElemType.toLowerCase() !== "substep" &&
            currElemState.current === "table"
          ) {
            if (
              flag4 !== 1 &&
              !targetElemState.targetRowId.includes("before_")
            ) {
              var targetElement = cloneDeep(targetElemState);
              targetElement.isSubForm = isSubForm;
              targetElement.isAdvanceListview = isAdvanceListview;

              if (!targetElemState.frameIndex) {
                targetElemState.frameIndex = document
                  .querySelector(`#${targetElement.targetId}`)
                  ?.closest("[elem_type=frame]")
                  ?.getAttribute("frameindex");
              }

              sendRequestForControl(
                targetElemState.frameIndex,
                "add",
                currElemState.current,
                targetElement,
                microFrontendData,
                activePage,
                activeSubForm
              ).then((response) => {
                if (response.data.status === 0) {
                  var controlElemToAdd = response.data;
                  setOpenQuickToolFor(controlElemToAdd?.id);
                  if (
                    targetElement.targetElemType === "tabChild" ||
                    Object.keys(response.data).includes(
                      "sheetFrameElementIndex"
                    )
                  ) {
                    controlElemToAdd.sheetIndex = targetElement.sheetIndex;
                    controlElemToAdd.elementIndex = targetElement.elementIndex;
                  }
                  if (
                    targetElement.sheetElementIndex !== undefined &&
                    targetElement.sheetElementIndex !== null
                  ) {
                    controlElemToAdd.sheetElementIndex =
                      targetElement.sheetElementIndex;
                  }
                  controlElemToAdd.columnList = [];
                  var extraDetails = {};

                  extraDetails.elementIndex = controlElemToAdd.elementIndex;
                  extraDetails.elem_type = "column";
                  if (targetElement.sheetIndex !== undefined) {
                    extraDetails.elementIndex = targetElement.elementIndex;
                    extraDetails.sheetIndex = targetElement.sheetIndex;
                    extraDetails.sheetElementIndex =
                      controlElemToAdd.sheetElementIndex;
                    extraDetails.elem_type = "column";
                  }
                  if (
                    targetElement.sheetElementIndex !== undefined &&
                    targetElement.sheetElementIndex !== null
                  ) {
                    extraDetails.sheetElementIndex =
                      targetElement.sheetElementIndex;
                    extraDetails.sheetFrameElementIndex =
                      controlElemToAdd.sheetFrameElementIndex;
                  }

                  if (
                    (controlElemToAdd?.elem_type !== "frame" &&
                      controlElemToAdd?.elem_type !== "wizard") ||
                    parentTab() ||
                    parentWizardCheck() ||
                    parentMenuCheck()
                  ) {
                    let frameEnableValue = true;
                    var framereadValue = false;
                    console.log(framereadValue);
                    let frameReadOnlyValue = false;
                    const parenttabVal = parentTab();
                    const parentWizardCheckVal = parentWizardCheck();
                    const parentMenuCheckVal = parentMenuCheck();
                    const parentSectionVal = parentSection();
                    const tabId = findTabId();
                    const sectionId = findSectionId();
                    const parentSectionCheck = parentSection(tabId);
                    const parentTabCheck = parentTab(sectionId);
                    const parentSectionId = findSectionId(tabId);

                    if (
                      parenttabVal &&
                      !parentWizardCheckVal &&
                      !parentMenuCheckVal
                    ) {
                      if (parentSectionCheck) {
                        if (
                          document
                            .getElementById(parentSectionId)
                            ?.getAttribute("enable") === "false" ||
                          document
                            .getElementById(parentSectionId)
                            ?.getAttribute("enable") === false
                        )
                          frameEnableValue = false;
                        else frameEnableValue = true;
                        if (
                          document
                            .getElementById(parentSectionId)
                            ?.getAttribute("readonly") === "true" ||
                          document
                            .getElementById(parentSectionId)
                            ?.getAttribute("readonly") === true
                        )
                          frameReadOnlyValue = true;
                        else frameReadOnlyValue = false;
                        if (
                          document
                            .getElementById(parentSectionId)
                            ?.getAttribute("readOnlyValue") === "true" ||
                          document
                            .getElementById(parentSectionId)
                            ?.getAttribute("readOnlyValue") === true
                        )
                          framereadValue = true;
                        else framereadValue = false;
                        if (
                          document
                            .getElementById(tabId)
                            ?.getAttribute("readonly") === "true" ||
                          document
                            .getElementById(tabId)
                            ?.getAttribute("readonly") === true
                        )
                          frameReadOnlyValue = true;
                        else frameReadOnlyValue = false;
                        if (
                          document
                            .getElementById(tabId)
                            ?.getAttribute("readOnlyValue") === "true" ||
                          document
                            .getElementById(tabId)
                            ?.getAttribute("readOnlyValue") === true
                        )
                          framereadValue = true;
                        else framereadValue = false;
                        console.log(
                          "tabId",
                          document.getElementById(findTabId())
                        );
                        console.log(
                          "TabEnable",
                          document
                            .getElementById(findTabId())
                            ?.getAttribute("enable")
                        );
                        if (
                          document
                            .getElementById(tabId)
                            ?.getAttribute("enable") === "true" ||
                          document
                            .getElementById(tabId)
                            ?.getAttribute("enable") === true
                        )
                          frameEnableValue = true;
                        else frameEnableValue = false;
                        if (parentTabCheck) {
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("enable") === "true" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("enable") === true
                          )
                            frameEnableValue = true;
                          else frameEnableValue = false;
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readonly") === "true" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readonly") === true
                          )
                            frameReadOnlyValue = true;
                          else frameReadOnlyValue = false;
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readOnlyValue") === "true" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readOnlyValue") === true
                          )
                            framereadValue = true;
                          else framereadValue = false;
                        }
                      } else {
                        if (
                          document
                            .getElementById(tabId)
                            ?.getAttribute("enable") === "false" ||
                          document
                            .getElementById(tabId)
                            ?.getAttribute("enable") === false
                        )
                          frameEnableValue = false;
                        else frameEnableValue = true;
                        if (
                          document
                            .getElementById(tabId)
                            ?.getAttribute("readonly") === "true" ||
                          document
                            .getElementById(tabId)
                            ?.getAttribute("readonly") === true
                        )
                          frameReadOnlyValue = true;
                        else frameReadOnlyValue = false;
                        if (
                          document
                            .getElementById(tabId)
                            ?.getAttribute("readOnlyValue") === "true" ||
                          document
                            .getElementById(tabId)
                            ?.getAttribute("readOnlyValue") === true
                        )
                          framereadValue = true;
                        else framereadValue = false;
                        if (parentSectionVal) {
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("enable") === "false" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("enable") === false
                          ) {
                            frameEnableValue = false;
                          } else frameEnableValue = true;
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readonly") === "true" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readonly") === true
                          )
                            frameReadOnlyValue = true;
                          else frameReadOnlyValue = false;
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readOnlyValue") === "true" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readOnlyValue") === true
                          )
                            framereadValue = true;
                          else framereadValue = false;
                        }
                      }
                    } else if (
                      parentSectionVal &&
                      !parentTabCheck &&
                      !parenttabVal &&
                      !parentWizardCheckVal &&
                      !parentMenuCheckVal
                    ) {
                      frameEnableValue = document
                        .getElementById(findSectionId())
                        ?.getAttribute("enable");
                      frameReadOnlyValue = document
                        .getElementById(findSectionId())
                        ?.getAttribute("readonly");
                      framereadValue = document
                        .getElementById(findSectionId())
                        ?.getAttribute("readOnlyValue");
                    } else if (parentWizardCheckVal) {
                      if (
                        document
                          .getElementById("wizard")
                          ?.getAttribute("readonly") === "true" ||
                        document
                          .getElementById("wizard")
                          ?.getAttribute("readOnly") === true
                      )
                        frameReadOnlyValue = true;
                      else frameReadOnlyValue = false;
                      if (sectionId) {
                        if (
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("enable") === "false" ||
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("enable") === false
                        )
                          frameEnableValue = false;
                        else frameEnableValue = true;
                        if (
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("readonly") === "true" ||
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("readonly") === true
                        )
                          frameReadOnlyValue = true;
                        else frameReadOnlyValue = false;
                        if (
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("readOnlyValue") === "true" ||
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("readOnlyValue") === true
                        )
                          framereadValue = true;
                        else framereadValue = false;
                      }
                    } else if (parentMenuCheckVal) {
                      if (
                        document
                          .getElementById("wizard")
                          ?.getAttribute("readOnlyValue") === "true" ||
                        document
                          .getElementById(findTabId())
                          ?.getAttribute("readonlyvalue") === true
                      )
                        framereadValue = true;
                      if (
                        document
                          .getElementById("wizard")
                          ?.getAttribute("readonly") === "true" ||
                        document
                          .getElementById("wizard")
                          ?.getAttribute("readOnly") === true
                      )
                        frameReadOnlyValue = true;
                      if (sectionId) {
                        if (
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("enable") === "false" ||
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("enable") === false
                        )
                          frameEnableValue = false;
                        else frameEnableValue = true;
                        if (
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("readonly") === "true" ||
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("readonly") === true
                        )
                          frameReadOnlyValue = true;
                        else frameReadOnlyValue = false;
                        if (
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("readOnlyValue") === "true" ||
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("readOnlyValue") === true
                        )
                          framereadValue = true;
                        else framereadValue = false;
                      }
                    }
                    if (
                      frameEnableValue === true ||
                      frameEnableValue === "true"
                    )
                      controlElemToAdd["style"].Enable = "true";
                    else controlElemToAdd["style"].Enable = "false";
                    if (
                      frameReadOnlyValue === true ||
                      frameReadOnlyValue === "true"
                    )
                      controlElemToAdd["style"].ReadOnlyStyle = "true";
                    else controlElemToAdd["style"].ReadOnlyStyle = "false";
                    if (framereadValue === true || framereadValue === "true")
                      controlElemToAdd["style"].ReadOnly = "true";
                    else controlElemToAdd["style"].ReadOnly = "false";
                  }

                  if (
                    controlElemToAdd &&
                    targetElement.sheetIndex !== undefined
                  ) {
                    if (controlElemToAdd) {
                      extraDetails.isSubForm = isSubForm;
                      extraDetails.isAdvanceListview = isAdvanceListview;
                      if (controlElemToAdd?.id)
                        extraDetails["id"] = controlElemToAdd?.id;
                      sendRequestForControl(
                        controlElemToAdd.frameIndex,
                        "add",
                        "tableColumn",
                        extraDetails,
                        microFrontendData,
                        activePage,
                        activeSubForm,
                        targetElement
                      ).then((response) => {
                        if (response.data.status === 0) {
                          var column = {};
                          column.frameIndex = response.data.frameIndex;
                          column.columnIndex = response.data.columnIndex;
                          column.elementIndex = response.data.elementIndex;
                          column.sheetIndex = response.data.sheetIndex;
                          column.sheetElementIndex =
                            response.data.sheetElementIndex;
                          column.parent = "sheet";
                          column.style = Object.assign(
                            {},
                            ThemeJSON.tableColumn1
                          );
                          controlElemToAdd.columnList.push(column);
                          controlElemToAdd.style = {
                            ...controlElemToAdd.style,
                            ...cloneDeep(ThemeJSON.table),
                          };
                          if (openCanvasForSubform === "subform") {
                            jsonObj = createSmartFormState(
                              subFormStateJson.current,
                              targetElement.targetId,
                              targetElement.targetElemType,
                              "table",
                              0,
                              targetElement.frameIndex,
                              controlElemToAdd,
                              targetElemState.targetRowId,
                              targetElemState.targetColId,
                              device
                            );
                          } else if (
                            openCanvasForSubform ===
                            "advanceListviewFromScratch"
                          ) {
                            jsonObj = createSmartFormState(
                              fetchGridStates()?.advanceListviewStateJson,
                              targetElemState.targetId,
                              targetElemState.targetElemType,
                              "table",
                              0,
                              targetElemState.frameIndex,
                              controlElemToAdd,
                              targetElemState.targetRowId,
                              targetElemState.targetColId,
                              device
                            );
                          } else {
                            jsonObj = createSmartFormState(
                              formState2,
                              targetElement.targetId,
                              targetElement.targetElemType,
                              "table",
                              0,
                              targetElement.frameIndex,
                              controlElemToAdd,
                              targetElemState.targetRowId,
                              targetElemState.targetColId,
                              device
                            );
                          }

                          targetElement.targetId = "";
                          targetElement.targetClass = "";
                          targetElement.targetElemType = "";
                          setCurrElem("");
                          if (openCanvasForSubform === "subform") {
                            setSubFormState({ ...jsonObj });
                          } else if (
                            openCanvasForSubform ===
                            "advanceListviewFromScratch"
                          ) {
                            dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj }, renderCanvas: true }));
                          } else {
                            setFormStateByUser({ ...jsonObj });
                          }
                        } else if (response.data.status === 1) {
                          showAlertConfirmNotifications({
                            open: true,
                            showConfirm: "showNotification",
                            alertType: "error",
                            alertContentKey: `${t("Reopen_Form")}`,
                          });
                        }
                        setCurrentDataObjectJson(cloneDeep({}));
                        dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                      })
                      .catch((error) => {
                        loading(false)
                      })
                    }
                  } else if (controlElemToAdd) {
                    if (controlElemToAdd) {
                      extraDetails.isSubForm = isSubForm;
                      extraDetails.isAdvanceListview = isAdvanceListview;
                      if (controlElemToAdd?.id)
                        extraDetails["id"] = controlElemToAdd?.id;
                      if (targetElement?.insideWizard) {
                        setIsStep(targetElement);
                        formState2.isStep = targetElement;
                      }
                      sendRequestForControl(
                        controlElemToAdd.frameIndex,
                        "add",
                        "tableColumn",
                        extraDetails,
                        microFrontendData,
                        activePage,
                        activeSubForm,
                        targetElement
                      ).then((response) => {
                        if (response.data.status === 0) {
                          var column = {};
                          column.frameIndex = response.data.frameIndex;
                          column.columnIndex = response.data.columnIndex;
                          column.elementIndex = response.data.elementIndex;
                          column.parent = "frame";
                          column.style = Object.assign(
                            {},
                            ThemeJSON.tableColumn1
                          );
                          controlElemToAdd.columnList.push(column);
                          controlElemToAdd.style = {
                            ...controlElemToAdd.style,
                            ...JSON.parse(JSON.stringify(ThemeJSON.table)),
                          };
                          if (openCanvasForSubform === "subform") {
                            jsonObj = createSmartFormState(
                              subFormStateJson.current,
                              targetElemState.targetId,
                              targetElemState.targetElemType,
                              "table",
                              0,
                              targetElemState.frameIndex,
                              controlElemToAdd,
                              targetElemState.targetRowId,
                              targetElemState.targetColId,
                              device
                            );
                          } else if (
                            openCanvasForSubform ===
                            "advanceListviewFromScratch"
                          ) {
                            jsonObj = createSmartFormState(
                              fetchGridStates().advanceListviewStateJson,
                              targetElemState.targetId,
                              targetElemState.targetElemType,
                              "table",
                              0,
                              targetElemState.frameIndex,
                              controlElemToAdd,
                              targetElemState.targetRowId,
                              targetElemState.targetColId,
                              device
                            );
                          } else {
                            jsonObj = createSmartFormState(
                              formState2,
                              targetElemState.targetId,
                              targetElemState.targetElemType,
                              "table",
                              0,
                              targetElemState.frameIndex,
                              controlElemToAdd,
                              targetElemState.targetRowId,
                              targetElemState.targetColId,
                              device
                            );
                          }

                          targetElemState.targetId = "";
                          targetElemState.targetClass = "";
                          targetElemState.targetElemType = "";
                          setCurrElem("");
                          if (openCanvasForSubform === "subform") {
                            setSubFormState({ ...jsonObj });
                          } else if (
                            openCanvasForSubform ===
                            "advanceListviewFromScratch"
                          ) {
                            dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj }, renderCanvas:true}));
                          } else {
                            setFormStateByUser({ ...jsonObj });
                          }
                        } else if (response.data.status === 1) {
                          showAlertConfirmNotifications({
                            open: true,
                            showConfirm: "showNotification",
                            alertType: "error",
                            alertContentKey: `${t("Reopen_Form")}`,
                          });
                        }
                        setCurrentDataObjectJson(cloneDeep({}));
                        dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                      })
                      .catch((error) => {
                        loading(false)
                      })
                    }
                  }
                } else if (response.data.status === 1) {
                  showAlertConfirmNotifications({
                    open: true,
                    showConfirm: "showNotification",
                    alertType: "error",
                    alertContentKey: `${t("Reopen_Form")}`,
                  });
                }
                setCurrentDataObjectJson(cloneDeep({}));
                dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
              })
              .catch((error) => {
                loading(false)
              })
            } else {
              setCurrentDataObjectJson(cloneDeep({}));
              dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: `${t(
                  "Please_Drop_Control_Inside_Section_Canvas"
                )}`,
              });
              
            }
          } else if (
            targetElemState.targetElemType.toLowerCase() !== "step" &&
            targetElemState.targetElemType.toLowerCase() !== "substep" &&
            currElemState.current === "listview" &&
            !targetElemState.targetRowId.includes("before_frame")
          ) {
            if (flag4 !== 1) {
              if (
                dataObjectJson &&
                Object.keys(dataObjectJson).length === 0 &&
                Object.keys(currentDataObjectJson.current).length === 0
              ) {
                targetElemState.isSubForm = isSubForm;
                targetElemState.isAdvanceListview = isAdvanceListview;
                if (!targetElemState.frameIndex) {
                  if (targetElement?.targetId) {
                    targetElemState.frameIndex = document
                      .querySelector(`#${targetElement.targetId}`)
                      .closest("[elem_type=frame]")
                      .getAttribute("frameindex");
                  } else if (targetElemState?.targetId) {
                    targetElemState.frameIndex = document
                      .querySelector(`#${targetElemState?.targetId}`)
                      .closest("[elem_type=frame]")
                      .getAttribute("frameindex");
                  }
                }
                sendRequestForControl(
                  targetElemState.frameIndex,
                  "add",
                  currElemState.current,
                  targetElemState,
                  microFrontendData,
                  activePage,
                  activeSubForm,
                  targetElemState
                ).then((response) => {
                  if (response.data.status === 0) {
                    var controlElemToAdd = response.data;
                    setOpenQuickToolFor(controlElemToAdd?.id);
                    if (
                      targetElemState.targetElemType === "tabChild" ||
                      Object.keys(response.data).includes(
                        "sheetFrameElementIndex"
                      )
                    ) {
                      controlElemToAdd.sheetIndex = targetElemState.sheetIndex;
                      controlElemToAdd.elementIndex =
                        targetElemState.elementIndex;
                    }
                    if (
                      targetElemState.sheetElementIndex !== undefined &&
                      targetElemState.sheetElementIndex !== null
                    ) {
                      controlElemToAdd.sheetElementIndex =
                        targetElemState.sheetElementIndex;
                    }
                    controlElemToAdd.columnList = [];
                    var extraDetails = {
                      targetElemType: targetElemState.targetElemType,
                    };

                    extraDetails.elementIndex = controlElemToAdd.elementIndex;
                    extraDetails.elem_type = "column";
                    if (targetElemState.sheetIndex !== undefined) {
                      extraDetails.elementIndex = targetElemState.elementIndex;
                      extraDetails.sheetIndex = targetElemState.sheetIndex;
                      extraDetails.sheetElementIndex =
                        controlElemToAdd.sheetElementIndex;
                      extraDetails.elem_type = "column";
                    }
                    if (
                      targetElemState.sheetElementIndex !== undefined &&
                      targetElemState.sheetElementIndex !== null
                    ) {
                      extraDetails.sheetElementIndex =
                        targetElemState.sheetElementIndex;
                      extraDetails.sheetFrameElementIndex =
                        controlElemToAdd.sheetFrameElementIndex;
                    }

                    if (controlElemToAdd) {
                      if (controlElemToAdd) {
                        extraDetails.isSubForm = isSubForm;
                        extraDetails.isAdvanceListview = isAdvanceListview;
                        if (controlElemToAdd?.id)
                          extraDetails["id"] = controlElemToAdd?.id;
                        setIsStep(targetElemState);
                        formState2.isStep = targetElemState;
                        sendRequestForControl(
                          controlElemToAdd.frameIndex,
                          "add",
                          "tableColumn",
                          extraDetails,
                          microFrontendData,
                          activePage,
                          activeSubForm,
                          targetElemState
                        ).then((response) => {
                          if (response.data.status === 0) {
                            var column = {};
                            column.frameIndex = response.data.frameIndex;
                            column.columnIndex = response.data.columnIndex;
                            column.elementIndex = response.data.elementIndex;
                            column.parent = "frame";
                            column.elementJson = response.data.elementJson;
                            column.style = Object.assign(
                              {},
                              ThemeJSON.tableColumn1
                            );
                            controlElemToAdd.columnList.push(column);
                            controlElemToAdd.style = JSON.parse(
                              JSON.stringify(ThemeJSON.listview)
                            );
                            if (openCanvasForSubform === "subform") {
                              jsonObj = createSmartFormState(
                                subFormStateJson.current,
                                targetElemState.targetId,
                                targetElemState.targetElemType,
                                "listview",
                                0,
                                targetElemState.frameIndex,
                                controlElemToAdd,
                                targetElemState.targetRowId,
                                targetElemState.targetColId,
                                device
                              );
                            } else if (
                              openCanvasForSubform ===
                              "advanceListviewFromScratch"
                            ) {
                              jsonObj = createSmartFormState(
                                fetchGridStates().advanceListviewStateJson,
                                targetElemState.targetId,
                                targetElemState.targetElemType,
                                "listview",
                                0,
                                targetElemState.frameIndex,
                                controlElemToAdd,
                                targetElemState.targetRowId,
                                targetElemState.targetColId,
                                device
                              );
                            } else {
                              jsonObj = createSmartFormState(
                                formState2,
                                targetElemState.targetId,
                                targetElemState.targetElemType,
                                "listview",
                                0,
                                targetElemState.frameIndex,
                                controlElemToAdd,
                                targetElemState.targetRowId,
                                targetElemState.targetColId,
                                device
                              );
                            }

                            targetElemState.targetId = "";
                            targetElemState.targetClass = "";
                            targetElemState.targetElemType = "";
                            setCurrElem("");
                            if (openCanvasForSubform === "subform") {
                              setSubFormState({ ...jsonObj });
                            } else if (
                              openCanvasForSubform ===
                              "advanceListviewFromScratch"
                            ) {
                              dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj }, renderCanvas:true}));
                            } else {
                              setFormStateByUser({ ...jsonObj });
                            }
                          } else if (response.data.status === 1) {
                            showAlertConfirmNotifications({
                              open: true,
                              showConfirm: "showNotification",
                              alertType: "error",
                              alertContentKey: `${t("Reopen_Form")}`,
                            });
                          }
                        })
                        .catch((error) => {
                          loading(false)
                        })
                      }
                    } else if (
                      controlElemToAdd &&
                      targetElemState.targetElemType === "tabChild"
                    ) {
                      if (controlElemToAdd) {
                        extraDetails.isSubForm = isSubForm;
                        extraDetails.isAdvanceListview = isAdvanceListview;
                        sendRequestForControl(
                          controlElemToAdd.frameIndex,
                          "add",
                          "tableColumn",
                          extraDetails,
                          activePage?.formId,
                          activePage,
                          activeSubForm
                        ).then((response) => {
                          if (response.data.status === 0) {
                            var column = {};
                            column.frameIndex = response.data.frameIndex;
                            column.columnIndex = response.data.columnIndex;
                            column.elementIndex = response.data.elementIndex;
                            column.sheetIndex = response.data.sheetIndex;
                            column.sheetElementIndex =
                              response.data.sheetElementIndex;
                            column.parent = "sheet";
                            column.style = Object.assign(
                              {},
                              ThemeJSON.tableColumn1
                            );
                            controlElemToAdd.columnList.push(column);
                            controlElemToAdd.style = JSON.parse(
                              JSON.stringify(ThemeJSON.listview)
                            );
                            if (openCanvasForSubform === "subform") {
                              jsonObj = createSmartFormState(
                                subFormStateJson.current,
                                targetElemState.targetId,
                                targetElemState.targetElemType,
                                "listview",
                                0,
                                targetElemState.frameIndex,
                                controlElemToAdd,
                                targetElemState.targetRowId,
                                targetElemState.targetColId,
                                device
                              );
                            } else if (
                              openCanvasForSubform ===
                              "advanceListviewFromScratch"
                            ) {
                              jsonObj = createSmartFormState(
                                fetchGridStates().advanceListviewStateJson,
                                targetElemState.targetId,
                                targetElemState.targetElemType,
                                "listview",
                                0,
                                targetElemState.frameIndex,
                                controlElemToAdd,
                                targetElemState.targetRowId,
                                targetElemState.targetColId,
                                device
                              );
                            } else {
                              jsonObj = createSmartFormState(
                                formState2,
                                targetElemState.targetId,
                                targetElemState.targetElemType,
                                "listview",
                                0,
                                targetElemState.frameIndex,
                                controlElemToAdd,
                                targetElemState.targetRowId,
                                targetElemState.targetColId,
                                device
                              );
                            }

                            targetElemState.targetId = "";
                            targetElemState.targetClass = "";
                            targetElemState.targetElemType = "";
                            setCurrElem("");
                            if (openCanvasForSubform === "subform") {
                              setSubFormState({ ...jsonObj });
                            } else if (
                              openCanvasForSubform ===
                              "advanceListviewFromScratch"
                            ) {
                              dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj }, renderCanvas:true}));
                            } else {
                              setFormStateByUser({ ...jsonObj });
                            }
                          } else if (response.data.status === 1) {
                            showAlertConfirmNotifications({
                              open: true,
                              showConfirm: "showNotification",
                              alertType: "error",
                              alertContentKey: `${t("Reopen_Form")}`,
                            });
                          }
                        })
                        .catch((error) => {
                          loading(false)
                        })
                      }
                    }
                  } else if (response.data.status === 1) {
                    showAlertConfirmNotifications({
                      open: true,
                      showConfirm: "showNotification",
                      alertType: "error",
                      alertContentKey: `${t("Reopen_Form")}`,
                    });
                  }
                  setCurrentDataObjectJson(cloneDeep({}));
                  dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                })
                .catch((error) => {
                  loading(false)
                })
              } else if (
                currentDataObjectJson.current &&
                Object.keys(currentDataObjectJson.current).length !== 0
              ) {
                targetElemState.isSubForm = isSubForm;
                targetElemState.isAdvanceListview = isAdvanceListview;
                if (!targetElemState.frameIndex) {
                  targetElemState.frameIndex = document
                    .querySelector(`#${targetElemState.targetId}`)
                    .closest("[elem_type=frame]")
                    .getAttribute("frameindex");
                }
                sendRequestForControl(
                  targetElemState.frameIndex,
                  "add",
                  currElemState.current,
                  targetElemState
                ).then(async (response) => {
                  if (response.data.status === 0) {
                    var controlElemToAdd = response.data;
                    setOpenQuickToolFor(controlElemToAdd?.id);

                    if (
                      currentDataObjectJson.current &&
                      currentDataObjectJson.current["treeName"]
                    ) {
                      let dataClassMap;

                      dataClassMap = currentDataObjectJson.current["treeName"];

                      mappingControlsIdMap.add(
                        currentDataObjectJson.current["treeName"]
                      );

                      // var treeName = data.treeName;
                      var treeName = currentDataObjectJson.current?.treeName;
                      let currentDataObjectsContent = getCurrentDataObjectsContent()
                      var hasChild;
                      let dataObj = findDataObjectListView(
                        currentDataObjectsContent || dataObjectsContent,
                        currentDataObjectJson.current?.treeName,
                        "children"
                      );
                      if (dataObj && dataObj.children && dataObj.children.length > 0) {
                        hasChild = true;
                      } else {
                        hasChild = false;
                      }

                      var jsonToSend = {
                        mappedField: treeName,
                        unbounded: currentDataObjectJson.current?.Unbounded,
                        isProcessVar:
                        currentDataObjectJson.current?.dataObjectType === "M"
                            ? false
                            : currentDataObjectJson.current?.dataObjectType === "P"
                            ? true
                            : "",
                        hasChild: hasChild,
                        formId:
                          microFrontendData?.formDefId ||
                          activePage?.formId ||
                          activeSubForm?.fragmentId ||
                          microFrontendData?.processDefId ||
                          microFrontendData?.templateId,
                      };
                      try{
                        mappingExistOrNot(jsonToSend).then((response) => {
                          if (response.data.status === "-1") {
                            showAlertConfirmNotifications({
                              open: true,
                              showConfirm: "showNotification",
                              alertType: "error",
                              alertContentKey: `mappingError`
                            });
                          }
                        })
                      }catch(e){
                        console.log(e)
                      }

                      controlElemToAdd["TypeOfValue"] =
                        currentDataObjectJson.current["VariableType"];
                      controlElemToAdd["dataclass"] = dataClassMap;
                      controlElemToAdd["unBounded"] = currentDataObjectJson.current["Unbounded"]

                      controlElemToAdd.style.Label = currentDataObjectJson.current["treeName"]
                      setCurrentMappedDO((prev) => {
                        return [...prev, currentDataObjectJson.current["treeName"]];
                      });
                      controlElemToAdd.style["ListviewLabel"] =
                        currentDataObjectJson.current["treeName"];
                      controlElemToAdd.style.Mapping = dataClassMap;
                      controlElemToAdd.style.MappingId =
                        currentDataObjectJson.current["treeName"];
                      currentDataObjectJson.current["isMapped"] = true;
                      // controlElemToAdd.style.MappingId = currentDataObjectJson['VariableName'];

                      //     controlElemToAdd['style'] = {'Label' : currentDataObjectJson['VariableName'],
                      //         'Mapping' : dataClassMap,
                      //         'MappingId' : currentDataObjectJson['VariableName']
                      // };
                    }

                    if (
                      targetElemState.targetElemType === "tabChild" ||
                      Object.keys(response.data).includes(
                        "sheetFrameElementIndex"
                      )
                    ) {
                      controlElemToAdd.sheetIndex = targetElemState.sheetIndex;
                      controlElemToAdd.elementIndex =
                        targetElemState.elementIndex;
                    }
                    if (
                      targetElemState.sheetElementIndex !== undefined &&
                      targetElemState.sheetElementIndex !== null
                    ) {
                      controlElemToAdd.sheetElementIndex =
                        targetElemState.sheetElementIndex;
                    }
                    controlElemToAdd.columnList = [];
                    var extraDetails = {
                      targetElemType: targetElemState.targetElemType,
                    };

                    extraDetails.elementIndex = controlElemToAdd.elementIndex;
                    extraDetails.elem_type = "column";
                    if (targetElemState.sheetIndex !== undefined) {
                      extraDetails.elementIndex = targetElemState.elementIndex;
                      extraDetails.sheetIndex = targetElemState.sheetIndex;
                      extraDetails.sheetElementIndex =
                        controlElemToAdd.sheetElementIndex;
                      extraDetails.elem_type = "column";
                    }
                    if (
                      targetElemState.sheetElementIndex !== undefined &&
                      targetElemState.sheetElementIndex !== null
                    ) {
                      extraDetails.sheetElementIndex =
                        targetElemState.sheetElementIndex;
                      extraDetails.sheetFrameElementIndex =
                        controlElemToAdd.sheetFrameElementIndex;
                    }

                    if (controlElemToAdd) {
                      if (controlElemToAdd) {
                        extraDetails.isSubForm = isSubForm;
                        extraDetails.isAdvanceListview = isAdvanceListview;

                        for (let columns of currentDataObjectJson.current
                          ?.children) {
                          loading(true)
                          const columnNameDataObject = columns.VariableName;
                          extraDetails.columnName = columnNameDataObject
                          if(columns?.VariableType?.toLowerCase() === "shortdate" || columns?.VariableType?.toLowerCase() === "short date") {
                            extraDetails["ColumnType"] = "datepick";
                          } else if(columns?.VariableType?.toLowerCase() === "date") {
                            extraDetails["ColumnType"] = "datepick";
                            extraDetails["PickerType"] = "2";
                          } else if(columns?.VariableType?.toLowerCase() === "boolean"){
                            extraDetails["ColumnType"] = "toggle";
                            extraDetails["ToggleState1"] = "No";
                            extraDetails["ToggleState2"] = "Yes";
                            extraDetails["ToggleStates"] = "Yes/No";
                            extraDetails["complexFieldType"] = "Boolean";
                          } else {
                            extraDetails["ColumnType"] = "textbox";
                            extraDetails?.["PickerType"] && delete extraDetails["PickerType"];
                            extraDetails?.["ToggleState1"] && delete extraDetails["ToggleState1"];
                            extraDetails?.["ToggleState2"] && delete extraDetails["ToggleState2"];
                            extraDetails?.["ToggleStates"] && delete extraDetails["ToggleStates"]
                            extraDetails?.["complexFieldType"] && delete extraDetails["complexFieldType"]
                          }
                          let colResponse = await sendRequestForControl(
                            controlElemToAdd.frameIndex,
                            "add",
                            "tableColumn",
                            extraDetails,
                            microFrontendData,
                            "",
                            "",
                            targetElemState,
                            controlElemToAdd, 
                            true
                          ).then((response) => {
                            if (response.data.status === 0) {
                              var column = {};
                              column.frameIndex = response.data.frameIndex;
                              column.columnIndex = response.data.columnIndex;
                              column.elementIndex = response.data.elementIndex;
                              column.parent = "frame";
                              column.elementJson = response.data.elementJson;
                              column.style = Object.assign(
                                {},
                                ThemeJSON.tableColumn1
                              );
                              if(columns?.VariableType?.toLowerCase() === "shortdate" || columns?.VariableType?.toLowerCase() === "short date") {
                                column.style["ColumnType"] = "datepick";
                                column.style["DateFormat"] = "1";
                              }else if(columns?.VariableType?.toLowerCase() === "date") {
                                column.style["ColumnType"] = "datetimepick";
                                column.style["PickerType"] = "2";
                                column.style["DateFormat"] = "5";
                              }else if(columns?.VariableType?.toLowerCase() === "boolean"){
                                column.style["ColumnType"] = "toggle";
                                column.style["ToggleState1"] = "No";
                                column.style["ToggleState2"] = "Yes";
                                column.style["ToggleStates"] = "Yes/No";
                                column.style["complexFieldType"] = "Boolean";
                              }else {
                                column.style["ColumnType"] = "textbox";
                                column.style?.["PickerType"] && delete column.style["PickerType"];
                                column.style?.["ToggleState1"] && delete column.style["ToggleState1"];
                                column.style?.["ToggleState2"] && delete column.style["ToggleState2"];
                                column.style?.["ToggleStates"] && delete column.style["ToggleStates"]
                                column.style?.["complexFieldType"] && delete column.style["complexFieldType"]
                              }
                              const defaultColumnWidth = 100/currentDataObjectJson.current.children.length
                              column.style["ColumnWidth"] = currentDataObjectJson.current.children.length > 10 ? `${defaultColumnWidth.toFixed(2)}%` : "10%";
                              column.style.ColumnName = columnNameDataObject;
                              column.style.complexFieldName =
                                columnNameDataObject;
                              column.style.complexFieldType =
                                columns?.VariableType;
                              column.style.complexFieldVariableLength =
                                columns?.VariableLength;
                              column.style.complexFieldVariablePrecision =
                                columns?.VarPrecision;
                              column=dragAndDropThroughMDM(columns,column);
                              setCurrentMappedDO((prev) => {
                                return [...prev, columns?.["treeName"]];
                              });
                              // column.style.controlid = response?.data?.id;
                              controlElemToAdd.columnList.push(column);
                              controlElemToAdd.initialColumnLength = currentDataObjectJson.current?.children?.length;
                              controlElemToAdd.style = {
                                ...controlElemToAdd.style,
                                ...JSON.parse(
                                  JSON.stringify(ThemeJSON.listview)
                                ),
                              };
                            } else if (response.data.status === 1) {
                              showAlertConfirmNotifications({
                                open: true,
                                showConfirm: "showNotification",
                                alertType: "error",
                                alertContentKey: `${t("Reopen_Form")}`,
                              });
                            }
                          })
                          .catch((error) => {
                            loading(false)
                          })
                        }
                        loading(false)
                      }
                    } else if (
                      controlElemToAdd &&
                      targetElemState.targetElemType === "tabChild"
                    ) {
                      if (controlElemToAdd) {
                        extraDetails.isSubForm = isSubForm;
                        extraDetails.isAdvanceListview = isAdvanceListview;
                        sendRequestForControl(
                          controlElemToAdd.frameIndex,
                          "add",
                          "tableColumn",
                          extraDetails,
                          activePage?.formId,
                          activePage
                        ).then((response) => {
                          if (response.data.status === 0) {
                            var column = {};
                            column.frameIndex = response.data.frameIndex;
                            column.columnIndex = response.data.columnIndex;
                            column.elementIndex = response.data.elementIndex;
                            column.sheetIndex = response.data.sheetIndex;
                            column.sheetElementIndex =
                              response.data.sheetElementIndex;
                            column.parent = "sheet";
                            column.style = Object.assign(
                              {},
                              ThemeJSON.tableColumn1
                            );
                            controlElemToAdd.columnList.push(column);
                            controlElemToAdd.style = JSON.parse(
                              JSON.stringify(ThemeJSON.listview)
                            );
                          } else if (response.data.status === 1) {
                            showAlertConfirmNotifications({
                              open: true,
                              showConfirm: "showNotification",
                              alertType: "error",
                              alertContentKey: `${t("Reopen_Form")}`,
                            });
                          }
                        })
                        .catch((error) => {
                          loading(false)
                        })
                      }
                    }
                    if (openCanvasForSubform === "subform") {
                      jsonObj = createSmartFormState(
                        subFormStateJson.current,
                        targetElemState.targetId,
                        targetElemState.targetElemType,
                        "listview",
                        0,
                        targetElemState.frameIndex,
                        controlElemToAdd,
                        targetElemState.targetRowId,
                        targetElemState.targetColId,
                        device
                      );
                    } else if (
                      openCanvasForSubform ===
                      "advanceListviewFromScratch"
                    ) {
                      jsonObj = createSmartFormState(
                        fetchGridStates().advanceListviewStateJson,
                        targetElemState.targetId,
                        targetElemState.targetElemType,
                        "listview",
                        0,
                        targetElemState.frameIndex,
                        controlElemToAdd,
                        targetElemState.targetRowId,
                        targetElemState.targetColId,
                        device
                      );
                    } else {
                      jsonObj = createSmartFormState(
                        formState2,
                        targetElemState.targetId,
                        targetElemState.targetElemType,
                        "listview",
                        0,
                        targetElemState.frameIndex,
                        controlElemToAdd,
                        targetElemState.targetRowId,
                        targetElemState.targetColId,
                        device
                      );
                    }

                    targetElemState.targetId = "";
                    targetElemState.targetClass = "";
                    targetElemState.targetElemType = "";
                    setCurrElem("");
                    if (openCanvasForSubform === "subform") {
                      setSubFormState({ ...jsonObj });
                    } else if (
                      openCanvasForSubform ===
                      "advanceListviewFromScratch"
                    ) {
                      dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj },renderCanvas:true}));
                    } else {
                      setFormStateByUser({ ...jsonObj });
                    }
                    setCurrentDataObjectJson(cloneDeep({}));
                    dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                  } else if (response.data.status === 1) {
                    showAlertConfirmNotifications({
                      open: true,
                      showConfirm: "showNotification",
                      alertType: "error",
                      alertContentKey: `${t("Reopen_Form")}`,
                    });
                  }
                  setCurrentDataObjectJson(cloneDeep({}));
                  dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                })
                .catch((error) => {
                  loading(false)
                })
              } else {
                Object.keys(dataObjectJson).map((key, data) => {
                  if (key === "columnList") {
                    Object.values(dataObjectJson[key]).map(
                      (dataOfChildren, index) => {
                        dataOfChildren["columnIndex"] = index;
                        dataOfChildren["elementIndex"] = index;
                        dataOfChildren["style"]["ColumnName"] =
                          dataOfChildren["style"]["Label"];
                        dataOfChildren["style"]["ColumnType"] =
                          dataOfChildren["elem_type"];

                        delete dataOfChildren["elem_type"];
                      }
                    );
                  }
                });

                // dataObjectJson["columnList"]=dataObjectJson["children"];

                var populateInside = {
                  id: "frame6",
                  elem_type: "frame",
                  frameIndex: targetElemState.frameIndex,
                  elementIndex: targetElemState.elementIndex,
                  sheetElementIndex: targetElemState.sheetElementIndex,
                  // sheetFrameElementIndex: parentControl["sheetFrameElementIndex"],
                  // sheetId: parentControl["sheetIndex"],
                };

                let jsonToBeSendToBackend = {
                  populateInside: populateInside,
                  populateElem: dataObjectJson,
                };

                if (!mappingDataObjectsMap.has(dataObjectJson["caption"])) {
                  jsonToBeSendToBackend.isSubForm = isSubForm;
                  jsonToBeSendToBackend.isAdvanceListview = isAdvanceListview;
                  sendRequestForControl(
                    null,
                    "duplicateDataObject",
                    null,
                    jsonToBeSendToBackend
                  ).then((response) => {
                    if (response.data.populatedJson !== null) {
                      response.data.populatedJson.VariableName =
                        dataObjectJson["caption"];
                      mappingDataObjectsMap.set(dataObjectJson["caption"], 10);

                      jsonObj = createSmartFormState(
                        formState2,
                        targetElemState.targetId,
                        targetElemState.targetElemType,
                        "listview",
                        0,
                        targetElemState.frameIndex,
                        response.data.populatedJson,
                        targetElemState.targetRowId,
                        targetElemState.targetColId,
                        device
                      );

                      targetElemState.targetId = "";
                      targetElemState.targetClass = "";
                      targetElemState.targetElemType = "";
                      setCurrElem("");
                      if (openCanvasForSubform === "subform") {
                        setSubFormState({ ...jsonObj });
                      } else if (
                        openCanvasForSubform === "advanceListviewFromScratch"
                      ) {
                        dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj },renderCanvas:true}));
                      } else {
                        setFormStateByUser({ ...jsonObj });
                      }
                    }
                    setCurrentDataObjectJson(cloneDeep({}));
                    dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                  })
                  .catch((error) => {
                    loading(false)
                  })

                  setDataObjectJson({});
                } else {
                  //customalert
                  showAlertConfirmNotifications({
                    open: true,
                    showConfirm: "showNotification",
                    alertType: "error",
                    alertContentKey: "DATA_PRESENT",
                  });
                  // alert('This Data Object is already present');
                }
              }
            } else {
              setCurrentDataObjectJson(cloneDeep({}));
              dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: `${t(
                  "Please_Drop_Control_Inside_Section_Canvas"
                )}`,
              });
              
            }
          } else if (
            targetElemState.targetElemType.toLowerCase() !== "step" &&
            targetElemState.targetElemType.toLowerCase() !== "substep" &&
            currElemState.current === "advancelistview"
          ) {
            if (
              flag4 !== 1 &&
              !targetElemState.targetRowId.includes("before_frame")
            ) {
              targetElemState.isSubForm = isSubForm;
              targetElemState.isAdvanceListview = isAdvanceListview;
              if (currElemState.current === "advancelistview") {
                // isAdvanceListview = true;
              }
              if (!targetElemState.frameIndex) {
                if (targetElement?.targetId) {
                  targetElemState.frameIndex = document
                    .querySelector(`#${targetElement.targetId}`)
                    .closest("[elem_type=frame]")
                    .getAttribute("frameindex");
                } else if (targetElemState?.targetId) {
                  targetElemState.frameIndex = document
                    .querySelector(`#${targetElemState?.targetId}`)
                    .closest("[elem_type=frame]")
                    .getAttribute("frameindex");
                }
              }
              sendRequestForControl(
                targetElemState.frameIndex,
                "add",
                currElemState.current,
                targetElemState,
                microFrontendData,
                activePage,
                targetElement
              ).then((response) => {
                if (response.data.status === 0) {
                  var controlElemToAdd = response.data;
                  setOpenQuickToolFor(controlElemToAdd?.id);

                  if (
                    currentDataObjectJson.current &&
                    currentDataObjectJson.current["treeName"]
                  ) {
                    var treeName = currentDataObjectJson.current?.treeName;
                    let currentDataObjectsContent = getCurrentDataObjectsContent()
                    var hasChild;
                    let dataObj = findDataObjectListView(
                      currentDataObjectsContent || dataObjectsContent,
                      currentDataObjectJson.current?.treeName,
                      "children"
                    );
                    if (dataObj && dataObj.children && dataObj.children.length > 0) {
                      hasChild = true;
                    } else {
                      hasChild = false;
                    }

                    var jsonToSend = {
                      mappedField: treeName,
                      unbounded: currentDataObjectJson.current?.Unbounded,
                      isProcessVar:
                      currentDataObjectJson.current?.dataObjectType === "M"
                          ? false
                          : currentDataObjectJson.current?.dataObjectType === "P"
                          ? true
                          : "",
                      hasChild: hasChild,
                      formId:
                        microFrontendData?.formDefId ||
                        activePage?.formId ||
                        activeSubForm?.fragmentId ||
                        microFrontendData?.processDefId ||
                        microFrontendData?.templateId,
                    };
                    try{
                      mappingExistOrNot(jsonToSend).then((response) => {
                        if (response.data.status === "-1") {
                          showAlertConfirmNotifications({
                            open: true,
                            showConfirm: "showNotification",
                            alertType: "error",
                            alertContentKey: `mappingError`
                          });
                        }
                      })
                    }catch(e){
                      console.log(e)
                    }

                    currentDataObjectJson.current["isMapped"] = true;
                    mappingControlsIdMap.add(
                      currentDataObjectJson.current["treeName"]
                    );
                    controlElemToAdd["TypeOfValue"] =
                    currentDataObjectJson.current["VariableType"];
                    controlElemToAdd["dataclass"] = currentDataObjectJson.current["treeName"];
                    controlElemToAdd["style"] = {
                    ...ThemeJSON.advancelistview,
                    Label: currentDataObjectJson.current["treeName"] || controlElemToAdd?.id,
                    Mapping:  currentDataObjectJson.current["treeName"],
                    MappingId:
                      currentDataObjectJson.current["treeName"],
                    Enable: "true",
                    Visible: "true",
                  };
                  setCurrentMappedDO((prev) => {
                    return [...prev, currentDataObjectJson.current["treeName"]];
                  });
                  }


                  if (
                    targetElemState.targetElemType === "tabChild" ||
                    Object.keys(response.data).includes(
                      "sheetFrameElementIndex"
                    )
                  ) {
                    controlElemToAdd.sheetIndex = targetElemState.sheetIndex;
                    controlElemToAdd.elementIndex =
                      targetElemState.elementIndex;
                  }
                  if (
                    targetElemState.sheetElementIndex !== undefined &&
                    targetElemState.sheetElementIndex !== null
                  ) {
                    controlElemToAdd.sheetElementIndex =
                      targetElemState.sheetElementIndex;
                  }
                  controlElemToAdd.columnList = [];
                  var extraDetails = {
                    targetElemType: targetElemState.targetElemType,
                  };

                  extraDetails.elementIndex = controlElemToAdd.elementIndex;
                  extraDetails.elem_type = "column";
                  if (targetElemState.sheetIndex !== undefined) {
                    extraDetails.elementIndex = targetElemState.elementIndex;
                    extraDetails.sheetIndex = targetElemState.sheetIndex;
                    extraDetails.sheetElementIndex =
                      controlElemToAdd.sheetElementIndex;
                    extraDetails.elem_type = "column";
                  }
                  if (
                    targetElemState.sheetElementIndex !== undefined &&
                    targetElemState.sheetElementIndex !== null
                  ) {
                    extraDetails.sheetElementIndex =
                      targetElemState.sheetElementIndex;
                    extraDetails.sheetFrameElementIndex =
                      controlElemToAdd.sheetFrameElementIndex;
                  }

                  if (controlElemToAdd) {
                    if (controlElemToAdd) {
                      extraDetails.isSubForm = isSubForm;
                      extraDetails.isAdvanceListview = isAdvanceListview;
                      if (controlElemToAdd?.id)
                        extraDetails["id"] = controlElemToAdd?.id;
                      setIsStep(targetElemState);
                      formState2.isStep = targetElemState;
                      sendRequestForControl(
                        controlElemToAdd.frameIndex,
                        "add",
                        "tableColumn",
                        extraDetails,
                        microFrontendData,
                        activePage,
                        activeSubForm,
                        targetElemState
                      ).then((response) => {
                        if (response.data.status === 0) {
                          var column = {};
                          column.frameIndex = response.data.frameIndex;
                          column.columnIndex = response.data.columnIndex;
                          column.elementIndex = response.data.elementIndex;
                          column.parent = "frame";
                          column.style = Object.assign(
                            {},
                            ThemeJSON.tableColumn1
                          );
                          controlElemToAdd.columnList.push(column);
                          controlElemToAdd.style = {...controlElemToAdd.style,
                            ...JSON.parse(
                            JSON.stringify(ThemeJSON.advancelistview)
                          )
                        };
                          if (openCanvasForSubform === "subform") {
                            // jsonObj =  createSmartFormState(subFormStateJson.current, targetElemState.targetId, targetElemState.targetElemType, 'listview',0, targetElemState.frameIndex, controlElemToAdd, device );
                            jsonObj = createSmartFormState(
                              subFormStateJson.current,
                              targetElemState.targetId,
                              targetElemState.targetElemType,
                              "advancelistView",
                              0,
                              targetElemState.frameIndex,
                              controlElemToAdd,
                              targetElemState.targetRowId,
                              targetElemState.targetColId,
                              device
                            );
                          } else if (
                            openCanvasForSubform ===
                            "advanceListviewFromScratch"
                          ) {
                            jsonObj = createSmartFormState(
                              fetchGridStates().advanceListviewStateJson,
                              targetElemState.targetId,
                              targetElemState.targetElemType,
                              "advancelistView",
                              0,
                              targetElemState.frameIndex,
                              controlElemToAdd,
                              targetElemState.targetRowId,
                              targetElemState.targetColId,
                              device
                            );
                          } else {
                            jsonObj = createSmartFormState(
                              formState2,
                              targetElemState.targetId,
                              targetElemState.targetElemType,
                              "advancelistView",
                              0,
                              targetElemState.frameIndex,
                              controlElemToAdd,
                              targetElemState.targetRowId,
                              targetElemState.targetColId,
                              device
                            );
                          }
                        //   currentDataObjectJson.current[
                        //     "isMapped"
                        //   ] = true;
                        //   mappingControlsIdMap.add(
                        //     currentDataObjectJson.current["treeName"]
                        //   );
                        //   controlElemToAdd["TypeOfValue"] =
                        //   currentDataObjectJson["VariableType"];
                        //   controlElemToAdd["dataclass"] = currentDataObjectJson.current["treeName"];
                        //   controlElemToAdd["style"] = {
                        //   ...ThemeJSON.advancelistview,
                        //   Label: currentDataObjectJson.current["treeName"] || controlElemToAdd?.id,
                        //   Mapping:  currentDataObjectJson.current["treeName"],
                        //   MappingId:
                        //     currentDataObjectJson.current["treeName"],
                        //   Enable: "true",
                        //   Visible: "true",
                        // };
                        setCurrentDataObjectJson(cloneDeep({}));
                        dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                          targetElemState.targetId = "";
                          targetElemState.targetClass = "";
                          targetElemState.targetElemType = "";
                          setCurrElem("");
                          if (openCanvasForSubform === "subform") {
                            setSubFormState({ ...jsonObj });
                          } else if (
                            openCanvasForSubform ===
                            "advanceListviewFromScratch"
                          ) {
                            dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj },renderCanvas:true}));
                          } else {
                            setFormStateByUser({ ...jsonObj });
                          }
                        } else if (response.data.status === 1) {
                          showAlertConfirmNotifications({
                            open: true,
                            showConfirm: "showNotification",
                            alertType: "error",
                            alertContentKey: `${t("Reopen_Form")}`,
                          });
                        }
                      })
                      .catch((error) => {
                        loading(false)
                      })
                    }
                  } else if (
                    controlElemToAdd &&
                    targetElemState.targetElemType === "tabChild"
                  ) {
                    if (controlElemToAdd) {
                      extraDetails.isSubForm = isSubForm;
                      extraDetails.isAdvanceListview = isAdvanceListview;
                      sendRequestForControl(
                        controlElemToAdd.frameIndex,
                        "add",
                        "tableColumn",
                        extraDetails,
                        activePage?.formId,
                        activePage
                      ).then((response) => {
                        if (response.data.status === 0) {
                          var column = {};
                          column.frameIndex = response.data.frameIndex;
                          column.columnIndex = response.data.columnIndex;
                          column.elementIndex = response.data.elementIndex;
                          column.sheetIndex = response.data.sheetIndex;
                          column.sheetElementIndex =
                            response.data.sheetElementIndex;
                          column.parent = "sheet";
                          column.style = Object.assign(
                            {},
                            ThemeJSON.tableColumn1
                          );
                          controlElemToAdd.columnList.push(column);
                          controlElemToAdd.style = JSON.parse(
                            JSON.stringify(ThemeJSON.advancelistview)
                          );
                          if (openCanvasForSubform === "subform") {
                            //  jsonObj =  createSmartFormState(subFormStateJson.current, targetElemState.targetId, targetElemState.targetElemType, 'listview',0, targetElemState.frameIndex, controlElemToAdd ,device );
                            jsonObj = createSmartFormState(
                              subFormStateJson.current,
                              targetElemState.targetId,
                              targetElemState.targetElemType,
                              "advancelistView",
                              0,
                              targetElemState.frameIndex,
                              controlElemToAdd,
                              targetElemState.targetRowId,
                              targetElemState.targetColId,
                              device
                            );
                          } else if (
                            openCanvasForSubform ===
                            "advanceListviewFromScratch"
                          ) {
                            // jsonObj =  createSmartFormState(advanceListviewStateJson, targetElemState.targetId, targetElemState.targetElemType, 'listview',0, targetElemState.frameIndex, controlElemToAdd ,device );
                            jsonObj = createSmartFormState(
                              fetchGridStates().advanceListviewStateJson,
                              targetElemState.targetId,
                              targetElemState.targetElemType,
                              "advancelistView",
                              0,
                              targetElemState.frameIndex,
                              controlElemToAdd,
                              targetElemState.targetRowId,
                              targetElemState.targetColId,
                              device
                            );
                          } else {
                            // jsonObj =  createSmartFormState(formState2, targetElemState.targetId, targetElemState.targetElemType, 'listview',0, targetElemState.frameIndex, controlElemToAdd, device );
                            jsonObj = createSmartFormState(
                              formState2,
                              targetElemState.targetId,
                              targetElemState.targetElemType,
                              "advancelistView",
                              0,
                              targetElemState.frameIndex,
                              controlElemToAdd,
                              targetElemState.targetRowId,
                              targetElemState.targetColId,
                              device
                            );
                          }

                          targetElemState.targetId = "";
                          targetElemState.targetClass = "";
                          targetElemState.targetElemType = "";
                          setCurrElem("");
                          if (openCanvasForSubform === "subform") {
                            setSubFormState({ ...jsonObj });
                          } else if (
                            openCanvasForSubform ===
                            "advanceListviewFromScratch"
                          ) {
                            dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj }, renderCanvas:true}));
                          } else {
                            setFormStateByUser({ ...jsonObj });
                          }
                        } else if (response.data.status === 1) {
                          showAlertConfirmNotifications({
                            open: true,
                            showConfirm: "showNotification",
                            alertType: "error",
                            alertContentKey: `${t("Reopen_Form")}`,
                          });
                        }
                      })
                      .catch((error) => {
                        loading(false)
                      })
                    }
                  }
                } else if (response.data.status === 1) {
                  showAlertConfirmNotifications({
                    open: true,
                    showConfirm: "showNotification",
                    alertType: "error",
                    alertContentKey: `${t("Reopen_Form")}`,
                  });
                }
                setCurrentDataObjectJson(cloneDeep({}));
                dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
              })
              .catch((error) => {
                loading(false)
              })
            } else {
              setCurrentDataObjectJson(cloneDeep({}));
              dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: `${t(
                  "Please_Drop_Control_Inside_Section_Canvas"
                )}`,
              });
              
            }
          }
          // else if(targetElemState.targetElemType.toLowerCase()!=="step" && targetElemState.targetElemType.toLowerCase()!=="substep" && currElemState.current==="toggle"){
          //     var controlElemToAdd = {
          //         "id": createUniqueId('toggle'),
          //         "elem_type": "toggle",
          //         "style": Object.assign({},ThemeJSON.toggle ? ThemeJSON.toggle :{})
          //     };
          //     if(openCanvasForSubform === 'subform'){
          //         jsonObj =  createSmartFormState(subFormStateJson.current, targetElemState.targetId, targetElemState.targetElemType, 'toggle',0, targetElemState.frameIndex, controlElemToAdd );
          //     } else {
          //         jsonObj =  createSmartFormState(formState2, targetElemState.targetId, targetElemState.targetElemType, 'toggle',0, targetElemState.frameIndex, controlElemToAdd);
          //     }

          //     targetElemState.targetId= '';
          //     targetElemState.targetClass= '';
          //     targetElemState.targetElemType= '';
          //     setCurrElem('');
          //     if(openCanvasForSubform === 'subform'){
          //         setSubFormState({...jsonObj});
          //     } else {
          //         setFormStateByUser({...jsonObj});
          //     }
          // }
          else if (
            (targetElemState.targetElemType.toLowerCase() !== "step" &&
              targetElemState.targetElemType.toLowerCase() !== "substep" &&
              currElemState.current === "wizard_h") ||
            currElemState.current === "wizard_v" ||
            currElemState.current === "sidenavigation"
          ) {
            var extraJson = {
              isSubForm: isSubForm,
              isAdvanceListview: isAdvanceListview,
            };
            sendRequestForControl(
              targetElemState.frameIndex,
              "add",
              currElemState.current,
              extraJson
            ).then((response) => {
              if (response.data.status === 0) {
                var controlElemToAdd = response.data;
                // setOpenQuickToolFor(controlElemToAdd?.id);
                controlElemToAdd.elem_type = currElemState.current;

                if(response?.data?.elem_type==="wizard"){
                  loading(true);
                }

                controlElemToAdd.style =
                  { ...ThemeJSON[currElemState.current] } || {};
                if (openCanvasForSubform === "subform") {
                  jsonObj = createSmartFormState(
                    subFormStateJson.current,
                    targetElemState.targetId,
                    targetElemState.targetElemType,
                    currElemState.current,
                    0,
                    targetElemState.frameIndex,
                    controlElemToAdd,
                    targetElemState.targetColId,
                    device
                  );
                } else if (
                  openCanvasForSubform === "advanceListviewFromScratch"
                ) {
                  jsonObj = createSmartFormState(
                    fetchGridStates().advanceListviewStateJson,
                    targetElemState.targetId,
                    targetElemState.targetElemType,
                    currElemState.current,
                    0,
                    targetElemState.frameIndex,
                    controlElemToAdd,
                    targetElemState.targetColId,
                    device
                  );
                } else {
                  jsonObj = createSmartFormState(
                    formState2,
                    targetElemState.targetId,
                    targetElemState.targetElemType,
                    currElemState.current,
                    0,
                    targetElemState.frameIndex,
                    controlElemToAdd,
                    targetElemState.targetRowId,
                    targetElemState.targetColId,
                    device,
                    updatedComponentInFormState
                  );
                }

                targetElemState.targetId = "";
                targetElemState.targetClass = "";
                targetElemState.targetElemType = "";
                setCurrElem("");

                if (openCanvasForSubform === "subform") {
                  setSubFormState({ ...jsonObj });
                } else if (
                  openCanvasForSubform === "advanceListviewFromScratch"
                ) {
                  dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj }, renderCanvas:true}));
                } else {
                  setFormStateByUser({ ...jsonObj });
                }
              } else if (response.data.status === 1) {
                showAlertConfirmNotifications({
                  open: true,
                  showConfirm: "showNotification",
                  alertType: "error",
                  alertContentKey: `${t("Reopen_Form")}`,
                });
              }
              setCurrentDataObjectJson(cloneDeep({}));
              dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
            })
            .catch((error) => {
              loading(false)
            })
          } else if (
            targetElemState.targetElemType.toLowerCase() !== "step" &&
            targetElemState.targetElemType.toLowerCase() !== "substep" &&
            currElemState.current === "Menu"
          ) {
            sendRequestForControl(
              targetElemState.frameIndex,
              "add",
              currElemState.current
            ).then((response) => {
              if (response.data.status === 0) {
                var controlElemToAdd = response.data;
                // setOpenQuickToolFor(controlElemToAdd?.id);
                controlElemToAdd.elem_type = currElemState.current;

                controlElemToAdd.style =
                  { ...ThemeJSON[currElemState.current] } || {};
                controlElemToAdd.styleWiz =
                  { ...ThemeJSON["sidenavigation"] } || {};
                if (openCanvasForSubform === "subform") {
                  jsonObj = createSmartFormState(
                    subFormStateJson.current,
                    targetElemState.targetId,
                    targetElemState.targetElemType,
                    currElemState.current,
                    0,
                    targetElemState.frameIndex,
                    controlElemToAdd,
                    targetElemState.targetColId,
                    device
                  );
                } else {
                  jsonObj = createSmartFormState(
                    formState2,
                    targetElemState.targetId,
                    targetElemState.targetElemType,
                    currElemState.current,
                    0,
                    targetElemState.frameIndex,
                    controlElemToAdd,
                    targetElemState.targetRowId,
                    targetElemState.targetColId,
                    device,
                    updatedComponentInFormState
                  );
                }

                targetElemState.targetId = "";
                targetElemState.targetClass = "";
                targetElemState.targetElemType = "";
                setCurrElem("");

                if (openCanvasForSubform === "subform") {
                  setSubFormState({ ...jsonObj });
                } else if (
                  openCanvasForSubform === "advanceListviewFromScratch"
                ) {
                  dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj }, renderCanvas:true}));
                } else {
                  setFormStateByUser({ ...jsonObj });
                }
              } else if (response.data.status === 1) {
                showAlertConfirmNotifications({
                  open: true,
                  showConfirm: "showNotification",
                  alertType: "error",
                  alertContentKey: `${t("Reopen_Form")}`,
                });
              }
              setCurrentDataObjectJson(cloneDeep({}));
              dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
            })
            .catch((error) => {
              loading(false)
            })
          } else {
            var generatedJson = generateJsonToSend(
              formState2,
              targetElemState.targetId
            );
            var extraDetails = {};
            extraDetails["isSubForm"] = isSubForm;
            extraDetails["isAdvanceListview"] = isAdvanceListview;
            if (
              targetElemState.sheetIndex !== undefined &&
              targetElemState.sheetIndex !== null
            ) {
              extraDetails.sheetIndex = targetElemState.sheetIndex;
              extraDetails.elementIndex = targetElemState.elementIndex;
            }
            if (
              targetElemState.sheetElementIndex !== undefined &&
              targetElemState.sheetElementIndex !== null
            ) {
              extraDetails.sheetElementIndex =
                targetElemState.sheetElementIndex;
            }
            if (
              (targetElemState.targetElemType.toLowerCase() === "step" ||
                targetElemState.targetElemType.toLowerCase() === "substep" 
                // || (parentWizardCheck() && headerJsonNew)
                ) && !targetElemState?.targetRowId?.includes("before_frame") &&
              (currElemState.current === "frame" ||
                currElemState.current === "section") && !isAboveWizard
            ) {
              targetElemState.isSubForm = isSubForm;
              targetElemState.isAdvanceListview = isAdvanceListview;
              if (Object.keys(headerJsonNew.current).length !== 0) {
                let frameIdNew;
                // let flag2 = 0;
                // const frameId = findJsonNew(formState2, "frame");
                // if (frameId.length > 0) {
                //   frameIdNew = frameId[frameId.length - 1];
                // } else {
                //   flag2 = 1;
                // }
                var controlElemToAdd1;
                var jsonToBeAdded;
                var propertyName = "new";
                var populateInside = {};
                // populateInside ={id: "RootControl", elem_type: "form"}
                // let payload = {
                //     populateInside: populateInside,
                //     // populateElem: props.data,
                //     populateElem: headerJsonNew
                //   };
                if (headerJsonNew.current) {
                  controlElemToAdd1 = headerJsonNew.current;
                  populateInside = {
                    id: "RootControl",
                    elem_type: "form",
                  };
                  if (headerJsonNew.current.elem_type === "form") {
                    headerJsonNew.current.elem_type = "frame";
                  }

                  if(targetElemState.insideWizard) {
                    populateInside = {
                      "elem_type": formState2?.containerControl || "",
                      "id": "wizard",
                      "stepIndex": targetElemState?.parentStep,
                      "subStepIndex": (targetElemState?.parentSubStep || targetElemState?.parentSubStep === 0) ? targetElemState?.parentSubStep : "-1" ,
                    }
                  }

                  populateInside["isSubForm"] = isSubForm;
                  populateInside["isAdvanceListview"] = isAdvanceListview;

                  if(populateInside["isAdvanceListview"]) {
                    populateInside = {
                      ...populateInside,
                      "elem_type": "form",
                      "id": "wizard",
                      "stepIndex": currentadvanceListview?.current?.stepIndex,
                      "subStepIndex": currentadvanceListview?.current?.subStepIndex,
                    }
                  } else if(populateInside["isSubForm"]) {
                    populateInside = {
                      ...populateInside,
                      "elem_type": "form",
                      "id": "wizard",
                      "stepIndex": currentButtonForSubform?.current?.stepIndex,
                      "subStepIndex": currentButtonForSubform?.current?.subStepIndex,
                    }
                  }

                  let payload = {
                    populateInside: populateInside,
                    // populateElem: props.data,
                    populateElem: headerJsonNew.current,
                  };
                  if (propertyName !== "") {
                    sendRequestForControl(
                      null,
                      "duplicate",
                      null,
                      payload
                    ).then((response) => {
                      let data = response.data;
                      controlElemToAdd= 
                      jsonToBeAdded = data.populatedJson;

                      jsonToBeAdded = convertElementIndex(jsonToBeAdded);
                      //  convertElementIndex(jsonToBeAdded);

                      if (jsonToBeAdded !== null) {
                        updateRowNColumn(jsonToBeAdded);

                        if (
                          (jsonToBeAdded?.elem_type !== "frame" &&
                            jsonToBeAdded?.elem_type !== "wizard") ||
                          parentTab() ||
                          parentWizardCheck() ||
                          parentMenuCheck()
                        ) {
                          let frameEnableValue = true;
                          var framereadValue = false;
                          console.log(framereadValue);
                          let frameReadOnlyValue = false;
                          const parenttabVal = parentTab();
                          const parentWizardCheckVal = parentWizardCheck();
                          const parentMenuCheckVal = parentMenuCheck();
                          const parentSectionVal = parentSection();
                          const tabId = findTabId();
                          const sectionId = findSectionId();
                          const parentSectionCheck = parentSection(tabId);
                          const parentTabCheck = parentTab(sectionId);
                          const parentSectionId = findSectionId(tabId);

                          if (
                            parenttabVal &&
                            !parentWizardCheckVal &&
                            !parentMenuCheckVal
                          ) {
                            if (parentSectionCheck) {
                              if (
                                document
                                  .getElementById(parentSectionId)
                                  ?.getAttribute("enable") === "false" ||
                                document
                                  .getElementById(parentSectionId)
                                  ?.getAttribute("enable") === false
                              )
                                frameEnableValue = false;
                              else frameEnableValue = true;
                              if (
                                document
                                  .getElementById(parentSectionId)
                                  ?.getAttribute("readonly") === "true" ||
                                document
                                  .getElementById(parentSectionId)
                                  ?.getAttribute("readonly") === true
                              )
                                frameReadOnlyValue = true;
                              else frameReadOnlyValue = false;
                              if (
                                document
                                  .getElementById(parentSectionId)
                                  ?.getAttribute("readOnlyValue") === "true" ||
                                document
                                  .getElementById(parentSectionId)
                                  ?.getAttribute("readOnlyValue") === true
                              )
                                framereadValue = true;
                              else framereadValue = false;
                              if (
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("readonly") === "true" ||
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("readonly") === true
                              )
                                frameReadOnlyValue = true;
                              else frameReadOnlyValue = false;
                              if (
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("readOnlyValue") === "true" ||
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("readOnlyValue") === true
                              )
                                framereadValue = true;
                              else framereadValue = false;
                              console.log(
                                "tabId",
                                document.getElementById(findTabId())
                              );
                              console.log(
                                "TabEnable",
                                document
                                  .getElementById(findTabId())
                                  ?.getAttribute("enable")
                              );
                              if (
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("enable") === "true" ||
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("enable") === true
                              )
                                frameEnableValue = true;
                              else frameEnableValue = false;
                              if (parentTabCheck) {
                                if (
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("enable") === "true" ||
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("enable") === true
                                )
                                  frameEnableValue = true;
                                else frameEnableValue = false;
                                if (
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("readonly") === "true" ||
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("readonly") === true
                                )
                                  frameReadOnlyValue = true;
                                else frameReadOnlyValue = false;
                                if (
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("readOnlyValue") ===
                                    "true" ||
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("readOnlyValue") === true
                                )
                                  framereadValue = true;
                                else framereadValue = false;
                              }
                            } else {
                              if (
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("enable") === "false" ||
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("enable") === false
                              )
                                frameEnableValue = false;
                              else frameEnableValue = true;
                              if (
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("readonly") === "true" ||
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("readonly") === true
                              )
                                frameReadOnlyValue = true;
                              else frameReadOnlyValue = false;
                              if (
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("readOnlyValue") === "true" ||
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("readOnlyValue") === true
                              )
                                framereadValue = true;
                              else framereadValue = false;
                              if (parentSectionVal) {
                                if (
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("enable") === "false" ||
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("enable") === false
                                ) {
                                  frameEnableValue = false;
                                } else frameEnableValue = true;
                                if (
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("readonly") === "true" ||
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("readonly") === true
                                )
                                  frameReadOnlyValue = true;
                                else frameReadOnlyValue = false;
                                if (
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("readOnlyValue") ===
                                    "true" ||
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("readOnlyValue") === true
                                )
                                  framereadValue = true;
                                else framereadValue = false;
                              }
                            }
                          } else if (
                            parentSectionVal &&
                            !parentTabCheck &&
                            !parenttabVal &&
                            !parentWizardCheckVal &&
                            !parentMenuCheckVal
                          ) {
                            frameEnableValue = document
                              .getElementById(findSectionId())
                              ?.getAttribute("enable");
                            frameReadOnlyValue = document
                              .getElementById(findSectionId())
                              ?.getAttribute("readonly");
                            framereadValue = document
                              .getElementById(findSectionId())
                              ?.getAttribute("readOnlyValue");
                          } else if (parentWizardCheckVal) {
                            if (
                              document
                                .getElementById("wizard")
                                ?.getAttribute("readonly") === "true" ||
                              document
                                .getElementById("wizard")
                                ?.getAttribute("readOnly") === true
                            )
                              frameReadOnlyValue = true;
                            else frameReadOnlyValue = false;
                            if (sectionId) {
                              if (
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("enable") === "false" ||
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("enable") === false
                              )
                                frameEnableValue = false;
                              else frameEnableValue = true;
                              if (
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("readonly") === "true" ||
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("readonly") === true
                              )
                                frameReadOnlyValue = true;
                              else frameReadOnlyValue = false;
                              if (
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("readOnlyValue") === "true" ||
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("readOnlyValue") === true
                              )
                                framereadValue = true;
                              else framereadValue = false;
                            }
                          } else if (parentMenuCheckVal) {
                            if (
                              document
                                .getElementById("wizard")
                                ?.getAttribute("readOnlyValue") === "true" ||
                              document
                                .getElementById(findTabId())
                                ?.getAttribute("readonlyvalue") === true
                            )
                              framereadValue = true;
                            if (
                              document
                                .getElementById("wizard")
                                ?.getAttribute("readonly") === "true" ||
                              document
                                .getElementById("wizard")
                                ?.getAttribute("readOnly") === true
                            )
                              frameReadOnlyValue = true;
                            if (sectionId) {
                              if (
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("enable") === "false" ||
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("enable") === false
                              )
                                frameEnableValue = false;
                              else frameEnableValue = true;
                              if (
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("readonly") === "true" ||
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("readonly") === true
                              )
                                frameReadOnlyValue = true;
                              else frameReadOnlyValue = false;
                              if (
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("readOnlyValue") === "true" ||
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("readOnlyValue") === true
                              )
                                framereadValue = true;
                              else framereadValue = false;
                            }
                          }
                          if (
                            frameEnableValue === true ||
                            frameEnableValue === "true"
                          )
                          jsonToBeAdded["style"].Enable = "true";
                          else jsonToBeAdded["style"].Enable = "false";
                          if (
                            frameReadOnlyValue === true ||
                            frameReadOnlyValue === "true"
                          )
                          jsonToBeAdded["style"].ReadOnlyStyle = "true";
                          else
                          jsonToBeAdded["style"].ReadOnlyStyle = "false";
                          if (
                            framereadValue === true ||
                            framereadValue === "true"
                          )
                          jsonToBeAdded["style"].ReadOnly = "true";
                          else jsonToBeAdded["style"].ReadOnly = "false";
                        }

                        // if(propertyName==="replace")
                        // {
                        // recursiveJsonForImportSection(formState2.children[1].children, props.id, 0, formState2.children[1].children, jsonToBeAdded, propertyName);
                        // }
                        if (propertyName === "new") {
                          if (
                            document
                              .getElementById(`${ev?.target?.id}`)
                              .getAttribute("id") !== undefined &&
                            document
                              .getElementById(`${ev?.target?.id}`)
                              .getAttribute("id") !== null &&
                            document
                              .getElementById(`${ev?.target?.id}`)
                              .getAttribute("id")
                              ?.includes("Step")
                          ) {
                            recursiveJsonForImportSection(
                              formState2.children[1].children,
                              frameIdNew,
                              0,
                              formState2.children[1].children,
                              jsonToBeAdded,
                              propertyName,
                              document
                                .getElementById(`${ev?.target?.id}`)
                                .getAttribute("id")
                            );
                          } else {
                            recursiveJsonForImportSection(
                              formState2.children[1].children,
                              frameIdNew,
                              0,
                              formState2.children[1].children,
                              jsonToBeAdded,
                              propertyName
                            );
                          }
                          targetElemState = {};
                          setCurrElem("");
                        } else {
                          var latestJson = { ...formState2 };
                          latestJson.children[1].children[1] = jsonToBeAdded;
                          targetElemState = {};
                          setCurrElem("");
                          setFormStateByUser({ ...latestJson });
                          updatedComponentInFormState();
                        }
                        showAlertConfirmNotifications({
                          open: true,
                          showConfirm: "showNotification",
                          alertType: "success",
                          vertical: "bottom",
                          horizontal: "left",
                          alertContentKey:
                            "SECTION_TEMPLATE_SUCCESS",
                          autoHideDuration: 3000,
                        });

                        // window.setTimeout(() => {
                        //     showAlertConfirmNotifications({
                        //     open: false,
                        //     showConfirm: "showNotification",
                        //     alertType: "success",
                        //     alertContentKey: "UploadSectionFailureMessage",
                        //     });
                        //     setQuickToolsClose(false);
                        // }, 1000);
                        // setHeaderJsonNew({});
                        headerJsonNew.current = {};
                      } else {
                        // alert("Json Is In Correct");
                        console.log("Json Is In Correct");
                      }
                      setCurrentDataObjectJson(cloneDeep({}));
                      dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                    })
                    .catch((error) => {
                      loading(false)
                    })
                  }
                }
              } else {
                sendRequestForControl(
                  targetElemState.frameIndex,
                  "add",
                  currElemState.current,
                  targetElemState
                ).then(async(response) => {
                  if (response.data.status === 0) {
                    var controlElemToAdd = response.data;
                    controlElemToAdd["style"] = {
                      ...ThemeJSON[currElemState.current],
                      Label: currentDataObjectJson.current["treeName"],
                    };
                    setOpenQuickToolFor(controlElemToAdd?.id);
                    if (
                      currentDataObjectJson.current &&
                      Object.keys(currentDataObjectJson.current)
                        .length === 0
                    ) {
                    } else {
                      if (
                        currentDataObjectJson.current &&
                        currentDataObjectJson.current[
                          "VariableName"
                        ]
                      ) {
                        let dataClassMap;

                        if (
                          currentDataObjectJson.current[
                            "parentName"
                          ] &&
                          currentDataObjectJson.current[
                            "parentName"
                          ] !== ""
                        ) {
                          dataClassMap =
                            currentDataObjectJson.current[
                              "treeName"
                            ];
                        } else {
                          dataClassMap =
                            currentDataObjectJson.current[
                              "VariableName"
                            ];
                        }

                        mappingControlsIdMap.add(
                          currentDataObjectJson.current["treeName"]
                        );
                        
                        if(!(currentDataObjectJson?.current?.["Unbounded"] === "N" && currentDataObjectJson.current?.children?.length > 0)) {
                          controlElemToAdd["TypeOfValue"] =
                            currentDataObjectJson.current[
                              "VariableType"
                            ];
                          controlElemToAdd["dataclass"] =
                            dataClassMap;
                          controlElemToAdd["style"] = {
                            ...controlElemToAdd.style,
                            Label:
                              currentDataObjectJson.current[
                                "treeName"
                              ],
                            Mapping: dataClassMap,
                            MappingId:
                              currentDataObjectJson.current[
                                "treeName"
                              ],
                            Enable: "true",
                            Visible: "true",
                            
                          };
                        }
                      }
                    }

                    if(!(currentDataObjectJson?.current?.["Unbounded"] === "N" && currentDataObjectJson.current?.children?.length > 0))
                      setCurrentDataObjectJson(cloneDeep({}));
                      dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                    if (
                      (controlElemToAdd?.elem_type !== "frame" &&
                        controlElemToAdd?.elem_type !== "wizard") ||
                      parentTab() ||
                      parentWizardCheck() ||
                      parentMenuCheck()
                    ) {
                      let frameEnableValue = true;
                      var framereadValue = false;
                      console.log(framereadValue);
                      let frameReadOnlyValue = false;
                      const parenttabVal = parentTab();
                      const parentWizardCheckVal = parentWizardCheck();
                      const parentMenuCheckVal = parentMenuCheck();
                      const parentSectionVal = parentSection();
                      const tabId = findTabId();
                      const sectionId = findSectionId();
                      const parentSectionCheck = parentSection(tabId);
                      const parentTabCheck = parentTab(sectionId);
                      const parentSectionId = findSectionId(tabId);

                      if (
                        parenttabVal &&
                        !parentWizardCheckVal &&
                        !parentMenuCheckVal
                      ) {
                        if (parentSectionCheck) {
                          if (
                            document
                              .getElementById(parentSectionId)
                              ?.getAttribute("enable") === "false" ||
                            document
                              .getElementById(parentSectionId)
                              ?.getAttribute("enable") === false
                          )
                            frameEnableValue = false;
                          else frameEnableValue = true;
                          if (
                            document
                              .getElementById(parentSectionId)
                              ?.getAttribute("readonly") === "true" ||
                            document
                              .getElementById(parentSectionId)
                              ?.getAttribute("readonly") === true
                          )
                            frameReadOnlyValue = true;
                          else frameReadOnlyValue = false;
                          if (
                            document
                              .getElementById(parentSectionId)
                              ?.getAttribute("readOnlyValue") === "true" ||
                            document
                              .getElementById(parentSectionId)
                              ?.getAttribute("readOnlyValue") === true
                          )
                            framereadValue = true;
                          else framereadValue = false;
                          if (
                            document
                              .getElementById(tabId)
                              ?.getAttribute("readonly") === "true" ||
                            document
                              .getElementById(tabId)
                              ?.getAttribute("readonly") === true
                          )
                            frameReadOnlyValue = true;
                          else frameReadOnlyValue = false;
                          if (
                            document
                              .getElementById(tabId)
                              ?.getAttribute("readOnlyValue") === "true" ||
                            document
                              .getElementById(tabId)
                              ?.getAttribute("readOnlyValue") === true
                          )
                            framereadValue = true;
                          else framereadValue = false;
                          console.log(
                            "tabId",
                            document.getElementById(findTabId())
                          );
                          console.log(
                            "TabEnable",
                            document
                              .getElementById(findTabId())
                              ?.getAttribute("enable")
                          );
                          if (
                            document
                              .getElementById(tabId)
                              ?.getAttribute("enable") === "true" ||
                            document
                              .getElementById(tabId)
                              ?.getAttribute("enable") === true
                          )
                            frameEnableValue = true;
                          else frameEnableValue = false;
                          if (parentTabCheck) {
                            if (
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("enable") === "true" ||
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("enable") === true
                            )
                              frameEnableValue = true;
                            else frameEnableValue = false;
                            if (
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("readonly") === "true" ||
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("readonly") === true
                            )
                              frameReadOnlyValue = true;
                            else frameReadOnlyValue = false;
                            if (
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("readOnlyValue") === "true" ||
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("readOnlyValue") === true
                            )
                              framereadValue = true;
                            else framereadValue = false;
                          }
                        } else {
                          if (
                            document
                              .getElementById(tabId)
                              ?.getAttribute("enable") === "false" ||
                            document
                              .getElementById(tabId)
                              ?.getAttribute("enable") === false
                          )
                            frameEnableValue = false;
                          else frameEnableValue = true;
                          if (
                            document
                              .getElementById(tabId)
                              ?.getAttribute("readonly") === "true" ||
                            document
                              .getElementById(tabId)
                              ?.getAttribute("readonly") === true
                          )
                            frameReadOnlyValue = true;
                          else frameReadOnlyValue = false;
                          if (
                            document
                              .getElementById(tabId)
                              ?.getAttribute("readOnlyValue") === "true" ||
                            document
                              .getElementById(tabId)
                              ?.getAttribute("readOnlyValue") === true
                          )
                            framereadValue = true;
                          else framereadValue = false;
                          if (parentSectionVal) {
                            if (
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("enable") === "false" ||
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("enable") === false
                            ) {
                              frameEnableValue = false;
                            } else frameEnableValue = true;
                            if (
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("readonly") === "true" ||
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("readonly") === true
                            )
                              frameReadOnlyValue = true;
                            else frameReadOnlyValue = false;
                            if (
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("readOnlyValue") === "true" ||
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("readOnlyValue") === true
                            )
                              framereadValue = true;
                            else framereadValue = false;
                          }
                        }
                      } else if (
                        parentSectionVal &&
                        !parentTabCheck &&
                        !parenttabVal &&
                        !parentWizardCheckVal &&
                        !parentMenuCheckVal
                      ) {
                        frameEnableValue = document
                          .getElementById(findSectionId())
                          ?.getAttribute("enable");
                        frameReadOnlyValue = document
                          .getElementById(findSectionId())
                          ?.getAttribute("readonly");
                        framereadValue = document
                          .getElementById(findSectionId())
                          ?.getAttribute("readOnlyValue");
                      } else if (parentWizardCheckVal) {
                        if (
                          document
                            .getElementById("wizard")
                            ?.getAttribute("readonly") === "true" ||
                          document
                            .getElementById("wizard")
                            ?.getAttribute("readOnly") === true
                        )
                          frameReadOnlyValue = true;
                        else frameReadOnlyValue = false;
                        if (sectionId) {
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("enable") === "false" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("enable") === false
                          )
                            frameEnableValue = false;
                          else frameEnableValue = true;
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readonly") === "true" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readonly") === true
                          )
                            frameReadOnlyValue = true;
                          else frameReadOnlyValue = false;
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readOnlyValue") === "true" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readOnlyValue") === true
                          )
                            framereadValue = true;
                          else framereadValue = false;
                        }
                      } else if (parentMenuCheckVal) {
                        if (
                          document
                            .getElementById("wizard")
                            ?.getAttribute("readOnlyValue") === "true" ||
                          document
                            .getElementById(findTabId())
                            ?.getAttribute("readonlyvalue") === true
                        )
                          framereadValue = true;
                        if (
                          document
                            .getElementById("wizard")
                            ?.getAttribute("readonly") === "true" ||
                          document
                            .getElementById("wizard")
                            ?.getAttribute("readOnly") === true
                        )
                          frameReadOnlyValue = true;
                        if (sectionId) {
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("enable") === "false" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("enable") === false
                          )
                            frameEnableValue = false;
                          else frameEnableValue = true;
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readonly") === "true" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readonly") === true
                          )
                            frameReadOnlyValue = true;
                          else frameReadOnlyValue = false;
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readOnlyValue") === "true" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readOnlyValue") === true
                          )
                            framereadValue = true;
                          else framereadValue = false;
                        }
                      }
                      if (
                        frameEnableValue === true ||
                        frameEnableValue === "true"
                      )
                        controlElemToAdd["style"].Enable = "true";
                      else controlElemToAdd["style"].Enable = "false";
                      if (
                        frameReadOnlyValue === true ||
                        frameReadOnlyValue === "true"
                      )
                        controlElemToAdd["style"].ReadOnlyStyle = "true";
                      else controlElemToAdd["style"].ReadOnlyStyle = "false";
                      if (framereadValue === true || framereadValue === "true")
                        controlElemToAdd["style"].ReadOnly = "true";
                      else controlElemToAdd["style"].ReadOnly = "false";
                    }
                    if (openCanvasForSubform === "subform") {
                      jsonObj = createSmartFormState(
                        subFormStateJson.current,
                        targetElemState.targetId,
                        targetElemState.targetElemType,
                        currElemState.current,
                        0,
                        targetElemState.frameIndex,
                        controlElemToAdd,
                        targetElemState.targetRowId,
                        targetElemState.targetColId,
                        device,
                        currentDataObjectJson?.current?.["Unbounded"] === "N" && currentDataObjectJson.current?.children?.length > 0 ? {"dataObjectDrop" : true, count: currentDataObjectJson.current?.children?.length} : "",
                      );
                    } else if (
                      openCanvasForSubform === "advanceListviewFromScratch"
                    ) {
                      jsonObj = createSmartFormState(
                        fetchGridStates().advanceListviewStateJson,
                        targetElemState.targetId,
                        targetElemState.targetElemType,
                        currElemState.current,
                        0,
                        targetElemState.frameIndex,
                        controlElemToAdd,
                        targetElemState.targetRowId,
                        targetElemState.targetColId,
                        device,
                        currentDataObjectJson?.current?.["Unbounded"] === "N" && currentDataObjectJson.current?.children?.length > 0 ? {"dataObjectDrop" : true, count: currentDataObjectJson.current?.children?.length} : "",
                      );
                    } else {
                      jsonObj = createSmartFormState(
                        formState2,
                        targetElemState.targetId,
                        targetElemState.targetElemType,
                        currElemState.current,
                        0,
                        targetElemState.frameIndex,
                        controlElemToAdd,
                        targetElemState.targetRowId,
                        targetElemState.targetColId,
                        device,
                        currentDataObjectJson?.current?.["Unbounded"] === "N" && currentDataObjectJson.current?.children?.length > 0 ? {"dataObjectDrop" : true, count: currentDataObjectJson.current?.children?.length} : "",
                      );
                    }
                    
                    if(currentDataObjectJson?.current?.["Unbounded"] === "N" && currentDataObjectJson.current?.children?.length > 0) {
                      setReRender(!reRender);
                      for(let index = 0; index < currentDataObjectJson.current?.children.length; index++) {
                        let child = currentDataObjectJson.current?.children[index];
                        currElemState.current =
                        child["VariableType"] === "Date" ||
                        child["VariableType"] === "shortDate" ||
                        child["VariableType"] === "Short Date"
                          ? "datepick"
                          : isAdvanceListviewCheck(child)
                          ? "advancelistview"
                          : child["Unbounded"] === "Y" && child.children
                          ? "listview"
                          : child["Unbounded"] === "Y" && !child.children
                          ? "listbox"
                          : child["Unbounded"] === "N" && child?.children?.length > 0
                          ? "section"
                          : child["Unbounded"] === "N" && child["VariableType"] === "Boolean"
                          ? "toggle"
                          : "textbox";
                          targetElemState.frameIndex = controlElemToAdd.frameIndex;
                          targetElemState.targetElemType = 'column';
                          targetElemState.targetClass = "COLUMN_col_css__3QcZb col-md-3 col-sm-6 col-12 draggingCol";
                          targetElemState.targetId = controlElemToAdd.children[0].children[index].id;
                          targetElemState.targetColId = controlElemToAdd.children[0].children[index].id;
                          await appendChildInSection(controlElemToAdd,targetElemState,jsonObj,child,index);
                      }
                  }
                    targetElemState = {};
                    setCurrElem("");
                    if (openCanvasForSubform === "subform") {
                      setSubFormState({ ...jsonObj });
                    } else if (
                      openCanvasForSubform === "advanceListviewFromScratch"
                    ) {
                      dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj }, renderCanvas:true}));
                    } else {
                      setFormStateByUser({ ...jsonObj });
                    }
                  } else if (response.data.status === 1) {
                    showAlertConfirmNotifications({
                      open: true,
                      showConfirm: "showNotification",
                      alertType: "error",
                      alertContentKey: `${t("Reopen_Form")}`,
                    });
                  }
                  setCurrentDataObjectJson(cloneDeep({}));
                  dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                })
                .catch((error) => {
                  loading(false)
                })
              }
            }
            if (
              (targetElemState.targetElemType.toLowerCase() === "mainmenu" ||
                targetElemState.targetElemType.toLowerCase() === "submenu" ||
                targetElemState.targetElemType.toLowerCase() ===
                  "subchildmenu"
                  // || (formState2.containerControl === "Menu" && headerJsonNew)
                ) &&
              !targetElemState?.targetRowId?.includes("before_frame") &&
              (currElemState.current === "frame" ||
                currElemState.current === "section")
            ) {
              if (Object.keys(headerJsonNew.current).length !== 0) {
                let frameIdNew;
                // let flag2 = 0;
                // const frameId = findJsonNew(formState2, "frame");
                // if (frameId.length > 0) {
                //   frameIdNew = frameId[frameId.length - 1];
                // } else {
                //   flag2 = 1;
                // }
                var controlElemToAdd1;
                var jsonToBeAdded;
                var propertyName = "new";
                var populateInside = {};
                // populateInside ={id: "RootControl", elem_type: "form"}
                // let payload = {
                //     populateInside: populateInside,
                //     // populateElem: props.data,
                //     populateElem: headerJsonNew
                //   };
                if (headerJsonNew.current) {
                  controlElemToAdd1 = headerJsonNew.current;
                  populateInside = {
                    id: "RootControl",
                    elem_type: "form",
                  };
                  if (headerJsonNew.current.elem_type === "form") {
                    headerJsonNew.current.elem_type = "frame";
                  }
                  if(targetElemState.insideMenu) {
                    populateInside = {
                      "elem_type": "menu",
                      "id": "wizard",
                      "stepIndex": targetElemState?.stepIndex,
                      "subStepIndex": targetElemState?.substepIndex,
                      "subChildMenuIndex": targetElemState?.subChildMenuIndex
                    }
                  }

                  populateInside["isSubForm"] = isSubForm;
                  populateInside["isAdvanceListview"] = isAdvanceListview;

                  if(populateInside["isAdvanceListview"]) {
                    populateInside = {
                      ...populateInside,
                      "elem_type": "form",
                      "id": "wizard",
                      "stepIndex": currentadvanceListview?.current?.stepIndex,
                      "subStepIndex": currentadvanceListview?.current?.subStepIndex,
                      "subChildMenuIndex": currentadvanceListview?.current?.subChildMenuIndex
                    }
                  } else if(populateInside["isSubForm"]) {
                    populateInside = {
                      ...populateInside,
                      "elem_type": "form",
                      "id": "wizard",
                      "stepIndex": currentButtonForSubform?.current?.stepIndex,
                      "subStepIndex": currentButtonForSubform?.current?.subStepIndex,
                      "subChildMenuIndex": currentButtonForSubform?.current?.subChildMenuIndex
                    }
                  }

                  let payload = {
                    populateInside: populateInside,
                    // populateElem: props.data,
                    populateElem: headerJsonNew.current,
                  };
                  if (propertyName !== "") {
                    sendRequestForControl(
                      null,
                      "duplicate",
                      null,
                      payload
                    ).then((response) => {
                      let data = response.data;

                      jsonToBeAdded = data.populatedJson;

                      jsonToBeAdded = convertElementIndex(jsonToBeAdded);
                      //  convertElementIndex(jsonToBeAdded);

                      if (jsonToBeAdded !== null) {
                         updateRowNColumn(jsonToBeAdded);

                        if (
                          (jsonToBeAdded?.elem_type !== "frame" &&
                            jsonToBeAdded?.elem_type !== "wizard") ||
                          parentTab() ||
                          parentWizardCheck() ||
                          parentMenuCheck()
                        ) {
                          let frameEnableValue = true;
                          var framereadValue = false;
                          console.log(framereadValue);
                          let frameReadOnlyValue = false;
                          const parenttabVal = parentTab();
                          const parentWizardCheckVal = parentWizardCheck();
                          const parentMenuCheckVal = parentMenuCheck();
                          const parentSectionVal = parentSection();
                          const tabId = findTabId();
                          const sectionId = findSectionId();
                          const parentSectionCheck = parentSection(tabId);
                          const parentTabCheck = parentTab(sectionId);
                          const parentSectionId = findSectionId(tabId);
                          const controlElemToAdd = jsonToBeAdded;

                          if (
                            parenttabVal &&
                            !parentWizardCheckVal &&
                            !parentMenuCheckVal
                          ) {
                            if (parentSectionCheck) {
                              if (
                                document
                                  .getElementById(parentSectionId)
                                  ?.getAttribute("enable") === "false" ||
                                document
                                  .getElementById(parentSectionId)
                                  ?.getAttribute("enable") === false
                              )
                                frameEnableValue = false;
                              else frameEnableValue = true;
                              if (
                                document
                                  .getElementById(parentSectionId)
                                  ?.getAttribute("readonly") === "true" ||
                                document
                                  .getElementById(parentSectionId)
                                  ?.getAttribute("readonly") === true
                              )
                                frameReadOnlyValue = true;
                              else frameReadOnlyValue = false;
                              if (
                                document
                                  .getElementById(parentSectionId)
                                  ?.getAttribute("readOnlyValue") === "true" ||
                                document
                                  .getElementById(parentSectionId)
                                  ?.getAttribute("readOnlyValue") === true
                              )
                                framereadValue = true;
                              else framereadValue = false;
                              if (
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("readonly") === "true" ||
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("readonly") === true
                              )
                                frameReadOnlyValue = true;
                              else frameReadOnlyValue = false;
                              if (
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("readOnlyValue") === "true" ||
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("readOnlyValue") === true
                              )
                                framereadValue = true;
                              else framereadValue = false;
                              console.log(
                                "tabId",
                                document.getElementById(findTabId())
                              );
                              console.log(
                                "TabEnable",
                                document
                                  .getElementById(findTabId())
                                  ?.getAttribute("enable")
                              );
                              if (
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("enable") === "true" ||
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("enable") === true
                              )
                                frameEnableValue = true;
                              else frameEnableValue = false;
                              if (parentTabCheck) {
                                if (
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("enable") === "true" ||
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("enable") === true
                                )
                                  frameEnableValue = true;
                                else frameEnableValue = false;
                                if (
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("readonly") === "true" ||
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("readonly") === true
                                )
                                  frameReadOnlyValue = true;
                                else frameReadOnlyValue = false;
                                if (
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("readOnlyValue") ===
                                    "true" ||
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("readOnlyValue") === true
                                )
                                  framereadValue = true;
                                else framereadValue = false;
                              }
                            } else {
                              if (
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("enable") === "false" ||
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("enable") === false
                              )
                                frameEnableValue = false;
                              else frameEnableValue = true;
                              if (
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("readonly") === "true" ||
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("readonly") === true
                              )
                                frameReadOnlyValue = true;
                              else frameReadOnlyValue = false;
                              if (
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("readOnlyValue") === "true" ||
                                document
                                  .getElementById(tabId)
                                  ?.getAttribute("readOnlyValue") === true
                              )
                                framereadValue = true;
                              else framereadValue = false;
                              if (parentSectionVal) {
                                if (
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("enable") === "false" ||
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("enable") === false
                                ) {
                                  frameEnableValue = false;
                                } else frameEnableValue = true;
                                if (
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("readonly") === "true" ||
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("readonly") === true
                                )
                                  frameReadOnlyValue = true;
                                else frameReadOnlyValue = false;
                                if (
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("readOnlyValue") ===
                                    "true" ||
                                  document
                                    .getElementById(sectionId)
                                    ?.getAttribute("readOnlyValue") === true
                                )
                                  framereadValue = true;
                                else framereadValue = false;
                              }
                            }
                          } else if (
                            parentSectionVal &&
                            !parentTabCheck &&
                            !parenttabVal &&
                            !parentWizardCheckVal &&
                            !parentMenuCheckVal
                          ) {
                            frameEnableValue = document
                              .getElementById(findSectionId())
                              ?.getAttribute("enable");
                            frameReadOnlyValue = document
                              .getElementById(findSectionId())
                              ?.getAttribute("readonly");
                            framereadValue = document
                              .getElementById(findSectionId())
                              ?.getAttribute("readOnlyValue");
                          } else if (parentWizardCheckVal) {
                            if (
                              document
                                .getElementById("wizard")
                                ?.getAttribute("readonly") === "true" ||
                              document
                                .getElementById("wizard")
                                ?.getAttribute("readOnly") === true
                            )
                              frameReadOnlyValue = true;
                            else frameReadOnlyValue = false;
                            if (sectionId) {
                              if (
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("enable") === "false" ||
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("enable") === false
                              )
                                frameEnableValue = false;
                              else frameEnableValue = true;
                              if (
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("readonly") === "true" ||
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("readonly") === true
                              )
                                frameReadOnlyValue = true;
                              else frameReadOnlyValue = false;
                              if (
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("readOnlyValue") === "true" ||
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("readOnlyValue") === true
                              )
                                framereadValue = true;
                              else framereadValue = false;
                            }
                          } else if (parentMenuCheckVal) {
                            if (
                              document
                                .getElementById("wizard")
                                ?.getAttribute("readOnlyValue") === "true" ||
                              document
                                .getElementById(findTabId())
                                ?.getAttribute("readonlyvalue") === true
                            )
                              framereadValue = true;
                            if (
                              document
                                .getElementById("wizard")
                                ?.getAttribute("readonly") === "true" ||
                              document
                                .getElementById("wizard")
                                ?.getAttribute("readOnly") === true
                            )
                              frameReadOnlyValue = true;
                            if (sectionId) {
                              if (
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("enable") === "false" ||
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("enable") === false
                              )
                                frameEnableValue = false;
                              else frameEnableValue = true;
                              if (
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("readonly") === "true" ||
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("readonly") === true
                              )
                                frameReadOnlyValue = true;
                              else frameReadOnlyValue = false;
                              if (
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("readOnlyValue") === "true" ||
                                document
                                  .getElementById(sectionId)
                                  ?.getAttribute("readOnlyValue") === true
                              )
                                framereadValue = true;
                              else framereadValue = false;
                            }
                          }
                          
                          if (
                            frameEnableValue === true ||
                            frameEnableValue === "true"
                          )
                            controlElemToAdd["style"].Enable = "true";
                          else controlElemToAdd["style"].Enable = "false";
                          if (
                            frameReadOnlyValue === true ||
                            frameReadOnlyValue === "true"
                          )
                            controlElemToAdd["style"].ReadOnlyStyle = "true";
                          else
                            controlElemToAdd["style"].ReadOnlyStyle = "false";
                          if (
                            framereadValue === true ||
                            framereadValue === "true"
                          )
                            controlElemToAdd["style"].ReadOnly = "true";
                          else controlElemToAdd["style"].ReadOnly = "false";
                        }

                        // if(propertyName==="replace")
                        // {
                        // recursiveJsonForImportSection(formState2.children[1].children, props.id, 0, formState2.children[1].children, jsonToBeAdded, propertyName);
                        // }
                        if (propertyName === "new") {
                          if (
                            document
                              .getElementById(`${ev?.target?.id}`)
                              .getAttribute("id") !== undefined &&
                            document
                              .getElementById(`${ev?.target?.id}`)
                              .getAttribute("id") !== null &&
                            (document
                              .getElementById(`${ev?.target?.id}`)
                              .getAttribute("id")
                              ?.includes("MainMenu") ||
                              document
                                .getElementById(`${ev?.target?.id}`)
                                .getAttribute("id")
                                ?.includes("SubMenu") ||
                              document
                                .getElementById(`${ev?.target?.id}`)
                                .getAttribute("id")
                                ?.includes("SubChildMenu"))
                          ) {
                            recursiveJsonForImportSection(
                              formState2.children[1].children,
                              frameIdNew,
                              0,
                              formState2.children[1].children,
                              jsonToBeAdded,
                              propertyName,
                              document
                                .getElementById(`${ev?.target?.id}`)
                                .getAttribute("id")
                            );
                          } else {
                            recursiveJsonForImportSection(
                              formState2.children[1].children,
                              frameIdNew,
                              0,
                              formState2.children[1].children,
                              jsonToBeAdded,
                              propertyName
                            );
                          }
                          targetElemState = {};
                          setCurrElem("");
                        } else {
                          var latestJson = { ...formState2 };
                          latestJson.children[1].children[1] = jsonToBeAdded;
                          targetElemState = {};
                          setCurrElem("");
                          setFormStateByUser({ ...latestJson });
                          updatedComponentInFormState();
                        }
                        showAlertConfirmNotifications({
                          open: true,
                          showConfirm: "showNotification",
                          alertType: "success",
                          vertical: "bottom",
                          horizontal: "left",
                          alertContentKey:
                            "SECTION_TEMPLATE_SUCCESS",
                          autoHideDuration: 3000,
                        });

                        // window.setTimeout(() => {
                        //     showAlertConfirmNotifications({
                        //     open: false,
                        //     showConfirm: "showNotification",
                        //     alertType: "success",
                        //     alertContentKey: "UploadSectionFailureMessage",
                        //     });
                        //     setQuickToolsClose(false);
                        // }, 1000);
                        // setHeaderJsonNew({});
                        headerJsonNew.current = {};
                      } else {
                        // alert("Json Is In Correct");
                        console.log("Json Is In Correct");
                      }
                      setCurrentDataObjectJson(cloneDeep({}));
                      dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                    })
                    .catch((error) => {
                      loading(false)
                    })
                  }
                }
              } else {
                sendRequestForControl(
                  targetElemState.frameIndex,
                  "add",
                  currElemState.current,
                  targetElemState
                ).then(async(response) => {
                  if (response.data.status === 0) {
                    var controlElemToAdd = response.data;
                    setOpenQuickToolFor(controlElemToAdd?.id);
                    if (
                      currentDataObjectJson.current &&
                      Object.keys(currentDataObjectJson.current)
                        .length === 0
                    ) {
                    } else {
                      if (
                        currentDataObjectJson.current &&
                        currentDataObjectJson.current[
                          "VariableName"
                        ]
                      ) {
                        let dataClassMap;

                        if (
                          currentDataObjectJson.current[
                            "parentName"
                          ] &&
                          currentDataObjectJson.current[
                            "parentName"
                          ] !== ""
                        ) {
                          dataClassMap =
                            currentDataObjectJson.current[
                              "treeName"
                            ];
                        } else {
                          dataClassMap =
                            currentDataObjectJson.current[
                              "VariableName"
                            ];
                        }

                        mappingControlsIdMap.add(
                          currentDataObjectJson.current["treeName"]
                        );
                        
                        if(!(currentDataObjectJson?.current?.["Unbounded"] === "N" && currentDataObjectJson.current?.children?.length > 0)) {
                          controlElemToAdd["TypeOfValue"] =
                            currentDataObjectJson.current[
                              "VariableType"
                            ];
                          controlElemToAdd["dataclass"] =
                            dataClassMap;
                          controlElemToAdd["style"] = {
                            ...controlElemToAdd.style,
                            Label:
                              currentDataObjectJson.current[
                                "treeName"
                              ],
                            Mapping: dataClassMap,
                            MappingId:
                              currentDataObjectJson.current[
                                "treeName"
                              ],
                            Enable: "true",
                            Visible: "true",
                            
                          };
                        }
                      }
                    }

                    if(!(currentDataObjectJson?.current?.["Unbounded"] === "N" && currentDataObjectJson.current?.children?.length > 0))
                      setCurrentDataObjectJson(cloneDeep({}));
                      dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                    controlElemToAdd["style"] = {
                      ...ThemeJSON[currElemState.current],
                      Label: currentDataObjectJson.current["treeName"],
                    };
                    if (
                      (controlElemToAdd?.elem_type !== "frame" &&
                        controlElemToAdd?.elem_type !== "wizard") ||
                      parentTab() ||
                      parentWizardCheck() ||
                      parentMenuCheck()
                    ) {
                      let frameEnableValue = true;
                      var framereadValue = false;
                      console.log(framereadValue);
                      let frameReadOnlyValue = false;
                      const parenttabVal = parentTab();
                      const parentWizardCheckVal = parentWizardCheck();
                      const parentMenuCheckVal = parentMenuCheck();
                      const parentSectionVal = parentSection();
                      const tabId = findTabId();
                      const sectionId = findSectionId();
                      const parentSectionCheck = parentSection(tabId);
                      const parentTabCheck = parentTab(sectionId);
                      const parentSectionId = findSectionId(tabId);

                      if (
                        parenttabVal &&
                        !parentWizardCheckVal &&
                        !parentMenuCheckVal
                      ) {
                        if (parentSectionCheck) {
                          if (
                            document
                              .getElementById(parentSectionId)
                              ?.getAttribute("enable") === "false" ||
                            document
                              .getElementById(parentSectionId)
                              ?.getAttribute("enable") === false
                          )
                            frameEnableValue = false;
                          else frameEnableValue = true;
                          if (
                            document
                              .getElementById(parentSectionId)
                              ?.getAttribute("readonly") === "true" ||
                            document
                              .getElementById(parentSectionId)
                              ?.getAttribute("readonly") === true
                          )
                            frameReadOnlyValue = true;
                          else frameReadOnlyValue = false;
                          if (
                            document
                              .getElementById(parentSectionId)
                              ?.getAttribute("readOnlyValue") === "true" ||
                            document
                              .getElementById(parentSectionId)
                              ?.getAttribute("readOnlyValue") === true
                          )
                            framereadValue = true;
                          else framereadValue = false;
                          if (
                            document
                              .getElementById(tabId)
                              ?.getAttribute("readonly") === "true" ||
                            document
                              .getElementById(tabId)
                              ?.getAttribute("readonly") === true
                          )
                            frameReadOnlyValue = true;
                          else frameReadOnlyValue = false;
                          if (
                            document
                              .getElementById(tabId)
                              ?.getAttribute("readOnlyValue") === "true" ||
                            document
                              .getElementById(tabId)
                              ?.getAttribute("readOnlyValue") === true
                          )
                            framereadValue = true;
                          else framereadValue = false;
                          console.log(
                            "tabId",
                            document.getElementById(findTabId())
                          );
                          console.log(
                            "TabEnable",
                            document
                              .getElementById(findTabId())
                              ?.getAttribute("enable")
                          );
                          if (
                            document
                              .getElementById(tabId)
                              ?.getAttribute("enable") === "true" ||
                            document
                              .getElementById(tabId)
                              ?.getAttribute("enable") === true
                          )
                            frameEnableValue = true;
                          else frameEnableValue = false;
                          if (parentTabCheck) {
                            if (
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("enable") === "true" ||
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("enable") === true
                            )
                              frameEnableValue = true;
                            else frameEnableValue = false;
                            if (
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("readonly") === "true" ||
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("readonly") === true
                            )
                              frameReadOnlyValue = true;
                            else frameReadOnlyValue = false;
                            if (
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("readOnlyValue") === "true" ||
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("readOnlyValue") === true
                            )
                              framereadValue = true;
                            else framereadValue = false;
                          }
                        } else {
                          if (
                            document
                              .getElementById(tabId)
                              ?.getAttribute("enable") === "false" ||
                            document
                              .getElementById(tabId)
                              ?.getAttribute("enable") === false
                          )
                            frameEnableValue = false;
                          else frameEnableValue = true;
                          if (
                            document
                              .getElementById(tabId)
                              ?.getAttribute("readonly") === "true" ||
                            document
                              .getElementById(tabId)
                              ?.getAttribute("readonly") === true
                          )
                            frameReadOnlyValue = true;
                          else frameReadOnlyValue = false;
                          if (
                            document
                              .getElementById(tabId)
                              ?.getAttribute("readOnlyValue") === "true" ||
                            document
                              .getElementById(tabId)
                              ?.getAttribute("readOnlyValue") === true
                          )
                            framereadValue = true;
                          else framereadValue = false;
                          if (parentSectionVal) {
                            if (
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("enable") === "false" ||
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("enable") === false
                            ) {
                              frameEnableValue = false;
                            } else frameEnableValue = true;
                            if (
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("readonly") === "true" ||
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("readonly") === true
                            )
                              frameReadOnlyValue = true;
                            else frameReadOnlyValue = false;
                            if (
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("readOnlyValue") === "true" ||
                              document
                                .getElementById(sectionId)
                                ?.getAttribute("readOnlyValue") === true
                            )
                              framereadValue = true;
                            else framereadValue = false;
                          }
                        }
                      } else if (
                        parentSectionVal &&
                        !parentTabCheck &&
                        !parenttabVal &&
                        !parentWizardCheckVal &&
                        !parentMenuCheckVal
                      ) {
                        frameEnableValue = document
                          .getElementById(findSectionId())
                          ?.getAttribute("enable");
                        frameReadOnlyValue = document
                          .getElementById(findSectionId())
                          ?.getAttribute("readonly");
                        framereadValue = document
                          .getElementById(findSectionId())
                          ?.getAttribute("readOnlyValue");
                      } else if (parentWizardCheckVal) {
                        if (
                          document
                            .getElementById("wizard")
                            ?.getAttribute("readonly") === "true" ||
                          document
                            .getElementById("wizard")
                            ?.getAttribute("readOnly") === true
                        )
                          frameReadOnlyValue = true;
                        else frameReadOnlyValue = false;
                        if (sectionId) {
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("enable") === "false" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("enable") === false
                          )
                            frameEnableValue = false;
                          else frameEnableValue = true;
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readonly") === "true" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readonly") === true
                          )
                            frameReadOnlyValue = true;
                          else frameReadOnlyValue = false;
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readOnlyValue") === "true" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readOnlyValue") === true
                          )
                            framereadValue = true;
                          else framereadValue = false;
                        }
                      } else if (parentMenuCheckVal) {
                        if (
                          document
                            .getElementById("wizard")
                            ?.getAttribute("readOnlyValue") === "true" ||
                          document
                            .getElementById(findTabId())
                            ?.getAttribute("readonlyvalue") === true
                        )
                          framereadValue = true;
                        if (
                          document
                            .getElementById("wizard")
                            ?.getAttribute("readonly") === "true" ||
                          document
                            .getElementById("wizard")
                            ?.getAttribute("readOnly") === true
                        )
                          frameReadOnlyValue = true;
                        if (sectionId) {
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("enable") === "false" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("enable") === false
                          )
                            frameEnableValue = false;
                          else frameEnableValue = true;
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readonly") === "true" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readonly") === true
                          )
                            frameReadOnlyValue = true;
                          else frameReadOnlyValue = false;
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readOnlyValue") === "true" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readOnlyValue") === true
                          )
                            framereadValue = true;
                          else framereadValue = false;
                        }
                      }
                      if (
                        frameEnableValue === true ||
                        frameEnableValue === "true"
                      )
                        controlElemToAdd["style"].Enable = "true";
                      else controlElemToAdd["style"].Enable = "false";
                      if (
                        frameReadOnlyValue === true ||
                        frameReadOnlyValue === "true"
                      )
                        controlElemToAdd["style"].ReadOnlyStyle = "true";
                      else controlElemToAdd["style"].ReadOnlyStyle = "false";
                      if (framereadValue === true || framereadValue === "true")
                        controlElemToAdd["style"].ReadOnly = "true";
                      else controlElemToAdd["style"].ReadOnly = "false";
                    }
                    if (openCanvasForSubform === "subform") {
                      jsonObj = createSmartFormState(
                        subFormStateJson.current,
                        targetElemState.targetId,
                        targetElemState.targetElemType,
                        currElemState.current,
                        0,
                        targetElemState.frameIndex,
                        controlElemToAdd,
                        targetElemState.targetRowId,
                        targetElemState.targetColId,
                        device,
                        currentDataObjectJson?.current?.["Unbounded"] === "N" && currentDataObjectJson.current?.children?.length > 0 ? {"dataObjectDrop" : true, count: currentDataObjectJson.current?.children?.length} : "",
                      );
                    } else {
                      if (targetElemState.insideMenu) {
                        jsonObj = createSmartFormState(
                          formState2,
                          targetElemState.targetId,
                          targetElemState.targetElemType,
                          currElemState.current,
                          0,
                          targetElemState.frameIndex ||
                            controlElemToAdd.frameIndex,
                          controlElemToAdd,
                          targetElemState.targetRowId,
                          targetElemState.targetColId,
                          device,
                          currentDataObjectJson?.current?.["Unbounded"] === "N" && currentDataObjectJson.current?.children?.length > 0 ? {"dataObjectDrop" : true, count: currentDataObjectJson.current?.children?.length} : "",
                        );
                      } else {
                        jsonObj = createSmartFormState(
                          formState2,
                          targetElemState.targetId,
                          targetElemState.targetElemType,
                          currElemState.current,
                          0,
                          targetElemState.frameIndex,
                          controlElemToAdd,
                          targetElemState.targetRowId,
                          targetElemState.targetColId,
                          device,
                          currentDataObjectJson?.current?.["Unbounded"] === "N" && currentDataObjectJson.current?.children?.length > 0 ? {"dataObjectDrop" : true, count: currentDataObjectJson.current?.children?.length} : "",
                        );
                      }
                    }
                    if(currentDataObjectJson?.current?.["Unbounded"] === "N" && currentDataObjectJson.current?.children?.length > 0) {
                      setReRender(!reRender);
                      for(let index = 0; index < currentDataObjectJson.current?.children.length; index++) {
                        let child = currentDataObjectJson.current?.children[index];
                        currElemState.current =
                        child["VariableType"] === "Date" ||
                        child["VariableType"] === "shortDate" ||
                        child["VariableType"] === "Short Date"
                          ? "datepick"
                          : isAdvanceListviewCheck(child)
                          ? "advancelistview"
                          : child["Unbounded"] === "Y" && child.children
                          ? "listview"
                          : child["Unbounded"] === "Y" && !child.children
                          ? "listbox"
                          : child["Unbounded"] === "N" && child?.children?.length > 0
                          ? "section"
                          : child["Unbounded"] === "N" && child["VariableType"] === "Boolean"
                          ? "toggle"
                          : "textbox";
                          targetElemState.frameIndex = controlElemToAdd.frameIndex;
                          targetElemState.targetElemType = 'column';
                          targetElemState.targetClass = "COLUMN_col_css__3QcZb col-md-3 col-sm-6 col-12 draggingCol";
                          targetElemState.targetId = controlElemToAdd.children[0].children[index].id;
                          targetElemState.targetColId = controlElemToAdd.children[0].children[index].id;
                          await appendChildInSection(controlElemToAdd,targetElemState,jsonObj,child,index);
                      }
                  }
                    targetElemState = {};
                    setCurrElem("");
                    if (openCanvasForSubform === "subform") {
                      setSubFormState({ ...jsonObj });
                    } else {
                      setFormStateByUser({ ...jsonObj });
                    }
                    setCurrentDataObjectJson(cloneDeep({}));
                    dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))                
                  } else if (response.data.status === 1) {
                    showAlertConfirmNotifications({
                      open: true,
                      showConfirm: "showNotification",
                      alertType: "error",
                      alertContentKey: `${t("Reopen_Form")}`,
                    });
                  }
                  setCurrentDataObjectJson(cloneDeep({}));
                  dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                })
                .catch((error) => {
                  loading(false)
                })
              }
            } else if (
              targetElemState.targetElemType.toLowerCase() !== "step" &&
              targetElemState.targetElemType.toLowerCase() !== "substep"
            ) {
              if (currElemState.current === "report11") {
                var controlElemToAdd = {};
                controlElemToAdd.id = createUniqueId(currElemState.current);
                controlElemToAdd.elem_type = currElemState.current;
                if (openCanvasForSubform === "subform") {
                  jsonObj = createSmartFormState(
                    subFormStateJson.current,
                    targetElemState.targetId,
                    targetElemState.targetElemType,
                    currElemState.current,
                    0,
                    targetElemState.frameIndex,
                    controlElemToAdd,
                    targetElemState.targetRowId,
                    targetElemState.targetColId,
                  );
                } else if (
                  openCanvasForSubform === "advanceListviewFromScratch"
                ) {
                  jsonObj = createSmartFormState(
                    fetchGridStates().advanceListviewStateJson,
                    targetElemState.targetId,
                    targetElemState.targetElemType,
                    currElemState.current,
                    0,
                    targetElemState.frameIndex,
                    controlElemToAdd,
                    targetElemState.targetRowId,
                    targetElemState.targetColId,
                  );
                } else {
                  jsonObj = createSmartFormState(
                    formState2,
                    targetElemState.targetId,
                    targetElemState.targetElemType,
                    currElemState.current,
                    0,
                    targetElemState.frameIndex,
                    controlElemToAdd,
                    targetElemState.targetRowId,
                    targetElemState.targetColId,
                  );
                }
                targetElemState.targetId = "";
                targetElemState.targetClass = "";
                targetElemState.targetElemType = "";
                setCurrElem("");

                if (openCanvasForSubform === "subform") {
                  setSubFormState({ ...jsonObj });
                } else if (
                  openCanvasForSubform === "advanceListviewFromScratch"
                ) {
                  dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj }, renderCanvas:true}));
                } else {
                  setFormStateByUser({ ...jsonObj });
                }
              } else {
                if (
                  dataObjectJson &&
                  Object.keys(dataObjectJson).length !== 0 &&
                  currElemState.current === "textbox"
                ) {
                  setDataObjectsArray([
                    ...DataObjectsArray,
                    dataObjectJson["caption"],
                  ]);

                  var populateInside = {
                    id: "frame6",
                    elem_type: "frame",
                    frameIndex: targetElemState.frameIndex,
                    elementIndex: targetElemState.elementIndex,
                    sheetElementIndex: targetElemState.sheetElementIndex,
                    //sheetFrameElementIndex: parentControl["sheetFrameElementIndex"],
                    // sheetId: parentControl["sheetIndex"],
                  };

                  let jsonToBeSendToBackend = {
                    populateInside: populateInside,
                    populateElem: dataObjectJson,
                    isSubForm: isSubForm,
                    isAdvanceListview: isAdvanceListview,
                  };

                  if (!mappingDataObjectsMap.has(dataObjectJson["caption"])) {
                    sendRequestForControl(
                      null,
                      "duplicateDataObject",
                      null,
                      jsonToBeSendToBackend
                    ).then((response) => {
                      if (response.data.populatedJson !== null) {
                        response.data.populatedJson["style"] = {
                          ...response.data.populatedJson["style"],
                          ...ThemeJSON["textbox"],
                        };
                        response.data.populatedJson["style"] = {
                          ...response.data.populatedJson["style"],
                          ...ThemeJSON["textboxDefaultStyle"],
                        };

                        delete response.data.populatedJson["ColumnLayout"];

                        mappingDataObjectsMap.set(
                          dataObjectJson["caption"],
                          10
                        );
                        response.data.populatedJson.attr = {};
                        response.data.populatedJson.VariableName =
                          dataObjectJson["caption"];

                        if (openCanvasForSubform === "subform") {
                          jsonObj = createSmartFormState(
                            subFormStateJson.current,
                            targetElemState.targetId,
                            targetElemState.targetElemType,
                            "textbox",
                            0,
                            targetElemState.frameIndex,
                            response.data.populatedJson,
                            targetElemState.targetRowId,
                            targetElemState.targetColId,
                            device
                          );
                        } else if (
                          openCanvasForSubform === "advanceListviewFromScratch"
                        ) {
                          jsonObj = createSmartFormState(
                            fetchGridStates().advanceListviewStateJson,
                            targetElemState.targetId,
                            targetElemState.targetElemType,
                            "textbox",
                            0,
                            targetElemState.frameIndex,
                            response.data.populatedJson,
                            targetElemState.targetRowId,
                            targetElemState.targetColId,
                            device
                          );
                        } else {
                          jsonObj = createSmartFormState(
                            formState2,
                            targetElemState.targetId,
                            targetElemState.targetElemType,
                            "textbox",
                            0,
                            targetElemState.frameIndex,
                            response.data.populatedJson,
                            targetElemState.targetRowId,
                            targetElemState.targetColId,
                            device
                          );
                        }

                        targetElemState.targetId = "";
                        targetElemState.targetClass = "";
                        targetElemState.targetElemType = "";
                        setCurrElem("");

                        if (openCanvasForSubform === "subform") {
                          setSubFormState({ ...jsonObj });
                        } else if (
                          openCanvasForSubform === "advanceListviewFromScratch"
                        ) {
                          dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj }, renderCanvas:true}));
                        } else {
                          setFormStateByUser({ ...jsonObj });
                        }
                      }
                      setCurrentDataObjectJson(cloneDeep({}));
                      dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                    })
                    .catch((error) => {
                      loading(false)
                    })

                    setDataObjectJson({});
                  } else {
                    //customalert
                    showAlertConfirmNotifications({
                      open: true,
                      showConfirm: "showNotification",
                      alertType: "error",
                      alertContentKey: "DATA_PRESENT",
                    });
                    // alert('This Data Object is already present');
                  }
                } else if (
                  dataObjectJson &&
                  Object.keys(dataObjectJson).length !== 0 &&
                  currElemState.current === "datepick"
                ) {
                  var populateInside = {
                    id: "frame6",
                    elem_type: "frame",
                    frameIndex: targetElemState.frameIndex,
                    elementIndex: targetElemState.elementIndex,
                    sheetElementIndex: targetElemState.sheetElementIndex,
                    //sheetFrameElementIndex: parentControl["sheetFrameElementIndex"],
                    // sheetId: parentControl["sheetIndex"],
                  };

                  let jsonToBeSendToBackend = {
                    populateInside: populateInside,
                    populateElem: dataObjectJson,
                    isSubForm: isSubForm,
                    isAdvanceListview: isAdvanceListview,
                  };

                  if (!mappingDataObjectsMap.has(dataObjectJson["caption"])) {
                    sendRequestForControl(
                      null,
                      "duplicateDataObject",
                      null,
                      jsonToBeSendToBackend
                    ).then((response) => {
                      if (response.data.populatedJson !== null) {
                        mappingDataObjectsMap.set(
                          dataObjectJson["caption"],
                          10
                        );
                        response.data.populatedJson["style"] = {
                          ...response.data.populatedJson["style"],
                          ...ThemeJSON["datepick"],
                        };
                        // response.data.populatedJson["style"]={...response.data.populatedJson["style"],...ThemeJSON["textboxDefaultStyle"]};

                        response.data.populatedJson.attr = {};
                        delete response.data.populatedJson["ColumnLayout"];

                        response.data.populatedJson.VariableName =
                          dataObjectJson["caption"];

                        jsonObj = createSmartFormState(
                          formState2,
                          targetElemState.targetId,
                          targetElemState.targetElemType,
                          "textbox",
                          0,
                          targetElemState.frameIndex,
                          response.data.populatedJson,
                          targetElemState.targetColId,
                          device
                        );

                        targetElemState.targetId = "";
                        targetElemState.targetClass = "";
                        targetElemState.targetElemType = "";
                        setCurrElem("");
                        if (openCanvasForSubform === "subform") {
                          setSubFormState({ ...jsonObj });
                        } else if (
                          openCanvasForSubform === "advanceListviewFromScratch"
                        ) {
                          dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj }, renderCanvas:true}));
                        } else {
                          setFormStateByUser({ ...jsonObj });
                        }
                      }
                      setCurrentDataObjectJson(cloneDeep({}));
                      dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                    })
                    .catch((error) => {
                      loading(false)
                    })

                    setDataObjectJson({});
                  } else {
                    //customalert
                    showAlertConfirmNotifications({
                      open: true,
                      showConfirm: "showNotification",
                      alertType: "error",
                      alertContentKey: "DATA_PRESENT",
                    });
                    // alert('This Data Object is already present');
                  }
                } else if (
                  dataObjectJson &&
                  Object.keys(dataObjectJson).length === 0
                ) {
                  if (shouldBeDropped || !shouldBeDropped) {
                    targetElemState["isSubForm"] = isSubForm;
                    targetElemState["isAdvanceListview"] = isAdvanceListview;
                    const frameIndexget =
                      ev?.currentTarget
                        ?.closest(`[elem_type=frame]`)
                        ?.getAttribute("frameindex") ||
                      ev?.currentTarget
                        ?.closest(`[elem_type=section]`)
                        ?.getAttribute("frameindex") ||
                      ev?.currentTarget
                        ?.closest(`[elem_type=form]`)
                        ?.getAttribute("frameindex");
                    if (Object.keys(headerJsonNew.current).length !== 0) {
                      let frameIdNew;
                      let flag2 = 0;
                      const frameId = findJsonNew(formState2, "frame");
                      if (frameId.length > 0) {
                        frameIdNew = frameId[frameId.length - 1];
                      } else {
                        flag2 = 1;
                      }
                      var controlElemToAdd1;
                      var jsonToBeAdded;
                      var propertyName = "new";
                      var populateInside = {};
                      // populateInside ={id: "RootControl", elem_type: "form"}
                      // let payload = {
                      //     populateInside: populateInside,
                      //     // populateElem: props.data,
                      //     populateElem: headerJsonNew
                      //   };
                      if (headerJsonNew.current) {
                        controlElemToAdd1 = headerJsonNew.current;
                        populateInside = {
                          id: "RootControl",
                          elem_type: "form",
                        };
                        if (headerJsonNew.current.elem_type === "form") {
                          headerJsonNew.current.elem_type = "frame";
                        }
                        if (
                          document
                            .getElementById(`${ev?.target?.id}`)
                            .getAttribute("sheetIndex") !== undefined &&
                          document
                            .getElementById(`${ev?.target?.id}`)
                            .getAttribute("sheetIndex") !== null
                        ) {
                          console.log(
                            "aa gaya",
                            document
                              .getElementById(`${ev?.target?.id}`)
                              .getAttribute("sheetIndex"),
                            document
                              .getElementById(`${ev?.target?.id}`)
                              .getAttribute("frameIndex")
                          );
                          populateInside["frameIndex"] = document
                            .getElementById(`${ev?.target?.id}`)
                            .getAttribute("frameIndex");
                          populateInside["elementIndex"] = document
                            .getElementById(`${ev?.target?.id}`)
                            .getAttribute("elementIndex");
                          populateInside["sheetId"] = document
                            .getElementById(`${ev?.target?.id}`)
                            .getAttribute("sheetIndex");
                          populateInside["elem_type"] = "sheet";
                          if (populateInside?.id) delete populateInside?.id;
                        }

                        if(targetElemState.insideMenu) {
                          populateInside = {
                            "elem_type": "menu",
                            "id": "wizard",
                            "stepIndex": targetElemState?.stepIndex,
                            "subStepIndex": targetElemState?.substepIndex,
                            "subChildMenuIndex": targetElemState?.subChildMenuIndex
                          }
                        }
      
                        populateInside["isSubForm"] = isSubForm;
                        populateInside["isAdvanceListview"] = isAdvanceListview;
      
                        if(populateInside["isAdvanceListview"]) {
                          populateInside = {
                            ...populateInside,
                            "elem_type": "form",
                            "id": "wizard",
                            "stepIndex": currentadvanceListview?.current?.stepIndex,
                            "subStepIndex": currentadvanceListview?.current?.subStepIndex,
                            "subChildMenuIndex": currentadvanceListview?.current?.subChildMenuIndex
                          }
                        } else if(populateInside["isSubForm"]) {
                          populateInside = {
                            ...populateInside,
                            "elem_type": "form",
                            "id": "wizard",
                            "stepIndex": currentButtonForSubform?.current?.stepIndex,
                            "subStepIndex": currentButtonForSubform?.current?.subStepIndex,
                            "subChildMenuIndex": currentButtonForSubform?.current?.subChildMenuIndex
                          }
                        }

                        let payload = {
                          populateInside: populateInside,
                          // populateElem: props.data,
                          populateElem: headerJsonNew.current,
                        };
                        if (propertyName !== "") {
                          sendRequestForControl(
                            null,
                            "duplicate",
                            null,
                            payload
                          ).then((response) => {
                            let data = response.data;

                            jsonToBeAdded = data.populatedJson;

                            jsonToBeAdded = convertElementIndex(jsonToBeAdded);
                            //  convertElementIndex(jsonToBeAdded);

                            if (jsonToBeAdded !== null) {
                              updateRowNColumn(jsonToBeAdded);

                              // if(propertyName==="replace")
                              // {
                              // recursiveJsonForImportSection(formState2.children[1].children, props.id, 0, formState2.children[1].children, jsonToBeAdded, propertyName);
                              // }
                              if (propertyName === "new" && flag2 === 0) {
                                if (
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("sheetName") !== undefined &&
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("sheetName") !== null
                                ) {
                                  recursiveJsonForImportSection(
                                    formState2.children[1].children,
                                    frameIdNew,
                                    0,
                                    formState2.children[1].children,
                                    jsonToBeAdded,
                                    propertyName,
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("sheetName")
                                  );
                                } else {
                                  if (
                                    targetElemState?.targetElemType?.includes(
                                      "column"
                                    ) &&
                                    targetElemState?.targetId?.includes(
                                      "column"
                                    )
                                  ) {
                                    frameIdNew = targetElemState?.targetId;
                                    jsonToBeAdded["sheetIndex"] = document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("sheetIndex");
                                    recursiveJsonForImportSection(
                                      formState2.children[1].children,
                                      frameIdNew,
                                      0,
                                      formState2.children[1].children,
                                      jsonToBeAdded,
                                      propertyName
                                    );
                                  } else {
                                    const newJson = updateTileIndex(
                                      jsonToBeAdded,
                                      jsonToBeAdded?.frameIndex
                                    );
                                    if (openCanvasForSubform === "subform") {
                                      if(subFormStateJson.current?.children?.[1]?.children) {
                                        subFormStateJson.current.children[1].children.push(newJson);
                                        updatedComponentInFormState();
                                      }
                                    }
                                    else if (openCanvasForSubform === "advanceListviewFromScratch") {
                                      if(fetchGridStates().advanceListviewStateJson?.children?.[0]?.children) {
                                        fetchGridStates().advanceListviewStateJson.children[0].children.push(newJson);
                                        updatedComponentInFormState();
                                      }
                                    }
                                    else {
                                      recursiveJsonForImportSection(
                                        formState2.children[1].children,
                                        frameIdNew,
                                        0,
                                        formState2.children[1].children,
                                        jsonToBeAdded,
                                        propertyName
                                      );
                                    }
                                  }
                                }
                                targetElemState = {};
                                setCurrElem("");
                              } else {
                                var latestJson = { ...formState2 };
                                latestJson.children[1].children[1] =
                                  jsonToBeAdded;
                                targetElemState = {};
                                setCurrElem("");
                                setFormStateByUser({ ...latestJson });
                                updatedComponentInFormState();
                              }
                              showAlertConfirmNotifications({
                                open: true,
                                showConfirm: "showNotification",
                                alertType: "success",
                                vertical: "bottom",
                                horizontal: "left",
                                alertContentKey:
                                  "SECTION_TEMPLATE_SUCCESS",
                                autoHideDuration: 3000,
                              });

                              // window.setTimeout(() => {
                              //     showAlertConfirmNotifications({
                              //     open: false,
                              //     showConfirm: "showNotification",
                              //     alertType: "success",
                              //     alertContentKey: "UploadSectionFailureMessage",
                              //     });
                              //     setQuickToolsClose(false);
                              // }, 1000);
                              // setHeaderJsonNew({});
                              headerJsonNew.current = {};
                            } else {
                              // alert("Json Is In Correct");
                              console.log("Json Is In Correct");
                            }
                            setCurrentDataObjectJson(cloneDeep({}));
                            dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                          })
                          .catch((error) => {
                            loading(false)
                          })
                        }
                      }
                    } else {
                      if (
                        (flag4 === 1 || (flag37 === 1 && frameNo !== "")) &&
                        currElemState.current === "section"
                      ) {
                        targetElemState.targetRowId = ev.target.id;
                        targetElemState.targetId = "RootControl";
                        targetElemState.targetElemType = "form";
                        if (
                          flag37 === 1 &&
                          targetElemState?.targetRowId?.includes(
                            "before_frame"
                          ) &&
                          document
                            .getElementById(`${ev?.target?.id}`)
                            .getAttribute("sheetName")
                        ) {
                          extraDetails.sheetIndex = document
                            .getElementById(`${ev?.target?.id}`)
                            ?.getAttribute("sheetIndex");
                          if (
                            targetElemState?.elementIndex === "" &&
                            document
                              .getElementById(`${ev?.target?.id}`)
                              ?.getAttribute("elementIndex")
                          ) {
                            targetElemState.elementIndex = document
                              .getElementById(`${ev?.target?.id}`)
                              ?.getAttribute("elementIndex");
                          }
                        }
                        if(extraDetails?.isSubForm && (targetElemState?.insideWizard || targetElemState?.insideMenu)){
                            targetElemState.insideWizard = false
                            targetElemState.insideMenu = false
                        }
                        sendRequestForControl(
                          flag37 === 1 && extraDetails?.sheetIndex
                            ? document
                                ?.getElementById(`${ev?.target?.id}`)
                                ?.getAttribute("frameIndex")
                            : undefined,
                          "add",
                          currElemState.current,
                          targetElemState,
                          extraDetails,
                          flag4,
                          flag37,
                          // (flag37 === 1 && extraDetails?.sheetIndex) ? (parseInt(frameNo) + 1) + "" : frameNo
                          frameNo
                        )
                          .then((response) => {
                            if (response.data.status === 0) {
                              var controlElemToAdd1;
                              // if(Object.keys(headerJsonNew).length !== 0){
                              //     if(headerJsonNew.frameIndex && headerJsonNew.id){
                              //         headerJsonNew.frameIndex = response.data.frameIndex
                              //         headerJsonNew.id = response.data.id
                              //         controlElemToAdd = headerJsonNew
                              //     }

                              // }
                              // else{
                              controlElemToAdd1 = response.data;
                              if (formState2?.customControl?.length > 0) {
                                formState2?.customControl?.forEach((key, index) => {
                                  if (key?.label === response?.data?.controlName) {
                                    controlElemToAdd1.properties = key?.properties;
                                  }
                                });
                              }
                              if (controlElemToAdd1 && controlElemToAdd1?.elem_type !== "frame") {
                                controlElemToAdd1.marvin = "false";
                              }
                              if (controlElemToAdd1?.elem_type === "radio") {
                                controlElemToAdd1.options = [
                                  {
                                    label: "Option1", value: "Option1",tooltip:"", FE_id: '1'
                                  },
                                  
                                ];
                              }
                              if (controlElemToAdd1?.elem_type === "combo") {
                                controlElemToAdd1.options = [
                                  {
                                    label:`${t("translation:Select")}`,
                                    value: "",
                                    FE_id: "1",
                                  },
                                ];
                              }
                              if (controlElemToAdd1?.elem_type === "listbox") {
                                controlElemToAdd1.options = [
                                  {
                                    label: "Default",
                                    value: "Default",
                                    FE_id: "1",
                                  },
                                ];
                                // controlElemToAdd.value = ["Default"];
                              }
                              // }

                              setOpenQuickToolFor(controlElemToAdd1?.id);
                              // setHeaderJsonNew({})
                              controlElemToAdd1["style"] = {
                                ...ThemeJSON[currElemState.current],
                              };
                              if (controlElemToAdd1?.elem_type === "image") {
                                if (controlElemToAdd1.style["imageStyle"] === undefined || controlElemToAdd1.style["imageStyle"] === null) {
                                  controlElemToAdd1.style.imageStyle = {
                                    ...controlElemToAdd1.style?.imageStyle,
                                    height: controlElemToAdd1.style.height,
                                    width: controlElemToAdd1.style.width,
                                    defaultWidth: controlElemToAdd1.style.defaultWidth,
                                    defaultHeight: controlElemToAdd1.style.defaultHeight,
                                    size: controlElemToAdd1.style.size,
                                    scale: "1",
                                    resize: controlElemToAdd1.style.resize,
                                    widthType: controlElemToAdd1.style.scale === "pixels" ? "px" : "%",
                                    aspectRatio: "auto",
                                    transform: "rotate(0deg) scale(1,1)",
                                    degree: 0,
                                    scaleX: 1,
                                    scaleY: 1
                                  };
                                }
                              }
                              if (controlElemToAdd1.controlName === "doclist") {
                                const handleDocuments = () => {
                                  //alert('Document click handler')
                                };
                                var docData = {
                                  documents: [],
                                  available_doc_types: [],
                                  available_owners: ["arj", "badmin"],
                                  doc_upload_options: {
                                    google_drive: false,
                                    camera: true,
                                    scan: false,
                                    omnidocs: false,
                                    system: true,
                                  },
                                  upload_doc_as: {
                                    new: true,
                                    new_version: true,
                                    overwrite: true,
                                  },
                                  docEventHandler: handleDocuments,
                                  docviewer_info: {
                                    viewer_location: "inline", //inline, popup, window
                                    ContainerId: "rdDIv", //Optional, Required in case viewer_location is Inline //Optional, Required in case viewer_location is Inline,
                                    view_annotation: true,
                                    view_stamps: true,
                                    show_opall_menu: true,
                                    opall_params: {
                                      printOption: "false",
                                      TransformOption: "",
                                    },
                                  },
                                  enable_next: true,
                                  enable_prev: false,
                                  enable_search: false,
                                  enable_filter: false,
                                  enable_upload: true,
                                  enable_sorting: false,
                                  source: "APPLICATION",
                                  pid: "",
                                  wid: "",
                                  ext_data: {},
                                };
                                controlElemToAdd1.json = docData;
                              }
                              if (
                                controlElemToAdd1.controlName === "password" &&
                                controlElemToAdd1.elem_type === "textbox"
                              )
                                controlElemToAdd1["style"] = {
                                  isPassword: true,
                                  Placeholder: "Enter Password",
                                  ShowPasswordIcon: "true",
                                  Mapping: "",
                                  ...Object.assign({}, ThemeJSON.textbox),
                                };

                              if (
                                controlElemToAdd1.elem_type === "iframe" &&
                                controlLabel.current === "Survey"
                              ) {
                                controlElemToAdd1 = {
                                  ...controlElemToAdd1,
                                  controlName: "Survey",
                                };
                              }

                              if (
                                currentDataObjectJson &&
                                Object.keys(currentDataObjectJson).length === 0
                              ) {
                              } else {
                                if (
                                  currentDataObjectJson &&
                                  currentDataObjectJson["VariableName"]
                                ) {
                                  let dataClassMap;

                                  if (
                                    currentDataObjectJson["parentName"] &&
                                    currentDataObjectJson["parentName"] !== ""
                                  ) {
                                    dataClassMap =
                                      currentDataObjectJson["treeName"];
                                  } else {
                                    dataClassMap =
                                      currentDataObjectJson["VariableName"];
                                  }

                                  mappingControlsIdMap.add(
                                    currentDataObjectJson["treeName"]
                                  );

                                  controlElemToAdd1["TypeOfValue"] =
                                    currentDataObjectJson["VariableType"];
                                  controlElemToAdd1["dataclass"] = dataClassMap;
                                  controlElemToAdd1["style"] = {
                                    Label: currentDataObjectJson["treeName"],
                                    Mapping: dataClassMap,
                                    MappingId:
                                      currentDataObjectJson["treeName"],
                                    Enable: "true",
                                    Visible: "true",
                                  };
                                }
                              }

                              setCurrentDataObjectJson(cloneDeep({}));
                              dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))

                              if (openCanvasForSubform === "subform") {
                                if (
                                  flag37 === 1 &&
                                  targetElemState?.targetRowId?.includes(
                                    "before_frame"
                                  ) &&
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("sheetName")
                                ) {
                                  targetElemState.targetElemType = "tabChild";
                                  targetElemState.targetId = document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("sheetName");
                                  targetElemState.targetRowId = "";
                                  jsonObj = createSmartFormState(
                                    subFormStateJson.current,
                                    targetElemState.targetId,
                                    targetElemState.targetElemType,
                                    controlElemToAdd1.controlName ===
                                      "password" &&
                                      controlElemToAdd1.elem_type === "textbox"
                                      ? "textbox"
                                      : currElemState.current,
                                    0,
                                    targetElemState.frameIndex,
                                    controlElemToAdd1,
                                    targetElemState.targetRowId,
                                    targetElemState.targetColId,
                                    device
                                  );
                                } else if (
                                  flag37 === 1 &&
                                  targetElemState?.targetRowId?.includes(
                                    "before_frame"
                                  ) &&
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("wizardSubStepName")
                                ) {
                                  targetElemState.targetElemType = "SubStep";
                                  targetElemState.targetId = document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("wizardSubStepName");
                                  targetElemState.targetRowId = "";
                                  jsonObj = createSmartFormState(
                                    subFormStateJson.current,
                                    targetElemState.targetId,
                                    targetElemState.targetElemType,
                                    controlElemToAdd1.controlName ===
                                      "password" &&
                                      controlElemToAdd1.elem_type === "textbox"
                                      ? "textbox"
                                      : currElemState.current,
                                    0,
                                    targetElemState.frameIndex,
                                    controlElemToAdd1,
                                    targetElemState.targetRowId,
                                    targetElemState.targetColId,
                                    device
                                  );
                                } else if (
                                  flag37 === 1 &&
                                  targetElemState?.targetRowId?.includes(
                                    "before_frame"
                                  ) &&
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("subStepName")
                                ) {
                                  targetElemState.targetElemType = "SubStep";
                                  targetElemState.targetId = document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("subStepName");
                                  targetElemState.targetRowId = "";
                                  jsonObj = createSmartFormState(
                                    subFormStateJson.current,
                                    targetElemState.targetId,
                                    targetElemState.targetElemType,
                                    controlElemToAdd1.controlName ===
                                      "password" &&
                                      controlElemToAdd1.elem_type === "textbox"
                                      ? "textbox"
                                      : currElemState.current,
                                    0,
                                    targetElemState.frameIndex,
                                    controlElemToAdd1,
                                    targetElemState.targetRowId,
                                    targetElemState.targetColId,
                                    device
                                  );
                                } else if (
                                  flag37 === 1 &&
                                  targetElemState?.targetRowId?.includes(
                                    "before_frame"
                                  ) &&
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("wizardStepName")
                                ) {
                                  targetElemState.targetElemType = "Step";
                                  targetElemState.targetId = document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("wizardStepName");
                                  targetElemState.targetRowId = "";
                                  jsonObj = createSmartFormState(
                                    subFormStateJson.current,
                                    targetElemState.targetId,
                                    targetElemState.targetElemType,
                                    controlElemToAdd1.controlName ===
                                      "password" &&
                                      controlElemToAdd1.elem_type === "textbox"
                                      ? "textbox"
                                      : currElemState.current,
                                    0,
                                    targetElemState.frameIndex,
                                    controlElemToAdd1,
                                    targetElemState.targetRowId,
                                    targetElemState.targetColId,
                                    device
                                  );
                                } else if (
                                  flag37 === 1 &&
                                  targetElemState?.targetRowId?.includes(
                                    "before_frame"
                                  ) &&
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("stepName")
                                ) {
                                  targetElemState.targetElemType = "MainMenu";
                                  targetElemState.targetId = document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("stepName");
                                  targetElemState.targetRowId = "";
                                  jsonObj = createSmartFormState(
                                    subFormStateJson.current,
                                    targetElemState.targetId,
                                    targetElemState.targetElemType,
                                    controlElemToAdd1.controlName ===
                                      "password" &&
                                      controlElemToAdd1.elem_type === "textbox"
                                      ? "textbox"
                                      : currElemState.current,
                                    0,
                                    targetElemState.frameIndex,
                                    controlElemToAdd1,
                                    targetElemState.targetRowId,
                                    targetElemState.targetColId,
                                    device
                                  );
                                } else {
                                  if (
                                    flag4 === 1 &&
                                    flag37 === 0 &&
                                    targetElemState?.targetRowId?.includes(
                                      "before_frame"
                                    ) &&
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("wizardSubStepName")
                                  ) {
                                    targetElemState.targetElemType = "SubStep";
                                    targetElemState.targetId = document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("wizardSubStepName");
                                    targetElemState.targetRowId = "";
                                    jsonObj = createSmartFormState(
                                      subFormStateJson.current,
                                      targetElemState.targetId,
                                      targetElemState.targetElemType,
                                      controlElemToAdd1.controlName ===
                                        "password" &&
                                        controlElemToAdd1.elem_type ===
                                          "textbox"
                                        ? "textbox"
                                        : currElemState.current,
                                      0,
                                      targetElemState.frameIndex,
                                      controlElemToAdd1,
                                      targetElemState.targetRowId,
                                      targetElemState.targetColId,
                                      device
                                    );
                                  } else if (
                                    flag4 === 1 &&
                                    flag37 === 0 &&
                                    targetElemState?.targetRowId?.includes(
                                      "before_frame"
                                    ) &&
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("subStepName")
                                  ) {
                                    targetElemState.targetElemType = "SubStep";
                                    targetElemState.targetId = document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("subStepName");
                                    targetElemState.targetRowId = "";
                                    jsonObj = createSmartFormState(
                                      subFormStateJson.current,
                                      targetElemState.targetId,
                                      targetElemState.targetElemType,
                                      controlElemToAdd1.controlName ===
                                        "password" &&
                                        controlElemToAdd1.elem_type ===
                                          "textbox"
                                        ? "textbox"
                                        : currElemState.current,
                                      0,
                                      targetElemState.frameIndex,
                                      controlElemToAdd1,
                                      targetElemState.targetRowId,
                                      targetElemState.targetColId,
                                      device
                                    );
                                  } else if (
                                    flag4 === 1 &&
                                    flag37 === 0 &&
                                    targetElemState?.targetRowId?.includes(
                                      "before_frame"
                                    ) &&
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("wizardStepName")
                                  ) {
                                    targetElemState.targetElemType = "Step";
                                    targetElemState.targetId = document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("wizardStepName");
                                    targetElemState.targetRowId = "";
                                    jsonObj = createSmartFormState(
                                      subFormStateJson.current,
                                      targetElemState.targetId,
                                      targetElemState.targetElemType,
                                      controlElemToAdd1.controlName ===
                                        "password" &&
                                        controlElemToAdd1.elem_type ===
                                          "textbox"
                                        ? "textbox"
                                        : currElemState.current,
                                      0,
                                      targetElemState.frameIndex,
                                      controlElemToAdd1,
                                      targetElemState.targetRowId,
                                      targetElemState.targetColId,
                                      device
                                    );
                                  } else if (
                                    flag4 === 1 &&
                                    flag37 === 0 &&
                                    targetElemState?.targetRowId?.includes(
                                      "before_frame"
                                    ) &&
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("stepName")
                                  ) {
                                    targetElemState.targetElemType = "MainMenu";
                                    targetElemState.targetId = document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("stepName");
                                    targetElemState.targetRowId = "";
                                    jsonObj = createSmartFormState(
                                      subFormStateJson.current,
                                      targetElemState.targetId,
                                      targetElemState.targetElemType,
                                      controlElemToAdd1.controlName ===
                                        "password" &&
                                        controlElemToAdd1.elem_type ===
                                          "textbox"
                                        ? "textbox"
                                        : currElemState.current,
                                      0,
                                      targetElemState.frameIndex,
                                      controlElemToAdd1,
                                      targetElemState.targetRowId,
                                      targetElemState.targetColId,
                                      device
                                    );
                                  } else {
                                    jsonObj = createSmartFormState(
                                      subFormStateJson.current,
                                      targetElemState.targetId,
                                      targetElemState.targetElemType,
                                      controlElemToAdd1.controlName ===
                                        "password" &&
                                        controlElemToAdd1.elem_type ===
                                          "textbox"
                                        ? "textbox"
                                        : currElemState.current,
                                      0,
                                      targetElemState.frameIndex,
                                      controlElemToAdd1,
                                      targetElemState.targetRowId,
                                      targetElemState.targetColId,
                                      device
                                    );
                                  }
                                }
                              } else if (
                                openCanvasForSubform ===
                                "advanceListviewFromScratch"
                              ) {
                                if (
                                  flag37 === 1 &&
                                  targetElemState?.targetRowId?.includes(
                                    "before_frame"
                                  ) &&
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("sheetName")
                                ) {
                                  targetElemState.targetElemType = "tabChild";
                                  targetElemState.targetId = document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("sheetName");
                                  targetElemState.targetRowId = "";
                                  jsonObj = createSmartFormState(
                                    fetchGridStates().advanceListviewStateJson,
                                    targetElemState.targetId,
                                    targetElemState.targetElemType,
                                    controlElemToAdd1.controlName ===
                                      "password" &&
                                      controlElemToAdd1.elem_type === "textbox"
                                      ? "textbox"
                                      : currElemState.current,
                                    0,
                                    targetElemState.frameIndex,
                                    controlElemToAdd1,
                                    targetElemState.targetRowId,
                                    targetElemState.targetColId,
                                    device
                                  );
                                } else if (
                                  flag37 === 1 &&
                                  targetElemState?.targetRowId?.includes(
                                    "before_frame"
                                  ) &&
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("wizardSubStepName")
                                ) {
                                  targetElemState.targetElemType = "SubStep";
                                  targetElemState.targetId = document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("wizardSubStepName");
                                  targetElemState.targetRowId = "";
                                  jsonObj = createSmartFormState(
                                    fetchGridStates().advanceListviewStateJson,
                                    targetElemState.targetId,
                                    targetElemState.targetElemType,
                                    controlElemToAdd1.controlName ===
                                      "password" &&
                                      controlElemToAdd1.elem_type === "textbox"
                                      ? "textbox"
                                      : currElemState.current,
                                    0,
                                    targetElemState.frameIndex,
                                    controlElemToAdd1,
                                    targetElemState.targetRowId,
                                    targetElemState.targetColId,
                                    device
                                  );
                                } else if (
                                  flag37 === 1 &&
                                  targetElemState?.targetRowId?.includes(
                                    "before_frame"
                                  ) &&
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("subStepName")
                                ) {
                                  targetElemState.targetElemType = "SubStep";
                                  targetElemState.targetId = document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("subStepName");
                                  targetElemState.targetRowId = "";
                                  jsonObj = createSmartFormState(
                                    fetchGridStates().advanceListviewStateJson,
                                    targetElemState.targetId,
                                    targetElemState.targetElemType,
                                    controlElemToAdd1.controlName ===
                                      "password" &&
                                      controlElemToAdd1.elem_type === "textbox"
                                      ? "textbox"
                                      : currElemState.current,
                                    0,
                                    targetElemState.frameIndex,
                                    controlElemToAdd1,
                                    targetElemState.targetRowId,
                                    targetElemState.targetColId,
                                    device
                                  );
                                } else if (
                                  flag37 === 1 &&
                                  targetElemState?.targetRowId?.includes(
                                    "before_frame"
                                  ) &&
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("wizardStepName")
                                ) {
                                  targetElemState.targetElemType = "Step";
                                  targetElemState.targetId = document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("wizardStepName");
                                  targetElemState.targetRowId = "";
                                  jsonObj = createSmartFormState(
                                    fetchGridStates().advanceListviewStateJson,
                                    targetElemState.targetId,
                                    targetElemState.targetElemType,
                                    controlElemToAdd1.controlName ===
                                      "password" &&
                                      controlElemToAdd1.elem_type === "textbox"
                                      ? "textbox"
                                      : currElemState.current,
                                    0,
                                    targetElemState.frameIndex,
                                    controlElemToAdd1,
                                    targetElemState.targetRowId,
                                    targetElemState.targetColId,
                                    device
                                  );
                                } else if (
                                  flag37 === 1 &&
                                  targetElemState?.targetRowId?.includes(
                                    "before_frame"
                                  ) &&
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("stepName")
                                ) {
                                  targetElemState.targetElemType = "MainMenu";
                                  targetElemState.targetId = document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("stepName");
                                  targetElemState.targetRowId = "";
                                  jsonObj = createSmartFormState(
                                    fetchGridStates().advanceListviewStateJson,
                                    targetElemState.targetId,
                                    targetElemState.targetElemType,
                                    controlElemToAdd1.controlName ===
                                      "password" &&
                                      controlElemToAdd1.elem_type === "textbox"
                                      ? "textbox"
                                      : currElemState.current,
                                    0,
                                    targetElemState.frameIndex,
                                    controlElemToAdd1,
                                    targetElemState.targetRowId,
                                    targetElemState.targetColId,
                                    device
                                  );
                                } else {
                                  if (
                                    flag4 === 1 &&
                                    flag37 === 0 &&
                                    targetElemState?.targetRowId?.includes(
                                      "before_frame"
                                    ) &&
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("wizardSubStepName")
                                  ) {
                                    targetElemState.targetElemType = "SubStep";
                                    targetElemState.targetId = document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("wizardSubStepName");
                                    targetElemState.targetRowId = "";
                                    jsonObj = createSmartFormState(
                                      fetchGridStates().advanceListviewStateJson,
                                      targetElemState.targetId,
                                      targetElemState.targetElemType,
                                      controlElemToAdd1.controlName ===
                                        "password" &&
                                        controlElemToAdd1.elem_type ===
                                          "textbox"
                                        ? "textbox"
                                        : currElemState.current,
                                      0,
                                      targetElemState.frameIndex,
                                      controlElemToAdd1,
                                      targetElemState.targetRowId,
                                      targetElemState.targetColId,
                                      device
                                    );
                                  } else if (
                                    flag4 === 1 &&
                                    flag37 === 0 &&
                                    targetElemState?.targetRowId?.includes(
                                      "before_frame"
                                    ) &&
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("subStepName")
                                  ) {
                                    targetElemState.targetElemType = "SubStep";
                                    targetElemState.targetId = document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("subStepName");
                                    targetElemState.targetRowId = "";
                                    jsonObj = createSmartFormState(
                                      fetchGridStates().advanceListviewStateJson,
                                      targetElemState.targetId,
                                      targetElemState.targetElemType,
                                      controlElemToAdd1.controlName ===
                                        "password" &&
                                        controlElemToAdd1.elem_type ===
                                          "textbox"
                                        ? "textbox"
                                        : currElemState.current,
                                      0,
                                      targetElemState.frameIndex,
                                      controlElemToAdd1,
                                      targetElemState.targetRowId,
                                      targetElemState.targetColId,
                                      device
                                    );
                                  } else if (
                                    flag4 === 1 &&
                                    flag37 === 0 &&
                                    targetElemState?.targetRowId?.includes(
                                      "before_frame"
                                    ) &&
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("wizardStepName")
                                  ) {
                                    targetElemState.targetElemType = "Step";
                                    targetElemState.targetId = document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("wizardStepName");
                                    targetElemState.targetRowId = "";
                                    jsonObj = createSmartFormState(
                                      fetchGridStates().advanceListviewStateJson,
                                      targetElemState.targetId,
                                      targetElemState.targetElemType,
                                      controlElemToAdd1.controlName ===
                                        "password" &&
                                        controlElemToAdd1.elem_type ===
                                          "textbox"
                                        ? "textbox"
                                        : currElemState.current,
                                      0,
                                      targetElemState.frameIndex,
                                      controlElemToAdd1,
                                      targetElemState.targetRowId,
                                      targetElemState.targetColId,
                                      device
                                    );
                                  } else if (
                                    flag4 === 1 &&
                                    flag37 === 0 &&
                                    targetElemState?.targetRowId?.includes(
                                      "before_frame"
                                    ) &&
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("stepName")
                                  ) {
                                    targetElemState.targetElemType = "MainMenu";
                                    targetElemState.targetId = document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("stepName");
                                    targetElemState.targetRowId = "";
                                    jsonObj = createSmartFormState(
                                      fetchGridStates().advanceListviewStateJson,
                                      targetElemState.targetId,
                                      targetElemState.targetElemType,
                                      controlElemToAdd1.controlName ===
                                        "password" &&
                                        controlElemToAdd1.elem_type ===
                                          "textbox"
                                        ? "textbox"
                                        : currElemState.current,
                                      0,
                                      targetElemState.frameIndex,
                                      controlElemToAdd1,
                                      targetElemState.targetRowId,
                                      targetElemState.targetColId,
                                      device
                                    );
                                  } else {
                                    jsonObj = createSmartFormState(
                                      fetchGridStates().advanceListviewStateJson,
                                      targetElemState.targetId,
                                      targetElemState.targetElemType,
                                      controlElemToAdd1.controlName ===
                                        "password" &&
                                        controlElemToAdd1.elem_type ===
                                          "textbox"
                                        ? "textbox"
                                        : currElemState.current,
                                      0,
                                      targetElemState.frameIndex,
                                      controlElemToAdd1,
                                      targetElemState.targetRowId,
                                      targetElemState.targetColId,
                                      device
                                    );
                                  }
                                }
                              } else {
                                if (
                                  currElemState.current.includes("template") &&
                                  controlElemToAdd1.populatedJson
                                ) {
                                  delete controlElemToAdd["style"];
                                  targetElemState.targetId = "design_page";
                                  targetElemState.targetElemType =
                                    "Design Page";
                                  targetElemState.frameIndex = null;
                                  targetElemState.targetRowId = null;
                                  jsonObj = createSmartFormState(
                                    formState2,
                                    targetElemState.targetId,
                                    targetElemState.targetElemType,
                                    "section",
                                    0,
                                    targetElemState.frameIndex,
                                    controlElemToAdd1.populatedJson,
                                    targetElemState.targetRowId,
                                    targetElemState.targetColId,
                                    device,
                                    { notCreateRow: "true", position: "start" }
                                  );
                                } else {
                                  if (
                                    flag37 === 1 &&
                                    targetElemState?.targetRowId?.includes(
                                      "before_frame"
                                    ) &&
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("sheetName")
                                  ) {
                                    targetElemState.targetElemType = "tabChild";
                                    targetElemState.targetId = document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("sheetName");
                                    targetElemState.targetRowId = "";
                                    jsonObj = createSmartFormState(
                                      formState2,
                                      targetElemState.targetId,
                                      targetElemState.targetElemType,
                                      controlElemToAdd1.controlName ===
                                        "password" &&
                                        controlElemToAdd1.elem_type ===
                                          "textbox"
                                        ? "textbox"
                                        : currElemState.current,
                                      0,
                                      targetElemState.frameIndex,
                                      controlElemToAdd1,
                                      targetElemState.targetRowId,
                                      targetElemState.targetColId,
                                      device
                                    );
                                  } else if (
                                    flag37 === 1 &&
                                    targetElemState?.targetRowId?.includes(
                                      "before_frame"
                                    ) &&
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("wizardSubStepName")
                                  ) {
                                    targetElemState.targetElemType = "SubStep";
                                    targetElemState.targetId = document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("wizardSubStepName");
                                    targetElemState.targetRowId = "";
                                    jsonObj = createSmartFormState(
                                      formState2,
                                      targetElemState.targetId,
                                      targetElemState.targetElemType,
                                      controlElemToAdd1.controlName ===
                                        "password" &&
                                        controlElemToAdd1.elem_type ===
                                          "textbox"
                                        ? "textbox"
                                        : currElemState.current,
                                      0,
                                      targetElemState.frameIndex,
                                      controlElemToAdd1,
                                      targetElemState.targetRowId,
                                      targetElemState.targetColId,
                                      device
                                    );
                                  } else if (
                                    flag37 === 1 &&
                                    targetElemState?.targetRowId?.includes(
                                      "before_frame"
                                    ) &&
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("subStepName")
                                  ) {
                                    targetElemState.targetElemType = "SubStep";
                                    targetElemState.targetId = document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("subStepName");
                                    targetElemState.targetRowId = "";
                                    jsonObj = createSmartFormState(
                                      formState2,
                                      targetElemState.targetId,
                                      targetElemState.targetElemType,
                                      controlElemToAdd1.controlName ===
                                        "password" &&
                                        controlElemToAdd1.elem_type ===
                                          "textbox"
                                        ? "textbox"
                                        : currElemState.current,
                                      0,
                                      targetElemState.frameIndex,
                                      controlElemToAdd1,
                                      targetElemState.targetRowId,
                                      targetElemState.targetColId,
                                      device
                                    );
                                  } else if (
                                    flag37 === 1 &&
                                    targetElemState?.targetRowId?.includes(
                                      "before_frame"
                                    ) &&
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("wizardStepName")
                                  ) {
                                    targetElemState.targetElemType = "Step";
                                    targetElemState.targetId = document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("wizardStepName");
                                    targetElemState.targetRowId = "";
                                    jsonObj = createSmartFormState(
                                      formState2,
                                      targetElemState.targetId,
                                      targetElemState.targetElemType,
                                      controlElemToAdd1.controlName ===
                                        "password" &&
                                        controlElemToAdd1.elem_type ===
                                          "textbox"
                                        ? "textbox"
                                        : currElemState.current,
                                      0,
                                      targetElemState.frameIndex,
                                      controlElemToAdd1,
                                      targetElemState.targetRowId,
                                      targetElemState.targetColId,
                                      device
                                    );
                                  } else if (
                                    flag37 === 1 &&
                                    targetElemState?.targetRowId?.includes(
                                      "before_frame"
                                    ) &&
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("stepName")
                                  ) {
                                    targetElemState.targetElemType = "MainMenu";
                                    targetElemState.targetId = document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("stepName");
                                    targetElemState.targetRowId = "";
                                    jsonObj = createSmartFormState(
                                      formState2,
                                      targetElemState.targetId,
                                      targetElemState.targetElemType,
                                      controlElemToAdd1.controlName ===
                                        "password" &&
                                        controlElemToAdd1.elem_type ===
                                          "textbox"
                                        ? "textbox"
                                        : currElemState.current,
                                      0,
                                      targetElemState.frameIndex,
                                      controlElemToAdd1,
                                      targetElemState.targetRowId,
                                      targetElemState.targetColId,
                                      device
                                    );
                                  } else {
                                    if (
                                      flag4 === 1 &&
                                      flag37 === 0 &&
                                      targetElemState?.targetRowId?.includes(
                                        "before_frame"
                                      ) &&
                                      document
                                        .getElementById(`${ev?.target?.id}`)
                                        .getAttribute("wizardSubStepName")
                                    ) {
                                      targetElemState.targetElemType =
                                        "SubStep";
                                      targetElemState.targetId = document
                                        .getElementById(`${ev?.target?.id}`)
                                        .getAttribute("wizardSubStepName");
                                      targetElemState.targetRowId = "";
                                      jsonObj = createSmartFormState(
                                        formState2,
                                        targetElemState.targetId,
                                        targetElemState.targetElemType,
                                        controlElemToAdd1.controlName ===
                                          "password" &&
                                          controlElemToAdd1.elem_type ===
                                            "textbox"
                                          ? "textbox"
                                          : currElemState.current,
                                        0,
                                        targetElemState.frameIndex,
                                        controlElemToAdd1,
                                        targetElemState.targetRowId,
                                        targetElemState.targetColId,
                                        device
                                      );
                                    } else if (
                                      flag4 === 1 &&
                                      flag37 === 0 &&
                                      targetElemState?.targetRowId?.includes(
                                        "before_frame"
                                      ) &&
                                      document
                                        .getElementById(`${ev?.target?.id}`)
                                        .getAttribute("subStepName")
                                    ) {
                                      targetElemState.targetElemType =
                                        "SubStep";
                                      targetElemState.targetId = document
                                        .getElementById(`${ev?.target?.id}`)
                                        .getAttribute("subStepName");
                                      targetElemState.targetRowId = "";
                                      jsonObj = createSmartFormState(
                                        formState2,
                                        targetElemState.targetId,
                                        targetElemState.targetElemType,
                                        controlElemToAdd1.controlName ===
                                          "password" &&
                                          controlElemToAdd1.elem_type ===
                                            "textbox"
                                          ? "textbox"
                                          : currElemState.current,
                                        0,
                                        targetElemState.frameIndex,
                                        controlElemToAdd1,
                                        targetElemState.targetRowId,
                                        targetElemState.targetColId,
                                        device
                                      );
                                    } else if (
                                      flag4 === 1 &&
                                      flag37 === 0 &&
                                      targetElemState?.targetRowId?.includes(
                                        "before_frame"
                                      ) &&
                                      document
                                        .getElementById(`${ev?.target?.id}`)
                                        .getAttribute("wizardStepName")
                                    ) {
                                      targetElemState.targetElemType = "Step";
                                      targetElemState.targetId = document
                                        .getElementById(`${ev?.target?.id}`)
                                        .getAttribute("wizardStepName");
                                      targetElemState.targetRowId = "";
                                      jsonObj = createSmartFormState(
                                        formState2,
                                        targetElemState.targetId,
                                        targetElemState.targetElemType,
                                        controlElemToAdd1.controlName ===
                                          "password" &&
                                          controlElemToAdd1.elem_type ===
                                            "textbox"
                                          ? "textbox"
                                          : currElemState.current,
                                        0,
                                        targetElemState.frameIndex,
                                        controlElemToAdd1,
                                        targetElemState.targetRowId,
                                        targetElemState.targetColId,
                                        device
                                      );
                                    } else if (
                                      flag4 === 1 &&
                                      flag37 === 0 &&
                                      targetElemState?.targetRowId?.includes(
                                        "before_frame"
                                      ) &&
                                      document
                                        .getElementById(`${ev?.target?.id}`)
                                        .getAttribute("stepName")
                                    ) {
                                      targetElemState.targetElemType =
                                        "MainMenu";
                                      targetElemState.targetId = document
                                        .getElementById(`${ev?.target?.id}`)
                                        .getAttribute("stepName");
                                      targetElemState.targetRowId = "";
                                      jsonObj = createSmartFormState(
                                        formState2,
                                        targetElemState.targetId,
                                        targetElemState.targetElemType,
                                        controlElemToAdd1.controlName ===
                                          "password" &&
                                          controlElemToAdd1.elem_type ===
                                            "textbox"
                                          ? "textbox"
                                          : currElemState.current,
                                        0,
                                        targetElemState.frameIndex,
                                        controlElemToAdd1,
                                        targetElemState.targetRowId,
                                        targetElemState.targetColId,
                                        device
                                      );
                                    } else {
                                      jsonObj = createSmartFormState(
                                        formState2,
                                        targetElemState.targetId,
                                        targetElemState.targetElemType,
                                        controlElemToAdd1.controlName ===
                                          "password" &&
                                          controlElemToAdd1.elem_type ===
                                            "textbox"
                                          ? "textbox"
                                          : currElemState.current,
                                        0,
                                        targetElemState.frameIndex,
                                        controlElemToAdd1,
                                        targetElemState.targetRowId,
                                        targetElemState.targetColId,
                                        device
                                      );
                                    }
                                  }
                                }
                              }
                              // console.log("jaabe", jsonObj);
                              var flag38 = 0;
                              if (flag4 === 1) {
                                if (
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("subStepName")
                                ) {
                                  var newJsonObj = findFrame(
                                    jsonObj,
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("frameIndex"),
                                    "0",
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("subStepName"),
                                    false
                                  );
                                } else if (
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("stepName")
                                ) {
                                  var newJsonObj = findFrame(
                                    jsonObj,
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("frameIndex"),
                                    "0",
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("stepName"),
                                    false
                                  );
                                } else if (
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("wizardSubStepName")
                                ) {
                                  var newJsonObj = findFrame(
                                    jsonObj,
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("frameIndex"),
                                    "0",
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("wizardSubStepName"),
                                    false
                                  );
                                } else if (
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("wizardStepName")
                                ) {
                                  var newJsonObj = findFrame(
                                    jsonObj,
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("frameIndex"),
                                    "0",
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("wizardStepName"),
                                    false
                                  );
                                } else {
                                  var currFrameId = controlElemToAdd1.id;
                                  var newJsonObj = findJsonNew1(
                                    jsonObj,
                                    "frame",
                                    currFrameId
                                  );

                                  if (
                                    openCanvasForSubform ===
                                    "advanceListviewFromScratch"
                                  ) {
                                    var arr1 =
                                      newJsonObj.children[0].children.splice(
                                        [
                                          newJsonObj.children[0].children
                                            .length - 1,
                                        ],
                                        1
                                      );
                                    console.log("hurr", arr1);
                                    newJsonObj.children[0].children.splice(
                                      0,
                                      0,
                                      arr1[0]
                                    );
                                  } else {
                                    // moveArrayItemToNewIndex(newJsonObj.children[1].children, 1, newJsonObj.children[1].children.length - 1)
                                    var arr1 =
                                      newJsonObj.children[1].children.splice(
                                        [
                                          newJsonObj.children[1].children
                                            .length - 1,
                                        ],
                                        1
                                      );
                                    // var newArr1 = findJsonNew2(arr1[0], 'frame', "")
                                    newJsonObj.children[1].children.splice(
                                      1,
                                      0,
                                      arr1[0]
                                    );
                                  }
                                }
                              } else if (flag37 === 1) {
                                // console.log("jaabe1", jsonObj);
                                // if(flag37 === 1 && extraDetails?.sheetIndex){
                                //   var newJsonObj = addFrameInBetween(jsonObj, targetElemState?.frameIndex, frameNo)
                                // }
                                // else{
                                var currFrameId = controlElemToAdd1.id;
                                // let tempState = formState2;
                                if (
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("sheetName")
                                ) {
                                  var newJsonObj = findFrame(
                                    jsonObj,
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("frameIndex"),
                                    frameNo,
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("sheetName"),
                                    true
                                  );
                                  flag38 = 1;
                                } else if (
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("subStepName")
                                ) {
                                  var newJsonObj = findFrame(
                                    jsonObj,
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("frameIndex"),
                                    frameNo,
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("subStepName"),
                                    false
                                  );
                                  flag38 = 1;
                                } else if (
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("stepName")
                                ) {
                                  var newJsonObj = findFrame(
                                    jsonObj,
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("frameIndex"),
                                    frameNo,
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("stepName"),
                                    false
                                  );
                                  flag38 = 1;
                                } else if (
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("wizardSubStepName")
                                ) {
                                  var newJsonObj = findFrame(
                                    jsonObj,
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("frameIndex"),
                                    frameNo,
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("wizardSubStepName"),
                                    false
                                  );
                                  flag38 = 1;
                                } else if (
                                  document
                                    .getElementById(`${ev?.target?.id}`)
                                    .getAttribute("wizardStepName")
                                ) {
                                  var newJsonObj = findFrame(
                                    jsonObj,
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("frameIndex"),
                                    frameNo,
                                    document
                                      .getElementById(`${ev?.target?.id}`)
                                      .getAttribute("wizardStepName"),
                                    false
                                  );
                                  flag38 = 1;
                                } else {
                                  var newJsonObj = findJsonNew2(
                                    jsonObj,
                                    "frame",
                                    currFrameId,
                                    frameNo
                                  );
                                }
                                console.log("faiku", newJsonObj);
                                // moveArrayItemToNewIndex(newJsonObj.children[1].children, 1, newJsonObj.children[1].children.length - 1)
                                if (flag38 === 0) {
                                  if (
                                    openCanvasForSubform ===
                                    "advanceListviewFromScratch"
                                  ) {
                                    var leng =
                                      newJsonObj.children[0].children.length -
                                      1;
                                    updateFrameIndex(
                                      newJsonObj.children[0].children[
                                        newJsonObj.children[0].children.length -
                                          1
                                      ],
                                      frameNo
                                    );
                                    var arr1 =
                                      newJsonObj.children[0].children[
                                        newJsonObj.children[0].children.length -
                                          1
                                      ];
                                    var arr2 =
                                      newJsonObj.children[0].children.splice(
                                        leng,
                                        1
                                      );
                                    // var newArr1 = findJsonNew2(arr1[0], 'frame', "")
                                    console.log("Dude", arr1, arr2);
                                    // var newArr1 = findJsonNew2(arr1[0], 'frame', "")
                                    newJsonObj.children[0].children.splice(
                                      parseInt(frameNo),
                                      0,
                                      arr1
                                    );
                                  } else {
                                    var leng =
                                      newJsonObj.children[1].children.length -
                                      1;
                                    updateFrameIndex(
                                      newJsonObj.children[1].children[
                                        newJsonObj.children[1].children.length -
                                          1
                                      ],
                                      frameNo
                                    );
                                    var arr1 =
                                      newJsonObj.children[1].children[
                                        newJsonObj.children[1].children.length -
                                          1
                                      ];
                                    var arr2 =
                                      newJsonObj.children[1].children.splice(
                                        leng,
                                        1
                                      );
                                    // var newArr1 = findJsonNew2(arr1[0], 'frame', "")
                                    console.log("Dude", arr1, arr2);
                                    // var newArr1 = findJsonNew2(arr1[0], 'frame', "")
                                    newJsonObj.children[1].children.splice(
                                      parseInt(frameNo) + 1,
                                      0,
                                      arr1
                                    );
                                  }
                                }

                                // }
                              } else newJsonObj = jsonObj;

                              targetElemState.targetId = "";
                              targetElemState.targetClass = "";
                              targetElemState.targetElemType = "";
                              setCurrElem("");

                              if (openCanvasForSubform === "subform") {
                                setSubFormState({ ...newJsonObj });
                              } else if (
                                openCanvasForSubform ===
                                "advanceListviewFromScratch"
                              ) {
                                dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...newJsonObj }, renderCanvas:true}));
                              } else {
                                setFormStateByUser({ ...newJsonObj });
                              }
                              if(currentDataObjectJson && currentDataObjectJson["VariableName"]){
                                controlElemToAdd1=dragAndDropThroughMDM(currentDataObjectJson,controlElemToAdd1);                                  
                                }                              
                            } else if (response.data.status === 1) {
                              showAlertConfirmNotifications({
                                open: true,
                                showConfirm: "showNotification",
                                alertType: "error",
                                alertContentKey: `${t("Reopen_Form")}`,
                              });
                            }
                            setCurrentDataObjectJson(cloneDeep({}));
                            dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                          })
                          .catch((error) => {
                            if (currElemState.current === "") {
                              setOpenDrawer(false);
                            }
                            showAlertConfirmNotifications({
                              open: true,
                              showConfirm: "showNotification",
                              alertType: "error",
                              alertContentKey: "WIZARD_DROP_MESSAGE",
                            });
                          });
                      } else {
                        if (currElemState.current === "CustomControl") {
                          extraDetails.controlLabel = controlLabel.current;
                        }
                        // const allPrimitiveControlList=["textbox","password","textarea","richtexteditor","datepick","slider","listbox",
                        // "combo","radio","checkbox","toggle","tile","picklist","button","link","label","paragraph","table","listview","advancelistview","image",
                        // "imagecarousel","report","iframe","captcha","sheet","tab"];
                        if (
                          flag4 === 0 ||
                          ((flag4 === 1 ||
                            targetElemState?.targetRowId.includes(
                              "before_frame"
                            )) &&
                            flag37 === 0)
                        ) {
                          if (flag4 === 1) {
                            targetElemState.targetRowId = ev.target.id;
                            targetElemState.targetId = "RootControl";
                            targetElemState.targetElemType = "form";
                          }
                          if (
                            targetElemState.targetElemType === "column" &&
                            (!ev.target.closest(`[elem_type=section]`) ||
                              checkTabParentSection === 1)
                          )
                            targetElemState.targetElemType = "column_tabChild";
                          targetElemState.insideMenu =
                            ev?.currentTarget?.closest(`[elem_type=Menu]`) ||
                            (openCanvasForSubform === "subform" &&
                              currentButtonForSubform.current
                                ?.containerControl === "Menu")
                              ? true
                              : false;
                          targetElemState.isSubForm =
                            openCanvasForSubform === "subform" ? true : false;
                          // if(targetElemState?.targetRowId?.includes("after_row")){
                          //   targetElemState.targetId = ev?.currentTarget?.getAttribute("control_id")
                          //   targetElemState.targetRowId = ""
                          // }
                          if (
                            targetElemState?.targetId !== undefined &&
                            targetElemState?.targetId !== "" &&
                            !isNaN(targetElemState?.targetId)
                          ) {
                            targetElemState.targetId = "RootControl";
                          }
                          extraDetails.isAboveWizard = isAboveWizard;
                          if(extraDetails?.isSubForm && (targetElemState?.insideWizard || targetElemState?.insideMenu)){
                            targetElemState.insideWizard = false
                            targetElemState.insideMenu = false
                          }
                          sendRequestForControl(
                            targetElemState.frameIndex || frameIndexget,
                            "add",
                            currElemState.current,
                            targetElemState,
                            extraDetails
                          )
                            .then(async(response) => {
                              if (response.data.status === 0) {
                                var controlElemToAdd;
                                // if(Object.keys(headerJsonNew).length !== 0){
                                //     if(headerJsonNew.frameIndex && headerJsonNew.id){
                                //         headerJsonNew.frameIndex = response.data.frameIndex
                                //         headerJsonNew.id = response.data.id
                                //         controlElemToAdd = headerJsonNew
                                //     }

                                // }
                                // else{

                                  if (
                                    targetElemState?.targetId?.includes("column") &&
                                    targetElemState?.targetElemType === "column_tabChild" && currElemState.current === "section"
                                  ) {
                                    response.data["insideTabColumn"] = true;
                                  }

                                  if (
                                    (targetElemState?.targetColId?.includes("before_column") || targetElemState?.targetColId?.includes("after_column")) &&
                                    targetElemState?.targetElemType === "row" && isControlDroppedUnderTabColumn(targetElemState?.targetId) && currElemState.current === "section"
                                  ) {
                                    response.data["insideTabColumn"] = true;
                                  }

                                controlElemToAdd = response.data;
                                if (formState2?.customControl?.length > 0) {
                                  formState2?.customControl?.forEach((key, index) => {
                                    if (key?.label === response?.data?.controlName) {
                                      controlElemToAdd.properties = key?.properties;
                                    }
                                  });
                                }
                                if (controlElemToAdd && controlElemToAdd?.elem_type !== "frame") {
                                  controlElemToAdd.marvin = "false";
                                }
                                if (controlElemToAdd?.elem_type === "radio") {
                                  controlElemToAdd.options = [
                                    {
                                      label: "Option1", value: "Option1",tooltip:"", FE_id: '1'
                                    },
                                    
                                  ];
                                }
                                if (controlElemToAdd?.elem_type === "button") {
                                  if(!controlElemToAdd?.eventSource || controlElemToAdd?.eventSource===undefined ){
                                    const controlJson= {...controlElemToAdd};
                                    controlJson.eventSource = uuid();
                                    controlElemToAdd.eventSource = controlJson.eventSource;
                                  }
                                }
                                if (controlElemToAdd?.elem_type === "button") {
                                  if(!controlElemToAdd?.eventSource || controlElemToAdd?.eventSource===undefined ){
                                    const controlJson= {...controlElemToAdd};
                                    controlJson.eventSource = uuid();
                                    controlElemToAdd.eventSource = controlJson.eventSource;
                                  }
                                }
                                if (controlElemToAdd?.elem_type === "combo") {
                                  controlElemToAdd.options = [
                                    {
                                      label:`${t("translation:Select")}`,
                                      value: "",
                                      FE_id: "1",
                                    },
                                  ];
                                }
                                if (controlElemToAdd?.elem_type === "listbox") {
                                  controlElemToAdd.options = [
                                    {
                                      label: "Default",
                                      value: "Default",
                                      FE_id: "1",
                                    },
                                  ];
                                  // controlElemToAdd.value = ["Default"];
                                }


                                if (
                                  currentDataObjectJson.current &&
                                  currentDataObjectJson.current["treeName"]
                                ) {
                                  let dataClassMap;
            
                                  dataClassMap = currentDataObjectJson.current["treeName"];
            
                                  mappingControlsIdMap.add(
                                    currentDataObjectJson.current["treeName"]
                                  );
            
                                  // var treeName = data.treeName;
                                  var treeName = currentDataObjectJson.current?.treeName;
                                  let currentDataObjectsContent = getCurrentDataObjectsContent()
                                  var hasChild;
                                  let dataObj = findDataObjectListView(
                                    currentDataObjectsContent || dataObjectsContent,
                                    currentDataObjectJson.current?.treeName,
                                    "children"
                                  );
                                  if (dataObj && dataObj.children && dataObj.children.length > 0) {
                                    hasChild = true;
                                  } else {
                                    hasChild = false;
                                  }
            
                                  if(!(currentDataObjectJson?.current?.["Unbounded"] === "N" && currentDataObjectJson.current?.children?.length > 0)) {
                                    var jsonToSend = {
                                      mappedField: treeName,
                                      unbounded: currentDataObjectJson.current?.Unbounded,
                                      isProcessVar:
                                      currentDataObjectJson.current?.dataObjectType === "M"
                                          ? false
                                          : currentDataObjectJson.current?.dataObjectType === "P"
                                          ? true
                                          : "",
                                      hasChild: hasChild,
                                      formId:
                                        microFrontendData?.formDefId ||
                                        activePage?.formId ||
                                        activeSubForm?.fragmentId ||
                                        microFrontendData?.processDefId ||
                                        microFrontendData?.templateId,
                                    };
                                    try{
                                      mappingExistOrNot(jsonToSend).then((response) => {
                                        if (response.data.status === "-1") {
                                          showAlertConfirmNotifications({
                                            open: true,
                                            showConfirm: "showNotification",
                                            alertType: "error",
                                            alertContentKey: `mappingError`
                                          });
                                        }
                                      })
                                    }catch(e){
                                      console.log(e)
                                    }
                                    controlElemToAdd["TypeOfValue"] =
                                      currentDataObjectJson.current["VariableType"];
                                    controlElemToAdd["dataclass"] = dataClassMap;
                                    controlElemToAdd["unBounded"] = currentDataObjectJson.current["Unbounded"]
                                    controlElemToAdd.style["ListviewLabel"] =
                                      currentDataObjectJson.current["treeName"];
                                    controlElemToAdd.style.Mapping = dataClassMap;
                                    controlElemToAdd.style.MappingId =
                                      currentDataObjectJson.current["treeName"];
                                  }
                                  currentDataObjectJson.current["isMapped"] = true;
                                  setCurrentMappedDO((prev) => {
                                    return [...prev, currentDataObjectJson.current["treeName"]];
                                  });
                                  dispatch(updateContexts({name: "currentMappedDO",value: [...currentMappedDO, currentDataObjectJson.current["treeName"]], key: containerId}));
                                }

                                
                                // }
                                currentDataObjectJson.current[
                                  "isMapped"
                                ] = true;
                                setOpenQuickToolFor(controlElemToAdd?.id);
                                controlElemToAdd["style"] = {
                                  ...ThemeJSON[currElemState.current],
                                  PickerType: currentDataObjectJson.current["VariableType"] ? currentDataObjectJson.current["VariableType"] === "Date" ? "2" : "1" : undefined,
                                  Label:
                                    currentDataObjectJson.current["treeName"],
                                };
                                if (controlElemToAdd?.elem_type === "image") {
                                  if (controlElemToAdd.style["imageStyle"] === undefined || controlElemToAdd.style["imageStyle"] === null) {
                                    controlElemToAdd.style.imageStyle = {
                                      ...controlElemToAdd.style?.imageStyle,
                                      height: controlElemToAdd.style.height,
                                      width: controlElemToAdd.style.width,
                                      defaultWidth: controlElemToAdd.style.defaultWidth,
                                      defaultHeight: controlElemToAdd.style.defaultHeight,
                                      size: controlElemToAdd.style.size,
                                      scale: "1",
                                      resize: controlElemToAdd.style.resize,
                                      widthType: controlElemToAdd.style.scale === "pixels" ? "px" : "%",
                                      aspectRatio: "auto",
                                      transform: "rotate(0deg) scale(1,1)",
                                      degree: 0,
                                      scaleX: 1,
                                      scaleY: 1
                                    };
                                  }
                                }
                                // if(currElemState.current === "textbox" || currElemState.current === "textarea" || currElemState.current === "password"){
                                //   controlElemToAdd["style"]["TextAlignment"] = translationStyles1 ? "right" : "left"
                                // }
                                if(controlElemToAdd.elem_type !== 'frame') {
                                  controlElemToAdd.datamapVariableType =
                                    currentDataObjectJson.current["VariableType"];
                                  controlElemToAdd.datamapVariableLength =
                                    currentDataObjectJson.current[
                                      "VariableLength"
                                    ];
                                  controlElemToAdd.datamapPercision =
                                    currentDataObjectJson.current["VarPrecision"];
                                }
                                controlElemToAdd.datamapVariableType =
                                  currentDataObjectJson.current["VariableType"];
                                controlElemToAdd.datamapVariableLength =
                                  currentDataObjectJson.current[
                                    "VariableLength"
                                  ];
                                controlElemToAdd.datamapPercision =
                                  currentDataObjectJson.current["VarPrecision"];
                                
                                if (
                                  controlElemToAdd.controlName === "doclist"
                                ) {
                                  const handleDocuments = () => {
                                    //alert('Document click handler')
                                  };
                                  var docData = {
                                    documents: [],
                                    available_doc_types: [],
                                    available_owners: ["arj", "badmin"],
                                    doc_upload_options: {
                                      google_drive: false,
                                      camera: true,
                                      scan: false,
                                      omnidocs: false,
                                      system: true,
                                    },
                                    upload_doc_as: {
                                      new: true,
                                      new_version: true,
                                      overwrite: true,
                                    },
                                    docEventHandler: handleDocuments,
                                    docviewer_info: {
                                      viewer_location: "inline", //inline, popup, window
                                      ContainerId: "rdDIv", //Optional, Required in case viewer_location is Inline //Optional, Required in case viewer_location is Inline,
                                      view_annotation: true,
                                      view_stamps: true,
                                      show_opall_menu: true,
                                      opall_params: {
                                        printOption: "false",
                                        TransformOption: "",
                                      },
                                    },
                                    enable_next: true,
                                    enable_prev: false,
                                    enable_search: false,
                                    enable_upload: true,
                                    enable_filter: false,
                                    enable_sorting: false,
                                    source: "APPLICATION",
                                    pid: "",
                                    wid: "",
                                    ext_data: {},
                                  };
                                  controlElemToAdd.json = docData;
                                }
                                if (
                                  controlElemToAdd?.controlName ===
                                    "password" &&
                                  controlElemToAdd?.elem_type === "textbox"
                                )
                                  controlElemToAdd["style"] = {
                                    isPassword: true,
                                    Placeholder: "Enter Password",
                                    ShowPasswordIcon: "true",
                                    Mapping: "",
                                    ...Object.assign({}, ThemeJSON.textbox),
                                  };

                                if (
                                  controlElemToAdd.elem_type === "iframe" &&
                                  controlLabel.current === "Survey"
                                ) {
                                  controlElemToAdd = {
                                    ...controlElemToAdd,
                                    controlName: "Survey",
                                  };
                                }

                                if (
                                  currentDataObjectJson.current &&
                                  Object.keys(currentDataObjectJson.current)
                                    .length === 0
                                ) {
                                } else {
                                  if (
                                    currentDataObjectJson.current &&
                                    currentDataObjectJson.current[
                                      "VariableName"
                                    ]
                                  ) {
                                    let dataClassMap;

                                    if (
                                      currentDataObjectJson.current[
                                        "parentName"
                                      ] &&
                                      currentDataObjectJson.current[
                                        "parentName"
                                      ] !== ""
                                    ) {
                                      dataClassMap =
                                        currentDataObjectJson.current[
                                          "treeName"
                                        ];
                                    } else {
                                      dataClassMap =
                                        currentDataObjectJson.current[
                                          "VariableName"
                                        ];
                                    }

                                    mappingControlsIdMap.add(
                                      currentDataObjectJson.current["treeName"]
                                    );

                                    if(!(currentDataObjectJson?.current?.["Unbounded"] === "N" && currentDataObjectJson.current?.children?.length > 0)) {
                                      controlElemToAdd["TypeOfValue"] =
                                        currentDataObjectJson.current[
                                          "VariableType"
                                        ];
                                      controlElemToAdd["dataclass"] =
                                        dataClassMap;
                                      controlElemToAdd["style"] = {
                                        ...controlElemToAdd.style,
                                        Label:
                                          currentDataObjectJson.current[
                                            "treeName"
                                          ],
                                        Mapping: dataClassMap,
                                        MappingId:
                                          currentDataObjectJson.current[
                                            "treeName"
                                          ],
                                        Enable: "true",
                                        Visible: "true",
                                        
                                      };
                                    }
                                  }
                                }                               
                                

                                if (
                                  (controlElemToAdd?.elem_type !== "frame" &&
                                    controlElemToAdd?.elem_type !== "wizard") ||
                                  parentTab() ||
                                  parentWizardCheck() ||
                                  parentMenuCheck()
                                ) {
                                  let frameEnableValue = true;
                                  var framereadValue = false;
                                  console.log(framereadValue);
                                  let frameReadOnlyValue = false;
                                  const parenttabVal = parentTab();
                                  const parentWizardCheckVal =
                                    parentWizardCheck();
                                  const parentMenuCheckVal = parentMenuCheck();
                                  const parentSectionVal = parentSection();
                                  const tabId = findTabId();
                                  const sectionId = findSectionId();
                                  const parentSectionCheck =
                                    parentSection(tabId);
                                  const parentTabCheck = parentTab(sectionId);
                                  const parentSectionId = findSectionId(tabId);

                                  if (
                                    parenttabVal &&
                                    !parentWizardCheckVal &&
                                    !parentMenuCheckVal
                                  ) {
                                    if (parentSectionCheck) {
                                      if (
                                        document
                                          .getElementById(parentSectionId)
                                          ?.getAttribute("enable") ===
                                          "false" ||
                                        document
                                          .getElementById(parentSectionId)
                                          ?.getAttribute("enable") === false
                                      )
                                        frameEnableValue = false;
                                      else frameEnableValue = true;
                                      if (
                                        document
                                          .getElementById(parentSectionId)
                                          ?.getAttribute("readonly") ===
                                          "true" ||
                                        document
                                          .getElementById(parentSectionId)
                                          ?.getAttribute("readonly") === true
                                      )
                                        frameReadOnlyValue = true;
                                      else frameReadOnlyValue = false;
                                      if (
                                        document
                                          .getElementById(parentSectionId)
                                          ?.getAttribute("readOnlyValue") ===
                                          "true" ||
                                        document
                                          .getElementById(parentSectionId)
                                          ?.getAttribute("readOnlyValue") ===
                                          true
                                      )
                                        framereadValue = true;
                                      else framereadValue = false;
                                      if (
                                        document
                                          .getElementById(tabId)
                                          ?.getAttribute("readonly") ===
                                          "true" ||
                                        document
                                          .getElementById(tabId)
                                          ?.getAttribute("readonly") === true
                                      )
                                        frameReadOnlyValue = true;
                                      else frameReadOnlyValue = false;
                                      if (
                                        document
                                          .getElementById(tabId)
                                          ?.getAttribute("readOnlyValue") ===
                                          "true" ||
                                        document
                                          .getElementById(tabId)
                                          ?.getAttribute("readOnlyValue") ===
                                          true
                                      )
                                        framereadValue = true;
                                      else framereadValue = false;
                                      console.log(
                                        "tabId",
                                        document.getElementById(findTabId())
                                      );
                                      console.log(
                                        "TabEnable",
                                        document
                                          .getElementById(findTabId())
                                          ?.getAttribute("enable")
                                      );
                                      if (
                                        document
                                          .getElementById(tabId)
                                          ?.getAttribute("enable") === "true" ||
                                        document
                                          .getElementById(tabId)
                                          ?.getAttribute("enable") === true
                                      )
                                        frameEnableValue = true;
                                      else frameEnableValue = false;
                                      if (parentTabCheck) {
                                        if (
                                          document
                                            .getElementById(sectionId)
                                            ?.getAttribute("enable") ===
                                            "true" ||
                                          document
                                            .getElementById(sectionId)
                                            ?.getAttribute("enable") === true
                                        )
                                          frameEnableValue = true;
                                        else frameEnableValue = false;
                                        if (
                                          document
                                            .getElementById(sectionId)
                                            ?.getAttribute("readonly") ===
                                            "true" ||
                                          document
                                            .getElementById(sectionId)
                                            ?.getAttribute("readonly") === true
                                        )
                                          frameReadOnlyValue = true;
                                        else frameReadOnlyValue = false;
                                        if (
                                          document
                                            .getElementById(sectionId)
                                            ?.getAttribute("readOnlyValue") ===
                                            "true" ||
                                          document
                                            .getElementById(sectionId)
                                            ?.getAttribute("readOnlyValue") ===
                                            true
                                        )
                                          framereadValue = true;
                                        else framereadValue = false;
                                      }
                                    } else {
                                      if (
                                        document
                                          .getElementById(tabId)
                                          ?.getAttribute("enable") ===
                                          "false" ||
                                        document
                                          .getElementById(tabId)
                                          ?.getAttribute("enable") === false
                                      )
                                        frameEnableValue = false;
                                      else frameEnableValue = true;
                                      if (
                                        document
                                          .getElementById(tabId)
                                          ?.getAttribute("readonly") ===
                                          "true" ||
                                        document
                                          .getElementById(tabId)
                                          ?.getAttribute("readonly") === true
                                      )
                                        frameReadOnlyValue = true;
                                      else frameReadOnlyValue = false;
                                      if (
                                        document
                                          .getElementById(tabId)
                                          ?.getAttribute("readOnlyValue") ===
                                          "true" ||
                                        document
                                          .getElementById(tabId)
                                          ?.getAttribute("readOnlyValue") ===
                                          true
                                      )
                                        framereadValue = true;
                                      else framereadValue = false;
                                      if (parentSectionVal) {
                                        if (
                                          document
                                            .getElementById(sectionId)
                                            ?.getAttribute("enable") ===
                                            "false" ||
                                          document
                                            .getElementById(sectionId)
                                            ?.getAttribute("enable") === false
                                        ) {
                                          frameEnableValue = false;
                                        } else frameEnableValue = true;
                                        if (
                                          document
                                            .getElementById(sectionId)
                                            ?.getAttribute("readonly") ===
                                            "true" ||
                                          document
                                            .getElementById(sectionId)
                                            ?.getAttribute("readonly") === true
                                        )
                                          frameReadOnlyValue = true;
                                        else frameReadOnlyValue = false;
                                        if (
                                          document
                                            .getElementById(sectionId)
                                            ?.getAttribute("readOnlyValue") ===
                                            "true" ||
                                          document
                                            .getElementById(sectionId)
                                            ?.getAttribute("readOnlyValue") ===
                                            true
                                        )
                                          framereadValue = true;
                                        else framereadValue = false;
                                      }
                                    }
                                  } else if (
                                    parentSectionVal &&
                                    !parentTabCheck &&
                                    !parenttabVal &&
                                    !parentWizardCheckVal &&
                                    !parentMenuCheckVal
                                  ) {
                                    frameEnableValue = document
                                      .getElementById(findSectionId())
                                      ?.getAttribute("enable");
                                    frameReadOnlyValue = document
                                      .getElementById(findSectionId())
                                      ?.getAttribute("readonly");
                                    framereadValue = document
                                      .getElementById(findSectionId())
                                      ?.getAttribute("readOnlyValue");
                                  } else if (parentWizardCheckVal) {
                                    if (
                                      document
                                        .getElementById("wizard")
                                        ?.getAttribute("readonly") === "true" ||
                                      document
                                        .getElementById("wizard")
                                        ?.getAttribute("readOnly") === true
                                    )
                                      frameReadOnlyValue = true;
                                    else frameReadOnlyValue = false;
                                    if (sectionId) {
                                      if (
                                        document
                                          .getElementById(sectionId)
                                          ?.getAttribute("enable") ===
                                          "false" ||
                                        document
                                          .getElementById(sectionId)
                                          ?.getAttribute("enable") === false
                                      )
                                        frameEnableValue = false;
                                      else frameEnableValue = true;
                                      if (
                                        document
                                          .getElementById(sectionId)
                                          ?.getAttribute("readonly") ===
                                          "true" ||
                                        document
                                          .getElementById(sectionId)
                                          ?.getAttribute("readonly") === true
                                      )
                                        frameReadOnlyValue = true;
                                      else frameReadOnlyValue = false;
                                      if (
                                        document
                                          .getElementById(sectionId)
                                          ?.getAttribute("readOnlyValue") ===
                                          "true" ||
                                        document
                                          .getElementById(sectionId)
                                          ?.getAttribute("readOnlyValue") ===
                                          true
                                      )
                                        framereadValue = true;
                                      else framereadValue = false;
                                    }
                                  } else if (parentMenuCheckVal) {
                                    if (
                                      document
                                        .getElementById("wizard")
                                        ?.getAttribute("readOnlyValue") ===
                                        "true" ||
                                      document
                                        .getElementById(findTabId())
                                        ?.getAttribute("readonlyvalue") === true
                                    )
                                      framereadValue = true;
                                    if (
                                      document
                                        .getElementById("wizard")
                                        ?.getAttribute("readonly") === "true" ||
                                      document
                                        .getElementById("wizard")
                                        ?.getAttribute("readOnly") === true
                                    )
                                      frameReadOnlyValue = true;
                                    if (sectionId) {
                                      if (
                                        document
                                          .getElementById(sectionId)
                                          ?.getAttribute("enable") ===
                                          "false" ||
                                        document
                                          .getElementById(sectionId)
                                          ?.getAttribute("enable") === false
                                      )
                                        frameEnableValue = false;
                                      else frameEnableValue = true;
                                      if (
                                        document
                                          .getElementById(sectionId)
                                          ?.getAttribute("readonly") ===
                                          "true" ||
                                        document
                                          .getElementById(sectionId)
                                          ?.getAttribute("readonly") === true
                                      )
                                        frameReadOnlyValue = true;
                                      else frameReadOnlyValue = false;
                                      if (
                                        document
                                          .getElementById(sectionId)
                                          ?.getAttribute("readOnlyValue") ===
                                          "true" ||
                                        document
                                          .getElementById(sectionId)
                                          ?.getAttribute("readOnlyValue") ===
                                          true
                                      )
                                        framereadValue = true;
                                      else framereadValue = false;
                                    }
                                  }
                                  if (
                                    frameEnableValue === true ||
                                    frameEnableValue === "true"
                                  )
                                    controlElemToAdd["style"].Enable = "true";
                                  else
                                    controlElemToAdd["style"].Enable = "false";
                                  if (
                                    frameReadOnlyValue === true ||
                                    frameReadOnlyValue === "true"
                                  )
                                    controlElemToAdd["style"].ReadOnlyStyle =
                                      "true";
                                  else
                                    controlElemToAdd["style"].ReadOnlyStyle =
                                      "false";
                                  if (
                                    framereadValue === true ||
                                    framereadValue === "true"
                                  )
                                    controlElemToAdd["style"].ReadOnly = "true";
                                  else
                                    controlElemToAdd["style"].ReadOnly =
                                      "false";
                                }
                                if(currentDataObjectJson.current &&
                                  currentDataObjectJson.current["treeName"]){
                                    controlElemToAdd=dragAndDropThroughMDM(currentDataObjectJson?.current,controlElemToAdd);                                                                   
                                  }
                                if (openCanvasForSubform === "subform") {
                                  jsonObj = createSmartFormState(
                                    subFormStateJson.current,
                                    targetElemState.targetId,
                                    targetElemState.targetElemType,
                                    controlElemToAdd.controlName ===
                                      "password" &&
                                      controlElemToAdd.elem_type === "textbox"
                                      ? "textbox"
                                      : currElemState.current,
                                    0,
                                    targetElemState.frameIndex,
                                    controlElemToAdd,
                                    targetElemState.targetRowId,
                                    targetElemState.targetColId,
                                    device,
                                    currentDataObjectJson?.current?.["Unbounded"] === "N" && currentDataObjectJson.current?.children?.length > 0 ? {"dataObjectDrop" : true, count: currentDataObjectJson.current?.children?.length} : "",
                                  );
                                } else if (
                                  openCanvasForSubform ===
                                  "advanceListviewFromScratch"
                                ) {
                                  jsonObj = createSmartFormState(
                                    fetchGridStates().advanceListviewStateJson,
                                    targetElemState.targetId,
                                    targetElemState.targetElemType,
                                    controlElemToAdd.controlName ===
                                      "password" &&
                                      controlElemToAdd.elem_type === "textbox"
                                      ? "textbox"
                                      : currElemState.current,
                                    0,
                                    targetElemState.frameIndex,
                                    controlElemToAdd,
                                    targetElemState.targetRowId,
                                    targetElemState.targetColId,
                                    device,
                                    currentDataObjectJson?.current?.["Unbounded"] === "N" && currentDataObjectJson.current?.children?.length > 0 ? {"dataObjectDrop" : true, count: currentDataObjectJson.current?.children?.length} : "",
                                  );
                                } else {
                                  if (
                                    currElemState.current.includes(
                                      "template"
                                    ) &&
                                    controlElemToAdd.populatedJson
                                  ) {
                                    delete controlElemToAdd["style"];
                                    targetElemState.targetId = "design_page";
                                    targetElemState.targetElemType =
                                      "Design Page";
                                    targetElemState.frameIndex = null;
                                    targetElemState.targetRowId = null;
                                    jsonObj = createSmartFormState(
                                      formState2,
                                      targetElemState.targetId,
                                      targetElemState.targetElemType,
                                      "section",
                                      0,
                                      targetElemState.frameIndex,
                                      controlElemToAdd.populatedJson,
                                      targetElemState.targetRowId,
                                      targetElemState.targetColId,
                                      device,
                                      {
                                        notCreateRow: "true",
                                        position: "start",
                                      }
                                    );
                                  } else {
                                    if (
                                      targetElemState?.targetElemType ===
                                        "section" &&
                                      !targetElemState?.targetId?.includes(
                                        "frame"
                                      )
                                    ) {
                                      var targetId_incoming =
                                        targetElemState.targetId;
                                      targetElemState.targetId = document
                                        .querySelector(
                                          `#${targetElemState.targetRowId}`
                                        )
                                        ?.closest(`[elem_type=frame]`)
                                        ?.getAttribute("id");

                                      if (
                                        targetElemState.targetId === undefined
                                      ) {
                                        targetElemState.targetId =
                                          targetId_incoming;
                                      }
                                    }
                                    jsonObj = createSmartFormState(
                                      formState2,
                                      targetElemState.targetId,
                                      targetElemState.targetElemType,
                                      controlElemToAdd.controlName ===
                                        "password" &&
                                        controlElemToAdd.elem_type === "textbox"
                                        ? "textbox"
                                        : currElemState.current,
                                      0,
                                      targetElemState.frameIndex,
                                      controlElemToAdd,
                                      targetElemState?.targetElemType ===
                                        "tabChild" &&
                                        targetElemState?.targetRowId.includes(
                                          "after_row"
                                        )
                                        ? ""
                                        : targetElemState.targetRowId,
                                        targetElemState?.targetElemType ===
                                        "tabChild" &&
                                        targetElemState?.targetRowId.includes(
                                          "after_column"
                                        )
                                        ? ""
                                        : targetElemState.targetColId,
                                      // targetElemState.targetRowId,
                                      device,
                                      currentDataObjectJson?.current?.["Unbounded"] === "N" && currentDataObjectJson.current?.children?.length > 0 ? {"dataObjectDrop" : true, count: currentDataObjectJson.current?.children?.length} : "",
                                    );
                                  }
                                }

                                if(isAboveWizard){
                                  appendSectionAboveWizard(jsonObj,controlElemToAdd)
                                }

                                targetElemState.targetId = "";
                                targetElemState.targetClass = "";
                                targetElemState.targetElemType = "";
                                setCurrElem("");

                                // if (openCanvasForSubform === "subform") {
                                //   setSubFormState({ ...jsonObj });
                                // } else if (
                                //   openCanvasForSubform ===
                                //   "advanceListviewFromScratch"
                                // ) {
                                //   dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj }, renderCanvas:true}));
                                // }
                                if(currentDataObjectJson?.current?.["Unbounded"] === "N" && currentDataObjectJson.current?.children?.length > 0) {
                                  setReRender(!reRender);
                                  for(let index = 0; index < currentDataObjectJson.current?.children.length; index++) {
                                      let child = currentDataObjectJson.current?.children[index];
                                      currElemState.current =
                                      child["VariableType"] === "Date" ||
                                      child["VariableType"] === "shortDate" ||
                                      child["VariableType"] === "Short Date"
                                        ? "datepick"
                                        : isAdvanceListviewCheck(child)
                                        ? "advancelistview"
                                        : child["Unbounded"] === "Y" && child.children
                                        ? "listview"
                                        : child["Unbounded"] === "Y" && !child.children
                                        ? "listbox"
                                        : child["Unbounded"] === "N" && child?.children?.length > 0
                                        ? "section"
                                        : child["Unbounded"] === "N" && child["VariableType"] === "Boolean"
                                        ? "toggle"
                                        : "textbox";
                                        targetElemState.frameIndex = controlElemToAdd.frameIndex;
                                        targetElemState.targetElemType = 'column';
                                        targetElemState.targetClass = "COLUMN_col_css__3QcZb col-md-3 col-sm-6 col-12 draggingCol";
                                        targetElemState.targetId = controlElemToAdd.children[0].children[index].id;
                                        targetElemState.targetColId = controlElemToAdd.children[0].children[index].id;
                                        await appendChildInSection(controlElemToAdd,targetElemState,jsonObj,child,index);
                                    }
                                }
                                if (openCanvasForSubform === "subform") {
                                  setSubFormState({ ...jsonObj });
                                } else if (
                                  openCanvasForSubform ===
                                  "advanceListviewFromScratch"
                                ) {
                                  dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj }, renderCanvas:true}));
                                  updatedComponentInFormState();
                                } else {
                                  setFormStateByUser(cloneDeep(jsonObj));

                                  // updatedComponentInFormState();
                                }
                                
                                  if(!(currentDataObjectJson?.current?.["Unbounded"] === "N" && currentDataObjectJson.current?.children?.length > 0))
                                    setCurrentDataObjectJson(cloneDeep({}));
                                    dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                              
                              } else if (response.data.status === 1) {
                                showAlertConfirmNotifications({
                                  open: true,
                                  showConfirm: "showNotification",
                                  alertType: "error",
                                  alertContentKey: `${t("Reopen_Form")}`,
                                });
                              }
                              setCurrentDataObjectJson(cloneDeep({}));
                              dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                            })
                            .catch((error) => {
                              if (currElemState.current === "") {
                                // setOpenDrawer(false);
                                window.changeDrawer("close");
                                  loading(false)
                              }
                              showAlertConfirmNotifications({
                                open: true,
                                showConfirm: "showNotification",
                                alertType: "error",
                                alertContentKey: "WIZARD_DROP_MESSAGE",
                              });
                            });
                        } else {
                          setCurrentDataObjectJson(cloneDeep({}));
                          dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                          showAlertConfirmNotifications({
                            open: true,
                            showConfirm: "showNotification",
                            alertType: "error",
                            alertContentKey: `${t(
                              "Please_Drop_Control_Inside_Section_Canvas"
                            )}`,
                          });
                          
                        }
                      }
                    }
                  }
                } else {
                  var populateInside = {
                    id: "RootControl",
                    elem_type: "form",
                    // frameIndex: "",
                    // elementIndex: parentControl["elementIndex"],
                    // sheetElementIndex: parentControl["sheetElementIndex"],
                    // sheetFrameElementIndex: parentControl["sheetFrameElementIndex"],
                    // sheetId: parentControl["sheetIndex"],
                  };

                  let jsonToBeSendToBackend = {
                    populateInside: populateInside,
                    populateElem: dataObjectJson,
                    isSubForm: isSubForm,
                    isAdvanceListview: isAdvanceListview,
                  };

                  var newFormData = {};

                  if (!mappingDataObjectsMap.has(dataObjectJson["caption"])) {
                    sendRequestForControl(
                      null,
                      "duplicateDataObject",
                      null,
                      jsonToBeSendToBackend
                    ).then((response) => {
                      mappingDataObjectsMap.set(dataObjectJson["caption"], 10);
                      response.data.populatedJson.VariableName =
                        dataObjectJson["caption"];

                      newFormData = addColsToControlsForDataObjects(
                        response.data.populatedJson,
                        response.data.populatedJson.frameIndex
                      );

                      //   formState2.children[1].children.push(newFormData);

                      var controlElemToAdd = newFormData;

                      if (openCanvasForSubform === "subform") {
                        jsonObj = createSmartFormState(
                          subFormStateJson.current,
                          targetElemState.targetId,
                          targetElemState.targetElemType,
                          currElemState.current,
                          0,
                          targetElemState.frameIndex,
                          controlElemToAdd,
                          targetElemState.targetRowId,
                          targetElemState.targetColId,
                          device
                        );
                      } else if (
                        openCanvasForSubform === "advanceListviewFromScratch"
                      ) {
                        jsonObj = createSmartFormState(
                          fetchGridStates().advanceListviewStateJson,
                          targetElemState.targetId,
                          targetElemState.targetElemType,
                          currElemState.current,
                          0,
                          targetElemState.frameIndex,
                          controlElemToAdd,
                          targetElemState.targetRowId,
                          targetElemState.targetColId,
                          device
                        );
                      } else {
                        jsonObj = createSmartFormState(
                          formState2,
                          targetElemState.targetId,
                          targetElemState.targetElemType,
                          currElemState.current,
                          0,
                          targetElemState.frameIndex,
                          controlElemToAdd,
                          targetElemState.targetRowId,
                          targetElemState.targetColId,
                          device
                        );
                      }

                      targetElemState.targetId = "";
                      targetElemState.targetClass = "";
                      targetElemState.targetElemType = "";
                      setCurrElem("");

                      if (openCanvasForSubform === "subform") {
                        setSubFormState({ ...jsonObj });
                      } else if (
                        openCanvasForSubform === "advanceListviewFromScratch"
                      ) {
                        dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj }, renderCanvas:true}));
                      } else {
                        setFormStateByUser({ ...jsonObj });
                      }

                      // updatedComponentInFormState();

                      setDataObjectJson({});
                      setCurrentDataObjectJson(cloneDeep({}));
                      dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
                    })
                    .catch((error) => {
                      loading(false)
                    })
                  } else {
                    //customalert
                    showAlertConfirmNotifications({
                      open: true,
                      showConfirm: "showNotification",
                      alertType: "error",
                      alertContentKey: "DATA_PRESENT",
                    });
                    // alert('This Data Object is already present');
                  }
                }

                // .catch((error)=>{
                //    alert('Dropping component here is not allowed!');
                // });
                // .catch(function (error) {
                //     showAlertConfirmNotifications({
                //         'open':true,
                //         'showConfirm':'showNotification',
                //         'alertType':'error',
                //         'alertContentKey':"Dropping component here is not allowed!"
                //         // 'alertContentKey':'SaveFormFailureMessage'
                //     });
                // });
              }
            }
          }
        } else if (
          (currElemState.current === "tab" &&
            (targetElemState.targetId === "design_page" ||
              targetElemState.targetId === "RootControl")) ||
          targetElemState.targetId === "FormDef" ||
          flag4 === 1 ||
          flag37 === 1 ||
          targetElemState.insideMenu === true ||
          targetElemState.insideWizard === true
        ) {
          if (flag4 === 1) {
            targetElemState.targetRowId = ev.target.id;
            targetElemState.targetId = "RootControl";
            targetElemState.targetElemType = "form";
          }
          if (flag37 === 1 && window?.onRootControl === true) {
            targetElemState.targetId = "RootControl";
          }
          let extraDetails = { isSubForm: isSubForm, ...targetElemState };
          extraDetails.isAdvanceListview = isAdvanceListview;
          sendRequestForControl(
            undefined,
            "add",
            "section",
            extraDetails,
            undefined,
            flag4,
            flag37,
            frameNo
          ).then((response) => {
            if (response.data.status === 0) {
              const response1= response?.data ? response : {};
              var controlElemToAdd= response1?.data ? response1.data : {}

              // var controlElemToAdd = response.data;
              controlElemToAdd.isParentOfTab = true;
              controlElemToAdd.ColumnLayout = "1";
              //currElemState.current
              if (openCanvasForSubform === "subform") {
                if (window?.onRootControl === true) {
                  targetElemState.targetRowId = "";
                  targetElemState.targetElemType = "form";
                }
                jsonObj = createSmartFormState(
                  subFormStateJson.current,
                  targetElemState.targetId,
                  targetElemState.targetElemType,
                  controlElemToAdd.elem_type,
                  0,
                  controlElemToAdd.frameIndex,
                  controlElemToAdd,
                  targetElemState.targetRowId,
                  targetElemState.targetColId,
                  device
                );
              } else if (
                openCanvasForSubform === "advanceListviewFromScratch"
              ) {
                if (window?.onRootControl === true) {
                  targetElemState.targetRowId = "";
                  targetElemState.targetElemType = "form";
                }
                jsonObj = createSmartFormState(
                  fetchGridStates().advanceListviewStateJson,
                  targetElemState.targetId,
                  targetElemState.targetElemType,
                  controlElemToAdd.elem_type,
                  0,
                  controlElemToAdd.frameIndex,
                  controlElemToAdd,
                  targetElemState.targetRowId,
                  targetElemState.targetColId,
                  device
                );
              } else {
                if (window?.onRootControl === true) {
                  targetElemState.targetRowId = "";
                  targetElemState.targetElemType = "form";
                }
                jsonObj = createSmartFormState(
                  formState2,
                  targetElemState.targetId,
                  targetElemState.targetElemType,
                  controlElemToAdd.elem_type,
                  0,
                  controlElemToAdd.frameIndex,
                  controlElemToAdd,
                  targetElemState.targetRowId,
                  targetElemState.targetColId,
                  device
                );
              }

              if (controlElemToAdd !== undefined)
                controlElemToAdd.style = { ...ThemeJSON["tab"] };
              extraDetails.isSubForm = isSubForm;
              extraDetails.isAdvanceListview = isAdvanceListview;
              sendRequestForControl(
                controlElemToAdd.frameIndex,
                "add",
                "tab",
                extraDetails
              ).then((response) => {
                if (response.data.status === 0) {
                  var tabControlElemToAdd = response.data;
                  setOpenQuickToolFor(tabControlElemToAdd?.id);
                  tabControlElemToAdd["style"] = {
                    ...ThemeJSON[currElemState.current],
                    Label: currentDataObjectJson.current["treeName"],
                  };
                  if (openCanvasForSubform === "subform") {
                    if (window?.onRootControl === true) {
                      targetElemState.targetRowId = "";
                      targetElemState.targetElemType = "form";
                      delete window?.onRootControl;
                    }
                    jsonObj = createSmartFormState(
                      subFormStateJson.current,
                      controlElemToAdd.id,
                      controlElemToAdd.elem_type,
                      "tab",
                      0,
                      controlElemToAdd.frameIndex,
                      tabControlElemToAdd,
                      targetElemState.targetRowId,
                      targetElemState.targetColId,
                      device
                    );
                  } else if (
                    openCanvasForSubform === "advanceListviewFromScratch"
                  ) {
                    if (window?.onRootControl === true) {
                      targetElemState.targetRowId = "";
                      targetElemState.targetElemType = "form";
                      delete window?.onRootControl;
                    }
                    jsonObj = createSmartFormState(
                      fetchGridStates().advanceListviewStateJson,
                      controlElemToAdd.id,
                      controlElemToAdd.elem_type,
                      "tab",
                      0,
                      controlElemToAdd.frameIndex,
                      tabControlElemToAdd,
                      targetElemState.targetRowId,
                      targetElemState.targetColId,
                      device
                    );
                  } else {
                    if (window?.onRootControl === true) {
                      targetElemState.targetRowId = "";
                      targetElemState.targetElemType = "form";
                      delete window?.onRootControl;
                    }
                    jsonObj = createSmartFormState(
                      jsonObj,
                      controlElemToAdd.id,
                      controlElemToAdd.elem_type,
                      "tab",
                      0,
                      controlElemToAdd.frameIndex,
                      tabControlElemToAdd,
                      targetElemState.targetRowId,
                      targetElemState.targetColId,
                      device
                    );
                  }

                  var newJsonObj;

                  if (flag4 === 1) {
                    var currFrameId = controlElemToAdd.id;
                    newJsonObj = findJsonNew1(jsonObj, "frame", currFrameId);

                    // moveArrayItemToNewIndex(newJsonObj.children[1].children, 1, newJsonObj.children[1].children.length - 1)
                    var arr1 = newJsonObj.children[1].children.splice(
                      [newJsonObj.children[1].children.length - 1],
                      1
                    );
                    // var newArr1 = findJsonNew2(arr1[0], 'frame', "")
                    newJsonObj.children[1].children.splice(1, 0, arr1[0]);
                  } else if (flag37 === 1) {
                    var currFrameId = controlElemToAdd.id;
                    // let tempState = formState2;
                    var newJsonObj = findJsonNew2(
                      jsonObj,
                      "frame",
                      currFrameId,
                      frameNo
                    );

                    // moveArrayItemToNewIndex(newJsonObj.children[1].children, 1, newJsonObj.children[1].children.length - 1)
                    if (openCanvasForSubform === "advanceListviewFromScratch") {
                      var leng = newJsonObj.children[0].children.length - 1;
                      updateFrameIndex(
                        newJsonObj.children[0].children[
                          newJsonObj.children[0].children.length - 1
                        ],
                        frameNo
                      );
                      var arr1 =
                        newJsonObj.children[0].children[
                          newJsonObj.children[0].children.length - 1
                        ];
                      var arr2 = newJsonObj.children[0].children.splice(
                        leng,
                        1
                      );
                      // var newArr1 = findJsonNew2(arr1[0], 'frame', "")
                      console.log("Dude", arr1, arr2);
                      // var newArr1 = findJsonNew2(arr1[0], 'frame', "")
                      newJsonObj.children[0].children.splice(
                        parseInt(frameNo),
                        0,
                        arr1
                      );
                    } else {
                      var leng = newJsonObj.children[1].children.length - 1;
                      updateFrameIndex(
                        newJsonObj.children[1].children[
                          newJsonObj.children[1].children.length - 1
                        ],
                        frameNo
                      );
                      var arr1 =
                        newJsonObj.children[1].children[
                          newJsonObj.children[1].children.length - 1
                        ];
                      var arr2 = newJsonObj.children[1].children.splice(
                        leng,
                        1
                      );
                      // var newArr1 = findJsonNew2(arr1[0], 'frame', "")
                      console.log("Dude", arr1, arr2);
                      // var newArr1 = findJsonNew2(arr1[0], 'frame', "")
                      newJsonObj.children[1].children.splice(
                        parseInt(frameNo) + 1,
                        0,
                        arr1
                      );
                    }
                  } else newJsonObj = jsonObj;

                  targetElemState.targetId = "";
                  targetElemState.targetClass = "";
                  targetElemState.targetElemType = "";
                  setCurrElem("");
                  if (openCanvasForSubform === "subform") {
                    setSubFormState({ ...newJsonObj });
                  } else if (
                    openCanvasForSubform === "advanceListviewFromScratch"
                  ) {
                    dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...newJsonObj }, renderCanvas:true}));
                  } else {
                    setFormStateByUser({ ...newJsonObj });
                  }
                } else if (response.data.status === 1) {
                  showAlertConfirmNotifications({
                    open: true,
                    showConfirm: "showNotification",
                    alertType: "error",
                    alertContentKey: `${t("Reopen_Form")}`,
                  });
                }
              })
              .catch((error) => {
                loading(false)
              })
            } else if (response.data.status === 1) {
              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: `${t("Reopen_Form")}`,
              });
            }
            setCurrentDataObjectJson(cloneDeep({}));
            dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
          })
          .catch((error) => {
            loading(false)
          })
        } else if (
          currElemState.current === "tab" &&
          (targetElemState.targetElemType === "section" ||
            targetElemState.targetElemType === "column" ||
            targetElemState.targetElemType === "row")
        ) {
          // var tab = {};
          // //now this part will be generated from backend
          //     tab.frameIndex = targetElemState.frameIndex;
          //     tab.id = createUniqueId('tab');
          //     tab.elem_type='tab';
          //     tab.ColumnLayout= "3";
          //     tab.children=[];
          //     tab.style={};

          //     var tabChild = {};
          //     tabChild.id = createUniqueId("tabChild");
          //     tabChild.elem_type='tabChild';
          //     tabChild.tabChildName=tabChild.id;
          //     tabChild.ColumnLayout= "3";
          //     tabChild.children=[];
          //     tabChild.icon={name:"",file:""};

          //     tab.children.push(tabChild);
          // controlElemToAdd
          let parentsSoFar = getRecursiveParent(targetElemState.targetId);
          let familyPathElemType = parentsSoFar?.familyPathElemType;
          let shouldBeDropped = true;
          if (familyPathElemType !== null && familyPathElemType !== undefined) {
            shouldBeDropped = checkForAllowedFormStructure(
              currElemState.current,
              familyPathElemType
            );
          }
          if (shouldBeDropped === true) {
            let extraDetails = { isSubForm: isSubForm };
            extraDetails.isAdvanceListview = isAdvanceListview;
            if (!familyPathElemType.includes("tabChild")) {
              sendRequestForControl(
                targetElemState.frameIndex,
                "add",
                "tab",
                extraDetails
              ).then((response) => {
                if (response.data.status === 0) {
                  var controlElemToAdd = response.data;
                  controlElemToAdd["style"] = {
                    ...ThemeJSON[currElemState.current],
                    Label: currentDataObjectJson.current["treeName"],
                  };
                  if (
                    targetElemState?.targetId?.includes("column") &&
                    targetElemState?.targetElemType === "column"
                  ) {
                    response.data["insideSectionColumn"] = true;
                  }
                  if (
                    (controlElemToAdd?.elem_type !== "frame" &&
                      controlElemToAdd?.elem_type !== "wizard") ||
                    parentTab() ||
                    parentWizardCheck() ||
                    parentMenuCheck()
                  ) {
                    let frameEnableValue = true;
                    var framereadValue = false;
                    console.log(framereadValue);
                    let frameReadOnlyValue = false;
                    const parenttabVal = parentTab();
                    const parentWizardCheckVal = parentWizardCheck();
                    const parentMenuCheckVal = parentMenuCheck();
                    const parentSectionVal = parentSection();
                    const tabId = findTabId();
                    const sectionId = findSectionId();
                    const parentSectionCheck = parentSection(tabId);
                    const parentTabCheck = parentTab(sectionId);
                    const parentSectionId = findSectionId(tabId);

                    if (
                      parenttabVal &&
                      !parentWizardCheckVal &&
                      !parentMenuCheckVal
                    ) {
                      if (parentSectionCheck) {
                        if (
                          document
                            .getElementById(parentSectionId)
                            ?.getAttribute("enable") === "false" ||
                          document
                            .getElementById(parentSectionId)
                            ?.getAttribute("enable") === false
                        )
                          frameEnableValue = false;
                        else frameEnableValue = true;
                        if (
                          document
                            .getElementById(parentSectionId)
                            ?.getAttribute("readonly") === "true" ||
                          document
                            .getElementById(parentSectionId)
                            ?.getAttribute("readonly") === true
                        )
                          frameReadOnlyValue = true;
                        else frameReadOnlyValue = false;
                        if (
                          document
                            .getElementById(parentSectionId)
                            ?.getAttribute("readOnlyValue") === "true" ||
                          document
                            .getElementById(parentSectionId)
                            ?.getAttribute("readOnlyValue") === true
                        )
                          framereadValue = true;
                        else framereadValue = false;
                        if (
                          document
                            .getElementById(tabId)
                            ?.getAttribute("readonly") === "true" ||
                          document
                            .getElementById(tabId)
                            ?.getAttribute("readonly") === true
                        )
                          frameReadOnlyValue = true;
                        else frameReadOnlyValue = false;
                        if (
                          document
                            .getElementById(tabId)
                            ?.getAttribute("readOnlyValue") === "true" ||
                          document
                            .getElementById(tabId)
                            ?.getAttribute("readOnlyValue") === true
                        )
                          framereadValue = true;
                        else framereadValue = false;
                        console.log(
                          "tabId",
                          document.getElementById(findTabId())
                        );
                        console.log(
                          "TabEnable",
                          document
                            .getElementById(findTabId())
                            ?.getAttribute("enable")
                        );
                        if (
                          document
                            .getElementById(tabId)
                            ?.getAttribute("enable") === "true" ||
                          document
                            .getElementById(tabId)
                            ?.getAttribute("enable") === true
                        )
                          frameEnableValue = true;
                        else frameEnableValue = false;
                        if (parentTabCheck) {
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("enable") === "true" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("enable") === true
                          )
                            frameEnableValue = true;
                          else frameEnableValue = false;
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readonly") === "true" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readonly") === true
                          )
                            frameReadOnlyValue = true;
                          else frameReadOnlyValue = false;
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readOnlyValue") === "true" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readOnlyValue") === true
                          )
                            framereadValue = true;
                          else framereadValue = false;
                        }
                      } else {
                        if (
                          document
                            .getElementById(tabId)
                            ?.getAttribute("enable") === "false" ||
                          document
                            .getElementById(tabId)
                            ?.getAttribute("enable") === false
                        )
                          frameEnableValue = false;
                        else frameEnableValue = true;
                        if (
                          document
                            .getElementById(tabId)
                            ?.getAttribute("readonly") === "true" ||
                          document
                            .getElementById(tabId)
                            ?.getAttribute("readonly") === true
                        )
                          frameReadOnlyValue = true;
                        else frameReadOnlyValue = false;
                        if (
                          document
                            .getElementById(tabId)
                            ?.getAttribute("readOnlyValue") === "true" ||
                          document
                            .getElementById(tabId)
                            ?.getAttribute("readOnlyValue") === true
                        )
                          framereadValue = true;
                        else framereadValue = false;
                        if (parentSectionVal) {
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("enable") === "false" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("enable") === false
                          ) {
                            frameEnableValue = false;
                          } else frameEnableValue = true;
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readonly") === "true" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readonly") === true
                          )
                            frameReadOnlyValue = true;
                          else frameReadOnlyValue = false;
                          if (
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readOnlyValue") === "true" ||
                            document
                              .getElementById(sectionId)
                              ?.getAttribute("readOnlyValue") === true
                          )
                            framereadValue = true;
                          else framereadValue = false;
                        }
                      }
                    } else if (
                      parentSectionVal &&
                      !parentTabCheck &&
                      !parenttabVal &&
                      !parentWizardCheckVal &&
                      !parentMenuCheckVal
                    ) {
                      frameEnableValue = document
                        .getElementById(findSectionId())
                        ?.getAttribute("enable");
                      frameReadOnlyValue = document
                        .getElementById(findSectionId())
                        ?.getAttribute("readonly");
                      framereadValue = document
                        .getElementById(findSectionId())
                        ?.getAttribute("readOnlyValue");
                    } else if (parentWizardCheckVal) {
                      if (
                        document
                          .getElementById("wizard")
                          ?.getAttribute("readonly") === "true" ||
                        document
                          .getElementById("wizard")
                          ?.getAttribute("readOnly") === true
                      )
                        frameReadOnlyValue = true;
                      else frameReadOnlyValue = false;
                      if (sectionId) {
                        if (
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("enable") === "false" ||
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("enable") === false
                        )
                          frameEnableValue = false;
                        else frameEnableValue = true;
                        if (
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("readonly") === "true" ||
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("readonly") === true
                        )
                          frameReadOnlyValue = true;
                        else frameReadOnlyValue = false;
                        if (
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("readOnlyValue") === "true" ||
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("readOnlyValue") === true
                        )
                          framereadValue = true;
                        else framereadValue = false;
                      }
                    } else if (parentMenuCheckVal) {
                      if (
                        document
                          .getElementById("wizard")
                          ?.getAttribute("readOnlyValue") === "true" ||
                        document
                          .getElementById(findTabId())
                          ?.getAttribute("readonlyvalue") === true
                      )
                        framereadValue = true;
                      if (
                        document
                          .getElementById("wizard")
                          ?.getAttribute("readonly") === "true" ||
                        document
                          .getElementById("wizard")
                          ?.getAttribute("readOnly") === true
                      )
                        frameReadOnlyValue = true;
                      if (sectionId) {
                        if (
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("enable") === "false" ||
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("enable") === false
                        )
                          frameEnableValue = false;
                        else frameEnableValue = true;
                        if (
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("readonly") === "true" ||
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("readonly") === true
                        )
                          frameReadOnlyValue = true;
                        else frameReadOnlyValue = false;
                        if (
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("readOnlyValue") === "true" ||
                          document
                            .getElementById(sectionId)
                            ?.getAttribute("readOnlyValue") === true
                        )
                          framereadValue = true;
                        else framereadValue = false;
                      }
                    }
                    if (
                      frameEnableValue === true ||
                      frameEnableValue === "true"
                    )
                      controlElemToAdd["style"].Enable = "true";
                    else controlElemToAdd["style"].Enable = "false";
                    if (
                      frameReadOnlyValue === true ||
                      frameReadOnlyValue === "true"
                    )
                      controlElemToAdd["style"].ReadOnlyStyle = "true";
                    else controlElemToAdd["style"].ReadOnlyStyle = "false";
                    if (framereadValue === true || framereadValue === "true")
                      controlElemToAdd["style"].ReadOnly = "true";
                    else controlElemToAdd["style"].ReadOnly = "false";
                  }
                  setOpenQuickToolFor(controlElemToAdd?.id);
                  if (openCanvasForSubform === "subform") {
                    jsonObj = createSmartFormState(
                      subFormStateJson.current,
                      targetElemState.targetId,
                      targetElemState.targetElemType,
                      currElemState.current,
                      currElemState.current.frameIndex,
                      targetElemState.frameIndex,
                      controlElemToAdd,
                      targetElemState.targetRowId,
                      targetElemState.targetColId,
                      device
                    );
                  } else if (
                    openCanvasForSubform === "advanceListviewFromScratch"
                  ) {
                    jsonObj = createSmartFormState(
                      fetchGridStates().advanceListviewStateJson,
                      targetElemState.targetId,
                      targetElemState.targetElemType,
                      currElemState.current,
                      currElemState.current.frameIndex,
                      targetElemState.frameIndex,
                      controlElemToAdd,
                      targetElemState.targetRowId,
                      targetElemState.targetColId,
                      device
                    );
                  } else {
                    jsonObj = createSmartFormState(
                      formState2,
                      targetElemState.targetId,
                      targetElemState.targetElemType,
                      currElemState.current,
                      currElemState.current.frameIndex,
                      targetElemState.frameIndex,
                      controlElemToAdd,
                      targetElemState.targetRowId,
                      targetElemState.targetColId,
                      device
                    );
                  }

                  targetElemState.targetId = "";
                  targetElemState.targetClass = "";
                  targetElemState.targetElemType = "";
                  setCurrElem("");
                  if (openCanvasForSubform === "subform") {
                    setSubFormState({ ...jsonObj });
                  } else if (
                    openCanvasForSubform === "advanceListviewFromScratch"
                  ) {
                    dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj }, renderCanvas:true}));
                  } else {
                    setFormStateByUser({ ...jsonObj });
                  }
                } else if (response.data.status === 1) {
                  showAlertConfirmNotifications({
                    open: true,
                    showConfirm: "showNotification",
                    alertType: "error",
                    alertContentKey: `${t("Reopen_Form")}`,
                  });
                }
                setCurrentDataObjectJson(cloneDeep({}));
                dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
              })
              .catch((error) => {
                loading(false)
              })
            } else {
              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: `${t(
                  "This_Operation_Is_Not_Allowed_Inside_This_Section"
                )}`,
              });
            }
          }
        } else if (
          (currElemState.current === "wizard_h" ||
            currElemState.current === "wizard_v" ||
            currElemState.current === "sidenavigation") &&
          (targetElemState.targetElemType === "section" ||
            targetElemState.targetElemType === "tab" ||
            targetElemState.targetElemType === "sheet" ||
            targetElemState.targetElemType === "column" ||
            targetElemState.targetElemType === "row")
        ) {
          //customalert
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: `Dropping  ${currElemState.current} here is not allowed!`,
          });
          // alert("Dropping " + currElemState+' here is not allowed!');
        }
      } else if (
        (currElemState.current === "wizard_h" ||
          currElemState.current === "wizard_v" ||
          currElemState.current === "sidenavigation") &&
        (targetElemState.targetElemType === "section" ||
          targetElemState.targetElemType === "tab" ||
          targetElemState.targetElemType === "sheet" ||
          targetElemState.targetElemType === "column" ||
          targetElemState.targetElemType === "row")
      ) {
        //customalert
        setCurrentDataObjectJson(cloneDeep({}));
        dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: `Dropping ${currElemState.current} here is not allowed!`,
        });
        // alert("Dropping " + currElemState+' here is not allowed!');
      } else {
        var controlElemToAdd = {};
        controlElemToAdd.id = createUniqueId(currElemState.current);
        controlElemToAdd.elem_type = currElemState.current;
        if (
          currElemState.current === "column" ||
          currElemState.current === "row"
        ) {
          controlElemToAdd.children = [];
        }
        if (openCanvasForSubform === "subform") {
          jsonObj = createSmartFormState(
            subFormStateJson.current,
            targetElemState.targetId,
            targetElemState.targetElemType,
            currElemState.current,
            0,
            targetElemState.frameIndex,
            controlElemToAdd,
            targetElemState.targetRowId,
            targetElemState.targetColId,
            device
          );
        } else if (openCanvasForSubform === "advanceListviewFromScratch") {
          jsonObj = createSmartFormState(
            fetchGridStates().advanceListviewStateJson,
            targetElemState.targetId,
            targetElemState.targetElemType,
            currElemState.current,
            0,
            targetElemState.frameIndex,
            controlElemToAdd,
            targetElemState.targetRowId,
            targetElemState.targetColId,
            device
          );
        } else {
          jsonObj = createSmartFormState(
            formState2,
            targetElemState.targetId,
            targetElemState.targetElemType,
            currElemState.current,
            0,
            targetElemState.frameIndex,
            controlElemToAdd,
            targetElemState.targetRowId,
            targetElemState.targetColId,
            device
          );
        }

        targetElemState.targetId = "";
        targetElemState.targetClass = "";
        targetElemState.targetElemType = "";
        targetElemState.targetRowId = "";
        setCurrElem("");
        if (openCanvasForSubform === "subform") {
          setSubFormState({ ...jsonObj });
        } else if (openCanvasForSubform === "advanceListviewFromScratch") {
          dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj }, renderCanvas:true}));
        } else {
          setFormStateByUser({ ...jsonObj });
        }
      }
      // setHoverColumn(false);
      // dispatch(updateStateInRedux({name: "hoverColumn", key: containerId, value: false}));
    } else {
      // alert('Dropping component here is not allowed!');
    }

    if (document.getElementsByClassName(toBeClearedClassName)) {
      var obj = document.getElementsByClassName(toBeClearedClassName);
      if (obj && obj.length > 0) {
        for (var i = 0; i < obj.length; i++) {
          obj[i].classList.remove("highlightedRow");
        }
      }
    }

    // if(dataObjectJson && Object.keys(dataObjectJson).length === 0){

    // }
    // setQuickToolsClose(true, () => {
    //     setTimeout(() => {
    //       setQuickToolsClose(false);
    //     }, 500);
    //   });

    // setQuickToolsClose(true, () => {
    // setTimeout(() => {
    //     setQuickToolsClose(false);
    // }, 500);
    // });
  };

  const addElemToFormData = (obj, Id, elemType, column_layout) => {
    var newJson = {};
    var newJsonChildren = [];
    var cl = column_layout;
    for (var attr in obj) {
      if (obj["elem_type"] === "frame" || obj["elem_type"] === "headerframe") {
        cl = findFrameColumnLayout(obj);
      }
      if (obj.id === Id && attr === "id") {
        let newElement = {}; // crating the new component to be dropped
        newElement.id = createUniqueId(currElemState.current);
        // newElement.style={};
        // newElement.class={};
        newElement.elem_type = currElemState.current;

        if (targetElemState.targetElemType === "row") {
        }
        if (currElemState.current === "column") {
          const w = 12 / cl;
          newElement.w = w;
          newElement.md = w;
          newElement.sm = w;
          newElement.xs = w;
        }
        if (
          obj["elem_type"] === "textbox" ||
          obj["elem_type"] === "datepick" ||
          obj["elem_type"] === "combo" ||
          obj["elem_type"] === "checkbox" ||
          obj["elem_type"] === "radio" ||
          obj["elem_type"] === "tab" ||
          obj["elem_type"] === "tabChild" ||
          obj["elem_type"] === "multiSelect" ||
          obj["elem_type"] === "table" ||
          obj["elem_type"] === "listview" ||
          obj["elem_type"] === "advancelistview" ||
          obj["elem_type"] === "toggle" ||
          obj["elem_type"] === "paragraph" ||
          obj["elem_type"] === "richtexteditor" ||
          obj["elem_type"] === "imagecarousel" ||
          obj["elem_type"] === "richtexteditor" ||
          obj["elem_type"] === "tile" ||
          obj["elem_type"] === "report"
        ) {
        } else {
          //add more controls here
          if (
            currElemState.current === "textbox" ||
            currElemState.current === "datepick" ||
            currElemState.current === "combo" ||
            currElemState.current === "checkbox" ||
            currElemState.current === "email" ||
            currElemState.current === "password" ||
            currElemState.current === "radio" ||
            currElemState.current === "tab" ||
            currElemState.current === "tabChild" ||
            currElemState.current === "multiSelect" ||
            currElemState.current === "table" ||
            currElemState.current === "listview" ||
            currElemState.current === "advancelistview" ||
            currElemState.current === "toggle" ||
            currElemState.current === "paragraph" ||
            currElemState.current === "richtexteditor" ||
            currElemState.current === "imagecarousel" ||
            currElemState.current === "richtexteditor" ||
            currElemState.current === "tile" ||
            currElemState.current === "report"
          ) {
          } else {
            newElement.children = [];
          }
          if (obj.children !== undefined) {
            obj.children.push(newElement);
          } else {
            obj.children = [];
            obj.children.push(newElement);
          }
        }
      }
      if (attr === "children") {
        if (obj.children.length > 0) {
          obj.children.map((child) => {
            newJsonChildren.push(addElemToFormData(child, Id, elemType, cl));
          });
        }
        newJson.children = newJsonChildren;
      } else {
        newJson[attr] = obj[attr];
        if (attr === "id") {
          // //console.log(obj.id+'___'+Id+'::'+(obj.id===Id));
        }
      }
    }
    return newJson;
  };

  function updateColumnWidth(columnData, widthClass, colWidth, type = "width") {
    const deviceFromDom = document.querySelector("#canvasId")?.getAttribute("deviceMode");
    var formState2FromRedux = getFormState2();

    // var formState2FromRedux= (formStateStore.getState().data.find(json => json.key === containerId))?.contexts?.formState2;

    if (deviceFromDom === "web") {
      columnData.w = parseInt(colWidth);
    }
    if (deviceFromDom === "tablet") {
      columnData.sm = parseInt(colWidth);
    }
    if (deviceFromDom === "mobile") {
      columnData.xs = parseInt(colWidth);
    }

    var latestJson = changeColumnWidth(
      formState2FromRedux,
      columnData.id,
      columnData,
      widthClass,
      colWidth,
      type
    );

    // dispatch(updateContexts({ name: "formState2", value:latestJson, key: containerId }));

    setFormState2(latestJson);

    // if (colWidth !== updatedCol) {
    //   setUpdatedCol((prev) => colWidth);
    // }
    // if(formState2!==latestJson){
    // } else {
    // console.log('State did not change');
    // }
  }

  // const updatedComponentInFormState = (controlId, controlData) => {
  //   setLatestChangesSaved(false);
  //   controlFoundFalseMaker();
  //   if (!controlId && !controlData) {
  //     setFormState2({ ...formState2 });
  //     return;
  //   }
  //   localStorage.setItem("loadVal", false);

  //   // setFormState2(prev => {
  //   //     const temp = {...prev};
  //   //     const outer = {...temp.children[1]};
  //   //     const frame = {...outer.children[1]};
  //   //     const row = {...frame.children[2]};
  //   //     const col = {...row.children[0]};
  //   //     const el = {...col.children[0]};
  //   //     el.style.Label = "changed";
  //   //     col.children[0] = el;
  //   //     row.children[0] = col;
  //   //     frame.children[2] = row;
  //   //     outer.children[1] = frame;
  //   //     temp.children[1] = outer;

  //   //     return temp;
  //   // })

  //   updateComponentInJsonPerformance(formState2, controlId, controlData);
  //   var arr = getControlsArray();

  //   const temp = { ...formState2 };
  //   if (arr.length > 0) {
  //     let pre = temp,
  //       tempArr = [];
  //     /*
  //           *** Refer to this FOR loop for debugging, works same as below MAP ***
  //           for (let i = 0; i < arr.length; i++) {
  //               x = { ...pre.children.find(el => el.id == arr[i]) };
  //               tempArr.push(x);
  //               pre = x;
  //           }
  //           */
  //     tempArr = arr.map(
  //       (el) => (pre = { ...pre.children.find((ele) => ele.id == el) })
  //     );
  //     tempArr[tempArr.length - 1] = controlData;
  //     for (let i = tempArr.length - 1; i > 0; i--) {
  //       let fIndex = tempArr[i - 1].children.findIndex(
  //         (el) => el.id == tempArr[i].id
  //       );
  //       // tempArr[i - 1].children.map((el, ind) => {
  //       //     if (el.id == tempArr[i].id) fIndex = ind;
  //       // });
  //       tempArr[i - 1].children[fIndex] = { ...tempArr[i] };
  //     }

  //     let fIndex = temp.children.findIndex((el) => el.id == tempArr[0].id);
  //     temp.children[fIndex] = { ...tempArr[0] };
  //   }

  //   setFormState2({ ...temp });
  // };
  console.log(formState2, "formState2==========>>>>>>>>>");
  const gdCall = useSelector((state) => state["generalDataCall"]);
  const iformClientLoaded = useSelector((state) => state["iformClientLoaded"]);

  const updatedComponentInFormState = (
    controlId,
    controlData,
    isAdvanceListviewPreview,
    is_formState_Modified,
    isCallingFromApi=false,
    isCallingFromMarvin = false
  ) => {

    var formState2FromRedux = getFormState2();
    var formState2FromRedux1 = getFormJsonFromStore()
    console.log("wow1", formState2, formState2FromRedux, formState2FromRedux1, childComp,{controlId,
      controlData,isAdvanceListviewPreview})
    if(childComp === "preview" || childComp === "application" || gdCall){
      const isComposed = window?.event?.composed;
      const isTrusted = window?.event?.isTrusted;

    if(isAdvanceListviewPreview === false) {
        isAdvanceListviewPreview = !controlData?.isAdvanceListview;
    }

    if(isAdvanceListviewPreview === false) {
        isAdvanceListviewPreview = !controlData?.isInsideListview;
    }

      if( isComposed || isTrusted ){
        // setformstate1( JSON.stringify(formState2FromRedux) );
        setLatestChangesSaved(false);
        setFormstateChangedByUser(true);
      }
      else if(isComposed === false){
        setFormstateChangedByUser(false);
      }
      
      controlFoundFalseMaker();
      const subFormMetaData = getSubFormMetaData();
      if(subFormMetaData?.includes(controlData?.buttonId) && controlData?.isSubForm) {
          var latestJson = JSON.parse(JSON.stringify(formState2));
          fetchAndUpdateJSON(latestJson,controlId,controlData); 
          setFormState2((prevState) => {
            return { ...latestJson };
          });
          return;
      }
      if(fetchGridStates().currentAdvanceListviewStateJson && getGridStates()?.openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" && fetchGridStates()?.subFormListviewJson && getGridStates()?.openCanvasForPreview === "showDataAdditonSection") {
        // let lvJson = fetchGridStates()?.subFormListviewJson;
        // let lvJson1 = updateComponentInJson(
        //   fetchGridStates()?.currentAdvanceListviewStateJson?.listviewFrameLayoutJson,
        //   controlId,
        //   controlData
        // );
        // let currentLvJson = functions.readJson(lvJson1, fetchGridStates()?.subFormListviewJson?.id)
        let lvJson = fetchGridStates()?.subFormListviewJson;
        fetchAndUpdateJSON(lvJson,controlId,controlData);
        console.log("hi this is lvjson",lvJson);
        // dispatch(
        //   updateGridContexts({
        //     name: "subFormListviewJson",
        //     key: containerId,
        //     value: { ...fetchGridStates()?.subFormListviewJson, listviewFrameLayoutJson: { ...lvJson1 }},
        //     renderListView: true, 
        //     // renderCanvas: true
        //   })
        // );

        // console.log("inside updated1", currentLvJson, lvJson1, fetchGridStates()?.currentAdvanceListviewStateJson?.listviewFrameLayoutJson, lvJson)
        // dispatch(
        //   updateGridContexts({
        //     name: "subFormListviewJson",
        //     key: containerId,
        //     value: { ...fetchGridStates()?.subFormListviewJson, listviewFrameLayoutJson: { ...currentLvJson?.listviewFrameLayoutJson }},
        //     renderListView: true, 
        //     // renderCanvas: true
        //   })
        // );
        dispatch(
          updateGridContexts({
            name: "subFormListviewJson",
            key: containerId,
            value: lvJson,
            // value: { ...fetchGridStates()?.subFormListviewJson, listviewFrameLayoutJson: { ...currentLvJson?.listviewFrameLayoutJson }},
            renderListView: true, 
            // renderCanvas: true
          })
        );
      // dispatch(updateGridContexts({ name: "currentAdvanceListviewStateJson", key: containerId, value: { ...fetchGridStates().currentAdvanceListviewStateJson, listviewFrameLayoutJson: { ...lvJson1 }}, renderAdvListView: true, renderListView: false}));
      }
      else if(fetchGridStates()?.subFormListviewJson && getGridStates()?.openCanvasForPreview === "showDataAdditonSection") {
        let lvJson = fetchGridStates()?.subFormListviewJson;
        let lvJson1 = updateComponentInJson(
          fetchGridStates()?.subFormListviewJson?.listviewFrameLayoutJson,
          controlId,
          controlData
        );
        console.log("inside updated2", lvJson1)
        dispatch(
          updateGridContexts({
            name: "subFormListviewJson",
            key: containerId,
            value: { ...fetchGridStates()?.subFormListviewJson, listviewFrameLayoutJson: { ...lvJson1 }},
            renderListView: true, 
            // renderCanvas: true
          })
        );
      }
      else if (isAdvanceListviewPreview === true) {
        var latestJson2 = updateComponentInJson(
          fetchGridStates().currentAdvanceListviewStateJson?.listviewFrameLayoutJson,
          controlId,
          controlData
        );
        // dispatch(
        //   updateGridContexts({
        //     name: "subFormListviewJson",
        //     key: containerId,
        //     value: { ...controlData},
        //     renderListView: false,
        //     // renderCanvas: true
        //   })
        // );
        // console.log(subFormStateJson.current,'latessssssJson2',latestJson2,'controlData',controlData)
        dispatch(updateGridContexts({ name: "currentAdvanceListviewStateJson", key: containerId, value: { ...fetchGridStates().currentAdvanceListviewStateJson, listviewFrameLayoutJson: { ...latestJson2 }}, renderAdvListView: true, renderListView: false, renderCanvas: true}));
      }
      else if (isAdvanceListviewPreview === "isADVListview") {
        var latestJson = updateComponentInJson(
          formState2,
          controlId,
          controlData
        );

        setFormState2((prevState) => {
          return { ...latestJson };
        });
      }
      else if(childComp === "subForm") {
        var latestJson = JSON.parse(JSON.stringify(window?.opener?.newMicroFrontendData?.data?.subform));
        fetchAndUpdateJSON(latestJson,controlId,controlData);
        
        console.log("wow2", window?.opener?.newMicroFrontendData?.data?.subform, latestJson, formState2FromRedux, {controlId, controlData,isAdvanceListviewPreview})
        if(window?.opener?.newMicroFrontendData?.data?.subform)
          window.opener.newMicroFrontendData.data.subform = latestJson;
      }
      else {
        // var latestJson = updateComponentInJson(
        //   formState2,
        //   controlId,
        //   controlData
        // );
        // console.log("wow2", formState2, latestJson, formState2FromRedux, {controlId,
        //   controlData,isAdvanceListviewPreview})
        // setFormState2((prevState) => {
        //   return { ...latestJson };
        // });

          var latestJson = JSON.parse(JSON.stringify(formState2));
          fetchAndUpdateJSON(latestJson,controlId,controlData);
          
          console.log("wow2", formState2, latestJson, formState2FromRedux, {controlId, controlData,isAdvanceListviewPreview})
          
          setFormState2((prevState) => {
            return { ...latestJson };
          });
      }
      return true;
    }
    else{

      if (is_formState_Modified=== false) {

      }
          //// nothing
      else{
        const isComposed = window?.event?.composed;
        const isTrusted = window?.event?.isTrusted;

        if( isComposed || isTrusted ){
          // setformstate1( JSON.stringify(formState2FromRedux) );
          setLatestChangesSaved(false);
          setFormstateChangedByUser(true);
        }
        else if(isComposed === false){
          setFormstateChangedByUser(false);
        }
        
        controlFoundFalseMaker();

        if (
          (openCanvasForSubform === false ||
            openCanvasForSubform === "advanceListviewFromScratch") &&
          fetchGridStates().advanceListviewStateJson &&
          !isAdvanceListviewPreview
        ) {
        var advFL;
        if (currentadvanceListview.current) {
          currentadvanceListview.current.listviewFrameLayoutJson =
            fetchGridStates().advanceListviewStateJson;
          advFL = currentadvanceListview.current?.listviewFrameLayoutJson;
        } else if (fetchGridStates().currentAdvanceListviewStateJson && !isAdvanceListviewPreview) {
          advFL = fetchGridStates().currentAdvanceListviewStateJson?.listviewFrameLayoutJson;
        } else {
          advFL = fetchGridStates().advanceListviewStateJson?.listviewFrameLayoutJson || fetchGridStates().advanceListviewStateJson;
        }
        var latestJson2 = advFL;
        if(!isCallingFromApi)
            latestJson2 = updateComponentInJson(advFL, controlId, controlData,undefined,isCallingFromMarvin);
        // if(isCallingFromApi) {
        //   const controlAdvId = fetchGridStates().currentAdvanceListviewStateJson?.id || fetchGridStates().advanceListviewStateJson?.id
        //   const newJson = functions.readJson(formState2,controlAdvId)?.listviewFrameLayoutJson;
        //   latestJson2 = updateComponentInJson(advFL, "FormDef", newJson);
        // }
        // else {
        //   latestJson2 = updateComponentInJson(advFL, controlId, controlData);
        // }
        dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...latestJson2}, renderCanvas: true }));
        props?.setRenderState(prev => !prev);
        if(isCallingFromApi) {
          var latestJson = updateComponentInJson(
            formState2,
            controlId,
            controlData
          );

          setFormState2((prevState) => {
            return { ...latestJson };
          });
        }
        }
        else if (isAdvanceListviewPreview === true) {
          var latestJson2 = updateComponentInJson(
            fetchGridStates().currentAdvanceListviewStateJson?.listviewFrameLayoutJson,
            controlId,
            controlData,
            undefined,
            isCallingFromMarvin
          );
          // console.log(subFormStateJson.current,'latessssssJson2',latestJson2,'controlData',controlData)
          dispatch(updateGridContexts({ name: "currentAdvanceListviewStateJson", key: containerId, value: { ...fetchGridStates().currentAdvanceListviewStateJson, listviewFrameLayoutJson: { ...latestJson2 }, renderAdvListView: true, renderListView: false, renderCanvas: true}}));
        }
        else if (isAdvanceListviewPreview === "isADVListview") {
          var latestJson = updateComponentInJson(
            formState2,
            controlId,
            controlData,
            undefined,
            isCallingFromMarvin
          );

          setFormState2((prevState) => {
            return { ...latestJson };
          });
        }
        else {
          // var latestJson = updateComponentInJson(
          //   formState2,
          //   controlId,
          //   controlData,
          //   undefined,
          //   isCallingFromMarvin
          // );

          // setFormState2((prevState) => {
          //   return { ...latestJson };
          // });

          if(controlData?.isAdvanceListview && openCanvasForSubform === "showDataAdditonSection") {
            const advSubformJson = fetchGridStates().advanceListviewStateJson;
            console.log("wow33", {formState2, advSubformJson, formState2FromRedux, extra: {controlId, controlData,isAdvanceListviewPreview}})
            
            fetchAndUpdateJSON(advSubformJson, controlId, controlData);
            dispatch(updateGridContexts({
              name: "advanceListviewStateJson",
              key: containerId,
              value: { ...advSubformJson },
              renderCanvas: true 
            }));
            
            console.log("wow34", {formState2, advSubformJson, formState2FromRedux, extra: {controlId, controlData,isAdvanceListviewPreview}})

          } else {
            var latestJson = JSON.parse(JSON.stringify(formState2));
            fetchAndUpdateJSON(latestJson,controlId,controlData);
            if(openCanvasForSubform === "subform"){
              let buttonJson = functions.readJson(latestJson, window?.currentOpenOverlayParentId);
              //subFormStateJson.current = buttonJson?.subform;
              setSubFormState({ ...buttonJson?.subform });
            }
            console.log("wow2", formState2, latestJson, formState2FromRedux, {controlId, controlData,isAdvanceListviewPreview})
            
            setFormState2((prevState) => {
              return { ...latestJson };
            });
          }

          if(openCanvasForSubform === "showDataAdditonSection") {
            props?.setRenderState(prev => !prev);
          }
        }
        window.formBuilderCheck()
        return true;
      }
    }
  };


  const removeAndUpdateComponentInFormState = (controlId, elem_type) => {
    var formState2FromRedux = getFormState2();

    var latestJson = removeAndUpdateComponentInJson(
      formState2,
      controlId,
      elem_type
    );
    // setformstate1( JSON.stringify(formState2) );
    setFormState2((prevState) => {
      return { ...latestJson };
    });
  };

  const findObjectById = (obj, Id) => {
    let newJson = {};
    let newJsonChildren = [];
    const id = obj.id;
    const children = obj.children;
    if (obj.id === Id) {
      return true;
    }

    if (children !== undefined) {
      if (children.length > 0) {
        children.map((child) => {
          if (child.id === Id) {
            activeForDrop.dropped = true;
            setDropState({
              droppedOn: Id,
              droppedElemType: targetElemState.targetElemType,
              droppedStatus: true,
            });
          } else {
            findObjectById(child, Id);
          }
        });
      }
    }
    return false;
  };

  // const [showProperties, setShowProperties] = useState(false);

  const showProperties = useRef(false);

  function setShowProperties(val) {
    showProperties.current = val;
  }

  // const [selectedControlId, setSelectedControlId] = useState("");
  // const [selectedControl, setSelectedControl] = useState({elem_type:""});

  const selectedControl = useRef({ elem_type: "" });

  function setSelectedControl(obj) {
    selectedControl.current = obj;
    if (window.selectedControl_forElemDel) {
      window.selectedControl_forElemDel(obj);
    }
    console.log("selectedControl", obj);
  }

  var prevSelectedID = "";
  const copyElement = useRef({});

  const [cutElement, setCutElement] = useState(false);
  const [saveElement, setSaveElement] = useState(false);

  function setCopyElement(obj) {
    copyElement.current = obj;
  }

  useEffect(() => {
    if (!window.myEventListenerAdded) {
      window.addEventListener("keydown", (ev) => {
        if (!ev.ctrlKey) {
          if (ev.key === "ArrowRight" || ev.key === "ArrowLeft") {
            if (ev.key === "ArrowRight") {
              if ( document.getElementById("wizard") && navOnWizByArrowsKeys()) {
                if(ev.target.nodeName!=="INPUT" && ev.target.nodeName!=="TEXTAREA"){
                  dispatch(updateStateInRedux({name: "callIncreaseStep",value: true}))
                }
              }
            }
            if (ev.key === "ArrowLeft") {
              if (document.getElementById("wizard") && navOnWizByArrowsKeys()) {
                if(ev.target.nodeName!=="INPUT" && ev.target.nodeName!=="TEXTAREA"){
                  dispatch(updateStateInRedux({name: "callDecreaseStep",value: true}))
                }
              }
            }
          }
        }

        let charCode = String.fromCharCode(ev.which).toLowerCase();
        if (
          (ev.ctrlKey || ev.metaKey) &&
          (ev.key === "ArrowRight" ||
            ev.key === "ArrowLeft" ||
            charCode === "f" ||
            charCode === "s" ||
            charCode === "d" ||
            charCode === "i")
        ) {
          if (ev.key === "ArrowRight") {
            if (document.getElementById("wizard") && navOnWizByArrowsKeys()) {
              if(ev.target.nodeName!=="INPUT" && ev.target.nodeName!=="TEXTAREA"){
                dispatch(updateStateInRedux({name: "callIncreaseStep",value: true}))
              }
            }
          } else if (ev.key === "ArrowLeft") {
            if (document.getElementById("wizard") && navOnWizByArrowsKeys()) {
              if(ev.target.nodeName!=="INPUT" && ev.target.nodeName!=="TEXTAREA"){
                dispatch(updateStateInRedux({name: "callDecreaseStep",value: true}))
              }
            }
          } else if (charCode === "f") {
            ev.preventDefault();
            if(ev.target.nodeName!=="INPUT" && ev.target.nodeName!=="TEXTAREA"){
              dispatch(updateStateInRedux({name: "callFinishJourney",value: true}))
            }
          } else if (charCode === "d") {
            if (formMataData) {
              ev.preventDefault();
              window.parent.WFDone();
            }
          } else if (charCode === "i") {
            if (formMataData) {
              ev.preventDefault();
              window.parent.WFDone();
            }
          } else if (charCode === "s") {
            ev.preventDefault()
            if(window.parent && window.parent.WFSave){
              document.activeElement.blur();
              window.parent.WFSave()
          }
          }
        }
      });
      window.myEventListenerAdded = true;
    }
  }, []);

  async function xyz2(response, jsonObj, ev, formstate, targetElemState2, childControl, subFormJSON){
    // if(response.status ===  200) {
    // var controlElemToAdd;
    // controlElemToAdd = response.data;
    var controlElemToAdd;
    if(response.status ===  200) {
      if (childControl?.elem_type?.toLowerCase() === "listview" || childControl?.elem_type?.toLowerCase() === "advancelistview")
        response.data = {...response.data.populatedJson};
      controlElemToAdd = response.data;
      if(response.data.elem_type === "button" && childControl?.subform){
        let jsonObj = {formBuffer: JSON.stringify(childControl?.subform)};
        let zip = new JSZip();
        zip.file(`${controlElemToAdd.id}.json`, JSON.stringify(jsonObj));
        const zipBlob = await zip.generateAsync({ type: "blob" });
        // zip.generateAsync({ type: "blob" }).then(async function (content) {
          var formDataSub = new FormData();
          const uploadZip1 = new Blob([zipBlob], { type: "application/x-zip-compressed" });
          formDataSub.append("file", uploadZip1);
          let formId = getFormId();
          let populateInside = {
            frameIndex: controlElemToAdd?.frameIndex,
            elementIndex: controlElemToAdd?.elementIndex,
            sheetElementIndex: controlElemToAdd?.sheetElementIndex,
            sheetFrameElementIndex:
              controlElemToAdd?.sheetFrameElementIndex,
            sheetId: controlElemToAdd?.sheetIndex,
            stepIndex: controlElemToAdd?.stepIndex,
            subStepIndex: controlElemToAdd?.subStepIndex,
            subChildMenuIndex: controlElemToAdd?.subChildMenuIndex,
            formId: formId?.toString(),
          };

          formDataSub.append(
            "populateInsideJson",
            JSON.stringify(populateInside)
          );
            try {
              let responseSub = await axios
              .post("/idesign/populateSubformFromJsoninFile", formDataSub, {
                withCredentials: true,
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              });
                let data = responseSub.data;
                let _alert = data.alert;
                if (_alert) {
                } else {
                  let populatedJson = data;
                  loading(true);
                  if (
                    populatedJson !== null &&
                    populatedJson !== undefined
                  ) {
                  if (responseSub?.data?.formBuffer) { 
                    controlElemToAdd["subform"] = JSON.parse(responseSub?.data?.formBuffer);
                    controlElemToAdd["selectedEvent"] = "subform";
                    controlElemToAdd["subform"]["id"] = controlElemToAdd?.id
                    updateRowNColumn(controlElemToAdd["subform"]);
                    loading(false);
                  }
                }
              }
            }
            catch(err) {
              if(err?.responseSub?.data?.errorcode === "-5001") {
                setAlertData({
                  open: true,
                  showConfirm: "showNotification",
                  alertType: "error",
                  alertContentKey: "Adv_not_allowd_in_btn_subform",
                  autoHideDuration: 4000
                });
              } else {
                setAlertData({
                  open: true,
                  showConfirm: "showNotification",
                  alertType: "error",
                  alertContentKey: "UploadSubFormFailureMessage",
                  autoHideDuration: 4000
                });
              }
              console.error("Error :: ", err);
            }
      }
      else  if(response.data.elem_type === "listview" && childControl?.listviewFrameLayoutJson){
        // controlElemToAdd.listviewFrameLayoutJson = childControl?.listviewFrameLayoutJson
        updateRowNColumn(controlElemToAdd.listviewFrameLayoutJson)
      }
      else  if(response.data.elem_type === "advancelistview" && childControl?.listviewFrameLayoutJson){
        // controlElemToAdd.listviewFrameLayoutJson = childControl?.listviewFrameLayoutJson
        updateRowNColumn(controlElemToAdd.listviewFrameLayoutJson)
      }
      const frameIndexget =
      ev.currentTarget
        ?.closest(`[elem_type=frame]`)
        ?.getAttribute("frameindex") ||
      ev.currentTarget
        ?.closest(`[elem_type=section]`)
        ?.getAttribute("frameindex") ||
      ev.currentTarget
        ?.closest(`[elem_type=form]`)
        ?.getAttribute("frameindex");
//       if(response.data.elem_type === "table" || response.data.elem_type === "listview" || response.data.elem_type === "advancelistview"){
//         const parentWizard = (controlId) => { 
//           if ( document .getElementById(`${controlId}`) ?.closest(`[elem_type=wizard_v]`) || document .getElementById(`${controlId}`) ?.closest(`[elem_type=wizard_h]`) || (document .getElementById(`${controlId}`) ?.closest(`[elem_type=sidenavigation]`) && !document.getElementById(`${controlId}`)?.closest(`[elem_type=tab]`)) ) 
//           { return true; } else 
//           { return false; } }; 
          
//           const parentMenuCheck = (controlId) => { 
//             if (document.getElementById(`${controlId}`)?.closest(`[elem_type=Menu]`)) { 
//               return true; 
//             } else { 
//               return false; 
//             } }; 
            
//             const parentTab = (controlId) => { 
//               if (document.getElementById(`${controlId}`)?.closest(`[elem_type=tab]`)) { 
//                 return true; 
//               } else { 
//                 return false; 
//               } };
//         let remainingURL;
// let stepIndex;
// let subStepIndex;
// let subChildMenuIndex;
// let isMenu = document
//   .querySelector(`#${response.data.id}`)
//   ?.closest(`[elem_type=Menu]`);
// let isWizard = document
//   .querySelector(`#${response.data.id}`)
//   ?.closest(`[elem_type=Menu]`);
// if (formState2?.isStep && formState2?.isStep?.insideWizard) {
//   remainingURL = "/Properties/addColumnInStep";
//   stepIndex = document
//     .querySelector(`#${response.data.id}`)
//     ?.closest(`main`)
//     ?.getAttribute("stepIndex");
//   subStepIndex = document
//     .querySelector(`#${response.data.id}`)
//     ?.closest(`main`)
//     ?.getAttribute("substepindex");
//   subChildMenuIndex = document
//     .querySelector(`#${response.data.id}`)
//     ?.closest(`main`)
//     ?.getAttribute("subchildmenuindex");
// } else if (isMenu) {
//   stepIndex = document
//     .querySelector(`#${response.data.id}`)
//     ?.closest(`main`)
//     ?.getAttribute("stepIndex");
//   subStepIndex = document
//     .querySelector(`#${response.data.id}`)
//     ?.closest(`main`)
//     ?.getAttribute("substepindex");
//   subChildMenuIndex = document
//     .querySelector(`#${response.data.id}`)
//     ?.closest(`main`)
//     ?.getAttribute("subchildmenuindex");
//   remainingURL = "/Properties/addColumnInStep";
// } else {
//   remainingURL = "/Properties/addColumn";
// }
// if (parentWizard(response.data.id)) {
//   response.data.insideWizard = true;
//   response.data.parentStep = formState2?.isStep?.parentStep;
//   response.data.parentSubStep = formState2?.isStep?.parentSubStep;
//   response.data.subChildMenuIndex = subChildMenuIndex;
// }
// if (parentMenuCheck(response.data.id)) {
//   let stepIndex = document
//     .getElementById(`${response.data.id}`)
//     .closest("main")
//     .getAttribute("stepindex");
//   let subStepIndex = document
//     .getElementById(`${response.data.id}`)
//     .closest("main")
//     .getAttribute("substepindex");
//   let subChildMenuIndex = document
//     .getElementById(`${response.data.id}`)
//     .closest("main")
//     .getAttribute("subchildmenustepindex");
//   response.data.insideMenu = true;
//   response.data.stepIndex = stepIndex;
//   response.data.subChildMenuIndex = subStepIndex;
//   response.data.subStepIndex = subChildMenuIndex;
// }
// if (parentTab(response.data.id)) {
//   response.data.insideTab = true;
// }
//         let columnList = []; 
//         for (let item of childControl.columnList) 
//         { 
//           let styleObj = item.style; 
//           styleObj["FormId"] = `${ microFrontendData?.formDefId || activePage?.formId || activeSubForm?.fragmentId || microFrontendData?.formId }`; 
//           styleObj["frameIndex"] = response.data.frameIndex; styleObj["elementIndex"] = response.data.elementIndex; 
//           styleObj["elem_type"] = "column"; styleObj["stepIndex"] = formState2?.isStep?.parentStep || stepIndex || -1; 
//           styleObj["subStepIndex"] = formState2?.isStep?.parentSubStep || -1; 
//           styleObj["subChildMenuIndex"] = subChildMenuIndex || subChildMenuIndex == 0 ? subChildMenuIndex : "-1"; 
//           columnList.push(item.style); 
//         }


//           let type = 1; 
//           if (formState2?.isStep?.insideWizard) { 
//             type = 3;
//            } 
//            if (parentMenuCheck(response.data.id)) { 
//             type = 4; 
//           } 
//           if (parentTab(response.data.id)) {
//              type = 4; 
//             } 
//           let columnJson = { columns: [...columnList], type: type,controlid:response.data.id }; 
//           let addedColumnResponse = await axios.post("Properties/addColumnsInTable", columnJson, { withCredentials: true, }) 
//           let requiredColumns = []
//           for(let col in columnList){
//             let obj = {};
//             // obj = { ...addedColumnResponse.data[col]?.body,...columnList[col]}
//             obj = { ...addedColumnResponse.data[col]?.body,style:{...columnList[col]}}
//             requiredColumns.push(obj)
//           }
//           console.log("columnResponse", response); 
//           controlElemToAdd.columnList = [];
//           controlElemToAdd.columnList = [...requiredColumns]

//       }

      if(response.data.elem_type === "report"){
        controlElemToAdd["selectId"] = childControl["selectId"];
      }

    controlElemToAdd["style"] = {
      ...childControl["style"],
    };

    if(childControl?.dataclass){
      controlElemToAdd.dataclass = childControl?.dataclass
      controlElemToAdd.datamapPercision = childControl?.datamapPercision
      controlElemToAdd.datamapVariableLength = childControl?.datamapVariableLength
      controlElemToAdd.datamapVariableType = childControl?.datamapVariableType
    }

    if(childControl?.options){
      controlElemToAdd["options"] = [
        ...childControl["options"],
      ];
    }

    if (childControl?.marvin !== undefined) {
      controlElemToAdd.marvin = childControl.marvin;
    }

    if(childControl?.columnList){
      controlElemToAdd.columnList = childControl.columnList
    }

    if(childControl?.unBounded){
      controlElemToAdd["unBounded"] = childControl.unBounded
    }
    if(childControl?.TypeOfValue){
      controlElemToAdd["TypeOfValue"] = childControl.TypeOfValue
    }

    if (openCanvasForSubform === "subform") {
      jsonObj = createSmartFormState(
        subFormJSON,
        targetElemState2?.targetId,
        "column",
        controlElemToAdd.controlName === "password" &&
        controlElemToAdd.elem_type === "textbox"
        ? "textbox"
        : childControl.elem_type,
        0,
        frameIndexget,
        controlElemToAdd,
        targetElemState2.targetRowId,
        device
      );
    } else if (
      openCanvasForSubform === "advanceListviewFromScratch"
    ) {
      jsonObj = createSmartFormState(
        fetchGridStates().advanceListviewStateJson,
        targetElemState2?.targetId,
        "column",
        controlElemToAdd.controlName === "password" &&
        controlElemToAdd.elem_type === "textbox"
        ? "textbox"
        : childControl.elem_type,
        0,
        frameIndexget,
        controlElemToAdd,
        targetElemState2.targetRowId,
        device
      );
    } else {
      jsonObj = createSmartFormState(
        formstate,
        targetElemState2?.targetId,
        "column",
        controlElemToAdd.controlName === "password" &&
        controlElemToAdd.elem_type === "textbox"
        ? "textbox"
        : childControl.elem_type,
        0,
        frameIndexget,
        controlElemToAdd,
        targetElemState2.targetRowId,
        device
      );
    }
    // jsonObj = createSmartFormState(
    //   formstate,
    //   data.id,
    //   data.elem_type,
    //   controlElemToAdd.controlName === "password" &&
    //     controlElemToAdd.elem_type === "textbox"
    //     ? "textbox"
    //     : copyElement.current.elem_type,
    //   0,
    //   frameIndexget,
    //   controlElemToAdd,
    //   targetElemState.targetRowId,
    //   device
    // );
    targetElemState = {}
    setCurrElem("")
    if (openCanvasForSubform === "subform") {
      setSubFormState({ ...jsonObj });
    } else if (
      openCanvasForSubform === "advanceListviewFromScratch"
    ) {
      dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj }, renderCanvas:true}));
    } else {
      setFormState2({ ...jsonObj });
    }
    }
    else if(response.data.status === 1){
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey:`${t("Reopen_Form")}`,
      });
    }
    else {
      setAlert({
        open: true,
        severity: "error",
        severityMessage: "Something went wrong",
      });
    }
    setCurrentDataObjectJson(cloneDeep({}));
}

  async function testClick(ev, data, sheetData,targetElemState1={}) {
    var formstate = formStateStore
      .getState()
      .data.find((json) => json.key === containerId)?.contexts?.formState2;
    // setHoverColumn(isMobile);
    // dispatch(updateStateInRedux({name: "hoverColumn", key: containerId, value: isMobile}));
    if(Object.keys(targetElemState1)?.length > 0 ) targetElemState = targetElemState1;
    if(data?.elem_type === "row"){
      if(data?.children?.length === 0){
        dispatch(updateStateInRedux({name: "noOfRows", key: containerId, value: 1}));
      }
    }
    // ev.preventDefault();
    // if(propertyPinned===false){
    //     // console.log('openProperties :: ',openProperties);
    //     if(openProperties){
    //         setOpenProperties(false);
    //     }
    // }

    // console.log("test click called", ev.target);
    //formState.containerControl === "wizard"
    // formState.containerControl === "wizard_h"

    if (!ev.ctrlKey) {
      if (ev.key === "ArrowRight" || ev.key === "ArrowLeft") {
        if (ev.key === "ArrowRight") {
          if (document.getElementById("wizard") && navOnWizByArrowsKeys()) {
            window.increaseSteps(ev);
          }
        }
        if (ev.key === "ArrowLeft") {
          if (document.getElementById("wizard") && navOnWizByArrowsKeys()) {
            window.decreaseSteps(ev);
          }
        }
      }
    }

    let charCode = String.fromCharCode(ev.which).toLowerCase();
    if (
      (ev.ctrlKey || ev.metaKey) &&
      (charCode === "c" ||
        charCode === "x" ||
        charCode === "s" ||
        ev.key === "ArrowRight" ||
        ev.key === "ArrowLeft" ||
        charCode === "f" ||
        charCode === "d" ||
        charCode === "i")
    ) {
      if (charCode === "c") {
        if(ev.target.id !== "EditableLabel"){
          setCopyElement(selectedControl?.current);
        }
      } else if (charCode === "x") {
        if(selectedControl?.current?.children?.length === 0){
          setAlert({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            autoHideDuration: 3000,
            alertContentKey: "Please copy column with some controls",
          });
          return
        }
        setCopyElement(data.elem_type === "column" ? selectedControl?.current : data);
        setCutElement(true);
        deleteControl(
          ev,
          data.elem_type === "column" ? selectedControl?.current?.id : data?.id,
          data.elem_type === "column" ? selectedControl?.current : data,
          undefined,
          formstate
        );
      } else if (charCode === "s") {
        ev.preventDefault();
        window.callSpecifiedFunctions(window.activeApplication);
      } else if (ev.key === "ArrowRight") {
        if (document.getElementById("wizard") && navOnWizByArrowsKeys()) {
          window.increaseSteps(ev);
        }
      } else if (ev.key === "ArrowLeft") {
        if (document.getElementById("wizard") && navOnWizByArrowsKeys()) {
          window.decreaseSteps(ev);
        }
      } else if (charCode === "f") {
        ev.preventDefault();
        window.applicationFinish();
      } else if (charCode === "d") {
        if (formMataData) {
          ev.preventDefault();
          window.parent.WFDone();
        }
      } else if (charCode === "i") {
        if (formMataData) {
          ev.preventDefault();
          window.parent.WFDone();
        }
      }
    } else if (
      (ev.ctrlKey || ev.metaKey) &&
      charCode === "v" &&
      Object.keys(copyElement?.current).length !== 0
    ) {
      const advJSON = getAdvanceListViewFormJsonFromStore(containerId);
      const subFormJSON = getSubFormStateJsonFromStore(containerId)
      console.log(copyElement, "dfvfvgsdfd===>>", charCode, advJSON, subFormJSON);
      if(copyElement?.current?.elem_type === "column" && !openQuickToolFor?.current){
        if(copyElement?.current?.children?.length === 0){
          setAlert({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            autoHideDuration: 3000,
            alertContentKey: "Please copy column with some controls",
          });
          return
        }
        else if(copyElement?.current?.children?.length > 0){
          var jsonObj = {};
              var extraDetails = {};
              let isSubForm = false;
              if (openCanvasForSubform === "subform") {
                isSubForm = true;
              }
              let isAdvanceListview = false;
              if (openCanvasForSubform === "advanceListviewFromScratch") {
                isAdvanceListview = true;
              }
              const parentWizard = (eve) => {
                if (
                  eve?.currentTarget?.closest(`[elem_type=wizard_v]`) ||
                  eve?.currentTarget?.closest(`[elem_type=wizard_h]`) ||
                  (eve?.currentTarget?.closest(`[elem_type=sidenavigation]`) &&
                    !eve?.currentTarget?.closest(`[elem_type=tab]`)) ||
                  (openCanvasForSubform === "subform" &&
                    currentButtonForSubform.current?.containerControl ===
                      "wizard_h") ||
                  (openCanvasForSubform === "subform" &&
                    currentButtonForSubform.current?.containerControl ===
                      "wizard_v") ||
                  (openCanvasForSubform === "subform" &&
                    currentButtonForSubform.current?.containerControl ===
                      "sidenavigation")
                ) {
                  return true;
                } else {
                  return false;
                }
              };
      
              const parentMenu = () => {
                if (
                  ev?.currentTarget?.closest(`[elem_type=Menu]`) ||
                  (openCanvasForSubform === "subform" &&
                    currentButtonForSubform.current?.containerControl === "Menu")
                ) {
                  return true;
                } else {
                  return false;
                }
              };
              const frameIndexget =
                ev.currentTarget
                  ?.closest(`[elem_type=frame]`)
                  ?.getAttribute("frameindex") ||
                ev.currentTarget
                  ?.closest(`[elem_type=section]`)
                  ?.getAttribute("frameindex") ||
                ev.currentTarget
                  ?.closest(`[elem_type=form]`)
                  ?.getAttribute("frameindex");
      
              let parentStep =
                (ev.currentTarget.closest(`[elem_type=Step]`) &&
                  ev.currentTarget
                    .closest(`[elem_type=Step]`)
                    .getAttribute("frameindex")) ||
                (ev.currentTarget.closest(`[elem_type=SubStep]`) &&
                  ev.currentTarget
                    .closest(`[elem_type=SubStep]`)
                    .getAttribute("frameindex")) ||
                "";
              let parentSubStep =
              (ev.currentTarget.closest(`[elem_type=SubStep]`) &&
                ev.currentTarget
                  .closest(`[elem_type=SubStep]`)
                  .getAttribute("substepindex")) ||
              (ev.currentTarget.closest(`[elem_type=SubStep]`) &&
                ev.currentTarget
                  .closest(`[elem_type=SubStep]`)
                  .getAttribute("elementindex")) ||
              "";

              if (parentWizard(ev)) {
                if (parentStep !== null) {
                  targetElemState["parentStep"] = parentStep;
                  targetElemState["insideWizard"] = parentWizard(ev);
                  targetElemState["stepIndex"] = parentStep;
                  targetElemState["subStepIndex"] = parentSubStep;
                  targetElemState["parentSubStep"] = parentSubStep;
                }
              } else if (parentMenu()) {
                targetElemState["insideMenu"] = parentMenu();
                if (
                  openCanvasForSubform === "subform" &&
                  currentButtonForSubform.current?.containerControl === "Menu"
                ) {
                  targetElemState.stepIndex =
                    currentButtonForSubform.current?.stepIndex ||
                    currentButtonForSubform.current?.stepIndex === 0
                      ? currentButtonForSubform.current?.stepIndex
                      : "-1";
                  targetElemState.substepIndex =
                    currentButtonForSubform.current?.subStepIndex ||
                    currentButtonForSubform.current?.subStepIndex === 0
                      ? currentButtonForSubform.current?.subStepIndex
                      : "-1";
                  targetElemState.subChildMenuIndex =
                    currentButtonForSubform.current?.subChildMenuIndex ||
                    currentButtonForSubform.current?.subChildMenuIndex === 0
                      ? currentButtonForSubform.current?.subChildMenuIndex
                      : "-1";
                } else {
                  targetElemState["substepIndex"] = document
                    .querySelector(".menuMain_Id")
                    .getAttribute("substepIndex");
                  targetElemState["subChildMenuIndex"] = document
                    .querySelector(".menuMain_Id")
                    .getAttribute("subChildMenuIndex");
                  targetElemState["stepIndex"] = document
                    .querySelector(".menuMain_Id")
                    .getAttribute("stepIndex");
                }
              }
              console.log("parentStep", parentStep);
              targetElemState["isSubForm"] = isSubForm;
              targetElemState["isAdvanceListview"] = isAdvanceListview;
              targetElemState["targetId"] = data.id;
              extraDetails["isSubForm"] = isSubForm;
              extraDetails["isAdvanceListview"] = isAdvanceListview;
      
              if (
                sheetData?.sheetIndex !== undefined ||
                sheetData?.sheetIndex !== ""
              ) {
                targetElemState["sheetIndex"] = sheetData?.sheetIndex;
                targetElemState["elementIndex"] = sheetData?.elementIndex;
              } else {
                delete targetElemState.sheetIndex;
              }
          var evee = ev
          var targetElemState2 = targetElemState
          for (let childControl of copyElement?.current?.children) {
            if(targetElemState2?.targetId?.includes("column")){
              if(childControl?.containerControl === "wizard_h" || childControl?.containerControl === "wizard_v" || childControl?.containerControl === "sidenavigation"){
                targetElemState2.parentSubStep = childControl?.subStepIndex
                targetElemState2.parentStep = childControl?.stepIndex
                targetElemState2.stepIndex = childControl?.stepIndex
                targetElemState2.subStepIndex = childControl?.subStepIndex
              }
              if(childControl?.containerControl?.toLowerCase() === "menu"){
                targetElemState2.childMenuIndex = childControl?.childMenuIndex
                targetElemState2.subChildMenuIndex = childControl?.subChildMenuIndex
                targetElemState2.stepIndex = childControl?.stepIndex
                targetElemState2.subStepIndex = childControl?.subStepIndex
              }
              let frameId ;
              if(targetElemState2.targetId){
                frameId = document.getElementById(targetElemState2?.targetId)?.closest(`[elem_type=frame]`)?.getAttribute('id');
              }
              const populateInside = {
                id: frameId,
                elem_type : parentWizard(ev) ? formState2.containerControl : "frame",
                elementIndex: data?.elementIndex,
                frameIndex: frameIndexget === null ? data?.frameIndex :frameIndexget,
                isSubForm: openCanvasForSubform === "subform",
                isAdvanceListview: openCanvasForSubform === "advanceListviewFromScratch"
              };
              let payload = {
                populateInside: parentWizard(ev)
                  ? {
                      ...populateInside,
                      stepIndex:openCanvasForSubform === "subform"?  currentButtonForSubform?.stepIndex : openCanvasForSubform === "advanceListviewFromScratch" ? currentadvanceListview?.stepIndex : getStepIndex(),
                      subStepIndex:openCanvasForSubform === "subform"? currentButtonForSubform?.subStepIndex : openCanvasForSubform === "advanceListviewFromScratch" ? currentadvanceListview?.subStepIndex : getSubStepIndex(),
                      subChildMenuIndex:openCanvasForSubform === "subform"? currentButtonForSubform?.subChildMenuIndex : openCanvasForSubform === "advanceListviewFromScratch" ? currentadvanceListview?.subChildMenuIndex : getSubChildMenuIndex()
                    }
                  : data?.sheetId
                  ? {
                      ...populateInside,
                      sheetElementIndex: data?.sheetElementIndex,
                      sheetId: data?.sheetId
                    }
                  : populateInside,
                populateElem: { ...childControl, elem_type: childControl?.elem_type === "advancelistView" ? "advancelistview" : childControl?.elem_type}
              };
              try {
                let response = await sendRequestForControl(
                  frameIndexget === null ? childControl?.frameIndex :frameIndexget,
                  childControl?.elem_type?.toLowerCase() ===  "listview" || childControl?.elem_type?.toLowerCase() ===  "advancelistview"? "import" : "add",
                  childControl?.controlName ? childControl?.controlName :childControl?.elem_type,
                  childControl?.elem_type?.toLowerCase() ===  "listview" || childControl?.elem_type?.toLowerCase() ===  "advancelistview" ?  payload : targetElemState2,
                  extraDetails
                )
                await xyz2(response, jsonObj, evee, formstate, targetElemState2, childControl, subFormJSON);
              } catch(error) {
                setAlertData({
                  open: true,
                  showConfirm: "showNotification",
                  alertType: "error",
                  alertContentKey: `${t('Invalid_Operation')}`
                });
              }
            }
            
            else{
              setCurrentDataObjectJson(cloneDeep({}));
              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                autoHideDuration: 3000,
                alertContentKey: "Please select a column before pasting",
              });
            }
          }
        }
      }
      else{
        console.log(copyElement, "dfvfvgsdfd===>>", charCode);
        if (Object.keys(copyElement?.current).length > 0 && !openQuickToolFor?.current) {
          var jsonObj = {};
          var extraDetails = {};
          let isSubForm = false;
          if (openCanvasForSubform === "subform") {
            isSubForm = true;
          }
          let isAdvanceListview = false;
          if (openCanvasForSubform === "advanceListviewFromScratch") {
            isAdvanceListview = true;
          }
          const parentWizard = (eve) => {
            if (
              eve?.currentTarget?.closest(`[elem_type=wizard_v]`) ||
              eve?.currentTarget?.closest(`[elem_type=wizard_h]`) ||
              (eve?.currentTarget?.closest(`[elem_type=sidenavigation]`) &&
                !eve?.currentTarget?.closest(`[elem_type=tab]`)) ||
              (openCanvasForSubform === "subform" &&
                currentButtonForSubform.current?.containerControl ===
                  "wizard_h") ||
              (openCanvasForSubform === "subform" &&
                currentButtonForSubform.current?.containerControl ===
                  "wizard_v") ||
              (openCanvasForSubform === "subform" &&
                currentButtonForSubform.current?.containerControl ===
                  "sidenavigation")
            ) {
              return true;
            } else {
              return false;
            }
          };

          const parentMenu = () => {
            if (
              ev?.currentTarget?.closest(`[elem_type=Menu]`) ||
              (openCanvasForSubform === "subform" &&
                currentButtonForSubform.current?.containerControl === "Menu")
            ) {
              return true;
            } else {
              return false;
            }
          };
          const frameIndexget =
            ev.currentTarget
              ?.closest(`[elem_type=frame]`)
              ?.getAttribute("frameindex") ||
            ev.currentTarget
              ?.closest(`[elem_type=section]`)
              ?.getAttribute("frameindex") ||
            ev.currentTarget
              ?.closest(`[elem_type=form]`)
              ?.getAttribute("frameindex");

          let parentStep =
            (ev.currentTarget.closest(`[elem_type=Step]`) &&
              ev.currentTarget
                .closest(`[elem_type=Step]`)
                .getAttribute("frameindex")) ||
            (ev.currentTarget.closest(`[elem_type=SubStep]`) &&
              ev.currentTarget
                .closest(`[elem_type=SubStep]`)
                .getAttribute("frameindex")) ||
            "";

          let parentSubStep =
          (ev.currentTarget.closest(`[elem_type=SubStep]`) &&
            ev.currentTarget
              .closest(`[elem_type=SubStep]`)
              .getAttribute("substepindex")) ||
          (ev.currentTarget.closest(`[elem_type=SubStep]`) &&
            ev.currentTarget
              .closest(`[elem_type=SubStep]`)
              .getAttribute("elementindex")) ||
          "";

          if (parentWizard(ev)) {
            if (parentStep !== null) {
              targetElemState["parentStep"] = parentStep;
              targetElemState["insideWizard"] = parentWizard(ev);
              targetElemState["stepIndex"] = copyElement.current.stepIndex;
              targetElemState["subStepIndex"] = copyElement.current.subStepIndex;
              targetElemState["parentSubStep"] = copyElement.current.subStepIndex;
            }
          } else if (parentMenu()) {
            targetElemState["insideMenu"] = parentMenu();
            if (
              openCanvasForSubform === "subform" &&
              currentButtonForSubform.current?.containerControl === "Menu"
            ) {
              targetElemState.stepIndex =
                currentButtonForSubform.current?.stepIndex ||
                currentButtonForSubform.current?.stepIndex === 0
                  ? currentButtonForSubform.current?.stepIndex
                  : "-1";
              targetElemState.substepIndex =
                currentButtonForSubform.current?.subStepIndex ||
                currentButtonForSubform.current?.subStepIndex === 0
                  ? currentButtonForSubform.current?.subStepIndex
                  : "-1";
              targetElemState.subChildMenuIndex =
                currentButtonForSubform.current?.subChildMenuIndex ||
                currentButtonForSubform.current?.subChildMenuIndex === 0
                  ? currentButtonForSubform.current?.subChildMenuIndex
                  : "-1";
            } else {
              targetElemState["substepIndex"] = document
                .querySelector(".menuMain_Id")
                .getAttribute("substepIndex");
              targetElemState["subChildMenuIndex"] = document
                .querySelector(".menuMain_Id")
                .getAttribute("subChildMenuIndex");
              targetElemState["stepIndex"] = document
                .querySelector(".menuMain_Id")
                .getAttribute("stepIndex");
            }
          }
          console.log("parentStep", parentStep);
          targetElemState["isSubForm"] = isSubForm;
          targetElemState["isAdvanceListview"] = isAdvanceListview;
          targetElemState["targetId"] = data.id;
          extraDetails["isSubForm"] = isSubForm;
          extraDetails["isAdvanceListview"] = isAdvanceListview;

          if (
            sheetData?.sheetIndex !== undefined ||
            sheetData?.sheetIndex !== ""
          ) {
            targetElemState["sheetIndex"] = sheetData?.sheetIndex;
            targetElemState["elementIndex"] = sheetData?.elementIndex;
          } else {
            delete targetElemState.sheetIndex;
          }
        if(targetElemState?.targetId?.includes("column")){
        let frameId = document.getElementById(targetElemState?.targetId)?.closest(`[elem_type=frame]`)?.getAttribute('id');
        if(document.getElementById(targetElemState?.targetId)?.closest(`[elem_type=tab]`))
            frameId = document.getElementById(targetElemState?.targetId)?.closest(`[elem_type=tab]`)?.getAttribute('parentframeid');
          const populateInside = {
            id: frameId,
            elem_type : parentWizard(ev) ? formState2.containerControl : "frame",
            elementIndex: data?.elementIndex,
            frameIndex: frameIndexget === null ? data?.frameIndex :frameIndexget,
            isSubForm: openCanvasForSubform === "subform",
            isAdvanceListview: openCanvasForSubform === "advanceListviewFromScratch"
          };
          let payload = {
            populateInside: parentWizard(ev)
              ? {
                  ...populateInside,
                  stepIndex:openCanvasForSubform === "subform"?  currentButtonForSubform?.stepIndex : openCanvasForSubform === "advanceListviewFromScratch" ? currentadvanceListview?.stepIndex : getStepIndex(),
                  subStepIndex:openCanvasForSubform === "subform"? currentButtonForSubform?.subStepIndex : openCanvasForSubform === "advanceListviewFromScratch" ? currentadvanceListview?.subStepIndex : getSubStepIndex(),
                  subChildMenuIndex:openCanvasForSubform === "subform"? currentButtonForSubform?.subChildMenuIndex : openCanvasForSubform === "advanceListviewFromScratch" ? currentadvanceListview?.subChildMenuIndex : getSubChildMenuIndex()
                }
              : data?.sheetId
              ? {
                  ...populateInside,
                  sheetElementIndex: data?.sheetElementIndex,
                  sheetId: data?.sheetId
                }
              : populateInside,
            populateElem: {...copyElement.current, elem_type: copyElement?.current?.elem_type === "advancelistView" ? "advancelistview" : copyElement?.current?.elem_type}
          };
          sendRequestForControl(
            frameIndexget === null ? data?.frameIndex :frameIndexget,
            copyElement.current?.elem_type?.toLowerCase() ===  "listview" || copyElement.current?.elem_type?.toLowerCase() ===  "advancelistview"? "import" : "add",
            copyElement.current?.controlName ? copyElement.current?.controlName :copyElement.current?.elem_type,
            copyElement.current?.elem_type?.toLowerCase() ===  "listview" || copyElement.current?.elem_type?.toLowerCase() ===  "advancelistview" ?  payload : targetElemState,
            extraDetails
          )
            .then( async (response) => {
              // if(response.status ===  200) {
              // var controlElemToAdd;
              // controlElemToAdd = response.data;
              if(response.status ===  200) {
                var controlElemToAdd;
                if(copyElement.current?.elem_type?.toLowerCase() ===  "listview" || copyElement.current?.elem_type?.toLowerCase() ===  "advancelistview")
                  response.data = {...response.data.populatedJson};
                controlElemToAdd = {...response.data};

              if(controlElemToAdd?.controlName==="doclist"){
                
                var controlElemToAdd_copy = response.data;
                // controlElemToAdd_copy = Object.assign(controlElemToAdd_copy, copyElement.current);
                // controlElemToAdd_copy = {...copyElement.current};

                // controlElemToAdd_copy.id= response.data.id;
                // controlElemToAdd_copy.frameIndex= response.data.frameIndex;
                // controlElemToAdd_copy.elementIndex= response.data.elementIndex;
                controlElemToAdd_copy.style= {...copyElement.current?.style};
                controlElemToAdd_copy.mappingJson= {...copyElement.current?.mappingJson};
                controlElemToAdd_copy.json= {...copyElement.current?.json};
                var controlElemToAdd_docs = []; 
                copyElement.current.documents?.forEach((doc)=>{
                  controlElemToAdd_docs.push(doc);
                });

                controlElemToAdd_copy.documents= controlElemToAdd_docs;

                controlElemToAdd_copy.style.DocumentLabel = response.data.id;
                controlElemToAdd_copy.style.Label = response.data.id;

                controlElemToAdd = {...controlElemToAdd_copy};
                response.data= {...controlElemToAdd_copy};
              }
              else  if(response.data.elem_type === "button" && copyElement?.current?.subform){
                let jsonObj = {formBuffer: JSON.stringify(copyElement?.current?.subform)};
                let zip = new JSZip();
                zip.file(`${controlElemToAdd.id}.json`, JSON.stringify(jsonObj));
                const zipBlob = await zip.generateAsync({ type: "blob" });
                // zip.generateAsync({ type: "blob" }).then(async function (content) {
                  var formDataSub = new FormData();
                  const uploadZip1 = new Blob([zipBlob], { type: "application/x-zip-compressed" });
                  formDataSub.append("file", uploadZip1);
                  let formId = getFormId();
                  let populateInside = {
                    frameIndex: controlElemToAdd?.frameIndex,
                    elementIndex: controlElemToAdd?.elementIndex,
                    sheetElementIndex: controlElemToAdd?.sheetElementIndex,
                    sheetFrameElementIndex:
                      controlElemToAdd?.sheetFrameElementIndex,
                    sheetId: controlElemToAdd?.sheetIndex,
                    stepIndex: controlElemToAdd?.stepIndex,
                    subStepIndex: controlElemToAdd?.subStepIndex,
                    subChildMenuIndex: controlElemToAdd?.subChildMenuIndex,
                    formId: formId?.toString(),
                  };
  
                  formDataSub.append(
                    "populateInsideJson",
                    JSON.stringify(populateInside)
                  );
                    try {
                      let responseSub = await axios
                      .post("/idesign/populateSubformFromJsoninFile", formDataSub, {
                        withCredentials: true,
                        headers: {
                          "Content-Type": "multipart/form-data",
                        },
                      });
                        let data = responseSub.data;
                        let _alert = data.alert;
                        if (_alert) {
                        } else {
                          let populatedJson = data;
                          // loading(true);
                          if (
                            populatedJson !== null &&
                            populatedJson !== undefined
                          ) {
                          if (responseSub?.data?.formBuffer) { 
                            controlElemToAdd["subform"] = JSON.parse(responseSub?.data?.formBuffer);
                            controlElemToAdd["subform"]["id"] = controlElemToAdd?.id
                            controlElemToAdd["selectedEvent"] = "subform";
                            updateRowNColumn(controlElemToAdd["subform"]);
                            // updatedComponentInFormState(controlElemToAdd.id, controlElemToAdd);
                            // loading(false);
                          }
                        }
                      }
                    }
                    catch(err) {
                      if(err?.responseSub?.data?.errorcode === "-5001") {
                        setAlertData({
                          open: true,
                          showConfirm: "showNotification",
                          alertType: "error",
                          alertContentKey: "Adv_not_allowd_in_btn_subform",
                          autoHideDuration: 4000
                        });
                      } else {
                        setAlertData({
                          open: true,
                          showConfirm: "showNotification",
                          alertType: "error",
                          alertContentKey: "UploadSubFormFailureMessage",
                          autoHideDuration: 4000
                        });
                      }
                      console.error("Error :: ", err);
                    }
              }
              else  if(response.data.elem_type === "listview" && copyElement?.current?.listviewFrameLayoutJson){
                // controlElemToAdd.listviewFrameLayoutJson = copyElement?.current?.listviewFrameLayoutJson
                updateRowNColumn(controlElemToAdd.listviewFrameLayoutJson)
              }
              else  if(response.data.elem_type === "advancelistview" && copyElement?.current?.listviewFrameLayoutJson){
                // controlElemToAdd.listviewFrameLayoutJson = copyElement?.current?.listviewFrameLayoutJson
                updateRowNColumn(controlElemToAdd.listviewFrameLayoutJson)
              }
          //       if(response.data.elem_type === "table" || response.data.elem_type === "listview" || response.data.elem_type === "advancelistview"){
          //         const parentWizard = (controlId) => { 
          //           if ( document .getElementById(`${controlId}`) ?.closest(`[elem_type=wizard_v]`) || document .getElementById(`${controlId}`) ?.closest(`[elem_type=wizard_h]`) || (document .getElementById(`${controlId}`) ?.closest(`[elem_type=sidenavigation]`) && !document.getElementById(`${controlId}`)?.closest(`[elem_type=tab]`)) ) 
          //           { return true; } else 
          //           { return false; } }; 
                    
          //           const parentMenuCheck = (controlId) => { 
          //             if (document.getElementById(`${controlId}`)?.closest(`[elem_type=Menu]`)) { 
          //               return true; 
          //             } else { 
          //               return false; 
          //             } }; 
                      
          //             const parentTab = (controlId) => { 
          //               if (document.getElementById(`${controlId}`)?.closest(`[elem_type=tab]`)) { 
          //                 return true; 
          //               } else { 
          //                 return false; 
          //               } };
          //         let remainingURL;
          // let stepIndex;
          // let subStepIndex;
          // let subChildMenuIndex;
          // let isMenu = document
          //   .querySelector(`#${response.data.id}`)
          //   ?.closest(`[elem_type=Menu]`);
          // let isWizard = document
          //   .querySelector(`#${response.data.id}`)
          //   ?.closest(`[elem_type=Menu]`);
          // if (formState2?.isStep && formState2?.isStep?.insideWizard) {
          //   remainingURL = "/Properties/addColumnInStep";
          //   stepIndex = document
          //     .querySelector(`#${response.data.id}`)
          //     ?.closest(`main`)
          //     ?.getAttribute("stepIndex");
          //   subStepIndex = document
          //     .querySelector(`#${response.data.id}`)
          //     ?.closest(`main`)
          //     ?.getAttribute("substepindex");
          //   subChildMenuIndex = document
          //     .querySelector(`#${response.data.id}`)
          //     ?.closest(`main`)
          //     ?.getAttribute("subchildmenuindex");
          // } else if (isMenu) {
          //   stepIndex = document
          //     .querySelector(`#${response.data.id}`)
          //     ?.closest(`main`)
          //     ?.getAttribute("stepIndex");
          //   subStepIndex = document
          //     .querySelector(`#${response.data.id}`)
          //     ?.closest(`main`)
          //     ?.getAttribute("substepindex");
          //   subChildMenuIndex = document
          //     .querySelector(`#${response.data.id}`)
          //     ?.closest(`main`)
          //     ?.getAttribute("subchildmenuindex");
          //   remainingURL = "/Properties/addColumnInStep";
          // } else {
          //   remainingURL = "/Properties/addColumn";
          // }
          // if (parentWizard(response.data.id)) {
          //   response.data.insideWizard = true;
          //   response.data.parentStep = formState2?.isStep?.parentStep;
          //   response.data.parentSubStep = formState2?.isStep?.parentSubStep;
          //   response.data.subChildMenuIndex = subChildMenuIndex;
          // }
          // if (parentMenuCheck(response.data.id)) {
          //   let stepIndex = document
          //     .getElementById(`${response.data.id}`)
          //     .closest("main")
          //     .getAttribute("stepindex");
          //   let subStepIndex = document
          //     .getElementById(`${response.data.id}`)
          //     .closest("main")
          //     .getAttribute("substepindex");
          //   let subChildMenuIndex = document
          //     .getElementById(`${response.data.id}`)
          //     .closest("main")
          //     .getAttribute("subchildmenustepindex");
          //   response.data.insideMenu = true;
          //   response.data.stepIndex = stepIndex;
          //   response.data.subChildMenuIndex = subStepIndex;
          //   response.data.subStepIndex = subChildMenuIndex;
          // }
          // if (parentTab(response.data.id)) {
          //   response.data.insideTab = true;
          // }
          //         let columnList = []; 
          //         for (let item of copyElement.current.columnList) 
          //         { 
          //           let styleObj = item.style; 
          //           styleObj["FormId"] = `${ microFrontendData?.formDefId || activePage?.formId || activeSubForm?.fragmentId || microFrontendData?.formId }`; 
          //           styleObj["frameIndex"] = response.data.frameIndex; styleObj["elementIndex"] = response.data.elementIndex; 
          //           styleObj["elem_type"] = "column"; styleObj["stepIndex"] = formState2?.isStep?.parentStep || stepIndex || -1; 
          //           styleObj["subStepIndex"] = formState2?.isStep?.parentSubStep || -1; 
          //           styleObj["subChildMenuIndex"] = subChildMenuIndex || subChildMenuIndex == 0 ? subChildMenuIndex : "-1"; 
          //           columnList.push(item.style); 
          //         }
    
    
          //           let type = 1; 
          //           if (formState2?.isStep?.insideWizard) { 
          //             type = 3;
          //           } 
          //           if (parentMenuCheck(response.data.id)) { 
          //             type = 4; 
          //           } 
          //           if (parentTab(response.data.id)) {
          //             type = 4; 
          //             } 
          //           let columnJson = { columns: [...columnList], type: type,controlid:response.data.id }; 
          //           let addedColumnResponse = await axios.post("Properties/addColumnsInTable", columnJson, { withCredentials: true, }) 
          //           let requiredColumns = []
          //           for(let col in columnList){
          //             let obj = {};
          //             // obj = { ...addedColumnResponse.data[col]?.body,...columnList[col]}
          //             obj = { ...addedColumnResponse.data[col]?.body,style:{...columnList[col]}}
          //             requiredColumns.push(obj)
          //           }
          //           console.log("columnResponse", response); 
          //           controlElemToAdd.columnList = [];
          //           controlElemToAdd.columnList = [...requiredColumns]
    
          //       }

                if(response.data.elem_type === "report"){
                  controlElemToAdd["selectId"] = copyElement.current["selectId"];
                }
    
              controlElemToAdd["style"] = {
                ...copyElement.current["style"],
              };
              // controlElemToAdd["style"].Label = copyElement.current?.dataclass ? copyElement.current?.dataclass : copyElement.current?.Label;

              if(copyElement?.current?.event){
                controlElemToAdd.event = {...copyElement?.current?.event}
                controlElemToAdd.eventsInArray = {...copyElement?.current?.eventsInArray}
              }

              if(copyElement?.current?.dataclass){
                controlElemToAdd.dataclass = copyElement?.current?.dataclass
                controlElemToAdd.datamapPercision = copyElement?.current?.datamapPercision
                controlElemToAdd.datamapVariableLength = copyElement?.current?.datamapVariableLength
                controlElemToAdd.datamapVariableType = copyElement?.current?.datamapVariableType
              }
              if (copyElement?.current?.marvin !== undefined) {
                controlElemToAdd.marvin = copyElement.current.marvin;
              }

              if(copyElement?.current?.columnList){
                controlElemToAdd.columnList = copyElement.current.columnList
              }

              if(copyElement?.current?.unBounded){
                controlElemToAdd["unBounded"] = copyElement.current.unBounded
              }

              if(copyElement?.current?.TypeOfValue){
                controlElemToAdd["TypeOfValue"] = copyElement.current.TypeOfValue
              }

              if(copyElement.current?.options){
                controlElemToAdd["options"] = [
                  ...copyElement.current["options"],
                ];
              }
    
              if (openCanvasForSubform === "subform") {
                jsonObj = createSmartFormState(
                  subFormJSON,
                  data.id,
                  data.elem_type,
                  controlElemToAdd.controlName === "password" &&
                  controlElemToAdd.elem_type === "textbox"
                  ? "textbox"
                  : copyElement.current.elem_type,
                  0,
                  frameIndexget,
                  controlElemToAdd,
                  targetElemState.targetRowId,
                  targetElemState.targetColId,
                  device
                );
              } else if (
                openCanvasForSubform === "advanceListviewFromScratch"
              ) {
                jsonObj = createSmartFormState(
                  fetchGridStates().advanceListviewStateJson,
                  data.id,
                  data.elem_type,
                  controlElemToAdd.controlName === "password" &&
                  controlElemToAdd.elem_type === "textbox"
                  ? "textbox"
                  : copyElement.current.elem_type,
                  0,
                  frameIndexget,
                  controlElemToAdd,
                  targetElemState.targetRowId,
                  targetElemState.targetColId,
                  device
                );
              } else {
                if(controlElemToAdd?.controlName==="doclist"){
                
                  var controlElemToAdd_copy = response.data;
                  // controlElemToAdd_copy = Object.assign(controlElemToAdd_copy, copyElement.current);
                  // controlElemToAdd_copy = {...copyElement.current};
  
                  // controlElemToAdd_copy.id= response.data.id;
                  // controlElemToAdd_copy.frameIndex= response.data.frameIndex;
                  // controlElemToAdd_copy.elementIndex= response.data.elementIndex;
                  controlElemToAdd_copy.style= {...copyElement.current.style};
                  controlElemToAdd_copy.mappingJson= {...copyElement.current.mappingJson};
                  controlElemToAdd_copy.json= {...copyElement.current.json};
                  var controlElemToAdd_docs = []; 
                  copyElement.current.documents.forEach((doc)=>{
                    controlElemToAdd_docs.push(doc);
                  });
  
                  controlElemToAdd_copy.documents= controlElemToAdd_docs;
  
                  controlElemToAdd_copy.style.DocumentLabel = response.data.id;
                  controlElemToAdd_copy.style.Label = response.data.id;
  
                  controlElemToAdd = {...controlElemToAdd_copy};
                  response.data= {...controlElemToAdd_copy};
                }
                // else  if(response.data.elem_type === "button" && copyElement?.current?.subform){
                //   controlElemToAdd.subform = copyElement?.current?.subform
                //   updateRowNColumn(controlElemToAdd.subform)
                // }
                // else  if(response.data.elem_type === "listview" && copyElement?.current?.listviewFrameLayoutJson){
                //   controlElemToAdd.listviewFrameLayoutJson = copyElement?.current?.listviewFrameLayoutJson
                //   updateRowNColumn(controlElemToAdd.listviewFrameLayoutJson)

                // }
                // else  if(response.data.elem_type === "advancelistview" && copyElement?.current?.listviewFrameLayoutJson){
                //   controlElemToAdd.listviewFrameLayoutJson = copyElement?.current?.listviewFrameLayoutJson
                //   updateRowNColumn(controlElemToAdd.listviewFrameLayoutJson)

                // }

                jsonObj = createSmartFormState(
                  formstate,
                  data.id,
                  data.elem_type,
                  controlElemToAdd.controlName === "password" &&
                  controlElemToAdd.elem_type === "textbox"
                  ? "textbox"
                  : copyElement.current.elem_type,
                  0,
                  frameIndexget,
                  controlElemToAdd,
                  targetElemState.targetRowId,
                  targetElemState.targetColId,
                  device
                );
              }
              // jsonObj = createSmartFormState(
              //   formstate,
              //   data.id,
              //   data.elem_type,
              //   controlElemToAdd.controlName === "password" &&
              //     controlElemToAdd.elem_type === "textbox"
              //     ? "textbox"
              //     : copyElement.current.elem_type,
              //   0,
              //   frameIndexget,
              //   controlElemToAdd,
              //   targetElemState.targetRowId,
              //   device
              // );
              targetElemState = {}
              setCurrElem("")
              if (openCanvasForSubform === "subform") {
                setSubFormState({ ...jsonObj });
              } else if (
                openCanvasForSubform === "advanceListviewFromScratch"
              ) {
                dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj }, renderCanvas:true}));
              } else {
                setFormState2({ ...jsonObj });
              }
              }
              else if(response.data.status === 1){
                showAlertConfirmNotifications({
                  open: true,
                  showConfirm: "showNotification",
                  alertType: "error",
                  alertContentKey:`${t("Reopen_Form")}`,
                });
              }
              else {
                setAlert({
                  open: true,
                  severity: "error",
                  severityMessage: "Something went wrong",
                });
              }
              setCurrentDataObjectJson(cloneDeep({}));
            })
            .catch((error) => {
              loading(false)
              setAlertData({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: `${t('Invalid_Operation')}`
              });
            })
            .catch((err) => {
            setOpenLoader(false);
            loading(false)
            setGlobalLoading(false)
            setGlobalLoadingMessage("")

            if(err?.response?.data?.error === "Can't upload advance listview or frame which contains advance listview inside a subform") {
              setAlertData({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: "Advance Listview cannot be imported in button subform",
                autoHideDuration: 4000
              });
            }
            console.log("UploadItem", err);
          });
          console.log(data, 'elseeeeeeeeee',copyElement,"targetElemState",frameIndexget)
        }
        else{
          setCurrentDataObjectJson(cloneDeep({}));
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            autoHideDuration: 3000,
            alertContentKey: "Please select a column before pasting",
          });
        }
        } else {
          setAlert({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            autoHideDuration: 3000,
            alertContentKey: "Please copy controls",
          });
        }
      }
    }

    var flag23 = 0;
    var selectedControlStyle = {};
    var selectedID = "";
    if (typeof ev !== "string") {
      if (ev.target.getAttribute("control_id") !== null) {
        if (ev.target.getAttribute("id") !== null) {
          if (ev.target.getAttribute("id").includes("before_frame")) {
            flag23 = 1;
          }
        }
      }
      if (ev.target.getAttribute("control_id") !== null) {
        if (flag23 === 1) {
          selectedID = "RootControl";
        } else {
          selectedID = ev.target.getAttribute("newControlId") || ev.target.getAttribute("control_id");
        }
      } else if (data?.id?.includes("table")) {
        selectedID = data?.id;
      } 
      else if(data?.id?.includes("row")){
        selectedID = data?.id
      }
      else if ($(ev.target).parent().attr("control_id") !== null) {
        selectedID = $(ev.target).parent().attr("newControlId") || $(ev.target).parent().attr("control_id");
        if (selectedID === null || selectedID === undefined) {
          selectedID = ev.target.getAttribute("elem_type");
        }
      } else {
        selectedID = ev.target.getAttribute("newControlId") || ev.target.getAttribute("control_id");
      }
      if(!selectedID && data?.elem_type === "paragraph") {
        selectedID = ev.currentTarget.getAttribute("control_id");
      }
      if (!selectedID || selectedID === null) {
        return;
      }
    }

    if (
      selectedID === "design_page" ||
      selectedID === "FormDef" ||
      selectedID === "RootControl" ||
      selectedID === "form"
    ) {
      selectedID = "FormDef";
      setSelectedControl(formstate);
      setShowProperties(true);
      // return;
    } else if (selectedID === "LoginHeader") {
      selectedID = "LoginHeader";
      setSelectedControl(headerJSON);
      setShowProperties(true);
      // return;
    } else {
      recursiveJsonReader(
        formstate,
        selectedID,
        ev.target.getAttribute("elem_type")
      );
    }

    if (openCanvasForSubform === "subform") {
      if (
        selectedID === "design_page" ||
        selectedID === "FormDef" ||
        selectedID === "RootControl"
      ) {
        selectedID = "FormDef";
        setSelectedControl(subFormStateJson.current);
        window.selectedControlId_function({...(currentButtonForSubform.current || {}), isButtonProperties: true});
        // setShowProperties(true);
        return;
      } else {
        recursiveJsonReader(
          subFormStateJson.current,
          selectedID,
          ev.target.getAttribute("elem_type")
        );
      }
    }
    if (openCanvasForSubform === "advanceListviewFromScratch") {
      if (
        selectedID === "design_page" ||
        selectedID === "FormDef" ||
        selectedID === "RootControl"
      ) {
        selectedID = "FormDef";
        setSelectedControl(fetchGridStates().advanceListviewStateJson);
        setShowProperties(true);
        window.selectedControlId_function(currentadvanceListview.current);
        return;
      } else {
        recursiveJsonReader(
          fetchGridStates().advanceListviewStateJson,
          selectedID,
          ev.target.getAttribute("elem_type")
        );
      }
    }
    if (openCanvasForSubform === "showDataAdditonSection") {
      if (
        selectedID === "design_page" ||
        selectedID === "FormDef" ||
        selectedID === "RootControl" ||
        (selectedID && selectedID.includes("_frameLV"))
      ) {
        selectedID = "FormDef";
        setSelectedControl(currentListviewForSubform);
        setShowProperties(true);
        window.selectedControlId_function(currentListviewForSubform);
        return;
      } else {
        recursiveJsonReader(
          currentListviewForSubform?.listviewFrameLayoutJson,
          selectedID,
          ev.target.getAttribute("elem_type")
        );
        if (
          selectedControl?.current?.elem_type === "column" ||
          selectedControl?.current?.elem_type === "row" ||
          selectedControl?.current?.elem_type === "frame"
        ) {
          selectedID = "FormDef";
          setSelectedControl(currentListviewForSubform);
          setShowProperties(true);
          window.selectedControlId_function(currentListviewForSubform);
        }
      }
    }

    window.selectedControlId_function(selectedControl.current, selectedID);
  }

  function hideProperties() {
    setShowProperties(false);
  }

  const cols_css = {
    paddingLeft: "0px",
    paddingRight: "0px",
  };

  const [customControlIdList, setCustomControlIdList] = useState([]);

  // function collectAllCustomControlId(formJsonData){
  //     try {
  //         if(Array.isArray(formJsonData)){
  //             formJsonData.map((item,index)=>{
  //                     if(item["id"]){
  //                         setCustomControlIdList(prev=> [...prev,item["id"]]);
  //                         addToAlreadyCreatedId(item['id']);
  //                     }
  //                     if(Object.keys(item).includes("children")){
  //                         collectAllCustomControlId(item);
  //                     }
  //             })
  //         } else{
  //                 if(formJsonData["id"]){
  //                     setCustomControlIdList(prev=> [...prev,formJsonData["id"]]);
  //                     addToAlreadyCreatedId(formJsonData["id"]);
  //                 }
  //                 if(formJsonData["children"]){
  //                     collectAllCustomControlId(formJsonData["children"]);
  //                 }
  //         }
  //     }
  //     catch(error) {console.log("Error while collecting custom control id.::"+error);
  //         // alert("Error while collecting custom control id.::"+error);
  //     }
  // }

  function collectAllCustomControlId(formJsonData) {
    const idsList = [];

    function inner(data) {
      try {
        if (Array.isArray(data)) {
          data.map((item, index) => {
            if (item["id"]) {
              idsList.push(item["id"]);
              addToAlreadyCreatedId(item["id"]);
            }
            if (Object.keys(item).includes("children")) {
              inner(item);
            }
          });
        } else {
          if (data["id"]) {
            idsList.push(data["id"]);
            addToAlreadyCreatedId(data["id"]);
          }
          if (data["children"]) {
            inner(data["children"]);
          }
        }
      } catch (error) {
        console.log("Error while collecting custom control id.::" + error);
      }
    }

    inner(formJsonData);
  }

  function handleCustomControlId(controlId, customControlId) {
    try {
      if (
        customControlIdList &&
        formState2 &&
        customControlIdList !== null &&
        formState2 !== null
      ) {
        if (customControlIdList.includes(customControlId)) {
          //customalert
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: `Entered custom control id ${currElemState.current} already exist.`,
          });
          // alert("Entered custom control id ' "+customControlId+" ' already exist.");
        } else if (!customControlIdList.includes(customControlId)) {
          setCustomControlIdList(
            customControlIdList.filter(
              (id) => id !== controlId && id !== customControlId
            )
          );
          updateControlIdUsingCustomControlId(
            formState2,
            controlId,
            customControlId
          );
        }
      }
    } catch (error) {
      // alert("Error while collecting custom control id.::" + error);
    }
  }

  function updateControlIdUsingCustomControlId(
    jsonData,
    existingControlId,
    newControlId
  ) {
    if (jsonData && jsonData !== null) {
      if (Array.isArray(jsonData)) {
        jsonData.map((item, index) => {
          if (item["id"] === existingControlId) {
            item["id"] = newControlId;
            setSelectedControl(item);
            window.selectedControlId_function(item);

            setShowProperties(true);
            setShowDataAdditionSection(false);
            return true;
          }
          if (Object.keys(item).includes("children")) {
            var matched = updateControlIdUsingCustomControlId(
              item,
              existingControlId,
              newControlId
            );
            if (matched === true) {
              return true;
            }
          }
        });
      } else {
        if (jsonData["id"] !== existingControlId) {
          updateControlIdUsingCustomControlId(
            jsonData["children"],
            existingControlId,
            newControlId
          );
        } else {
          jsonData["id"] = newControlId;
          setSelectedControl(jsonData);
          window.selectedControlId_function(jsonData);

          setShowProperties(true);
          setShowDataAdditionSection(false);
          return true;
        }
      }
    }
  }

  function addColsToControls(newFormData) {
    // var newJSON = recurseJson(formdata);
    var newJSON = recurseJson(newFormData, -1);
    collectAllCustomControlId(newJSON);
    setFormState2(newJSON);
  }

  function addColsToControlsForDataObjects(
    newFormData,
    frameIndex,
    id,
    colLayout
  ) {
    // var newJSON = recurseJson(formdata);

    //  var newJSON = recurseJson(newFormData, -1);

    var newJSON = recurseJson(newFormData, frameIndex);
    collectAllCustomControlId(newJSON);
    recursiveJsonForRowColId(newJSON, frameIndex);

    //  setFormState2(newJSON);
    return newJSON;

    //   var newJson = rowColumnAddition(newFormData, frameIndex, id, colLayout);

    //   return newJson;
  }

  function addColumnObj(frameIndex, w) {
    var columnJson = addColumnObject(frameIndex, w);
    return columnJson;
  }

  function addRowObj(frameIndexRow, sectionId, colLayout) {
    var rowJson = addRowObject(frameIndexRow, sectionId, colLayout);
    return rowJson;
  }

  function recursiveJsonForRowColId(
    jsonData,
    frameIndex,
    selectedID,
    elemType
  ) {
    if(jsonData){
      if (Array.isArray(jsonData)) {
      jsonData.map((item, index) => {
        if (Object.keys(item).includes("children")) {
          if (item.elem_type === "row" || item.elem_type === "column") {
            if (item.frameIndex === -1) {
              item.frameIndex = frameIndex;
            }
          }
          // var matched = recursiveJsonForRowColId(
          //   item,
          //   frameIndex,
          //   selectedID,
          //   elemType
          // );
        } else {
        }
      });
      } else {
      if (jsonData["id"] !== selectedID) {
        recursiveJsonForRowColId(
          jsonData["children"],
          frameIndex,
          selectedID,
          elemType
        );
      } else if (jsonData["control_id"] !== selectedID) {
        recursiveJsonForRowColId(
          jsonData["children"],
          frameIndex,
          selectedID,
          elemType
        );
      }
      }
    }
  }

  function testFunctionAsParameter() {
    //console.log('testFunctionAsParameter :: ');
  }


  // const [openLoader, setOpenLoader] = useState(false);

  const openLoader = useRef(false);

  function setOpenLoader(val) {
    if (document.querySelector(".psh_SimpleLoader")) {
      if (val === true) {
        document.querySelector(".psh_SimpleLoader").style.display =
          "flex";
      } else if (val === false) {
        document.querySelector(".psh_SimpleLoader").style.display =
          "none";
      }
    }
    openLoader.current = val;
  }

  const formFullyLoaded = useRef(false);

  useEffect(() => {
    //Loader code
    if (Object.keys(formState2).length > 0) {
      if (!formFullyLoaded.current) {
        formFullyLoaded.current = true;
        // timerRef.current =
        window.setTimeout(() => {
          //   setQuery("success");
          setOpenLoader(false);
        }, 100);
      }
    } else {
      //   setOpenLoader(true);
    }

    if (window?.containerSizesOnDrop?.column_size_web) {
      window.containerSizesOnDrop.column_size_web = undefined;
    }

    if (window?.containerSizesOnDrop?.column_size_tablet) {
      window.containerSizesOnDrop.column_size_tablet = undefined;
    }

    if (window?.containerSizesOnDrop?.column_size_mobile) {
      window.containerSizesOnDrop.column_size_mobile = undefined;
    }
    if(checkEmpty(formState2) && !window.emptyScreen1) {
      if(window.changeEmptyScreen)
        window.changeEmptyScreen(true)
    }
  }, [formState2]);

  // function validateComponentInGrid(frameLayoutJson) {
  //   if (listviewMandatoryControls.length === 0) {
  //     let mandatoryArr = [];
  //     checkForAllNonFilledMandatoryFields(frameLayoutJson, mandatoryArr);

  //     if (mandatoryArr.length > 0) {
  //       setListviewMandatoryControls([...mandatoryArr]);
  //       functions.setFocus(mandatoryArr[0]);
  //       return false;
  //     } else {
  //       return true;
  //     }
  //   } else {
  //     return false;
  //   }
  // }

  // const [activePage,setActivePage]=useState();
  // const [activeSubForm, setActiveSubForm] = useState();
  const [showSubForm, setShowSubForm] = useState(false);
  const [activeApplication, setActiveApplication] = useState(undefined);
  const [allPages, setAllPages] = useState([]);
  const [allSubForms, setSubForms] = useState([]);
  const [loginErrorPage, setLoginErrorPage] = useState(false);
  const formBuillderMode = useRef("");
  const setFormBuillderMode = (val) => {
    formBuillderMode.current = val;
  };
  const [sessionTime, setSessionTime] = useState();
  const [openSession, setOpenSession] = useState(false);

  // const [sessionPopupTime, setSessionPopupTime] = useState({});

  const sessionPopupTime = useRef({});

  function setSessionPopupTime(obj) {
    sessionPopupTime.current = obj;
  }

  // const [globalTime, setGlobalTime] = useState({});

  function setGlobalTime(obj) {
    globalTime.current = obj;
  }

  // const count = useRef(0);

  // useEffect(() => {
  //   count.current = count.current + 1;
  // });

  var modeReadOrWrite = "W";
  modeReadOrWrite = modeReadOrWrite.toLowerCase();
  window.isDesigner = (childComp === "app" || childComp === "application" || activePage || activeSubForm) && !getGdToken() && !getWIToken();
   
  let isPortal = childComp === "application" || activePage || activeSubForm;
  // useEffect(() => {
  // setTimeout(() => {
  if (
    microFrontendData !== undefined &&
    microFrontendData.formMataData_json !== undefined &&
    formMataData !== undefined
  ) {
    // if (
    //   microFrontendData !== undefined &&
    //   microFrontendData.component === "preview"
    // ) {
    try {
      // modeReadOrWrite = functions.getWorkItemData("mode",containerId);
      modeReadOrWrite = formMataData.mode;
      modeReadOrWrite = modeReadOrWrite.toLowerCase();
      console.log("formStateStore2", modeReadOrWrite);
    } catch (e) {}
  }
  // }, 2000)

  // }, [microFrontendData?.formMataData_json, formMataData])

  window.mf_containerId_psh = containerId;
  window.activeApplication = activeApplication;
  function isApp() {
    if (formMataData) {
      return false;
    } else if (appId) {
      return true;
    }
  }

  useEffect(() => {
    // window.activeSubForm = activeSubForm;
    if (props?.appDesignerCallback) {
      props?.appDesignerCallback(activeSubForm);
    }
    // else {
    // }
  }, [activeSubForm]);

  const [subformDragged, setSubformDragged] = useState(null);

  const [getDeviceFromProps_mf, setDeviceFromProps_mf] = useState(false);

  useEffect(() => {
    // setDevice(props?.mfProps?.data?.device);
    if (
      props?.mfProps?.data?.device !== undefined &&
      props?.mfProps?.data?.device !== null &&
      props?.mfProps?.data?.device
    ) {
      setDeviceFromProps_mf(true);
    }
  }, []);

  useEffect(() => {
    if (
      sessionPopupTime.current.min !== undefined &&
      sessionPopupTime.current.sec !== undefined &&
      globalTime.current.min !== undefined &&
      globalTime.current.sec != undefined
    ) {
      if (
        globalTime.current.sec === sessionPopupTime.current.sec &&
        globalTime.current.min === sessionPopupTime.current.min
      ) {
        setOpenSession(true);
      }
    }
  });

  function handleClose() {
    setOpen1(false);
    setOpenSession(false);
  }
  const [pageDataLoaded, setPageDataLoaded] = useState(undefined);
  // **************** CALLS TO LOAD INTERFACE(PAGES) AND WIDGETS(SUB-FORM) IN CASE OF LOADING AS MICROFRONT END IN APPLICATION LAUNCHER ONLY ********************************//
  useEffect(() => {
    var interfaceType = undefined;
    interfaceType = microFrontendData?.interfaceType;
    var categoryId = microFrontendData?.categoryId;

    if (
      appId &&
      !interfaceType &&
      !formDefId &&
      !processId &&
      !formId &&
      categoryId !== "TEMPLATE"
    ) {
      if(childComp==="app"){
        setGlobalLoading(true)
        setGlobalLoadingMessage("Loading Form...")
      }      
      axios
        .get(`/interfaces/${appId}`, { withCredentials: true })
        .then((res) => {
          setAllPages([...sanitizeJson(res.data)]);

          axios
            .get(`/widgets/${appId}`, { withCredentials: true })
            .then((resp) => {
              setSubForms([...sanitizeJson(resp.data)]);
              setPageDataLoaded(appId);
            })
            .catch(() => {
              console.log("ERROR ON LOADING SUB FORMS OF APP ID ", appId);
              setGlobalLoading(false)
              setGlobalLoadingMessage("")
            });
        })
        .catch(() => {
          console.log("ERROR ON LOADING PAGES OF APP ID ", appId);
          setGlobalLoading(false)
          setGlobalLoadingMessage("")
        });
    } else if (appId && interfaceType === "T" && categoryId === "TEMPLATE") {
      var templateBufferId = "";
      axios
        .get(`/templates/${appId}`, { withCredentials: true })
        .then((response) => {
          templateBufferId = response.data.templatebuffer;

          axios
            .get(`/interfaces/${templateBufferId}`, { withCredentials: true })
            .then((res) => {
              setAllPages([...sanitizeJson(res.data)]);

              axios
                .get(`/widgets/${templateBufferId}`, { withCredentials: true })
                .then((resp) => {
                  setSubForms([...sanitizeJson(resp.data)]);
                  setPageDataLoaded(appId);
                })
                .catch(() => {
                  console.log("ERROR ON LOADING SUB FORMS OF APP ID ", appId);
                });
            })
            .catch(() => {
              console.log("ERROR ON LOADING PAGES OF APP ID ", appId);
            });
        });
    } else if (
      appId &&
      childComp === "preview" &&
      !formId &&
      ((!interfaceType && categoryId === "TEMPLATE") ||
        (interfaceType === "T" && categoryId === "PAGE") || 
        (!interfaceType && categoryId))
    ) {
      setPageDataLoaded(appId);
    }
  }, [appId]);

  useEffect(() => {
    if(childComp === "reusableFunction"){
      if(props?.microFrontendData?.parentType === "A"){
          axios.get(`/${props?.microFrontendData?.formType}/${props?.microFrontendData?.parentId}/${props?.microFrontendData?.formId}`, {withCredentials: true})
          .then((response) => {
            if(response.data.formBuffer || response.data.fragmentBuffer){
              let obj = {
                applicationId: props?.microFrontendData?.parentId,
                formId: props?.microFrontendData?.formId,
                formJson: response.data.formBuffer || response.data.fragmentBuffer,
                userName: props?.microFrontendData?.sessionData?.sessionData?.userId,
                userIndex: props?.microFrontendData?.sessionData?.sessionData?.userIndex,
              }
              axios.post(`/idesign/populateFormStateFromJson`, obj, {withCredentials: true})
              .then((response) => {
                console.log(response)
                let resp = businessFunctionDataObjects(props?.microFrontendData?.savedCustomCode?.current?.[0]?.id)
                console.log("resp", resp)
                fetchDataObject(false, true)
              })
            }
          })
      }else{
        axios.get(`/process/${props.microFrontendData?.stateType === "L" ? "local" : props.microFrontendData?.stateType === "R" ? "registered" : "local"}/${props?.microFrontendData?.parentId}/${props?.microFrontendData?.formId}`, {withCredentials: true})
        .then((response) => {
          dispatch(
            updateMarvinContexts({
              key: containerId,
              states: {
                isMarvinEnabled: response?.data?.isMarvinEnabled,  
              },                  
            })
          );
          if(response.data.formBuffer){
            let payload = {
              formId: props?.microFrontendData?.formId,
              formJson: response.data.formBuffer,
            }
            axios.post(`/idesign/populateFormStateFromJson`, payload, {withCredentials: true})
              .then((response) => {
                console.log(response)
                const payload = {
                  formId: props?.microFrontendData?.formId,
                  processName: props.microFrontendData?.processStatus,
                  processdefId: props.microFrontendData?.parentId,
                  processState: props.microFrontendData?.stateType,
                }
                let resp = businessFunctionDataObjects(props?.microFrontendData?.savedCustomCode?.current?.[0]?.id)
                console.log("resp", resp)
                fetchProcessModularData(payload).then((response) => {
                  setCurrentDataObjectsContent(response.data["children"])
                  setDataObjectsContent(response.data["children"]);
                  setfilteredDataObject(response.data["children"]);
                  setfilteredDataObjectCopy(response.data["children"]);
                  setGlobalLoading(false);
                })
                .catch((err) => {
                  setCurrentDataObjectsContent([])
                  setDataObjectsContent([]);
                  setfilteredDataObject([]);
                  setfilteredDataObjectCopy([]);
                  setGlobalLoading(false);
                })
              })
          }
        })
      }
    }
  }, [props?.microFrontendData?.formId, props?.microFrontendData?.parentId, props?.microFrontendData?.savedCustomCode?.current?.[0]?.id])

 
  var jwtToken =  JSON.parse(secureLocalStorage.getItem(isPortalLive ?  `launchpadKey_${applicationNameObj.applicationName}` || `launchpadKey_bypass_${applicationNameObj.applicationName}` || "launchpadKey" : "launchpadKey"))?.token ||
secureSessionStorage.getItem("Authorization") ||
undefined;

  // **************** CALLS TO LOAD DESIGNER ********************************//
  useEffect(() => {
    // if(loading)
    //   loading(true)
    if (childComp === "app") {
      if(loading)
        loading(true)
      if (componentType === "TF") {
        // setGlobalLoading(true);
        // setGlobalLoadingMessage("Loading form...");
        axios
          .get(
            `taskform/${microFrontendData.taskId}/${microFrontendData.processDefId}`,
            {
              headers: {
                Authorization: `${microFrontendData?.token}`,
              },
              withCredentials: true,
            }
          )
          .then((response) => {
            // if(response.data.formBuffer === ""){
            //     setFormState2(defaultBuffer);
            //     setFormBuillderMode("designer");
            // }
            // else{
            var formBuffer;
            if (
              response.data.formBuffer === "" ||
              response.data.formBuffer === "{}"
            ) {
              // formBuffer = defaultBuffer;
              let clone = cloneDeep(defaultBuffer);
              formBuffer = clone;
            } else {
              formBuffer = sanitizeStringToJson(response.data.formBuffer);
            }
            addIdsFromJsonToExistingIDs(formBuffer);
            setDefaultPageStyles(formBuffer);
            // callingDataObjects();
            //callingDataObjectsForProcess();
            fetchingMaskingForTextbox();
            // recursiveJsonForMapping(response.data);

            const repopulateJson = {
              formId: `${microFrontendData.processDefId}`,
              formJson: JSON.stringify(formBuffer),
            };

            axios
              .post(
                "/idesign/populateFormStateFromJson",
                sanitizeJson(repopulateJson),
                { withCredentials: true }
              )
              .then((response) => {
                // console.log(response)
                fetchProcessVariables();
              })
              .catch((err) => console.log(err));

            axios
              .post("/idesign/getRegexJson", new Object({}), {
                withCredentials: true,
              })
              .then((response) => {
                localStorage.setItem("regex", JSON.stringify(response.data));
              })
              .catch((err) => console.log("Regex error::", err));
            fetchProcessDataObject();
            if (props?.appDesignerCallback) {
              props?.appDesignerCallback(microFrontendData);
            }
            setFormBuillderMode("designer");
            setFormStateOnOpen(formBuffer);
            // setFormState2(formBuffer);
            setGlobalLoading(false)
            setGlobalLoadingMessage("")
            loading(false);
            // }
          })
          .catch((err) => {
            setGlobalLoading(false)
            setGlobalLoadingMessage("")
            loading(false);
          });
      } else if (componentType === "GT") {
        setGlobalLoading(true);
        setGlobalLoadingMessage("Loading form...");
        axios
          .get(`tasktemplateform/${microFrontendData.templateId}`, {
            headers: {
              Authorization: `${microFrontendData?.token}`,
            },
            withCredentials: true,
          })
          .then((response) => {
            var formBuffer;
            if (
              response.data.formBuffer === "" ||
              response.data.formBuffer === "{}"
            ) {
              // formBuffer = defaultBuffer;
              let clone = cloneDeep(defaultBuffer);
              formBuffer = clone;
            } else {
              formBuffer = sanitizeStringToJson(response.data.formBuffer);
            }
            addIdsFromJsonToExistingIDs(formBuffer);
            setDefaultPageStyles(formBuffer);
            // callingDataObjects();
            //callingDataObjectsForProcess();
            fetchingMaskingForTextbox();

            // var formDataObj = JSON.parse(response.data.formBuffer);

            // recursiveJsonForMapping(formDataObj.children);
            // recursiveJsonForMapping(response.data);

            const repopulateJson = {
              formId: `${
                microFrontendData?.processDefId || microFrontendData?.templateId
              }`,
              formJson: JSON.stringify(formBuffer),
            };

            axios
              .post(
                "/idesign/populateFormStateFromJson",
                sanitizeJson(repopulateJson),
                { withCredentials: true }
              )
              .then((response) => {
                // console.log(response)

                fetchProcessVariables();
              })
              .catch((err) => console.log(err));

            axios
              .post("/idesign/getRegexJson", new Object({}), {
                withCredentials: true,
              })
              .then((response) => {
                localStorage.setItem("regex", JSON.stringify(response.data));
              })
              .catch((err) => console.log("Regex error::", err));
            fetchProcessDataObject();
            if (props?.appDesignerCallback) {
              props?.appDesignerCallback(microFrontendData);
            }
            setFormBuillderMode("designer");
            setFormStateOnOpen(formBuffer);
            // setFormState2(formBuffer);
            loading(false);
            setGlobalLoading(false)
            setGlobalLoadingMessage("")
          })
          .catch((err) => {
            setGlobalLoading(false)
            setGlobalLoadingMessage("")
            loading(false);
          });
      } else if (formDefId && processId) {
        //*******  TO LOAD APPLICATION WHEN WE ARE OPENING A FORM INSIDE A PROCESS ***** //
        if (formPageType === "Portals") {
          // For Forms as Portals and in that also Pages
          // setGlobalLoading(true);
          loading(true)
          setGlobalLoadingMessage("Loading form...");
          axios
            .get(`/interfaces/${processId}/${formDefId}`, {
              headers: {
                Authorization: `${microFrontendData?.token}`,
              },
              withCredentials: true,
            })
            .then((response) => {
              // setActivePage(sanitizeJson(response.data));
              setActiveApplication({
                ...response.data,
                formPageType: "Portals",
              });
              var formBuffer;
              let clone = cloneDeep(defaultBuffer);
              formBuffer = clone;
              if (
                response.data.formBuffer === "" ||
                response.data.formBuffer === "{}" ||
                response.data.formBuffer === null
              ) {
                // formBuffer = defaultBuffer;
                
              } else {
                formBuffer = sanitizeStringToJson(response.data.formBuffer);
              }
              addIdsFromJsonToExistingIDs(formBuffer);
              setDefaultPageStyles(formBuffer);
              // callingDataObjects();
              //callingDataObjectsForProcess();
              fetchingMaskingForTextbox();
              // recursiveJsonForMapping(response.data);
              let formId = getFormId();
              const repopulateJson = {
                formId: `${formDefId || formId.toString()}`,
                formJson: JSON.stringify(formBuffer),
                applicationName: microFrontendData?.applicationName,
                applicationId:
                  microFrontendData?.applicationId ||
                  response.data.existingFormId ||
                  response.data.projectId,
                userName: microFrontendData?.sessionData?.sessionData?.userId,
                userIndex:
                  microFrontendData?.sessionData?.sessionData?.userIndex,
              };

              axios
                .post(
                  "/idesign/populateFormStateFromJson",
                  sanitizeJson(repopulateJson),
                  { withCredentials: true }
                )
                .then((response) => {
                  // console.log(response)
                  fetchProcessVariables();
                })
                .catch((err) => console.log(err));

              axios
                .post("/idesign/getRegexJson", new Object({}), {
                  withCredentials: true,
                })
                .then((response) => {
                  localStorage.setItem("regex", JSON.stringify(response.data));
                })
                .catch((err) => console.log("Regex error::", err));

              setFormBuillderMode("designer");
              setFormStateOnOpen(formBuffer);
              // setFormState2(formBuffer);
              setGlobalLoading(false)
              setGlobalLoadingMessage("")
              loading(false);
            })
            .catch((err) => {
              console.log("error in loading form of above process");
              setGlobalLoading(false)
              setGlobalLoadingMessage("")
              loading(false);
            });
        } else {
          if (statusType === "L") {
            // Form as processes in Draft
            // setGlobalLoading(true);
            loading(true)
            setGlobalLoadingMessage("Loading form...");
            axios
              .get(`/process/local/${processId}/${formDefId}`, {
                // headers: {
                //   Authorization: `${microFrontendData?.token}`,
                // },
                withCredentials: true,
              })
              .then((response) => {
                // setActivePage(sanitizeJson(response.data));
                dispatch(
                  updateMarvinContexts({
                    key: containerId,
                    states: {
                      isMarvinEnabled: response?.data?.isMarvinEnabled,  
                    },                  
                  })
                );
                setActiveApplication({ ...response.data }, { status: "local" });
                var formBuffer;
                if (
                  response.data.formBuffer === "" ||
                  response.data.formBuffer === "{}" ||
                  response.data.formBuffer === " " || response.data.formBuffer === "null"
                ) {
                  // formBuffer = defaultBuffer;
                  let clone = cloneDeep(defaultBuffer);
                  formBuffer = clone;
                } else {
                  formBuffer = sanitizeStringToJson(response.data.formBuffer);
                }
                addIdsFromJsonToExistingIDs(formBuffer);
                setDefaultPageStyles(formBuffer);
                // callingDataObjects();
                //callingDataObjectsForProcess();
                fetchingMaskingForTextbox();
                // recursiveJsonForMapping(response.data);
                let formId = getFormId();
                const repopulateJson = {
                  formId: `${formDefId || formId.toString()}`,
                  formJson: JSON.stringify(formBuffer),
                  //"formJson": Object.keys(response.data.formBuffer).length !== 0 ? `${response.data.formBuffer}`   : defaultBuffer
                  // "formJson": defaultBuffer
                };

                axios
                  .post(
                    "/idesign/populateFormStateFromJson",
                    sanitizeJson(repopulateJson),
                    { withCredentials: true }
                  )
                  .then((response) => {
                    // console.log(response);
                    // setGlobalLoading(false)
                    fetchProcessVariables();
                  })
                  .catch((err) => console.log(err));

                axios
                  .post("/idesign/getRegexJson", new Object({}), {
                    withCredentials: true,
                  })
                  .then((response) => {
                    localStorage.setItem(
                      "regex",
                      JSON.stringify(response.data)
                    );
                  })
                  .catch((err) => console.log("Regex error::", err));

                setFormBuillderMode("designer");
                setFormStateOnOpen(formBuffer);
                // setFormState2(formBuffer);
                setGlobalLoading(false)
                setGlobalLoadingMessage("")
                loading(false);
              })
              .catch((err) => {
                console.log("error in loading form of above process");
                setGlobalLoading(false)
                setGlobalLoadingMessage("")
                loading(false);
              });
          } else {
            // Form as processes in Deployed
            // setGlobalLoading(true);
            loading(true)

            setGlobalLoadingMessage("Loading form...");
            axios
              .get(`/process/registered/${processId}/${formDefId}`, {
                // headers: {
                //   Authorization: `${microFrontendData?.token}`,
                // },
                withCredentials: true,
              })
              .then((response) => {
                // setActivePage(sanitizeJson(response.data));
                dispatch(
                  updateMarvinContexts({
                    key: containerId,
                    states: {
                      isMarvinEnabled: response?.data?.isMarvinEnabled,  
                    },                  
                  })
                );
                setActiveApplication(
                  { ...response.data },
                  { status: "registered" }
                );
                var formBuffer;
                if (
                  response.data.formBuffer === "" ||
                  response.data.formBuffer === "{}" ||
                  response.data.formBuffer === " "
                ) {
                  // formBuffer = defaultBuffer;
                  let clone = cloneDeep(defaultBuffer);
                  formBuffer = clone;
                } else {
                  formBuffer = sanitizeStringToJson(response.data.formBuffer);
                }
                addIdsFromJsonToExistingIDs(formBuffer);
                setDefaultPageStyles(formBuffer);
                // callingDataObjects();
                //callingDataObjectsForProcess();
                fetchingMaskingForTextbox();
                // recursiveJsonForMapping(response.data);
                let formId = getFormId();
                const repopulateJson = {
                  formId: `${formDefId || formId.toString()}`,
                  formJson: JSON.stringify(formBuffer),
                };

                axios
                  .post(
                    "/idesign/populateFormStateFromJson",
                    sanitizeJson(repopulateJson),
                    {
                      headers: {
                        Authorization: `${microFrontendData?.token}`,
                      },
                      withCredentials: true,
                    }
                  )
                  .then((response) => {
                    // console.log(response);

                    fetchProcessVariables();
                  })
                  .catch((err) => console.log(err));

                axios
                  .post("/idesign/getRegexJson", new Object({}), {
                    headers: {
                      Authorization: `${microFrontendData?.token}`,
                    },
                    withCredentials: true,
                  })
                  .then((response) => {
                    localStorage.setItem(
                      "regex",
                      JSON.stringify(response.data)
                    );
                  })
                  .catch((err) => console.log("Regex error::", err));

                setFormBuillderMode("designer");
                setFormStateOnOpen(formBuffer);
                // setFormState2(formBuffer);
                setGlobalLoading(false)
                setGlobalLoadingMessage("")
                loading(false);
              })
              .catch((err) => {
                console.log("error in loading form of above process");
                setGlobalLoading(false)
                setGlobalLoadingMessage("")
                loading(false);
              });
          }
        }
      } else if (formId) {
        //For Templates as pages and forms
        // setGlobalLoading(true);
        loading(true)

        setGlobalLoadingMessage("Loading form...");
        axios
          .get(`/templates/${props.formId}`, {
            headers: {
              Authorization: `${microFrontendData?.token}`,
            },
            withCredentials: true,
          })
          .then((response) => {
            setActiveApplication(response.data);
            var formBuffer;

            if (
              response.data.formBuffer === "" ||
              response.data.formBuffer === "{}" ||
              response.data.templatebuffer === "" ||
              response.data.templatebuffer === "{}"
            ) {
              // formBuffer = defaultBuffer;
              let clone = cloneDeep(defaultBuffer);
              formBuffer = clone;
            } else {
              formBuffer = sanitizeStringToJson(
                response?.data?.formBuffer || response?.data?.templatebuffer
              );
            }

            addIdsFromJsonToExistingIDs(formBuffer);
            setDefaultPageStyles(formBuffer);
            // callingDataObjects();
            // setActiveApplication(res.data);
            // setApplicationData(res.data);
            // setGlobalTime({min:sessionTime, sec:0});
            fetchingMaskingForTextbox();
            // recursiveJsonForMapping(res.data);
            const repopulateJson = {
              formId: `${formId}`,
              formJson: JSON.stringify(formBuffer),
            };
            axios
              .post(
                "/idesign/populateFormStateFromJson",
                sanitizeJson(repopulateJson),
                {
                  headers: {
                    Authorization: `${microFrontendData?.token}`,
                  },
                  withCredentials: true,
                }
              )
              .then((response) => {
                // console.log(response);
                setGlobalLoading(false);
              })
              .catch((err) => console.log(err));
            axios
              .post("/idesign/getRegexJson", new Object({}), {
                headers: {
                  Authorization: `${microFrontendData?.token}`,
                },
                withCredentials: true,
              })
              .then((response) => {
                localStorage.setItem("regex", JSON.stringify(response.data));
              })
              .catch((err) => console.log("Regex error::", err));
            setFormBuillderMode("designer");
            setFormStateOnOpen(formBuffer);
            // setFormState2(formBuffer);
            setGlobalLoading(false)
            setGlobalLoadingMessage("")
            loading(false);
          })
          .catch(function (error) {
            console.log("Error", error);
            setGlobalLoading(false)
            setGlobalLoadingMessage("")
            loading(false);
          });
      } else if (microFrontendData?.fragmentId) {
        // Forms as portals in that also Forms
        axios
          .get(
            `widgets/${microFrontendData.processId}/${microFrontendData.fragmentId}`,
            { withCredentials: true }
          )
          .then((response) => {
            setActiveApplication(response.data);
            setActiveSubForm(response.data);
            setActivePage(null);
            var formBuffer;
            if (
              response.data.fragmentBuffer === "" ||
              response.data.fragmentBuffer === "{}"
            ) {
              // formBuffer = defaultBuffer;
              let clone = cloneDeep(defaultBuffer);
              formBuffer = clone;
            } else {
              formBuffer = JSON.parse(response.data.fragmentBuffer);
            }
            // var formBuffer = JSON.parse(response.data.fragmentBuffer);
            // addIdsFromJsonToExistingIDs(formBuffer);

            const repopulateJson = {
              formId: `${microFrontendData.fragmentId}`,
              formJson: JSON.stringify(formBuffer),
            };

            axios
              .post("/idesign/populateFormStateFromJson", repopulateJson, {
                withCredentials: true,
              })
              .then((response) => {
                //  console.log(response)
                fetchDataObject();
              });
            setFormStateOnOpen(formBuffer);
            // setFormState2(formBuffer);
            setCurrentMappedDO([]);
            setGlobalLoading(false)
            setGlobalLoadingMessage("")
            loading(false);
          })
          .catch(function (error) {
            console.log(error);
            setGlobalLoading(false)
            setGlobalLoadingMessage("")
            loading(false);
          });
      } else if (appId && pageDataLoaded && pageDataLoaded === appId) {
        var activeApp;
        var newId;
        if (microFrontendData?.categoryId === "TEMPLATE") {
          // For Templates as Portals
          if (microFrontendData?.activeStatusType === "A") {
            var templateBufferId = "";
            axios
              .get(`/templates/${appId}`, { withCredentials: true })
              .then((response) => {
                templateBufferId = response.data.templatebuffer;
              })
              .then((data) => {
                setGlobalTime({ min: sessionTime, sec: 0 });
                axios
                  .get(`/applications/${templateBufferId}`, {
                    // headers: {
                    //   Authorization: `${microFrontendData?.token}`,
                    // },
                    withCredentials: true,
                  })
                  .then((res) => {
                    activeApp = res.data;
                    dispatch(
                      updateMarvinContexts({
                        key: containerId,
                        states: {
                          isMarvinEnabled: res?.data?.isMarvinEnabled,  
                        },                  
                      })
                    );
                    setActiveApplication({
                      ...activeApp,
                      status: res.data.status,
                    });
                    setApplicationData(res.data);
                    setGlobalTime({ min: sessionTime, sec: 0 });

                    if (activePage && activePage?.formId) {
                      axios
                        .get(
                          `interfaces/${templateBufferId}/${activePage?.formId}`,
                          { withCredentials: true }
                        )
                        .then((response) => {
                          // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
                          var formBuffer;
                          if (
                            response.data.formBuffer === "" ||
                            response.data.formBuffer === "{}"
                          ) {
                            // formBuffer = defaultBuffer;
                            let clone = cloneDeep(defaultBuffer);
                            formBuffer = clone;
                          } else {
                            formBuffer = sanitizeStringToJson(
                              response.data.formBuffer
                            );
                          }
                          setActivePage(sanitizeJson(response.data));
                          setActiveSubForm(null);

                          // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                          addIdsFromJsonToExistingIDs(formBuffer);
                          setDefaultPageStyles(formBuffer);
                          // callingDataObjects();
                          //callingDataObjectsForProcess();
                          fetchingMaskingForTextbox();
                          // recursiveJsonForMapping(response.data);

                          const repopulateJson = {
                            formId: `${response.data.formId}`,
                            formJson: JSON.stringify(formBuffer),
                          };

                          axios
                            .post(
                              "/idesign/populateFormStateFromJson",
                              sanitizeJson(repopulateJson),
                              { withCredentials: true }
                            )
                            .then((response) => {
                              fetchDataObject();
                            })
                            .catch((err) => console.log(err));

                          axios
                            .post("/idesign/getRegexJson", new Object({}), {
                              withCredentials: true,
                            })
                            .then((response) => {
                              localStorage.setItem(
                                "regex",
                                JSON.stringify(response.data)
                              );
                            })
                            .catch((err) => console.log("Regex error::", err));

                          setFormBuillderMode("designer");
                          setFormStateOnOpen(formBuffer);
                          // setFormState2(formBuffer);
                          // dispatch(setFormState1(formBuffer));

                          collectAllCustomControlId(formBuffer);
                          setDefaultPageStyles(formBuffer);
                          if (formBuffer) {
                            const themeData = Object.assign(
                              {},
                              formBuffer.theme
                            );
                            if (themeData.themeName) {
                            } else {
                              themeData["themeName"] = "Default Theme";
                            }
                            //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                          }
                          setGlobalLoading(false)
                          setGlobalLoadingMessage("")
                          loading(false);
                        })
                        .catch(function (error) {});
                    } else if (res.data.defaultFormId !== 0) {
                      axios
                        .get(
                          `interfaces/${templateBufferId}/${res.data.defaultFormId}`,
                          { withCredentials: true }
                        )
                        .then((response) => {
                          // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
                          var formBuffer;
                          if (
                            response.data.formBuffer === "" ||
                            response.data.formBuffer === "{}"
                          ) {
                            // formBuffer = defaultBuffer;
                            let clone = cloneDeep(defaultBuffer);
                            formBuffer = clone;
                          } else {
                            formBuffer = sanitizeStringToJson(
                              response.data.formBuffer
                            );
                          }
                          setActivePage(sanitizeJson(response.data));
                          setActiveSubForm(null);

                          // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                          addIdsFromJsonToExistingIDs(formBuffer);
                          setDefaultPageStyles(formBuffer);
                          // callingDataObjects();
                          //callingDataObjectsForProcess();
                          fetchingMaskingForTextbox();
                          // recursiveJsonForMapping(response.data);

                          const response1 = response?.data ? response : {};
                          const response2 = response1 ? (response1?.data ? response1.data : {}) : {};
                          const response3 = response2 ? (response2?.formBuffer ? response2.formBuffer : {}) : {};

                          var formDataObj = JSON.parse(response3);

                          recursiveJsonForMapping(formDataObj.children);

                          const repopulateJson = {
                            formId: `${response.data.formId}`,
                            formJson: `${response.data.formBuffer}`,
                            applicationName: microFrontendData?.applicationName,
                            applicationId: microFrontendData?.applicationId,
                            userName:
                              microFrontendData?.sessionData?.sessionData
                                ?.userId,
                            userIndex:
                              microFrontendData?.sessionData?.sessionData
                                ?.userIndex,
                          };

                          axios
                            .post(
                              "/idesign/populateFormStateFromJson",
                              sanitizeJson(repopulateJson),
                              { withCredentials: true }
                            )
                            .then((response) => {
                              // console.log(response)
                              fetchDataObject();
                            })
                            .catch((err) => console.log(err));

                          axios
                            .post("/idesign/getRegexJson", new Object({}), {
                              withCredentials: true,
                            })
                            .then((response) => {
                              // console.log('regex response :: ',response);
                              localStorage.setItem(
                                "regex",
                                JSON.stringify(response.data)
                              );
                            })
                            .catch((err) => console.log("Regex error::", err));

                          setFormBuillderMode("designer");
                          setFormStateOnOpen(formBuffer);
                          // setFormState2(formBuffer);
                          // dispatch(setFormState1(formBuffer));

                          collectAllCustomControlId(formBuffer);
                          setDefaultPageStyles(formBuffer);
                          if (formBuffer) {
                            const themeData = Object.assign(
                              {},
                              formBuffer.theme
                            );
                            if (themeData.themeName) {
                            } else {
                              themeData["themeName"] = "Default Theme";
                            }
                            //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                          }
                          setGlobalLoading(false)
                          setGlobalLoadingMessage("")
                          loading(false);
                        })
                        .catch(function (error) {
                          setOpenLoader(false);
                          setGlobalLoading(false)
                          setGlobalLoadingMessage("")
                          loading(false);
                          // alert("There is some issue in form opening. Kindly check with system administrator");
                          showAlertConfirmNotifications({
                            open: true,
                            showConfirm: "showNotification",
                            alertType: "error",
                            alertContentKey:
                              "There is some issue in form opening. Kindly check with system administrator",
                          });
                        });
                    } else {
                      // WHEN DEFAULT FORMID DOES NOT EXISTS i.e. default page on an application does not exists

                      const activeApplicationNew = {
                        ...res.data,
                        defaultFormId: allPages[0]?.formId,
                      };

                      axios
                        .post(
                          `applications/`,
                          sanitizeJson(activeApplicationNew),
                          { withCredentials: true }
                        )
                        .then((res) => {
                          setActiveApplication(sanitizeJson(res.data));
                          axios
                            .get(
                              `interfaces/${props.appId}/${res.data.defaultFormId}`,
                              { withCredentials: true }
                            )
                            .then((response) => {
                              var formBuffer;
                              if (
                                response.data.formBuffer === "" ||
                                response.data.formBuffer === "{}"
                              ) {
                                // formBuffer = defaultBuffer;
                                let clone = cloneDeep(defaultBuffer);
                                formBuffer = clone;
                              } else {
                                formBuffer = sanitizeStringToJson(
                                  response.data.formBuffer
                                );
                              }
                              setActivePage(sanitizeJson(response.data));
                              setActiveSubForm(null);

                              // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                              addIdsFromJsonToExistingIDs(formBuffer);
                              setDefaultPageStyles(formBuffer);
                              // callingDataObjects();
                              //callingDataObjectsForProcess();
                              fetchingMaskingForTextbox();
                              // recursiveJsonForMapping(response.data);

                              const repopulateJson = {
                                formId: `${response.data.formId}`,
                                formJson: JSON.stringify(formBuffer),
                              };

                              axios
                                .post(
                                  "/idesign/populateFormStateFromJson",
                                  sanitizeJson(repopulateJson),
                                  { withCredentials: true }
                                )
                                .then((response) => {
                                  // console.log(response)
                                })
                                .catch((err) => console.log(err));

                              axios
                                .post("/idesign/getRegexJson", new Object({}), {
                                  withCredentials: true,
                                })
                                .then((response) => {
                                  localStorage.setItem(
                                    "regex",
                                    JSON.stringify(response.data)
                                  );
                                })
                                .catch((err) => console.log(err));

                              setFormStateOnOpen(formBuffer);
                              // setFormState2(formBuffer);
                              collectAllCustomControlId(formBuffer);
                              setDefaultPageStyles(formBuffer);
                              if (formBuffer) {
                                const themeData = Object.assign(
                                  {},
                                  formBuffer.theme
                                );
                                if (themeData.themeName) {
                                } else {
                                  themeData["themeName"] = "Default Theme";
                                }
                                //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                              }
                              setGlobalLoading(false)
                              setGlobalLoadingMessage("")
                              loading(false);
                            })
                            .catch((err) => {
                              console.log(err);
                              setGlobalLoading(false)
                              setGlobalLoadingMessage("")
                              loading(false);
                            });
                        })
                        .catch((err) => {
                          console.log("ERROR FOUND in saving page: ", err);
                          setGlobalLoading(false)
                          setGlobalLoadingMessage("")
                          loading(false);
                        });
                    }
                  })
                  .catch(function (error) {
                    console.log("Error", error);
                  });
              });
          } else if (
            microFrontendData?.activeStatusType === "L" &&
            microFrontendData?.activeFormPageType === "Processes"
          ) {
            axios
              .get(`/templates/${appId}`, { withCredentials: true })
              .then((response) => {
                newId = parseInt(response.data.templatebuffer);
                setActiveApplication({ ...response.data });
              })
              .then((data) => {
                axios
                  .get(
                    `/process/local/${microFrontendData?.activeIdentifierId}/${newId}`,
                    {
                      // headers: {
                      //   Authorization: `${microFrontendData?.token}`,
                      // },
                      withCredentials: true,
                    }
                  )
                  .then((response) => {
                    // setActivePage(sanitizeJson(response.data));
                    // setActiveApplication({...response.data},{status:"local"});
                    dispatch(
                      updateMarvinContexts({
                        key: containerId,
                        states: {
                          isMarvinEnabled: response?.data?.isMarvinEnabled,  
                        },                  
                      })
                    );
                    var formBuffer;
                    if (
                      response.data.formBuffer === "" ||
                      response.data.formBuffer === "{}" ||
                      response.data.formBuffer === " "
                    ) {
                      // formBuffer = defaultBuffer;
                      let clone = cloneDeep(defaultBuffer);
                      formBuffer = clone;
                    } else {
                      formBuffer = sanitizeStringToJson(
                        response.data.formBuffer
                      );
                    }
                    addIdsFromJsonToExistingIDs(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    // callingDataObjects();
                    //callingDataObjectsForProcess();
                    fetchingMaskingForTextbox();
                    // recursiveJsonForMapping(response.data);

                    const repopulateJson = {
                      formId: `${newId}`,
                      formJson: JSON.stringify(formBuffer),
                      //"formJson": Object.keys(response.data.formBuffer).length !== 0 ? `${response.data.formBuffer}`   : defaultBuffer
                      // "formJson": defaultBuffer
                    };

                    axios
                      .post(
                        "/idesign/populateFormStateFromJson",
                        sanitizeJson(repopulateJson),
                        { withCredentials: true }
                      )
                      .then((response) => {
                        // console.log(response);
                      })
                      .catch((err) => console.log(err));

                    axios
                      .post("/idesign/getRegexJson", new Object({}), {
                        withCredentials: true,
                      })
                      .then((response) => {
                        localStorage.setItem(
                          "regex",
                          JSON.stringify(response.data)
                        );
                      })
                      .catch((err) => console.log("Regex error::", err));

                    setFormBuillderMode("designer");
                    setFormStateOnOpen(formBuffer);
                    // setFormState2(formBuffer);
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  })
                  .catch((err) => {
                    console.log("error in loading form of above process");
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  });
              });
          } else if (
            microFrontendData?.activeStatusType === "R" &&
            microFrontendData?.activeFormPageType === "Processes"
          ) {
            axios
              .get(`/templates/${appId}`, { withCredentials: true })
              .then((response) => {
                newId = parseInt(response.data.templatebuffer);
                setActiveApplication({ ...response.data });
              })
              .then((data) => {
                axios
                  .get(
                    `/process/registered/${microFrontendData?.activeIdentifierId}/${newId}`,
                    {
                      // headers: {
                      //   Authorization: `${microFrontendData?.token}`,
                      // },
                      withCredentials: true,
                    }
                  )
                  .then((response) => {
                    // setActivePage(sanitizeJson(response.data));
                    // setActiveApplication({...response.data},{status:"registered"});
                    dispatch(
                      updateMarvinContexts({
                        key: containerId,
                        states: {
                          isMarvinEnabled: response?.data?.isMarvinEnabled,  
                        },                  
                      })
                    );
                    var formBuffer;
                    if (
                      response.data.formBuffer === "" ||
                      response.data.formBuffer === "{}" ||
                      response.data.formBuffer === " "
                    ) {
                      // formBuffer = defaultBuffer;
                      let clone = cloneDeep(defaultBuffer);
                      formBuffer = clone;
                    } else {
                      formBuffer = sanitizeStringToJson(
                        response.data.formBuffer
                      );
                    }
                    addIdsFromJsonToExistingIDs(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    // callingDataObjects();
                    //callingDataObjectsForProcess();
                    fetchingMaskingForTextbox();
                    // recursiveJsonForMapping(response.data);

                    const repopulateJson = {
                      formId: `${newId}`,
                      formJson: JSON.stringify(formBuffer),
                    };

                    axios
                      .post(
                        "/idesign/populateFormStateFromJson",
                        sanitizeJson(repopulateJson),
                        {
                          headers: {
                            Authorization: `${microFrontendData?.token}`,
                          },
                          withCredentials: true,
                        }
                      )
                      .then((response) => {
                        // console.log(response);
                      })
                      .catch((err) => console.log(err));

                    axios
                      .post("/idesign/getRegexJson", new Object({}), {
                        headers: {
                          Authorization: `${microFrontendData?.token}`,
                        },
                        withCredentials: true,
                      })
                      .then((response) => {
                        localStorage.setItem(
                          "regex",
                          JSON.stringify(response.data)
                        );
                      })
                      .catch((err) => console.log("Regex error::", err));

                    setFormBuillderMode("designer");
                    setFormStateOnOpen(formBuffer);
                    // setFormState2(formBuffer);
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  })
                  .catch((err) => {
                    console.log("error in loading form of above process");
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  });
              });
          } else if (
            microFrontendData?.activeStatusType === "L" &&
            microFrontendData?.activeFormPageType === "Portals"
          ) {
            axios
              .get(`/templates/${appId}`, { withCredentials: true })
              .then((response) => {
                newId = parseInt(response.data.templatebuffer);
                setActiveApplication({ ...response.data });
              })
              .then((data) => {
                axios
                  .get(
                    `/interfaces/${microFrontendData?.activeIdentifierId}/${newId}`,
                    {
                      headers: {
                        Authorization: `${microFrontendData?.token}`,
                      },
                      withCredentials: true,
                    }
                  )
                  .then((response) => {
                    // setActivePage(sanitizeJson(response.data));
                    // setActiveApplication({...response.data},{status:"registered"});
                    var formBuffer;
                    if (
                      response.data.formBuffer === "" ||
                      response.data.formBuffer === "{}"
                    ) {
                      // formBuffer = defaultBuffer;
                      let clone = cloneDeep(defaultBuffer);
                      formBuffer = clone;
                    } else {
                      formBuffer = sanitizeStringToJson(
                        response.data.formBuffer
                      );
                    }
                    addIdsFromJsonToExistingIDs(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    // callingDataObjects();
                    //callingDataObjectsForProcess();
                    fetchingMaskingForTextbox();
                    // recursiveJsonForMapping(response.data);

                    const repopulateJson = {
                      formId: `${newId}`,
                      formJson: JSON.stringify(formBuffer),
                      applicationName: microFrontendData?.applicationName,
                      applicationId:
                        microFrontendData?.applicationId ||
                        response.data.existingFormId ||
                        response.data.projectId,
                      userName:
                        microFrontendData?.sessionData?.sessionData?.userId,
                      userIndex:
                        microFrontendData?.sessionData?.sessionData?.userIndex,
                    };

                    axios
                      .post(
                        "/idesign/populateFormStateFromJson",
                        sanitizeJson(repopulateJson),
                        { withCredentials: true }
                      )
                      .then((response) => {
                        // console.log(response)
                      })
                      .catch((err) => console.log(err));

                    axios
                      .post("/idesign/getRegexJson", new Object({}), {
                        withCredentials: true,
                      })
                      .then((response) => {
                        // console.log('regex response :: ',response);
                        localStorage.setItem(
                          "regex",
                          JSON.stringify(response.data)
                        );
                      })
                      .catch((err) => console.log("Regex error::", err));

                    setFormBuillderMode("designer");
                    setFormStateOnOpen(formBuffer);
                    // setFormState2(formBuffer);
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  })
                  .catch((err) => {
                    console.log("error in loading form of above process");
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  });
              });
          } else if (
            microFrontendData?.activeStatusType === "R" &&
            microFrontendData?.activeFormPageType === "Portals"
          ) {
            axios
              .get(`/templates/${appId}`, { withCredentials: true })
              .then((response) => {
                newId = response.data.templatebuffer;
                setActiveApplication({ ...response.data });
              })
              .then((data) => {
                axios
                  .get(
                    `widgets/${microFrontendData?.activeIdentifierId}/${newId}`,
                    { withCredentials: true }
                  )
                  .then((response) => {
                    // setActiveApplication(response.data)
                    setActiveSubForm(response.data);
                    setActivePage(null);
                    var formBuffer = JSON.parse(response.data.fragmentBuffer);
                    // addIdsFromJsonToExistingIDs(formBuffer);

                    const repopulateJson = {
                      formId: `${newId}`,
                      formJson: `${response.data.fragmentBuffer}`,
                    };

                    axios
                      .post(
                        "/idesign/populateFormStateFromJson",
                        repopulateJson,
                        { withCredentials: true }
                      )
                      .then((response) => {
                        //  console.log(response)
                        fetchDataObject();
                      });
                    setFormStateOnOpen(formBuffer);
                    // setFormState2(formBuffer);
                    setCurrentMappedDO([]);
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  })
                  .catch(function (error) {
                    console.log(error);
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  });
              });
          }
        }
        // LOADING DESIGNER ON BASIS ON APPLICATION ID ( USED WHEN USED AS MICROFRONTEND IN APPLICATION LAUNCHER )
        else {
          // For Portals
          setGlobalTime({ min: sessionTime, sec: 0 });
          axios
            .get(`/applications/${props.appId}`, {
              // headers: {
              //   Authorization: `${microFrontendData?.token}`,
              // },
              withCredentials: true,
            })
            .then((res) => {
              dispatch(
                updateMarvinContexts({
                  key: containerId,
                  states: {
                    isMarvinEnabled: res?.data?.isMarvinEnabled,  
                  },                  
                })
              );
              setActiveApplication(res.data);
              setApplicationData(res.data);
              setGlobalTime({ min: sessionTime, sec: 0 });
              isLoginPortal.current = res?.data?.islogin
              dispatch(updateStateInRedux({name: "loginPortal", value: res?.data?.islogin}));
              if (window?.currentActiveTab?.PagePreview) {
                if (window?.currentActiveTab.PagePreview?.page !== undefined) {
                  axios
                    .get(
                      `interfaces/${props.appId}/${window?.currentActiveTab.PagePreview?.page?.formId}`,
                      { withCredentials: true }
                    )
                    .then((response) => {
                      // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
                      var formBuffer;
                      if (
                        response.data.formBuffer === "" ||
                        response.data.formBuffer === "{}"
                      ) {
                        // formBuffer = defaultBuffer;
                        let clone = cloneDeep(defaultBuffer);
                        formBuffer = clone;
                      } else {
                        formBuffer = sanitizeStringToJson(
                          response.data.formBuffer
                        );
                      }
                      setActivePage(sanitizeJson(response.data));
                      setActiveSubForm(null);

                      // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                      addIdsFromJsonToExistingIDs(formBuffer);
                      setDefaultPageStyles(formBuffer);
                      // callingDataObjects();
                      //callingDataObjectsForProcess();
                      fetchingMaskingForTextbox();
                      // recursiveJsonForMapping(response.data);

                      const repopulateJson = {
                        applicationId: microFrontendData?.applicationId,
                        formId: `${response.data.formId}`,
                        formJson: JSON.stringify(formBuffer),
                      };

                      axios
                        .post(
                          "/idesign/populateFormStateFromJson",
                          sanitizeJson(repopulateJson),
                          { withCredentials: true }
                        )
                        .then((response) => {
                          // console.log(response)
                          fetchDataObject();
                        })
                        .catch((err) => console.log(err));

                      axios
                        .post("/idesign/getRegexJson", new Object({}), {
                          withCredentials: true,
                        })
                        .then((response) => {
                          localStorage.setItem(
                            "regex",
                            JSON.stringify(response.data)
                          );
                        })
                        .catch((err) => console.log("Regex error::", err));

                      setFormBuillderMode("designer");
                      setFormStateOnOpen(formBuffer);
                      // setFormState2(formBuffer);
                      // dispatch(setFormState1(formBuffer));

                      collectAllCustomControlId(formBuffer);
                      setDefaultPageStyles(formBuffer);
                      if (formBuffer) {
                        const themeData = Object.assign({}, formBuffer.theme);
                        if (themeData.themeName) {
                        } else {
                          themeData["themeName"] = "Default Theme";
                        }
                        //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                      }
                      setGlobalLoading(false)
                      setGlobalLoadingMessage("")
                      loading(false);
                    })
                    .catch(function (error) {});
                } else {
                  // `widgets/${microFrontendData.processId}/${microFrontendData.fragmentId}
                  axios
                    .get(
                      `widgets/${props.appId}/${window?.currentActiveTab?.PagePreview?.subform?.fragmentId}`,
                      { withCredentials: true }
                    )
                    .then((response) => {
                      // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
                      var formBuffer;
                      if (
                        response.data.fragmentBuffer === "" ||
                        response.data.fragmentBuffer === "{}"
                      ) {
                        // formBuffer = defaultBuffer;
                        let clone = cloneDeep(defaultBuffer);
                        formBuffer = clone;
                      } else {
                        formBuffer = sanitizeStringToJson(
                          response.data.fragmentBuffer
                        );
                      }
                      setActiveSubForm(sanitizeJson(response.data));
                      setActivePage(null);
                      // setActivePage(sanitizeJson(response.data));
                      // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                      addIdsFromJsonToExistingIDs(formBuffer);
                      // console.log(formBuffer);
                      setDefaultPageStyles(formBuffer);
                      // callingDataObjects();
                      //callingDataObjectsForProcess();
                      fetchingMaskingForTextbox();
                      // recursiveJsonForMapping(response.data);

                      axios
                        .post(
                          "/idesign/populateFormStateFromJson",
                          repopulateJson,
                          { withCredentials: true }
                        )
                        .then((response) => {});

                      const repopulateJson = {
                        applicationId: microFrontendData?.applicationId,
                        formId: `${response.data.fragmentId}`,
                        formJson: JSON.stringify(formBuffer),
                      };

                      axios
                        .post(
                          "/idesign/populateFormStateFromJson",
                          sanitizeJson(repopulateJson),
                          { withCredentials: true }
                        )
                        .then((response) => {
                          // console.log(response)
                          fetchDataObject();
                        })
                        .catch((err) => console.log(err));

                      axios
                        .post("/idesign/getRegexJson", new Object({}), {
                          withCredentials: true,
                        })
                        .then((response) => {
                          localStorage.setItem(
                            "regex",
                            JSON.stringify(response.data)
                          );
                        })
                        .catch((err) => console.log("Regex error::", err));

                      setFormBuillderMode("designer");
                      setFormStateOnOpen(formBuffer);
                      // setFormState2(formBuffer);
                      // dispatch(setFormState1(formBuffer));

                      collectAllCustomControlId(formBuffer);
                      setDefaultPageStyles(formBuffer);
                      if (formBuffer) {
                        const themeData = Object.assign({}, formBuffer.theme);
                        if (themeData.themeName) {
                        } else {
                          themeData["themeName"] = "Default Theme";
                        }
                        //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                      }
                      setGlobalLoading(false)
                      setGlobalLoadingMessage("")
                      loading(false);
                    })
                    .catch(function (error) {});
                }
              } else if (
                microFrontendData?.selectedPage &&
                Object.keys(microFrontendData?.selectedPage).length > 0
              ) {
                axios
                  .get(
                    `interfaces/${props.appId}/${microFrontendData?.selectedPage?.formId}`,
                    { withCredentials: true }
                  )
                  .then((response) => {
                    // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
                    var formBuffer;
                    if (
                      response.data.formBuffer === "" ||
                      response.data.formBuffer === "{}"
                    ) {
                      // formBuffer = defaultBuffer;
                      let clone = cloneDeep(defaultBuffer);
                      formBuffer = clone;
                    } else {
                      formBuffer = sanitizeStringToJson(
                        response.data.formBuffer
                      );
                    }
                    setActivePage(sanitizeJson(response.data));
                    setActiveSubForm(null);

                    // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                    addIdsFromJsonToExistingIDs(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    // callingDataObjects();
                    //callingDataObjectsForProcess();
                    fetchingMaskingForTextbox();
                    // recursiveJsonForMapping(response.data);

                    const repopulateJson = {
                      applicationId: microFrontendData?.applicationId,
                      formId: `${response.data.formId}`,
                      formJson: JSON.stringify(formBuffer),
                    };

                    axios
                      .post(
                        "/idesign/populateFormStateFromJson",
                        sanitizeJson(repopulateJson),
                        { withCredentials: true }
                      )
                      .then((response) => {
                        // console.log(response)
                        fetchDataObject();
                      })
                      .catch((err) => console.log(err));

                    axios
                      .post("/idesign/getRegexJson", new Object({}), {
                        withCredentials: true,
                      })
                      .then((response) => {
                        localStorage.setItem(
                          "regex",
                          JSON.stringify(response.data)
                        );
                      })
                      .catch((err) => console.log("Regex error::", err));
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    setFormBuillderMode("designer");
                    // setFormState2(formBuffer);
                    setFormStateOnOpen(formBuffer);
                    // dispatch(setFormState1(formBuffer));

                    collectAllCustomControlId(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    if (formBuffer) {
                      const themeData = Object.assign({}, formBuffer.theme);
                      if (themeData.themeName) {
                      } else {
                        themeData["themeName"] = "Default Theme";
                      }
                      //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                    }
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  })
                  .catch(function (error) {});
              } else if (
                microFrontendData?.selectedSubform &&
                Object.keys(microFrontendData?.selectedSubform).length > 0
              ) {
                // `widgets/${microFrontendData.processId}/${microFrontendData.fragmentId}
                axios
                  .get(
                    `widgets/${props.appId}/${microFrontendData?.selectedSubform?.fragmentId}`,
                    { withCredentials: true }
                  )
                  .then((response) => {
                    // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
                    var formBuffer;
                    if (
                      response.data.fragmentBuffer === "" ||
                      response.data.fragmentBuffer === "{}"
                    ) {
                      // formBuffer = defaultBuffer;
                      let clone = cloneDeep(defaultBuffer);
                      formBuffer = clone;
                    } else {
                      formBuffer = sanitizeStringToJson(
                        response.data.fragmentBuffer
                      );
                    }
                    setActiveSubForm(sanitizeJson(response.data));
                    setActivePage(null);
                    // setActivePage(sanitizeJson(response.data));
                    // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                    addIdsFromJsonToExistingIDs(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    // callingDataObjects();
                    //callingDataObjectsForProcess();
                    fetchingMaskingForTextbox();
                    // recursiveJsonForMapping(response.data);

                    // axios
                    //   .post(
                    //     "/idesign/populateFormStateFromJson",
                    //     repopulateJson,
                    //     { withCredentials: true }
                    //   )
                    //   .then((response) => {});

                    const repopulateJson = {
                      applicationId: microFrontendData?.applicationId,
                      formId: `${response.data.fragmentId}`,
                      formJson: JSON.stringify(formBuffer),
                    };

                    axios
                      .post(
                        "/idesign/populateFormStateFromJson",
                        sanitizeJson(repopulateJson),
                        { withCredentials: true }
                      )
                      .then((response) => {
                        // console.log(response)
                        fetchDataObject();
                      })
                      .catch((err) => console.log(err));

                    axios
                      .post("/idesign/getRegexJson", new Object({}), {
                        withCredentials: true,
                      })
                      .then((response) => {
                        localStorage.setItem(
                          "regex",
                          JSON.stringify(response.data)
                        );
                      })
                      .catch((err) => console.log("Regex error::", err));

                    setFormBuillderMode("designer");
                    // setFormState2(formBuffer);
                    setFormStateOnOpen(formBuffer);
                    // dispatch(setFormState1(formBuffer));

                    collectAllCustomControlId(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    if (formBuffer) {
                      const themeData = Object.assign({}, formBuffer.theme);
                      if (themeData.themeName) {
                      } else {
                        themeData["themeName"] = "Default Theme";
                      }
                      //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                    }
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  })
                  .catch(function (error) {});
              } else if (res.data.defaultFormId !== 0) {
                axios
                  .get(`interfaces/${props.appId}/${res.data.defaultFormId}`, {
                    withCredentials: true,
                  })
                  .then((response) => {
                    // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
                    window.currentInterface = response.data;
                    var formBuffer;
                    if (
                      response.data.formBuffer === "" ||
                      response.data.formBuffer === "{}"
                    ) {
                      // formBuffer = defaultBuffer;
                      let clone = cloneDeep(defaultBuffer);
                      formBuffer = clone;
                    } else {
                      formBuffer = sanitizeStringToJson(
                        response.data.formBuffer
                      );
                    }
                    setActivePage(sanitizeJson(response.data));
                    setActiveSubForm(null);
                    // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                    addIdsFromJsonToExistingIDs(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    // callingDataObjects();
                    //callingDataObjectsForProcess();
                    fetchingMaskingForTextbox();
                    // recursiveJsonForMapping(response.data);
                    const response1 = response?.data ? response : {};
                    const response2 = response1 ? (response1?.data ? response1.data : {}) : {};
                    const response3 = response2 ? (response2?.formBuffer ? response2.formBuffer : {}) : {};

                    var formDataObj = JSON.parse(response3);
                    // var formDataObj = JSON.parse(response.data.formBuffer);
                    if(isLoginPortal.current === "Y" && formDataObj?.routeCriteriaApplied){
                        dispatch(updateStateInRedux({name: "routeCriteriaApplied", value: true}));
                      }
                    recursiveJsonForMapping(formDataObj.children);

                    const repopulateJson = {
                      formId: `${response.data.formId}`,
                      formJson: `${response.data.formBuffer}`,
                      applicationName: microFrontendData?.applicationName,
                      applicationId: microFrontendData?.applicationId,
                      userName:
                        microFrontendData?.sessionData?.sessionData?.userId,
                      userIndex:
                        microFrontendData?.sessionData?.sessionData?.userIndex,
                    };
                        axios
                          .post(
                            "/idesign/populateFormStateFromJson",
                            sanitizeJson(repopulateJson),
                            { withCredentials: true }
                          )
                          .then((response) => {
                            // console.log(response)
                            fetchDataObject();
                          })
                          .catch((err) => {console.log(err)
                            setGlobalLoading(false)
                            setGlobalLoadingMessage("")});
                          setGlobalLoading(false)
                          setGlobalLoadingMessage("")
                        axios
                          .post("/idesign/getRegexJson", new Object({}), {
                            withCredentials: true,
                          })
                          .then((response) => {
                            localStorage.setItem(
                              "regex",
                              JSON.stringify(response.data)
                            );
                          })
                          .catch((err) => console.log("Regex error::", err));

                        setFormBuillderMode("designer");
                        // setFormState2(formBuffer);
                        setFormStateOnOpen({...formBuffer, "formId": `${response.data.formId}`});
                        // dispatch(setFormState1(formBuffer));

                    collectAllCustomControlId(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    if (formBuffer) {
                      const themeData = Object.assign({}, formBuffer.theme);
                      if (themeData.themeName) {
                      } else {
                        themeData["themeName"] = "Default Theme";
                      }
                      //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                    }
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  })
                  .catch(function (error) {
                    setOpenLoader(false);
                    setGlobalLoading(false)
                      setGlobalLoadingMessage("")
                    // alert("There is some issue in form opening. Kindly check with system administrator");
                    showAlertConfirmNotifications({
                      open: true,
                      showConfirm: "showNotification",
                      alertType: "error",
                      alertContentKey:
                        "There is some issue in form opening. Kindly check with system administrator",
                    });
                  });
              } else if (activePage && activePage?.formId) {
                axios
                  .get(`interfaces/${props.appId}/${activePage?.formId}`, {
                    withCredentials: true,
                  })
                  .then((response) => {
                    // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
                    var formBuffer;
                    if (
                      response.data.formBuffer === "" ||
                      response.data.formBuffer === "{}"
                    ) {
                      // formBuffer = defaultBuffer;
                      let clone = cloneDeep(defaultBuffer);
                      formBuffer = clone;
                    } else {
                      formBuffer = sanitizeStringToJson(
                        response.data.formBuffer
                      );
                    }
                    setActivePage(sanitizeJson(response.data));
                    setActiveSubForm(null);
                    // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                    addIdsFromJsonToExistingIDs(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    // callingDataObjects();
                    //callingDataObjectsForProcess();
                    fetchingMaskingForTextbox();
                    // recursiveJsonForMapping(response.data);

                    const repopulateJson = {
                      formId: `${response.data.formId}`,
                      formJson: JSON.stringify(formBuffer),
                    };

                    axios
                      .post(
                        "/idesign/populateFormStateFromJson",
                        sanitizeJson(repopulateJson),
                        { withCredentials: true }
                      )
                      .then((response) => {
                        // console.log(response)
                        fetchDataObject();
                      })
                      .catch((err) => console.log(err));

                    axios
                      .post("/idesign/getRegexJson", new Object({}), {
                        withCredentials: true,
                      })
                      .then((response) => {
                        localStorage.setItem(
                          "regex",
                          JSON.stringify(response.data)
                        );
                      })
                      .catch((err) => console.log("Regex error::", err));

                    setFormBuillderMode("designer");
                    // setFormState2(formBuffer);
                    setFormStateOnOpen(formBuffer);
                    // dispatch(setFormState1(formBuffer));

                    collectAllCustomControlId(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    if (formBuffer) {
                      const themeData = Object.assign({}, formBuffer.theme);
                      if (themeData.themeName) {
                      } else {
                        themeData["themeName"] = "Default Theme";
                      }
                      //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                    }
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  })
                  .catch(function (error) {});
              }
              // else if(res.data.defaultFormId!==0 ){
              // axios.get(`interfaces/${props.appId}/${res.data.defaultFormId}`,{withCredentials:true})
              //     .then((response)=>{
              //         // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
              //         var formBuffer
              //     if(response.data.formBuffer === "" || response.data.formBuffer === "{}"){
              //         // formBuffer = defaultBuffer;
              // let clone = cloneDeep((defaultBuffer))
              // formBuffer = clone;
              //     }else{
              //         formBuffer=sanitizeStringToJson(response.data.formBuffer);
              //     }
              //         setActivePage(sanitizeJson(response.data));
              //         // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
              //         addIdsFromJsonToExistingIDs(formBuffer);
              //         setDefaultPageStyles(formBuffer);
              //         // callingDataObjects();
              //         //callingDataObjectsForProcess();
              //         fetchingMaskingForTextbox();
              //         // recursiveJsonForMapping(response.data);

              //         var formDataObj = JSON.parse(response.data.formBuffer);

              //         recursiveJsonForMapping(formDataObj.children);

              //         const repopulateJson={
              //             "formId":`${response.data.formId}`,
              //             "formJson":JSON.stringify(formBuffer),
              //             "formJson":`${response.data.formBuffer}`,
              //             "applicationName":microFrontendData?.applicationName,
              //             "applicationId":microFrontendData?.applicationId,
              //             "userName":microFrontendData?.sessionData?.sessionData?.userId,
              //             "userIndex":microFrontendData?.sessionData?.sessionData?.userIndex

              //         };

              //         axios.post('/idesign/populateFormStateFromJson',sanitizeJson(repopulateJson),{withCredentials:true})
              //         .then((response)=>{
              //             // console.log(response)
              //             fetchDataObject()
              //         })
              //         .catch((err)=> console.log(err));

              //         axios.post('/idesign/getRegexJson',new Object({}),{withCredentials:true})
              //         .then((response)=>{
              //             // console.log('regex response :: ',response);
              //             localStorage.setItem("regex",JSON.stringify(response.data));
              //         })
              //         .catch((err)=> console.log('Regex error::',err));

              //         setFormState2(formBuffer);
              //         setFormBuillderMode("designer");
              //         // dispatch(setFormState1(formBuffer));

              //         collectAllCustomControlId(formBuffer);
              //         setDefaultPageStyles(formBuffer);
              //         if(formBuffer){
              //             const themeData = Object.assign({ }, formBuffer.theme );
              //             if( themeData.themeName){

              //             }else {
              //                 themeData['themeName'] = "Default Theme" ;
              //             }
              //             //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
              //         }
              //     })
              //     .catch(function (error) {
              //         setOpenLoader(false);
              //         // alert("There is some issue in form opening. Kindly check with system administrator");
              //         showAlertConfirmNotifications({
              //             'open':true,
              //             'showConfirm':'showNotification',
              //             'alertType':'error',
              //             'alertContentKey':'There is some issue in form opening. Kindly check with system administrator'});
              //     });
              // }
              else {
                // WHEN DEFAULT FORMID DOES NOT EXISTS i.e. default page on an application does not exists
                // console.log("inside setting default page of application");

                const activeApplicationNew = {
                  ...res.data,
                  defaultFormId: allPages[0]?.formId,
                };

                axios
                  .post(`applications/`, sanitizeJson(activeApplicationNew), {
                    withCredentials: true,
                  })
                  .then((res) => {
                    setActiveApplication(sanitizeJson(res.data));
                    // console.log("Application homepagesaved Saved");
                    axios
                      .get(
                        `interfaces/${props.appId}/${res.data.defaultFormId}`,
                        { withCredentials: true }
                      )
                      .then((response) => {
                        var formBuffer;
                        if (
                          response.data.formBuffer === "" ||
                          response.data.formBuffer === "{}"
                        ) {
                          // formBuffer = defaultBuffer;
                          let clone = cloneDeep(defaultBuffer);
                          formBuffer = clone;
                        } else {
                          formBuffer = sanitizeStringToJson(
                            response.data.formBuffer
                          );
                        }
                        setActivePage(sanitizeJson(response.data));
                        setActiveSubForm(null);

                        // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                        addIdsFromJsonToExistingIDs(formBuffer);
                        // console.log(formBuffer);
                        setDefaultPageStyles(formBuffer);
                        // callingDataObjects();
                        //callingDataObjectsForProcess();
                        fetchingMaskingForTextbox();
                        // recursiveJsonForMapping(response.data);

                        const repopulateJson = {
                          formId: `${response.data.formId}`,
                          formJson: JSON.stringify(formBuffer),
                        };

                        axios
                          .post(
                            "/idesign/populateFormStateFromJson",
                            sanitizeJson(repopulateJson),
                            { withCredentials: true }
                          )
                          .then((response) => {
                            // console.log(response)
                          })
                          .catch((err) => console.log(err));

                        axios
                          .post("/idesign/getRegexJson", new Object({}), {
                            withCredentials: true,
                          })
                          .then((response) => {
                            localStorage.setItem(
                              "regex",
                              JSON.stringify(response.data)
                            );
                          })
                          .catch((err) => console.log(err));

                        // setFormState2(formBuffer);
                        setFormStateOnOpen(formBuffer);
                        collectAllCustomControlId(formBuffer);
                        setDefaultPageStyles(formBuffer);
                        if (formBuffer) {
                          const themeData = Object.assign({}, formBuffer.theme);
                          if (themeData.themeName) {
                          } else {
                            themeData["themeName"] = "Default Theme";
                          }
                          //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                        }
                        setGlobalLoading(false)
                        setGlobalLoadingMessage("")
                        loading(false);
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  })
                  .catch((err) => {
                    console.log("ERROR FOUND in saving page: ", err);
                  });
              }
            })
            .catch(function (error) {
              console.log("Error", error);
            });
        }
      } else if (!appId) {
        // LOADING DESIGNER ON BASIS ON test.json or text.xml file in file system ( USED WHEN opened directly ie not as microfront end)
        // getConnectionSession();
        var newFormData = {};
        const jsonToSend = { formName: "testForm", formId: "5" };
        setGlobalTime({ min: sessionTime, sec: 0 });
        jsonElementOperation(jsonToSend, "getFormStateFromJson", function () {})
          .then((response) => {
            recursiveJson(response.data);
            // callingDataObjects();
            // callingDataObjectsForProcess();
            fetchingMaskingForTextbox();
            setDefaultPageStyles(sanitizeJson(response.data));

            // recursiveJsonForMapping(response.data);

            axios
              .post("/idesign/getRegexJson", new Object({}), {
                headers: {
                  Authorization: `${microFrontendData?.token}`,
                },
                withCredentials: true,
              })
              .then((response) => {
                localStorage.setItem("regex", JSON.stringify(response.data));
              });
            collectAllCustomControlId(sanitizeJson(response.data));
            setDefaultPageStyles(sanitizeJson(response.data));
            if (response.data) {
              const themeData = Object.assign({}, response.data.theme);
              if (response.data.theme && response.data.theme.themeName) {
              } else {
                themeData["themeName"] = "Default Theme";
              }
              setThemeDetails({
                ...themeDetails.current,
                appliedTheme: themeData,
              });
            }
            setFormBuillderMode("designer");
            // setFormState2(sanitizeJson(response.data));
            setFormStateOnOpen(sanitizeJson(response.data));
            setGlobalLoading(false)
            setGlobalLoadingMessage("")
            loading(false);
          })
          .catch(function (error) {
            // ***************    Data will be retrieved from XML ************************* //
            setGlobalTime({ min: sessionTime, sec: 0 });
            try {
              jsonElementOperation(jsonToSend, "getFormStateFromXml")
                .then((response) => {
                  setDefaultPageStyles(sanitizeJson(response.data));
                  axios
                    .post("/idesign/getRegexJson", new Object({}), {
                      headers: {
                        Authorization: `${microFrontendData?.token}`,
                      },
                      withCredentials: true,
                    })
                    .then((response) => {
                      // console.log("regex response :: ", response);
                      localStorage.setItem(
                        "regex",
                        JSON.stringify(response.data)
                      );
                    });
                  setFormBuillderMode("designer");
                  setDefaultPageStyles(sanitizeJson(response.data));
                  if (response.data) {
                    const themeData = Object.assign({}, response.data.theme);
                    if (response.data.theme && response.data.theme.themeName) {
                    } else {
                      themeData["themeName"] = "Default Theme";
                    }
                    setThemeDetails({
                      ...themeDetails.current,
                      appliedTheme: themeData,
                    });
                  }
                  // newFormData = addColsToControls(sanitizeJson(response.data));
                })
                .catch(function (error) {
                  // handle error
                  // console.log('regex error :: ',error);
                  showAlertConfirmNotifications({
                    open: true,
                    showConfirm: "showNotification",
                    alertType: "error",
                    alertContentKey: "FormLoadingFailureMessage",
                  });
                  // alert('You are not connected to the backend server! Application won\'t work! '+error);
                });
            } catch (e) {
              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: "FormLoadingFailureMessage",
              });
            }
          });
      }
      // const appScreenshotAlreadyPresent=appScreenshotSavedDetails.find(item=>item.componentType===componentType && item.formDefId===formDefId && item.processId===processId && item.formId===formId && item.fragementId===microFrontendData?.fragementId && item.appId===appId);
      // if(!appScreenshotAlreadyPresent){
      //   dispatch(setAppScreenshotSavedDetails([...appScreenshotSavedDetails,{appId,componentType,formDefId,processId,formId,fragementId:microFrontendData?.fragementId,isScreenshotTaken:false,screenshot:null}]))
      // }

      // setQuickToolsClose(true)
    }
    else if(childComp === "subForm") {
      if(loading)
        loading(false)
    }
    // window.setTimeout(()=>{
    //     setQuickToolsClose(false);
    // },1000);
  }, [appId, childComp, formDefId, processId, pageDataLoaded]);

  // **************** CALLS TO LOAD PREVIEW/ APPVIEWER ********************************//

  useEffect(() => {
    const width = window.screen.width;
    const height = window.screen.height;
    const language = window?.psh_configs?.selectedLanguage;
    const cabinetName_fromIni = secureLocalStorage.getItem("cabinet") || localStorage.getItem("cabinet") || window?.activeCabinet_formbuilder ;
    document.documentElement.lang = language;
    includeTheme(cabinetName_fromIni, `${width}_${height}`, language, jwtToken);
    if (childComp === "preview") {
      if (formMataData) {

      } else if (componentType === "TF") {
        axios
          .get(
            `taskform/${microFrontendData.taskId}/${microFrontendData.processDefId}`,
            {
              headers: {
                Authorization: `${microFrontendData?.token}`,
              },
              withCredentials: true,
            }
          )
          .then((response) => {
            // if(response.data.formBuffer === ""){
            //     setFormState2(defaultBuffer);
            //     setFormBuillderMode("designer");
            // }
            // else{
            var formBuffer;
            if (
              response.data.formBuffer === "" ||
              response.data.formBuffer === "{}"
            ) {
              // formBuffer = defaultBuffer;
              let clone = cloneDeep(defaultBuffer);
              formBuffer = clone;
            } else {
              formBuffer = sanitizeStringToJson(response.data.formBuffer);
            }
            addIdsFromJsonToExistingIDs(formBuffer);
            setDefaultPageStyles(formBuffer);
            // callingDataObjects();
            //callingDataObjectsForProcess();
            fetchingMaskingForTextbox();
            // recursiveJsonForMapping(response.data);

            const repopulateJson = {
              formId: `${microFrontendData.processDefId}`,
              formJson: JSON.stringify(formBuffer),
            };

            axios
              .post(
                "/idesign/populateFormStateFromJson",
                sanitizeJson(repopulateJson),
                { withCredentials: true }
              )
              .then((response) => {
                // console.log(response)
              })
              .catch((err) => console.log(err));

            axios
              .post("/idesign/getRegexJson", new Object({}), {
                withCredentials: true,
              })
              .then((response) => {
                localStorage.setItem("regex", JSON.stringify(response.data));
              })
              .catch((err) => console.log("Regex error::", err));

            setFormBuillderMode("designer");
            // setFormState2(formBuffer);
            setFormStateOnOpen(formBuffer);
            setGlobalLoading(false)
          setGlobalLoadingMessage("")
            loading(false);
            // }
          })
          .catch((err) => {});
      } else if (componentType === "GT") {
        axios
          .get(`tasktemplateform/${microFrontendData.templateId}`, {
            headers: {
              Authorization: `${microFrontendData?.token}`,
            },
            withCredentials: true,
          })
          .then((response) => {
            var formBuffer;
            if (
              response.data.formBuffer === "" ||
              response.data.formBuffer === "{}"
            ) {
              // formBuffer = defaultBuffer;
              let clone = cloneDeep(defaultBuffer);
              formBuffer = clone;
            } else {
              formBuffer = sanitizeStringToJson(response.data.formBuffer);
            }
            addIdsFromJsonToExistingIDs(formBuffer);
            setDefaultPageStyles(formBuffer);
            // callingDataObjects();
            //callingDataObjectsForProcess();
            fetchingMaskingForTextbox();

            // var formDataObj = JSON.parse(response.data.formBuffer);

            // recursiveJsonForMapping(formDataObj.children);
            // recursiveJsonForMapping(response.data);

            const repopulateJson = {
              formId: `${
                microFrontendData?.processDefId || microFrontendData?.templateId
              }`,
              formJson: JSON.stringify(formBuffer),
            };

            axios
              .post(
                "/idesign/populateFormStateFromJson",
                sanitizeJson(repopulateJson),
                { withCredentials: true }
              )
              .then((response) => {
                // console.log(response)
              })
              .catch((err) => console.log(err));

            axios
              .post("/idesign/getRegexJson", new Object({}), {
                withCredentials: true,
              })
              .then((response) => {
                localStorage.setItem("regex", JSON.stringify(response.data));
              })
              .catch((err) => console.log("Regex error::", err));

            setFormBuillderMode("designer");
            // setFormState2(formBuffer);
            setFormStateOnOpen(formBuffer);
            setGlobalLoading(false)
            setGlobalLoadingMessage("")

            loading(false);
          })
          .catch((err) => {});
      } else if (formDefId && processId) {
        //*******  TO LOAD APPLICATION WHEN WE ARE OPENING A FORM INSIDE A PROCESS ***** //
        if (
          props.containerId === "mf_formPreview" &&
          window.statusTypeForm !== undefined
        ) {
          if (window.statusTypeForm === "L") {
            axios
              .get(`/process/local/${processId}/${formDefId}`, {
                withCredentials: true,
              })
              .then((response) => {
                // setActivePage(sanitizeJson(response.data));
                dispatch(
                  updateMarvinContexts({
                    key: containerId,
                    states: {
                      isMarvinEnabled: response?.data?.isMarvinEnabled,  
                    },                  
                  })
                );
                var formBuffer;
                if (
                  response.data.formBuffer === "" ||
                  response.data.formBuffer === "{}"
                ) {
                  // formBuffer = defaultBuffer;
                  let clone = cloneDeep(defaultBuffer);
                  formBuffer = clone;
                } else {
                  formBuffer = sanitizeStringToJson(response.data.formBuffer);
                }
                addIdsFromJsonToExistingIDs(formBuffer);
                // console.log(formBuffer);
                setDefaultPageStyles(formBuffer);
                // callingDataObjects();
                //callingDataObjectsForProcess();
                fetchingMaskingForTextbox();
                // recursiveJsonForMapping(response.data);

                const repopulateJson = {
                  formId: `${formDefId}`,
                  formJson: JSON.stringify(formBuffer),
                };

                axios
                  .post(
                    "/idesign/populateFormStateFromJson",
                    sanitizeJson(repopulateJson),
                    { withCredentials: true }
                  )
                  .then((response) => {
                    // console.log(response);
                  })
                  .catch((err) => console.log(err));

                axios
                  .post("/idesign/getRegexJson", new Object({}), {
                    withCredentials: true,
                  })
                  .then((response) => {
                    localStorage.setItem(
                      "regex",
                      JSON.stringify(response.data)
                    );
                  })
                  .catch((err) => console.log("Regex error::", err));

                setFormBuillderMode("preview");
                // setFormState2(formBuffer);
                setFormStateOnOpen(formBuffer);
                delete window.statusTypeForm;
                setGlobalLoading(false)
                setGlobalLoadingMessage("")
                loading(false);
              })
              .catch((err) => {
                console.log("error in loading form of above process");
              });
          } else {
            axios
              .get(`/process/registered/${processId}/${formDefId}`, {
                withCredentials: true,
              })
              .then((response) => {
                // setActivePage(sanitizeJson(response.data));
                dispatch(
                  updateMarvinContexts({
                    key: containerId,
                    states: {
                      isMarvinEnabled: response?.data?.isMarvinEnabled,  
                    },                  
                  })
                );
                var formBuffer;
                if (
                  response.data.formBuffer === "" ||
                  response.data.formBuffer === "{}"
                ) {
                  // formBuffer = defaultBuffer;
                  let clone = cloneDeep(defaultBuffer);
                  formBuffer = clone;
                } else {
                  formBuffer = sanitizeStringToJson(response.data.formBuffer);
                }
                addIdsFromJsonToExistingIDs(formBuffer);
                // console.log(formBuffer);
                setDefaultPageStyles(formBuffer);
                // callingDataObjects();
                //callingDataObjectsForProcess();
                fetchingMaskingForTextbox();
                // recursiveJsonForMapping(response.data);

                const repopulateJson = {
                  formId: `${formDefId}`,
                  formJson: JSON.stringify(formBuffer),
                };

                axios
                  .post(
                    "/idesign/populateFormStateFromJson",
                    sanitizeJson(repopulateJson),
                    { withCredentials: true }
                  )
                  .then((response) => {
                    // console.log(response);
                  })
                  .catch((err) => console.log(err));

                axios
                  .post("/idesign/getRegexJson", new Object({}), {
                    withCredentials: true,
                  })
                  .then((response) => {
                    localStorage.setItem(
                      "regex",
                      JSON.stringify(response.data)
                    );
                  })
                  .catch((err) => console.log("Regex error::", err));

                setFormBuillderMode("preview");
                // setFormState2(formBuffer);
                setFormStateOnOpen(formBuffer);
                
                delete window.statusTypeForm;
                setGlobalLoading(false)
                setGlobalLoadingMessage("")
                loading(false);
              })
              .catch((err) => {
                console.log("error in loading form of above process");
                loading(false);
              });
          }
        } else if (formPageType === "Portals") {
          axios
            .get(`/interfaces/${processId}/${formDefId}`, {
              withCredentials: true,
            })
            .then((response) => {
              // setActivePage(sanitizeJson(response.data));
              var formBuffer;
              if (
                response.data.formBuffer === "" ||
                response.data.formBuffer === "{}"
              ) {
                // formBuffer = defaultBuffer;
                let clone = cloneDeep(defaultBuffer);
                formBuffer = clone;
              } else {
                formBuffer = sanitizeStringToJson(response.data.formBuffer);
              }
              addIdsFromJsonToExistingIDs(formBuffer);
              setDefaultPageStyles(formBuffer);
              // callingDataObjects();
              //callingDataObjectsForProcess();
              fetchingMaskingForTextbox();

              // recursiveJsonForMapping(response.data);

              const repopulateJson = {
                formId: `${formDefId}`,
                formJson: JSON.stringify(formBuffer),
                applicationName: microFrontendData.applicationName,
                applicationId: microFrontendData.applicationId,
                userName: microFrontendData?.sessionData?.sessionData?.userId,
                userIndex:
                  microFrontendData?.sessionData?.sessionData?.userIndex,
              };

              axios
                .post(
                  "/idesign/populateFormStateFromJson",
                  sanitizeJson(repopulateJson),
                  { withCredentials: true }
                )
                .then((response) => {
                  // console.log(response)
                })
                .catch((err) => console.log(err));

              axios
                .post("/idesign/getRegexJson", new Object({}), {
                  withCredentials: true,
                })
                .then((response) => {
                  // console.log('regex response :: ',response);
                  localStorage.setItem("regex", JSON.stringify(response.data));
                })
                .catch((err) => console.log("Regex error::", err));

              setFormBuillderMode("designer");
              // setFormState2(formBuffer);
              setFormStateOnOpen(formBuffer);
              setGlobalLoading(false)
              setGlobalLoadingMessage("")
              loading(false);
            })
            .catch((err) => {
              console.log("error in loading form of above process");
              setGlobalLoading(false)
              setGlobalLoadingMessage("")
              loading(false);
            });
        } else {
          if (statusType === "L") {
            axios
              .get(`/process/local/${processId}/${formDefId}`, {
                withCredentials: true,
              })
              .then((response) => {
                // setActivePage(sanitizeJson(response.data));
                dispatch(
                  updateMarvinContexts({
                    key: containerId,
                    states: {
                      isMarvinEnabled: response?.data?.isMarvinEnabled,  
                    },                  
                  })
                );
                var formBuffer;
                if (
                  response.data.formBuffer === "" ||
                  response.data.formBuffer === "{}"
                ) {
                  // formBuffer = defaultBuffer;
                  let clone = cloneDeep(defaultBuffer);
                  formBuffer = clone;
                } else {
                  formBuffer = sanitizeStringToJson(response.data.formBuffer);
                }
                addIdsFromJsonToExistingIDs(formBuffer);
                // console.log(formBuffer);
                setDefaultPageStyles(formBuffer);
                // callingDataObjects();
                //callingDataObjectsForProcess();
                fetchingMaskingForTextbox();
                // recursiveJsonForMapping(response.data);

                const repopulateJson = {
                  formId: `${formDefId}`,
                  formJson: JSON.stringify(formBuffer),
                };

                // axios
                //   .post(
                //     "/idesign/populateFormStateFromJson",
                //     sanitizeJson(repopulateJson),
                //     { withCredentials: true }
                //   )
                //   .then((response) => {
                //     // console.log(response);
                //   })
                //   .catch((err) => console.log(err));

                axios
                  .post("/idesign/getRegexJson", new Object({}), {
                    withCredentials: true,
                  })
                  .then((response) => {
                    localStorage.setItem(
                      "regex",
                      JSON.stringify(response.data)
                    );
                  })
                  .catch((err) => console.log("Regex error::", err));

                setFormBuillderMode("preview");
                // setFormState2(formBuffer);
                setFormStateOnOpen(formBuffer);
                setGlobalLoading(false)
              setGlobalLoadingMessage("")
                loading(false);
              })
              .catch((err) => {
                console.log("error in loading form of above process");
                setGlobalLoading(false)
              setGlobalLoadingMessage("")
                loading(false);
              });
          } else {
            axios
              .get(`/process/registered/${processId}/${formDefId}`, {
                withCredentials: true,
              })
              .then((response) => {
                // setActivePage(sanitizeJson(response.data));
                dispatch(
                  updateMarvinContexts({
                    key: containerId,
                    states: {
                      isMarvinEnabled: response?.data?.isMarvinEnabled,  
                    },                  
                  })
                );
                var formBuffer;
                if (
                  response.data.formBuffer === "" ||
                  response.data.formBuffer === "{}"
                ) {
                  // formBuffer = defaultBuffer;
                  let clone = cloneDeep(defaultBuffer);
                  formBuffer = clone;
                } else {
                  formBuffer = sanitizeStringToJson(response.data.formBuffer);
                }
                addIdsFromJsonToExistingIDs(formBuffer);
                // console.log(formBuffer);
                setDefaultPageStyles(formBuffer);
                // callingDataObjects();
                //callingDataObjectsForProcess();
                fetchingMaskingForTextbox();
                // recursiveJsonForMapping(response.data);

                const repopulateJson = {
                  formId: `${formDefId}`,
                  formJson: JSON.stringify(formBuffer),
                };

                axios
                  .post(
                    "/idesign/populateFormStateFromJson",
                    sanitizeJson(repopulateJson),
                    { withCredentials: true }
                  )
                  .then((response) => {
                    // console.log(response);
                  })
                  .catch((err) => console.log(err));

                axios
                  .post("/idesign/getRegexJson", new Object({}), {
                    withCredentials: true,
                  })
                  .then((response) => {
                    localStorage.setItem(
                      "regex",
                      JSON.stringify(response.data)
                    );
                  })
                  .catch((err) => console.log("Regex error::", err));

                setFormBuillderMode("preview");
                // setFormState2(formBuffer);
                setFormStateOnOpen(formBuffer);
                setGlobalLoading(false)
                setGlobalLoadingMessage("")
                loading(false);
              })
              .catch((err) => {
                console.log("error in loading form of above process");
                setGlobalLoading(false)
              setGlobalLoadingMessage("")
                loading(false);
              });
          }
        }
      } else if (formId) {
        axios
          .get(`/templates/${props.formId}`, { withCredentials: true })
          .then((response) => {
            // console.log("process/local/",response);
            var templatebuffer = sanitizeStringToJson(
              response.data.templatebuffer
            );
            setDevice(props?.mfProps?.data?.device);
            const viewformJson = {
              isApp: "false",
              DeviceType: "W",
              isGeneralDataCreated: false,
              isWIModelCreated: false,
              gdtoken: "TestProcess-0000000003-process_GeneralData",
              witoken: "",
              pid: "TestProcess-0000000003-process",
              wid: "1",
              tid: "",
              fid: "Form_TestProcess-0000000003-process_1",
              formJson: response.data.templatebuffer,
              isPreview: true,
              jwtToken: jwtToken,
            };

            axios
              .post("/viewform/", viewformJson, { withCredentials: true })
              .then((resp) => {
                setFormBuillderMode("preview");
                // setFormState2(templatebuffer);
                setFormStateOnOpen(templatebuffer);
                setGlobalLoading(false)
                setGlobalLoadingMessage("")
                loading(false);
                // dispatch(setFormState1(formBuffer));
              })
              .catch((err) => {
                console.log(err);
                setFormBuillderMode("preview");
                setFormStateOnOpen(templatebuffer);
                setGlobalLoading(false)
                setGlobalLoadingMessage("")
                // setFormState2(templatebuffer);
                loading(false);
              });
          });
      } else if (microFrontendData?.fragmentId) {
        axios
          .get(
            `widgets/${microFrontendData.processId}/${microFrontendData.fragmentId}`,
            { withCredentials: true }
          )
          .then((response) => {
            setActiveApplication(response.data);
            setActiveSubForm(response.data);
            setActivePage(null);
            var formBuffer = JSON.parse(response.data.fragmentBuffer);
            // addIdsFromJsonToExistingIDs(formBuffer);
            //  console.log(formBuffer);

            const repopulateJson = {
              formId: `${microFrontendData.fragmentId}`,
              formJson: `${response.data.fragmentBuffer}`,
            };

            axios
              .post("/idesign/populateFormStateFromJson", repopulateJson, {
                withCredentials: true,
              })
              .then((response) => {
                //  console.log(response)
                fetchDataObject();
              });
            // setFormState2(formBuffer);
            setFormStateOnOpen(formBuffer);
            setGlobalLoading(false)
            setGlobalLoadingMessage("")
            loading(false);
            setCurrentMappedDO([]);
          })
          .catch(function (error) {
            console.log(error);
            setGlobalLoading(false)
            setGlobalLoadingMessage("")
            loading(false);
          });
      } else if (appId && pageDataLoaded && pageDataLoaded === appId) {
        //console.log("activeApplication0", activeApplication)
        var activeApp;
        var newId;
        if (microFrontendData.categoryId === "TEMPLATE") {
          if (microFrontendData?.activeStatusType === "A") {
            var templateBufferId = "";
            axios
              .get(`/templates/${appId}`, { withCredentials: true })
              .then((response) => {
                templateBufferId = response.data.templatebuffer;
                activeApp = response.data;
              })
              .then((data) => {
                setGlobalTime({ min: sessionTime, sec: 0 });
                axios
                  .get(`/applications/${templateBufferId}`, {
                    // headers: {
                    //   Authorization: `${microFrontendData?.token}`,
                    // },
                    withCredentials: true,
                  })
                  .then((res) => {
                    dispatch(
                      updateMarvinContexts({
                        key: containerId,
                        states: {
                          isMarvinEnabled: res?.data?.isMarvinEnabled,  
                        },                  
                      })
                    );
                    setActiveApplication(
                      { ...activeApp },
                      { status: res.data.status }
                    );
                    setApplicationData(res.data);
                    setGlobalTime({ min: sessionTime, sec: 0 });

                    if (activePage && activePage?.formId) {
                      axios
                        .get(
                          `interfaces/${templateBufferId}/${activePage?.formId}`,
                          { withCredentials: true }
                        )
                        .then((response) => {
                          // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
                          var formBuffer;
                          if (
                            response.data.formBuffer === "" ||
                            response.data.formBuffer === "{}"
                          ) {
                            // formBuffer = defaultBuffer;
                            let clone = cloneDeep(defaultBuffer);
                            formBuffer = clone;
                          } else {
                            formBuffer = sanitizeStringToJson(
                              response.data.formBuffer
                            );
                          }
                          setActivePage(sanitizeJson(response.data));
                          setActiveSubForm(null);

                          // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                          addIdsFromJsonToExistingIDs(formBuffer);
                          // console.log(formBuffer);
                          setDefaultPageStyles(formBuffer);
                          // callingDataObjects();
                          //callingDataObjectsForProcess();
                          fetchingMaskingForTextbox();
                          // recursiveJsonForMapping(response.data);

                          const repopulateJson = {
                            formId: `${response.data.formId}`,
                            formJson: JSON.stringify(formBuffer),
                          };

                          axios
                            .post(
                              "/idesign/populateFormStateFromJson",
                              sanitizeJson(repopulateJson),
                              { withCredentials: true }
                            )
                            .then((response) => {
                              // console.log(response)
                              fetchDataObject();
                            })
                            .catch((err) => console.log(err));

                          axios
                            .post("/idesign/getRegexJson", new Object({}), {
                              withCredentials: true,
                            })
                            .then((response) => {
                              localStorage.setItem(
                                "regex",
                                JSON.stringify(response.data)
                              );
                            })
                            .catch((err) => console.log("Regex error::", err));

                          setFormBuillderMode("designer");
                          // setFormState2(formBuffer);
                          setFormStateOnOpen(formBuffer);

                          // dispatch(setFormState1(formBuffer));

                          collectAllCustomControlId(formBuffer);
                          setDefaultPageStyles(formBuffer);
                          if (formBuffer) {
                            const themeData = Object.assign(
                              {},
                              formBuffer.theme
                            );
                            if (themeData.themeName) {
                            } else {
                              themeData["themeName"] = "Default Theme";
                            }
                            //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                          }
                          setGlobalLoading(false)
                          setGlobalLoadingMessage("")
                          loading(false);
                        })
                        .catch(function (error) {});
                    } else if (res.data.defaultFormId !== 0) {
                      axios
                        .get(
                          `interfaces/${templateBufferId}/${res.data.defaultFormId}`,
                          { withCredentials: true }
                        )
                        .then((response) => {
                          // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
                          var formBuffer;
                          if (
                            response.data.formBuffer === "" ||
                            response.data.formBuffer === "{}"
                          ) {
                            // formBuffer = defaultBuffer;
                            let clone = cloneDeep(defaultBuffer);
                            formBuffer = clone;
                          } else {
                            formBuffer = sanitizeStringToJson(
                              response.data.formBuffer
                            );
                          }
                          setActivePage(sanitizeJson(response.data));
                          setActiveSubForm(null);

                          // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                          addIdsFromJsonToExistingIDs(formBuffer);
                          // console.log(formBuffer);
                          setDefaultPageStyles(formBuffer);
                          // callingDataObjects();
                          //callingDataObjectsForProcess();
                          fetchingMaskingForTextbox();
                          // recursiveJsonForMapping(response.data);

                          const response1 = response?.data ? response : {};
                          const response2 = response1 ? (response1?.data ? response1.data : {}) : {};
                          const response3 = response2 ? (response2?.formBuffer ? response2.formBuffer : {}) : {};

                          var formDataObj = JSON.parse(response3);

                          recursiveJsonForMapping(formDataObj.children);

                          const repopulateJson = {
                            formId: `${response.data.formId}`,
                            formJson: `${response.data.formBuffer}`,
                            applicationName: microFrontendData?.applicationName,
                            applicationId: microFrontendData?.applicationId,
                            userName:
                              microFrontendData?.sessionData?.sessionData
                                ?.userId,
                            userIndex:
                              microFrontendData?.sessionData?.sessionData
                                ?.userIndex,
                          };

                          axios
                            .post(
                              "/idesign/populateFormStateFromJson",
                              sanitizeJson(repopulateJson),
                              { withCredentials: true }
                            )
                            .then((response) => {
                              // console.log(response)
                              fetchDataObject();
                            })
                            .catch((err) => console.log(err));

                          axios
                            .post("/idesign/getRegexJson", new Object({}), {
                              withCredentials: true,
                            })
                            .then((response) => {
                              // console.log('regex response :: ',response);
                              localStorage.setItem(
                                "regex",
                                JSON.stringify(response.data)
                              );
                            })
                            .catch((err) => console.log("Regex error::", err));

                          setFormBuillderMode("designer");
                          // setFormState2(formBuffer);
                          setFormStateOnOpen(formBuffer);
                          
                          // dispatch(setFormState1(formBuffer));

                          collectAllCustomControlId(formBuffer);
                          setDefaultPageStyles(formBuffer);
                          if (formBuffer) {
                            const themeData = Object.assign(
                              {},
                              formBuffer.theme
                            );
                            if (themeData.themeName) {
                            } else {
                              themeData["themeName"] = "Default Theme";
                            }
                            //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                          }
                          setGlobalLoading(false)
                          setGlobalLoadingMessage("")
                          loading(false);
                        })
                        .catch(function (error) {
                          setOpenLoader(false);
                          // alert("There is some issue in form opening. Kindly check with system administrator");
                          showAlertConfirmNotifications({
                            open: true,
                            showConfirm: "showNotification",
                            alertType: "error",
                            alertContentKey:
                              "There is some issue in form opening. Kindly check with system administrator",
                          });
                        });
                    } else {
                      // WHEN DEFAULT FORMID DOES NOT EXISTS i.e. default page on an application does not exists
                      // console.log("inside setting default page of application");

                      const activeApplicationNew = {
                        ...res.data,
                        defaultFormId: allPages[0]?.formId,
                      };

                      axios
                        .post(
                          `applications/`,
                          sanitizeJson(activeApplicationNew),
                          { withCredentials: true }
                        )
                        .then((res) => {
                          setActiveApplication(sanitizeJson(res.data));
                          // console.log("Application homepagesaved Saved");
                          axios
                            .get(
                              `interfaces/${props.appId}/${res.data.defaultFormId}`,
                              { withCredentials: true }
                            )
                            .then((response) => {
                              var formBuffer;
                              if (
                                response.data.formBuffer === "" ||
                                response.data.formBuffer === "{}"
                              ) {
                                // formBuffer = defaultBuffer;
                                let clone = cloneDeep(defaultBuffer);
                                formBuffer = clone;
                              } else {
                                formBuffer = sanitizeStringToJson(
                                  response.data.formBuffer
                                );
                              }
                              setActivePage(sanitizeJson(response.data));
                              setActiveSubForm(null);

                              // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                              addIdsFromJsonToExistingIDs(formBuffer);
                              // console.log(formBuffer);
                              setDefaultPageStyles(formBuffer);
                              // callingDataObjects();
                              //callingDataObjectsForProcess();
                              fetchingMaskingForTextbox();
                              // recursiveJsonForMapping(response.data);

                              const repopulateJson = {
                                formId: `${response.data.formId}`,
                                formJson: JSON.stringify(formBuffer),
                              };

                              axios
                                .post(
                                  "/idesign/populateFormStateFromJson",
                                  sanitizeJson(repopulateJson),
                                  { withCredentials: true }
                                )
                                .then((response) => {
                                  // console.log(response)
                                })
                                .catch((err) => console.log(err));

                              axios
                                .post("/idesign/getRegexJson", new Object({}), {
                                  withCredentials: true,
                                })
                                .then((response) => {
                                  localStorage.setItem(
                                    "regex",
                                    JSON.stringify(response.data)
                                  );
                                })
                                .catch((err) => console.log(err));

                              // setFormState2(formBuffer);
                              setFormStateOnOpen(formBuffer);
                              collectAllCustomControlId(formBuffer);
                              setDefaultPageStyles(formBuffer);
                              if (formBuffer) {
                                const themeData = Object.assign(
                                  {},
                                  formBuffer.theme
                                );
                                if (themeData.themeName) {
                                } else {
                                  themeData["themeName"] = "Default Theme";
                                }
                                //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                              }
                              setGlobalLoading(false)
                          setGlobalLoadingMessage("")
                              loading(false);
                            })
                            .catch((err) => {
                              console.log(err);
                            });
                        })
                        .catch((err) => {
                          console.log("ERROR FOUND in saving page: ", err);
                        });
                    }
                  })
                  .catch(function (error) {
                    console.log("Error", error);
                  });
              });
          } else if (
            microFrontendData?.activeStatusType === "L" &&
            microFrontendData?.activeFormPageType === "Processes"
          ) {
            axios
              .get(`/templates/${appId}`, { withCredentials: true })
              .then((response) => {
                newId = parseInt(response.data.templatebuffer);
                setActiveApplication({ ...response.data });
              })
              .then((data) => {
                axios
                  .get(
                    `/process/local/${microFrontendData?.activeIdentifierId}/${newId}`,
                    {
                      // headers: {
                      //   Authorization: `${microFrontendData?.token}`,
                      // },
                      withCredentials: true,
                    }
                  )
                  .then((response) => {
                    // setActivePage(sanitizeJson(response.data));
                    // setActiveApplication({...response.data},{status:"local"});
                    dispatch(
                      updateMarvinContexts({
                        key: containerId,
                        states: {
                          isMarvinEnabled: response?.data?.isMarvinEnabled,  
                        },                  
                      })
                    );
                    var formBuffer;
                    if (
                      response.data.formBuffer === "" ||
                      response.data.formBuffer === "{}" ||
                      response.data.formBuffer === " "
                    ) {
                      // formBuffer = defaultBuffer;
                      let clone = cloneDeep(defaultBuffer);
                      formBuffer = clone;
                    } else {
                      formBuffer = sanitizeStringToJson(
                        response.data.formBuffer
                      );
                    }
                    addIdsFromJsonToExistingIDs(formBuffer);
                    // console.log(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    // callingDataObjects();
                    //callingDataObjectsForProcess();
                    fetchingMaskingForTextbox();
                    // recursiveJsonForMapping(response.data);

                    const repopulateJson = {
                      formId: `${newId}`,
                      formJson: JSON.stringify(formBuffer),
                      //"formJson": Object.keys(response.data.formBuffer).length !== 0 ? `${response.data.formBuffer}`   : defaultBuffer
                      // "formJson": defaultBuffer
                    };

                    axios
                      .post(
                        "/idesign/populateFormStateFromJson",
                        sanitizeJson(repopulateJson),
                        { withCredentials: true }
                      )
                      .then((response) => {
                        // console.log(response);
                      })
                      .catch((err) => console.log(err));

                    axios
                      .post("/idesign/getRegexJson", new Object({}), {
                        withCredentials: true,
                      })
                      .then((response) => {
                        localStorage.setItem(
                          "regex",
                          JSON.stringify(response.data)
                        );
                      })
                      .catch((err) => console.log("Regex error::", err));

                    setFormBuillderMode("designer");
                    // setFormState2(formBuffer);
                    setFormStateOnOpen(formBuffer);
                  })
                  .catch((err) => {
                    console.log("error in loading form of above process");
                  });
              });
          } else if (
            microFrontendData?.activeStatusType === "R" &&
            microFrontendData?.activeFormPageType === "Processes"
          ) {
            axios
              .get(`/templates/${appId}`, { withCredentials: true })
              .then((response) => {
                newId = parseInt(response.data.templatebuffer);
                setActiveApplication({ ...response.data });
              })
              .then((data) => {
                axios
                  .get(
                    `/process/registered/${microFrontendData?.activeIdentifierId}/${newId}`,
                    {
                      // headers: {
                      //   Authorization: `${microFrontendData?.token}`,
                      // },
                      withCredentials: true,
                    }
                  )
                  .then((response) => {
                    // setActivePage(sanitizeJson(response.data));
                    // setActiveApplication({...response.data},{status:"registered"});
                    dispatch(
                      updateMarvinContexts({
                        key: containerId,
                        states: {
                          isMarvinEnabled: response?.data?.isMarvinEnabled,  
                        },                  
                      })
                    );
                    var formBuffer;
                    if (
                      response.data.formBuffer === "" ||
                      response.data.formBuffer === "{}" ||
                      response.data.formBuffer === " "
                    ) {
                      // formBuffer = defaultBuffer;
                      let clone = cloneDeep(defaultBuffer);
                      formBuffer = clone;
                    } else {
                      formBuffer = sanitizeStringToJson(
                        response.data.formBuffer
                      );
                    }
                    addIdsFromJsonToExistingIDs(formBuffer);
                    // console.log(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    // callingDataObjects();
                    //callingDataObjectsForProcess();
                    fetchingMaskingForTextbox();
                    // recursiveJsonForMapping(response.data);

                    const repopulateJson = {
                      formId: `${newId}`,
                      formJson: JSON.stringify(formBuffer),
                    };

                    axios
                      .post(
                        "/idesign/populateFormStateFromJson",
                        sanitizeJson(repopulateJson),
                        {
                          headers: {
                            Authorization: `${microFrontendData?.token}`,
                          },
                          withCredentials: true,
                        }
                      )
                      .then((response) => {
                        // console.log(response);
                      })
                      .catch((err) => console.log(err));

                    axios
                      .post("/idesign/getRegexJson", new Object({}), {
                        headers: {
                          Authorization: `${microFrontendData?.token}`,
                        },
                        withCredentials: true,
                      })
                      .then((response) => {
                        localStorage.setItem(
                          "regex",
                          JSON.stringify(response.data)
                        );
                      })
                      .catch((err) => console.log("Regex error::", err));

                    setFormBuillderMode("designer");
                    // setFormState2(formBuffer);
                    setFormStateOnOpen(formBuffer);
                  })
                  .catch((err) => {
                    console.log("error in loading form of above process");
                  });
              });
          } else if (
            microFrontendData?.activeStatusType === "L" &&
            microFrontendData?.activeFormPageType === "Portals"
          ) {
            axios
              .get(`/templates/${appId}`, { withCredentials: true })
              .then((response) => {
                newId = parseInt(response.data.templatebuffer);
                setActiveApplication({ ...response.data });
              })
              .then((data) => {
                axios
                  .get(
                    `/interfaces/${microFrontendData?.activeIdentifierId}/${newId}`,
                    {
                      headers: {
                        Authorization: `${microFrontendData?.token}`,
                      },
                      withCredentials: true,
                    }
                  )
                  .then((response) => {
                    // setActivePage(sanitizeJson(response.data));
                    // setActiveApplication({...response.data},{status:"registered"});
                    var formBuffer;
                    if (
                      response.data.formBuffer === "" ||
                      response.data.formBuffer === "{}"
                    ) {
                      // formBuffer = defaultBuffer;
                      let clone = cloneDeep(defaultBuffer);
                      formBuffer = clone;
                    } else {
                      formBuffer = sanitizeStringToJson(
                        response.data.formBuffer
                      );
                    }
                    addIdsFromJsonToExistingIDs(formBuffer);
                    // console.log(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    // callingDataObjects();
                    //callingDataObjectsForProcess();
                    fetchingMaskingForTextbox();
                    // recursiveJsonForMapping(response.data);

                    const repopulateJson = {
                      formId: `${newId}`,
                      formJson: JSON.stringify(formBuffer),
                      applicationName: microFrontendData?.applicationName,
                      applicationId:
                        microFrontendData?.applicationId ||
                        response.data.existingFormId ||
                        response.data.projectId,
                      userName:
                        microFrontendData?.sessionData?.sessionData?.userId,
                      userIndex:
                        microFrontendData?.sessionData?.sessionData?.userIndex,
                    };

                    axios
                      .post(
                        "/idesign/populateFormStateFromJson",
                        sanitizeJson(repopulateJson),
                        { withCredentials: true }
                      )
                      .then((response) => {
                        // console.log(response)
                      })
                      .catch((err) => console.log(err));

                    axios
                      .post("/idesign/getRegexJson", new Object({}), {
                        withCredentials: true,
                      })
                      .then((response) => {
                        // console.log('regex response :: ',response);
                        localStorage.setItem(
                          "regex",
                          JSON.stringify(response.data)
                        );
                      })
                      .catch((err) => console.log("Regex error::", err));

                    setFormBuillderMode("designer");
                    // setFormState2(formBuffer);
                    setFormStateOnOpen(formBuffer);
                    setGlobalLoading(false)
                          setGlobalLoadingMessage("")
                    loading(false);
                  })
                  .catch((err) => {
                    console.log("error in loading form of above process");
                    setGlobalLoading(false)
                          setGlobalLoadingMessage("")
                    loading(false);
                  });
              });
          } else if (
            microFrontendData?.activeStatusType === "R" &&
            microFrontendData?.activeFormPageType === "Portals"
          ) {
            axios
              .get(`/templates/${appId}`, { withCredentials: true })
              .then((response) => {
                newId = response.data.templatebuffer;
                setActiveApplication({ ...response.data });
              })
              .then((data) => {
                axios
                  .get(
                    `widgets/${microFrontendData?.activeIdentifierId}/${newId}`,
                    { withCredentials: true }
                  )
                  .then((response) => {
                    // setActiveApplication(response.data)
                    setActiveSubForm(response.data);
                    setActivePage(null);
                    var formBuffer = JSON.parse(response.data.fragmentBuffer);
                    // addIdsFromJsonToExistingIDs(formBuffer);
                    //  console.log(formBuffer);

                    const repopulateJson = {
                      formId: `${newId}`,
                      formJson: `${response.data.fragmentBuffer}`,
                    };

                    axios
                      .post(
                        "/idesign/populateFormStateFromJson",
                        repopulateJson,
                        { withCredentials: true }
                      )
                      .then((response) => {
                        //  console.log(response)
                        fetchDataObject();
                      });
                    // setFormState2(formBuffer);
                    setFormStateOnOpen(formBuffer);
                    setCurrentMappedDO([]);
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  })
                  .catch(function (error) {
                    console.log(error);
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  });
              });
          }
        }
        // LOADING DESIGNER ON BASIS ON APPLICATION ID ( USED WHEN USED AS MICROFRONTEND IN APPLICATION LAUNCHER )
        else {
          setGlobalTime({ min: sessionTime, sec: 0 });
          axios
            .get(`/applications/${props.appId}`, {
              // headers: {
              //   Authorization: `${microFrontendData?.token}`,
              // },
              withCredentials: true,
            })
            .then((res) => {
              dispatch(
                updateMarvinContexts({
                  key: containerId,
                  states: {
                    isMarvinEnabled: res?.data?.isMarvinEnabled,  
                  },                  
                })
              );
              setActiveApplication(res.data);
              setApplicationData(res.data);
              setGlobalTime({ min: sessionTime, sec: 0 });
              isLoginPortal.current = res?.data?.islogin
              dispatch(updateStateInRedux({name: "loginPortal", value: res?.data?.islogin}));
              if (window?.afterClosing?.CurrentPage?.formId) {
                axios
                  .get(
                    `interfaces/${props.appId}/${window?.afterClosing?.CurrentPage?.formId}`,
                    { withCredentials: true }
                  )
                  .then((response) => {
                    // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
                    var formBuffer;
                    if (
                      response.data.formBuffer === "" ||
                      response.data.formBuffer === "{}"
                    ) {
                      // formBuffer = defaultBuffer;
                      let clone = cloneDeep(defaultBuffer);
                      formBuffer = clone;
                    } else {
                      formBuffer = sanitizeStringToJson(
                        response.data.formBuffer
                      );
                    }
                    setActivePage(sanitizeJson(response.data));
                    setActiveSubForm(null);

                    // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                    addIdsFromJsonToExistingIDs(formBuffer);
                    // console.log(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    // callingDataObjects();
                    //callingDataObjectsForProcess();
                    fetchingMaskingForTextbox();
                    // recursiveJsonForMapping(response.data);

                    const repopulateJson = {
                      applicationId: microFrontendData?.applicationId,
                      formId: `${response.data.formId}`,
                      formJson: JSON.stringify(formBuffer),
                    };

                    axios
                      .post(
                        "/idesign/populateFormStateFromJson",
                        sanitizeJson(repopulateJson),
                        { withCredentials: true }
                      )
                      .then((response) => {
                        // console.log(response)
                        fetchDataObject();
                      })
                      .catch((err) => console.log(err));

                    axios
                      .post("/idesign/getRegexJson", new Object({}), {
                        withCredentials: true,
                      })
                      .then((response) => {
                        localStorage.setItem(
                          "regex",
                          JSON.stringify(response.data)
                        );
                      })
                      .catch((err) => console.log("Regex error::", err));

                    setFormBuillderMode("designer");
                    // setFormState2(formBuffer);
                    setFormStateOnOpen(formBuffer);
                    // dispatch(setFormState1(formBuffer));

                    collectAllCustomControlId(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    if (formBuffer) {
                      const themeData = Object.assign({}, formBuffer.theme);
                      if (themeData.themeName) {
                      } else {
                        themeData["themeName"] = "Default Theme";
                      }
                      //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                      delete window.afterClosing;
                    }
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  })
                  .catch(function (error) {
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  });
              } else if (window?.afterClosing?.CurrentSubForm?.fragmentId) {
                // `widgets/${microFrontendData.processId}/${microFrontendData.fragmentId}
                axios
                  .get(
                    `widgets/${props.appId}/${window?.afterClosing?.CurrentSubForm?.fragmentId}`,
                    { withCredentials: true }
                  )
                  .then((response) => {
                    // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
                    var formBuffer;
                    if (
                      response.data.fragmentBuffer === "" ||
                      response.data.fragmentBuffer === "{}"
                    ) {
                      // formBuffer = defaultBuffer;
                      let clone = cloneDeep(defaultBuffer);
                      formBuffer = clone;
                    } else {
                      formBuffer = sanitizeStringToJson(
                        response.data.fragmentBuffer
                      );
                    }
                    setActiveSubForm(sanitizeJson(response.data));
                    setActivePage(null);
                    // setActivePage(sanitizeJson(response.data));
                    // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                    addIdsFromJsonToExistingIDs(formBuffer);
                    // console.log(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    // callingDataObjects();
                    //callingDataObjectsForProcess();
                    fetchingMaskingForTextbox();
                    // recursiveJsonForMapping(response.data);

                    axios
                      .post(
                        "/idesign/populateFormStateFromJson",
                        repopulateJson,
                        { withCredentials: true }
                      )
                      .then((response) => {});

                    const repopulateJson = {
                      applicationId: microFrontendData?.applicationId,
                      formId: `${response.data.fragmentId}`,
                      formJson: JSON.stringify(formBuffer),
                    };

                    // axios
                    //   .post(
                    //     "/idesign/populateFormStateFromJson",
                    //     sanitizeJson(repopulateJson),
                    //     { withCredentials: true }
                    //   )
                    //   .then((response) => {
                    //     // console.log(response)
                    //     fetchDataObject();
                    //   })
                    //   .catch((err) => console.log(err));

                    axios
                      .post("/idesign/getRegexJson", new Object({}), {
                        withCredentials: true,
                      })
                      .then((response) => {
                        localStorage.setItem(
                          "regex",
                          JSON.stringify(response.data)
                        );
                      })
                      .catch((err) => console.log("Regex error::", err));

                    setFormBuillderMode("designer");
                    // setFormState2(formBuffer);
                    setFormStateOnOpen(formBuffer);
                    // dispatch(setFormState1(formBuffer));

                    collectAllCustomControlId(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    if (formBuffer) {
                      const themeData = Object.assign({}, formBuffer.theme);
                      if (themeData.themeName) {
                      } else {
                        themeData["themeName"] = "Default Theme";
                      }
                      delete window.afterClosing;
                      //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                    }
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  })
                  .catch(function (error) {
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  });
              } else if (
                window?.currentActiveTab?.PagePreview ||
                window?.currentActiveTab?.HomePage
              ) {
                if (window?.currentActiveTab?.HomePage !== undefined) {
                  axios
                    .get(
                      `interfaces/${props.appId}/${window?.currentActiveTab?.HomePage?.defaultFormId}`,
                      { withCredentials: true }
                    )
                    .then((response) => {
                      // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
                      var formBuffer;
                      if (
                        response.data.formBuffer === "" ||
                        response.data.formBuffer === "{}"
                      ) {
                        // formBuffer = defaultBuffer;
                        let clone = cloneDeep(defaultBuffer);
                        formBuffer = clone;
                      } else {
                        formBuffer = sanitizeStringToJson(
                          response.data.formBuffer
                        );
                      }
                      setActivePage(sanitizeJson(response.data));
                      setActiveSubForm(null);

                      // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                      addIdsFromJsonToExistingIDs(formBuffer);
                      setDefaultPageStyles(formBuffer);
                      // callingDataObjects();
                      //callingDataObjectsForProcess();
                      fetchingMaskingForTextbox();
                      // recursiveJsonForMapping(response.data);

                      const repopulateJson = {
                        applicationId: microFrontendData?.applicationId,
                        formId: `${response.data.formId}`,
                        formJson: JSON.stringify(formBuffer),
                      };

                      // axios
                      //   .post(
                      //     "/idesign/populateFormStateFromJson",
                      //     sanitizeJson(repopulateJson),
                      //     { withCredentials: true }
                      //   )
                      //   .then((response) => {
                      //     // console.log(response)
                      //     fetchDataObject();
                      //   })
                      //   .catch((err) => console.log(err));

                      axios
                        .post("/idesign/getRegexJson", new Object({}), {
                          withCredentials: true,
                        })
                        .then((response) => {
                          localStorage.setItem(
                            "regex",
                            JSON.stringify(response.data)
                          );
                        })
                        .catch((err) => console.log("Regex error::", err));

                      setFormBuillderMode("designer");
                      // setFormState2(formBuffer);
                      setFormStateOnOpen(formBuffer);
                      // dispatch(setFormState1(formBuffer));

                      collectAllCustomControlId(formBuffer);
                      setDefaultPageStyles(formBuffer);
                      if (formBuffer) {
                        const themeData = Object.assign({}, formBuffer.theme);
                        if (themeData.themeName) {
                        } else {
                          themeData["themeName"] = "Default Theme";
                        }
                        //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                      }
                      delete window.currentActiveTab.HomePage;
                      setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                      loading(false);
                    })
                    .catch(function (error) {
                      setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                      loading(false);
                    });
                } else if (
                  activePage?.formId !== undefined &&
                  window?.currentActiveTab.PagePreview?.page?.formId !==
                    undefined
                ) {
                  axios
                    .get(
                      `interfaces/${props.appId}/${
                        activePage.formId ||
                        window?.currentActiveTab.PagePreview?.page?.formId
                      }`,
                      { withCredentials: true }
                    )
                    .then((response) => {
                      // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
                      var formBuffer;
                      if (
                        response.data.formBuffer === "" ||
                        response.data.formBuffer === "{}"
                      ) {
                        // formBuffer = defaultBuffer;
                        let clone = cloneDeep(defaultBuffer);
                        formBuffer = clone;
                      } else {
                        formBuffer = sanitizeStringToJson(
                          response.data.formBuffer
                        );
                      }
                      setActivePage(sanitizeJson(response.data));
                      setActiveSubForm(null);

                      // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                      addIdsFromJsonToExistingIDs(formBuffer);
                      setDefaultPageStyles(formBuffer);
                      // callingDataObjects();
                      //callingDataObjectsForProcess();
                      fetchingMaskingForTextbox();
                      // recursiveJsonForMapping(response.data);

                      // const repopulateJson = {
                      //   applicationId: microFrontendData?.applicationId,
                      //   formId: `${response.data.formId}`,
                      //   formJson: JSON.stringify(formBuffer),
                      // };

                      // axios
                      //   .post(
                      //     "/idesign/populateFormStateFromJson",
                      //     sanitizeJson(repopulateJson),
                      //     { withCredentials: true }
                      //   )
                      //   .then((response) => {
                      //     // console.log(response)
                      //     fetchDataObject();
                      //   })
                      //   .catch((err) => console.log(err));

                      axios
                        .post("/idesign/getRegexJson", new Object({}), {
                          withCredentials: true,
                        })
                        .then((response) => {
                          localStorage.setItem(
                            "regex",
                            JSON.stringify(response.data)
                          );
                        })
                        .catch((err) => console.log("Regex error::", err));

                      setFormBuillderMode("designer");
                      // setFormState2(formBuffer);
                      setFormStateOnOpen(formBuffer);
                      // dispatch(setFormState1(formBuffer));

                      collectAllCustomControlId(formBuffer);
                      setDefaultPageStyles(formBuffer);
                      if (formBuffer) {
                        const themeData = Object.assign({}, formBuffer.theme);
                        if (themeData.themeName) {
                        } else {
                          themeData["themeName"] = "Default Theme";
                        }
                        //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                        delete window.currentActiveTab;
                      }
                      setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                      loading(false);
                    })
                    .catch(function (error) {
                      setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                      loading(false);
                    });
                } else {
                  // `widgets/${microFrontendData.processId}/${microFrontendData.fragmentId}
                  axios
                    .get(
                      `widgets/${props.appId}/${
                        activeSubForm.fragmentId ||
                        window?.currentActiveTab?.PagePreview?.subform
                          ?.fragmentId
                      }`,
                      { withCredentials: true }
                    )
                    .then((response) => {
                      // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
                      var formBuffer;
                      if (
                        response.data.fragmentBuffer === "" ||
                        response.data.fragmentBuffer === "{}"
                      ) {
                        // formBuffer = defaultBuffer;
                        let clone = cloneDeep(defaultBuffer);
                        formBuffer = clone;
                      } else {
                        formBuffer = sanitizeStringToJson(
                          response.data.fragmentBuffer
                        );
                      }
                      setActiveSubForm(sanitizeJson(response.data));
                      setActivePage(null);
                      // setActivePage(sanitizeJson(response.data));
                      // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                      addIdsFromJsonToExistingIDs(formBuffer);
                      // console.log(formBuffer);
                      setDefaultPageStyles(formBuffer);
                      // callingDataObjects();
                      //callingDataObjectsForProcess();
                      fetchingMaskingForTextbox();
                      // recursiveJsonForMapping(response.data);

                      // axios
                      //   .post(
                      //     "/idesign/populateFormStateFromJson",
                      //     repopulateJson,
                      //     { withCredentials: true }
                      //   )
                      //   .then((response) => {});

                      const repopulateJson = {
                        applicationId: microFrontendData?.applicationId,
                        formId: `${response.data.fragmentId}`,
                        formJson: JSON.stringify(formBuffer),
                      };

                      // axios
                      //   .post(
                      //     "/idesign/populateFormStateFromJson",
                      //     sanitizeJson(repopulateJson),
                      //     { withCredentials: true }
                      //   )
                      //   .then((response) => {
                      //     // console.log(response)
                      //     fetchDataObject();
                      //   })
                      //   .catch((err) => console.log(err));

                      axios
                        .post("/idesign/getRegexJson", new Object({}), {
                          withCredentials: true,
                        })
                        .then((response) => {
                          localStorage.setItem(
                            "regex",
                            JSON.stringify(response.data)
                          );
                        })
                        .catch((err) => console.log("Regex error::", err));

                      setFormBuillderMode("designer");
                      // setFormState2(formBuffer);
                      setFormStateOnOpen(formBuffer);
                      // dispatch(setFormState1(formBuffer));

                      collectAllCustomControlId(formBuffer);
                      setDefaultPageStyles(formBuffer);
                      if (formBuffer) {
                        const themeData = Object.assign({}, formBuffer.theme);
                        if (themeData.themeName) {
                        } else {
                          themeData["themeName"] = "Default Theme";
                        }
                        //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                        delete window.currentActiveTab;
                      }
                      setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                      loading(false);
                    })
                    .catch(function (error) {
                      setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                      loading(false);
                    });
                }
              } else if (
                microFrontendData?.selectedPage &&
                Object.keys(microFrontendData?.selectedPage).length > 0
              ) {
                axios
                  .get(
                    `interfaces/${props.appId}/${microFrontendData?.selectedPage?.formId}`,
                    { withCredentials: true }
                  )
                  .then((response) => {
                    // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
                    var formBuffer;
                    if (
                      response.data.formBuffer === "" ||
                      response.data.formBuffer === "{}"
                    ) {
                      // formBuffer = defaultBuffer;
                      let clone = cloneDeep(defaultBuffer);
                      formBuffer = clone;
                    } else {
                      formBuffer = sanitizeStringToJson(
                        response.data.formBuffer
                      );
                    }
                    setActivePage(sanitizeJson(response.data));
                    setActiveSubForm(null);

                    // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                    addIdsFromJsonToExistingIDs(formBuffer);
                    // console.log(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    // callingDataObjects();
                    //callingDataObjectsForProcess();
                    fetchingMaskingForTextbox();
                    // recursiveJsonForMapping(response.data);

                    const repopulateJson = {
                      applicationId: microFrontendData?.applicationId,
                      formId: `${response.data.formId}`,
                      formJson: JSON.stringify(formBuffer),
                    };

                    axios
                      .post(
                        "/idesign/populateFormStateFromJson",
                        sanitizeJson(repopulateJson),
                        { withCredentials: true }
                      )
                      .then((response) => {
                        // console.log(response)
                        fetchDataObject();
                      })
                      .catch((err) => console.log(err));

                    axios
                      .post("/idesign/getRegexJson", new Object({}), {
                        withCredentials: true,
                      })
                      .then((response) => {
                        localStorage.setItem(
                          "regex",
                          JSON.stringify(response.data)
                        );
                      })
                      .catch((err) => console.log("Regex error::", err));

                    setFormBuillderMode("designer");
                    // setFormState2(formBuffer);
                    setFormStateOnOpen(formBuffer);
                    // dispatch(setFormState1(formBuffer));

                    collectAllCustomControlId(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    if (formBuffer) {
                      const themeData = Object.assign({}, formBuffer.theme);
                      if (themeData.themeName) {
                      } else {
                        themeData["themeName"] = "Default Theme";
                      }
                      //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                    }
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  })
                  .catch(function (error) {
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  });
              } else if (
                microFrontendData?.selectedSubform &&
                Object.keys(microFrontendData?.selectedSubform).length > 0
              ) {
                // `widgets/${microFrontendData.processId}/${microFrontendData.fragmentId}
                axios
                  .get(
                    `widgets/${props.appId}/${microFrontendData?.selectedSubform?.fragmentId}`,
                    { withCredentials: true }
                  )
                  .then((response) => {
                    // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
                    var formBuffer;
                    if (
                      response.data.fragmentBuffer === "" ||
                      response.data.fragmentBuffer === "{}"
                    ) {
                      // formBuffer = defaultBuffer;
                      let clone = cloneDeep(defaultBuffer);
                      formBuffer = clone;
                    } else {
                      formBuffer = sanitizeStringToJson(
                        response.data.fragmentBuffer
                      );
                    }
                    setActiveSubForm(sanitizeJson(response.data));
                    setActivePage(null);
                    // setActivePage(sanitizeJson(response.data));
                    // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                    addIdsFromJsonToExistingIDs(formBuffer);
                    // console.log(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    // callingDataObjects();
                    //callingDataObjectsForProcess();
                    fetchingMaskingForTextbox();
                    // recursiveJsonForMapping(response.data);

                    // axios
                    //   .post(
                    //     "/idesign/populateFormStateFromJson",
                    //     repopulateJson,
                    //     { withCredentials: true }
                    //   )
                    //   .then((response) => {});

                    const repopulateJson = {
                      applicationId: microFrontendData?.applicationId,
                      formId: `${response.data.fragmentId}`,
                      formJson: JSON.stringify(formBuffer),
                    };

                    axios
                      .post(
                        "/idesign/populateFormStateFromJson",
                        sanitizeJson(repopulateJson),
                        { withCredentials: true }
                      )
                      .then((response) => {
                        // console.log(response)
                        fetchDataObject();
                      })
                      .catch((err) => console.log(err));

                    axios
                      .post("/idesign/getRegexJson", new Object({}), {
                        withCredentials: true,
                      })
                      .then((response) => {
                        localStorage.setItem(
                          "regex",
                          JSON.stringify(response.data)
                        );
                      })
                      .catch((err) => console.log("Regex error::", err));

                    setFormBuillderMode("designer");
                    // setFormState2(formBuffer);
                    setFormStateOnOpen(formBuffer);
                    // dispatch(setFormState1(formBuffer));

                    collectAllCustomControlId(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    if (formBuffer) {
                      const themeData = Object.assign({}, formBuffer.theme);
                      if (themeData.themeName) {
                      } else {
                        themeData["themeName"] = "Default Theme";
                      }
                      //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                    }
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  })
                  .catch(function (error) {
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  });
              } else if (res.data.defaultFormId !== 0) {
                axios
                  .get(`interfaces/${props.appId}/${res.data.defaultFormId}`, {
                    withCredentials: true,
                  })
                  .then((response) => {
                    // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
                    var formBuffer;
                    if (
                      response.data.formBuffer === "" ||
                      response.data.formBuffer === "{}"
                    ) {
                      // formBuffer = defaultBuffer;
                      let clone = cloneDeep(defaultBuffer);
                      formBuffer = clone;
                    } else {
                      formBuffer = sanitizeStringToJson(
                        response.data.formBuffer
                      );
                    }
                    setActivePage(sanitizeJson(response.data));
                    setActiveSubForm(null);

                    // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                    addIdsFromJsonToExistingIDs(formBuffer);
                    // console.log(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    // callingDataObjects();
                    //callingDataObjectsForProcess();
                    fetchingMaskingForTextbox();
                    // recursiveJsonForMapping(response.data);

                    const response1 = response?.data ? response : {};
                    const response2 = response1 ? (response1?.data ? response1.data : {}) : {};
                    const response3 = response2 ? (response2?.formBuffer ? response2.formBuffer : {}) : {};

                    var formDataObj = JSON.parse(response3);

                    recursiveJsonForMapping(formDataObj.children);

                    const repopulateJson = {
                      formId: `${response.data.formId}`,
                      formJson: `${response.data.formBuffer}`,
                      applicationName: microFrontendData?.applicationName,
                      applicationId: microFrontendData?.applicationId,
                      userName:
                        microFrontendData?.sessionData?.sessionData?.userId,
                      userIndex:
                        microFrontendData?.sessionData?.sessionData?.userIndex,
                    };

                    axios
                      .post(
                        "/idesign/populateFormStateFromJson",
                        sanitizeJson(repopulateJson),
                        { withCredentials: true }
                      )
                      .then((response) => {
                        // console.log(response)
                        fetchDataObject();
                      })
                      .catch((err) => console.log(err));

                    axios
                      .post("/idesign/getRegexJson", new Object({}), {
                        withCredentials: true,
                      })
                      .then((response) => {
                        // console.log('regex response :: ',response);
                        localStorage.setItem(
                          "regex",
                          JSON.stringify(response.data)
                        );
                      })
                      .catch((err) => console.log("Regex error::", err));

                    setFormBuillderMode("designer");
                    setFormStateOnOpen(formBuffer);
                    // setFormState2(formBuffer);
                    // dispatch(setFormState1(formBuffer));

                    collectAllCustomControlId(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    if (formBuffer) {
                      const themeData = Object.assign({}, formBuffer.theme);
                      if (themeData.themeName) {
                      } else {
                        themeData["themeName"] = "Default Theme";
                      }
                      //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                    }
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  })
                  .catch(function (error) {
                    setOpenLoader(false);
                    // alert("There is some issue in form opening. Kindly check with system administrator");
                    showAlertConfirmNotifications({
                      open: true,
                      showConfirm: "showNotification",
                      alertType: "error",
                      alertContentKey:
                        "There is some issue in form opening. Kindly check with system administrator",
                    });
                  });
              } else if (activePage && activePage?.formId) {
                axios
                  .get(`interfaces/${props.appId}/${activePage?.formId}`, {
                    withCredentials: true,
                  })
                  .then((response) => {
                    // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
                    var formBuffer;
                    if (
                      response.data.formBuffer === "" ||
                      response.data.formBuffer === "{}"
                    ) {
                      // formBuffer = defaultBuffer;
                      let clone = cloneDeep(defaultBuffer);
                      formBuffer = clone;
                    } else {
                      formBuffer = sanitizeStringToJson(
                        response.data.formBuffer
                      );
                    }
                    setActivePage(sanitizeJson(response.data));
                    setActiveSubForm(null);

                    // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                    addIdsFromJsonToExistingIDs(formBuffer);
                    // console.log(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    // callingDataObjects();
                    //callingDataObjectsForProcess();
                    fetchingMaskingForTextbox();
                    // recursiveJsonForMapping(response.data);

                    const repopulateJson = {
                      formId: `${response.data.formId}`,
                      formJson: JSON.stringify(formBuffer),
                    };

                    axios
                      .post(
                        "/idesign/populateFormStateFromJson",
                        sanitizeJson(repopulateJson),
                        { withCredentials: true }
                      )
                      .then((response) => {
                        // console.log(response)
                        fetchDataObject();
                      })
                      .catch((err) => console.log(err));

                    axios
                      .post("/idesign/getRegexJson", new Object({}), {
                        withCredentials: true,
                      })
                      .then((response) => {
                        localStorage.setItem(
                          "regex",
                          JSON.stringify(response.data)
                        );
                      })
                      .catch((err) => console.log("Regex error::", err));

                    setFormBuillderMode("designer");
                    // setFormState2(formBuffer);
                    setFormStateOnOpen(formBuffer);
                    // dispatch(setFormState1(formBuffer));

                    collectAllCustomControlId(formBuffer);
                    setDefaultPageStyles(formBuffer);
                    if (formBuffer) {
                      const themeData = Object.assign({}, formBuffer.theme);
                      if (themeData.themeName) {
                      } else {
                        themeData["themeName"] = "Default Theme";
                      }
                      //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                    }
                    setGlobalLoading(false)
                    setGlobalLoadingMessage("")
                    loading(false);
                  })
                  .catch(function (error) {});
              }
              // else if(res.data.defaultFormId!==0 ){
              // axios.get(`interfaces/${props.appId}/${res.data.defaultFormId}`,{withCredentials:true})
              //     .then((response)=>{
              //         // WHEN DEFAULT FORMID EXISTS ie default page on an application exists
              //         var formBuffer
              //     if(response.data.formBuffer === "" || response.data.formBuffer === "{}"){
              //         // formBuffer = defaultBuffer;
              // let clone = cloneDeep((defaultBuffer))
              // formBuffer = clone;
              //     }else{
              //         formBuffer=sanitizeStringToJson(response.data.formBuffer);
              //     }
              //         setActivePage(sanitizeJson(response.data));
              //         // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
              //         addIdsFromJsonToExistingIDs(formBuffer);
              //         // console.log(formBuffer);
              //         setDefaultPageStyles(formBuffer);
              //         // callingDataObjects();
              //         //callingDataObjectsForProcess();
              //         fetchingMaskingForTextbox();
              //         // recursiveJsonForMapping(response.data);

              //         var formDataObj = JSON.parse(response.data.formBuffer);

              //         recursiveJsonForMapping(formDataObj.children);

              //         const repopulateJson={
              //             "formId":`${response.data.formId}`,
              //             "formJson":JSON.stringify(formBuffer),
              //             "formJson":`${response.data.formBuffer}`,
              //             "applicationName":microFrontendData?.applicationName,
              //             "applicationId":microFrontendData?.applicationId,
              //             "userName":microFrontendData?.sessionData?.sessionData?.userId,
              //             "userIndex":microFrontendData?.sessionData?.sessionData?.userIndex

              //         };

              //         axios.post('/idesign/populateFormStateFromJson',sanitizeJson(repopulateJson),{withCredentials:true})
              //         .then((response)=>{
              //             // console.log(response)
              //             fetchDataObject()
              //         })
              //         .catch((err)=> console.log(err));

              //         axios.post('/idesign/getRegexJson',new Object({}),{withCredentials:true})
              //         .then((response)=>{
              //             // console.log('regex response :: ',response);
              //             localStorage.setItem("regex",JSON.stringify(response.data));
              //         })
              //         .catch((err)=> console.log('Regex error::',err));

              //         setFormState2(formBuffer);
              //         setFormBuillderMode("designer");
              //         // dispatch(setFormState1(formBuffer));

              //         collectAllCustomControlId(formBuffer);
              //         setDefaultPageStyles(formBuffer);
              //         if(formBuffer){
              //             const themeData = Object.assign({ }, formBuffer.theme );
              //             if( themeData.themeName){

              //             }else {
              //                 themeData['themeName'] = "Default Theme" ;
              //             }
              //             //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
              //         }
              //     })
              //     .catch(function (error) {
              //         setOpenLoader(false);
              //         // alert("There is some issue in form opening. Kindly check with system administrator");
              //         showAlertConfirmNotifications({
              //             'open':true,
              //             'showConfirm':'showNotification',
              //             'alertType':'error',
              //             'alertContentKey':'There is some issue in form opening. Kindly check with system administrator'});
              //     });
              // }
              else {
                // WHEN DEFAULT FORMID DOES NOT EXISTS i.e. default page on an application does not exists
                // console.log("inside setting default page of application");

                const activeApplicationNew = {
                  ...res.data,
                  defaultFormId: allPages[0]?.formId,
                };

                axios
                  .post(`applications/`, sanitizeJson(activeApplicationNew), {
                    withCredentials: true,
                  })
                  .then((res) => {
                    setActiveApplication(sanitizeJson(res.data));
                    // console.log("Application homepagesaved Saved");
                    axios
                      .get(
                        `interfaces/${props.appId}/${res.data.defaultFormId}`,
                        { withCredentials: true }
                      )
                      .then((response) => {
                        var formBuffer;
                        if (
                          response.data.formBuffer === "" ||
                          response.data.formBuffer === "{}"
                        ) {
                          // formBuffer = defaultBuffer;
                          let clone = cloneDeep(defaultBuffer);
                          formBuffer = clone;
                        } else {
                          formBuffer = sanitizeStringToJson(
                            response.data.formBuffer
                          );
                        }
                        setActivePage(sanitizeJson(response.data));
                        setActiveSubForm(null);

                        // var formBuffer=sanitizeStringToJson(response.data.formBuffer);
                        addIdsFromJsonToExistingIDs(formBuffer);
                        // console.log(formBuffer);
                        setDefaultPageStyles(formBuffer);
                        // callingDataObjects();
                        //callingDataObjectsForProcess();
                        fetchingMaskingForTextbox();
                        // recursiveJsonForMapping(response.data);

                        const repopulateJson = {
                          formId: `${response.data.formId}`,
                          formJson: JSON.stringify(formBuffer),
                        };

                        axios
                          .post(
                            "/idesign/populateFormStateFromJson",
                            sanitizeJson(repopulateJson),
                            { withCredentials: true }
                          )
                          .then((response) => {
                            // console.log(response)
                          })
                          .catch((err) => console.log(err));

                        axios
                          .post("/idesign/getRegexJson", new Object({}), {
                            withCredentials: true,
                          })
                          .then((response) => {
                            localStorage.setItem(
                              "regex",
                              JSON.stringify(response.data)
                            );
                          })
                          .catch((err) => console.log(err));

                        // setFormState2(formBuffer);
                        setFormStateOnOpen(formBuffer);
                        collectAllCustomControlId(formBuffer);
                        setDefaultPageStyles(formBuffer);
                        if (formBuffer) {
                          const themeData = Object.assign({}, formBuffer.theme);
                          if (themeData.themeName) {
                          } else {
                            themeData["themeName"] = "Default Theme";
                          }
                          //setThemeDetails((prev)=> {return{...prev, 'appliedTheme': themeData}})
                        }
                        setGlobalLoading(false)
                        setGlobalLoadingMessage("")
                        loading(false);
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  })
                  .catch((err) => {
                    console.log("ERROR FOUND in saving page: ", err);
                  });
              }
            })
            .catch(function (error) {
              console.log("Error", error);
            });
        }
      } else if (!appId) {
        //*********** WHEN PREVIEW/APPVIEWER OPENS LOCALLY THROUGH TEST.JSON ***********/

        var newFormData = {};
        const jsonToSend = { formName: "testForm", formId: "5" };
        jsonElementOperation(jsonToSend, "getFormStateFromJson", function () {})
          .then((response) => {
            setFormBuillderMode("preview");

            // dispatch(setFormState1(sanitizeJson(response.data)));

            const viewformJson = {
              isApp: "false",
              DeviceType: "W",
              isGeneralDataCreated: true,
              isWIModelCreated: false,
              gdtoken: "TestProcess-0000000003-process_GeneralData",
              witoken: "",
              pid: "TestProcess-0000000003-process",
              wid: "1",
              tid: "",
              fid: "Form_TestProcess-0000000003-process_1",
              sessionInfo: "TestProcess-0000000003-process_sessionInfo",
              formJson: JSON.stringify(response.data),
              isPreview: true,
            };
            axios
              .post("/viewform/", viewformJson, { withCredentials: true })
              .then((resp) => {
                // setFormState2(sanitizeJson(resp.data.formJson));
                setFormStateOnOpen(sanitizeJson(resp.data.formJson));
                var value = "";
                value = resp.data.witoken;
                dispatch(
                  updateStore({ name: "witoken", value, key: containerId })
                );
                value = resp.data.gdtoken;
                dispatch(
                  updateStore({ name: "gdtoken", value, key: containerId })
                );
                setGlobalLoading(false)
                setGlobalLoadingMessage("")
                loading(false);
              });
          })
          .catch(function (error) {
            try {
              jsonElementOperation(jsonToSend, "getFormStateFromXml")
                .then((response) => {
                  var newFormData = recurseJson(sanitizeJson(response.data));
                  // console.log('response :: ',newFormData);
                  // dispatch(setFormState1(sanitizeJson(newFormData)));
                  setFormBuillderMode("preview");
                  // setFormState2(newFormData);
                  setFormStateOnOpen(newFormData);
                  setGlobalLoading(false)
                  setGlobalLoadingMessage("")
                  loading(false);
                })

                .catch(function (error) {
                  console.log(error);
                });
            } catch (e) {
              console.log(e);
            }
          });
      }
    }
  }, [appId, childComp, formDefId, processId, pageDataLoaded]);

  useEffect(() => {
    if(callHomePage) {
      if(!QueryString) {
        QueryString = '%20';
      } else {
        QueryString = encodeURIComponent(QueryString);
      }
      const width = window.screen.width;
      const height = window.screen.height;
      const language = window?.psh_configs?.selectedLanguage;
      const cabinetName_fromIni = secureLocalStorage.getItem("cabinet") || localStorage.getItem("cabinet") || window?.activeCabinet_formbuilder ;
      document.documentElement.lang = language;
      var jwtToken = formMataData?.token;
      includeTheme(cabinetName_fromIni, `${width}_${height}`, language, jwtToken, true);
      // getHomePage(QueryString);
      const urlParams = new URLSearchParams(window.location.search);
      const navigationPage = urlParams.get('navigationPage');
      const PTId = urlParams.get('PTId');

      if(navigationPage===null && PTId===null){
        getHomePage(QueryString);
      }
      else{
        window.location.reload(false);
      }
      dispatch(updateStateInRedux({name: "callHomePage", value: false}));
    }
  },[callHomePage])


useEffect(() => {
    if(postChangeFormLang_samepage===true){
      dispatch(updateStateInRedux({name: "postChangeFormLang_samepage", value: false}));
      reloadCurrentPage();
    }
  }, [postChangeFormLang_samepage])

  // function reloadCurrentPage(){

  //   const applicationId = openingAsApplication?.applicationId || applicationData?.applicationId  || microFrontendData?.applicationId ;

  //   console.log("applicationData : ", applicationData , "openingAsApplication", openingAsApplication , "microFrontendData" , microFrontendData)

  //    axios.get(`interfaces/${applicationId}/${activePage?.formId}`, { withCredentials: true })
  //         .then((response) => {
  //           window.currentInterface = response.data;
  //           setActiveApplication({ ...applicationData, selectedPage: response.data });
  //           if (window?.currentActiveTab) {
  //             delete window.currentActiveTab;
  //           }
  //           setActivePage(response?.data);
  //           // setActiveSubForm(null);
  //           // setIsStep({});
  //           // setSelectedControl({ elem_type: "" });
  //           // window.selectedControlId_function({ elem_type: "" });
  //           // setActiveMenuId(null);

  //           formState2.isStep = {
  //             parentStep: 0
  //           };
  //           var formBuffer = JSON.parse(response?.data?.formBuffer);
  //           addIdsFromJsonToExistingIDs(formBuffer);
  //           //  console.log(formBuffer);

  //           const repopulateJson = {
  //             applicationId: openingAsApplication.applicationId,
  //             formId: `${activePage?.formId}`,
  //             formJson: `${response.data.formBuffer}`
  //           };

  //           axios.post("/idesign/populateFormStateFromJson", repopulateJson, { withCredentials: true }).then((response) => {
  //             // fetchDataObject(openingAsApplication.applicationId, activePage?.formId);
  //             setCurrentMappedDO([]);
  //           });

  //           setFormState2(formBuffer);
  //           // setEventList([]);
  //           // setPropertyPinned(false);
  //         })
  //         .catch(function (error) {
  //           console.log(error);
  //           setGlobalLoading(false);
  //         });
  // }

function reloadCurrentPage(hookName){
  const applicationId = openingAsApplication?.applicationId || applicationData?.applicationId  || microFrontendData?.applicationId ;

              // const applicationId = ;
  
              axios.get(`interfacesbyname/${applicationId}/${activePage?.formName}`,
                  {
                    withCredentials: true,
                    headers: {
                      mode: window.isDesigner ? "D" : "V",
                      hardRefresh: 'N',
                      isComingFromJourney: 'Y',
                    },
                  }
              )
              .then((resp) => {
                  if (resp.data.status === "1") {
                      showAlertConfirmNotifications({
                        open: true,
                        showConfirm: "showNotification",
                        alertType: "error",
                        alertContentKey:
                          resp?.data?.err_msg_description ||
                          "some error occured",
                      });
                  } 
                  else if(resp?.data?.err_Msg && resp?.data?.status==="-2"){
                      showAlertConfirmNotifications({
                        'open':true,
                        'showConfirm':'showNotification',
                        'alertType':'error',
                        'alertContentKey': resp?.data?.err_Msg || "some error occured"
                      });
                  }
                  else {
                      // window.wizard_stage_fromOpenTransaction = resp?.Stage || resp?.data?.Stage || "" ;
                      window.wizard_stage_fromOpenTransaction =  resp?.data?.Stage  || resp?.Stage || "" ;

                      // window.callstaging();
                      
                      setOpeningAsApplication((prev) => {
                        return {
                          ...prev,
                          "Stage": resp?.data?.Stage || resp?.Stage || ""
                        };
                      });

                    dispatch(updateStateInRedux({name:"wizard_stage", value: resp?.data?.Stage || resp?.Stage }));

                    dispatch(updateStateInRedux({name: "wizard_stage", key: containerId, value: resp?.data?.Stage || resp?.Stage }));
                    dispatch(updateStateInRedux({name:"renderUpdatedLocale", value: true }));
  

                      window.formBuilder_transactionid_generalData= resp?.data?.TransactionId;
                      setFormState2(resp.data?.formJson);
                      // setActivePage(resp?.data);

                      
                      // if ( resp?.data?.SelectionPage &&
                      //       resp?.data?.SelectionPage.toString().length > 0
                      // ) {
                      //   dispatch(
                      //     updateRouteJourneySelectionPage({
                      //       key: props?.containerId,
                      //       value: resp?.data?.SelectionPage.toString(),
                      //     })
                      //   );
                      // }
                  }
              })
              .catch((err) => {
                console.log(err);
              });
          }


  // **************** CALLS TO DATAOBJECTS *********************************************//

  const [OpenPicklistValidationModal,setOpenPicklistValidationModal]  =useState(false);
  const [validationResponse,setValidationResponse]=useState([]);
  const picklistIds=[];
  const validResponse=[];

  const validatePicklistFunction =()=>{
      const previewMode = childComp !== "app" && childComp !== "reusableFunction" ? true : false;
      if(!previewMode){
          if(formState2?.picklistInstanceArray?.length>0){
              formState2?.picklistInstanceArray?.forEach((pick)=>{
                  picklistIds.push(pick?.picklist_instance_id)
                  })
                  const picklistInstancesPayload={
                      "picklistInstanceIds": picklistIds
                  };
                  axios1.post("/idesign/validatepicklistinstances",picklistInstancesPayload,{withCredentials:true})
                  .then(res=>{
                    console.log("res",res,res?.data?.picklist_instances);
                    const picklistData=res?.data?.picklist_instances
                    if(picklistData){
                      for (let key in picklistData )
                      {
                          if(picklistData.hasOwnProperty(key)){
                              if(picklistData[key]==="failed")
                              validResponse.push(key)
                          }
                      }   
                      setValidationResponse(()=>validResponse)                 
                      setOpenPicklistValidationModal(true);                    
                    }
                  
                  })
                  .catch(err=>{
                  //   alert("unable to logout: Logout API failed");
                    console.log("No response");
                  })
          }
      }
  }

  // ***** Useeffect to call formLoad **** //

  useEffect(() => {
    if (window.formLoaderRan === undefined) {
      window.formLoaderRan = false;
    }
    if(checkEmpty(formState2)){
      window.emptyScreen1 = true;
    }
    const onPageLoad = () => {
      console.log("page loaded");
      window.errorContainingControls = {}
      if (!window.formLoaderRan && props.childComp === "preview" && !(formMataData || isPortalLive) && !gdCall) {
        // setTimeout(() => {
          try{
            if(formMataData){
              if( !window.location.pathname.includes("afb_subform") ){
               window.formLoad();
               functions.updateJSON(true);
              }
              if(getContainerId() === "ngform") {
                if(window.globalLoading)
                  window.globalLoading(false, false)
              }
              else {
                if(window.fullLoaderFunction)
                  window.fullLoaderFunction(false)
              };
            }
            else{
              loading(true);
              if( !window.location.pathname.includes("afb_subform") ){
               window.formLoad();
               functions.updateJSON(true)
              }
              if(window.setformPMWEBLoader)
                window.setformPMWEBLoader(false)
              loading(false)
            }
          }
          catch(e){
            if(formMataData){
              if(getContainerId() === "ngform") {
                if(window.globalLoading)
                  window.globalLoading(false, false)
              }
              else {
                if(window.fullLoaderFunction)
                  window.fullLoaderFunction(false)
              };
            }
            loading(false)
            if(window.setformPMWEBLoader)
              window.setformPMWEBLoader(false)
          }
          // window.setIformLoading(false);
        // }, 1000);
        window.formLoaderRan = true;
      }
      else {
        let condition = iformClientLoaded || isPortalLive;
        if(window?.getExternalJSPaths && window?.getExternalJSPaths().length){
          condition = iformClientLoaded;
        }
        console.log("Gd Call value: ",gdCall, "isIformClientLoaded: ",iformClientLoaded,"window.formLoaderRan: ",window.formLoaderRan,"condition: ",condition)
        requestAnimationFrame(() => {
          if((gdCall) && !window.formLoaderRan && condition) {
            console.log("Inside Page Load: ", formMataData)
            // if(formMataData?.APIData) {
            //   renderExecuteServerEventAPIData({outputArray: formMataData?.APIData, sync: true, renderFlag: true});
            //   loading(false);
            // }
            // setTimeout(async() => {
              try{
                if(formMataData){
                if( !window.location.pathname.includes("afb_subform") ){
                  console.log("Before FormLoad")
                  window.formLoad();
                  console.log("formLoad ran successfully")
                  functions.updateJSON(true);
                  dispatch(updateStateInRedux({name:"afterFormLoad",value: new Date()}));
                }
                  if(getContainerId() === "ngform") {
                    if(window.globalLoading)
                      window.globalLoading(false, false)
                  }
                  else {
                    if(window.fullLoaderFunction)
                      window.fullLoaderFunction(false)
                    console.log("fullLoaderFunction ran successfully")
                  }
                }
                else{
                  loading(true);
                if( !window.location.pathname.includes("afb_subform") ){
                  window.formLoad();
                  functions.updateJSON(true);
                  dispatch(updateStateInRedux({name:"afterFormLoad",value: new Date()}));
                }
                  if(window.setformPMWEBLoader)
                    window.setformPMWEBLoader(false)
                  loading(false)
                }
              }
              catch(e){
                if(formMataData){
                  if(getContainerId() === "ngform") {
                    if(window.globalLoading)
                      window.globalLoading(false, false)
                  }
                else {
                  if(window.fullLoaderFunction)
                    window.fullLoaderFunction(false)
                };
                }
                loading(false)
                if(window.setformPMWEBLoader)
                  window.setformPMWEBLoader(false)
              }
              // window.setIformLoading(false);
            // }, 1000);
            window.formLoaderRan = true;
          }
        })
      }
      // if (window.validatePicklistFunction) {
        setTimeout(() => {
          validatePicklistFunction();
        }, 1000)
      // }
    };
    if (document.readyState === "complete") {
      onPageLoad();
    } else {
      window.addEventListener("load", onPageLoad, false);

      return () => window.removeEventListener("load", onPageLoad);
    }
  }, [gdCall,iformClientLoaded]);
  

  function loadFonts(){
    console.log("loadfonts");
  
    if(window?.getExternalFonts){
      const externalFonts= window.getExternalFonts();
  
      externalFonts?.map((fontName)=>{
          console.log("loadfonts", fontName);
        try{

          const url = `url(${process.env.REACT_APP_PUBLIC_URL}/fonts/${encodeURIComponent(fontName)}.ttf)`;
          const myFont = new FontFace(`${fontName}`, url);
          myFont.load();
          document.fonts.add(myFont);
          console.log("loadfonts", fontName, myFont);
        }
        catch{
          console.log("error due to fonts: ", fontName );
        }
  
          // font-family: 'Playfair Display';
          // src: url(./fonts/Playfair_Display/PlayfairDisplay-Italic.ttf);
          // font-style: italic;
          // font-weight: 100;
        })
      }
    }

  useEffect(() => {
    // if(iformClientLoaded){
      loadFonts();
    // }
  }, [iformClientLoaded]);

  function callingDataObjects() {
    fetch(`${window.Configs.backEndUrl}/connection/`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        cabinetName: "bamdev5sp2",
        userName: "dash",
        authCode: "system123",
        ip: window.Configs.bam_Ip,
        port: window.Configs.bam_port,
      }),
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (data) {
        // setSessionId(data);
        // setSessionIdConnection(data);  backEndUrl2

        // fetch(`${window.Configs.backEndUrl2}/mdm-rest/app/applogin`, {
        fetch("/mdm-rest/app/applogin", {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            locale: "en_US",
            user_index: "3",
            user_id: "badmin",
            session_id: data,
            cabinet_name: "bamdev5sp2",
            personal_name: "New User",
            family_name: "",
            client_gmt_offset: 0,
            batch_size: 10,
            server_gmt_offset: 330,
            theme_id: "0",
            eds: "N",
            udb_encrypt: "N",
          }),
        });
      })
      .then((result) => {
        fetch("/mdm-rest/app/dataobjects", {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            "Authorization": jwtToken,
          },
          body: JSON.stringify({
            parent_id: "29104",
            // "parent_id": `${props.appId}`,
            type: "AP",
            sort_order: "A",
            order_by: "1",
            records_to_fetch: "30",
            mode: "tree",
          }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (content) {
            //console.log("content.data content.data ", content.data_objects);

            if (content.data.data_objects !== undefined) {
              var jsonDataSend = {
                data: content.data.data_objects,
              };

              var data = JSON.stringify(content.data.data_objects);

              axios
                .post(
                  "/idesign/getDataObjectsforMapping",
                  { data },
                  { withCredentials: true }
                )
                .then((response) => {
                  // setDataObjectsState(response.data);
                  setCurrentDataObjectsContent(response.data)
                  setDataObjectsContent(response.data);
                })
                .catch(function (error) {
                  if (error.response) {
                  }
                  // alert(error);
                  console.log("error is", error);
                });
            }
          })
          .catch((err) => {
            console.log("error is", err);
          });
      });
  }

  // ************ CALLS FOR PROCESS VARIABLES *************** //

  function fetchProcessVariables(str) {
    setGlobalLoadingMessage("Fetching Data objects...");
    const portalState =
      microFrontendData?.formPageType || microFrontendData?.processName
        ? "Processes"
        : "Portals";
    if (Object.keys(dataObjectsContent).length === 0 || str === "yes") {
      if (microFrontendData?.componentType === "TF") {
        // setIsLoading(true);
        let jsonForProcess = {
          taskId: microFrontendData?.taskId,
          processdefId: microFrontendData?.processDefId,
          processState: microFrontendData?.statusType || "L",
        };
        fetchProcessTaskTemplate(jsonForProcess)
          .then((response) => {
            setCurrentDataObjectsContent(response.data["children"])
            setDataObjectsContent(response.data["children"]);
            setfilteredDataObject(response.data["children"]);
            setfilteredDataObjectCopy(response.data["children"]);
            setGlobalLoading(false);
          })
          .catch(function (error) {
            console.log("Error :: ", error);
            setGlobalLoading(false);
          });
      } else if (microFrontendData?.componentType === "GT") {
        // setIsLoading(true);
        var jsonForProcess = {
          globalTemplateId: microFrontendData?.templateId,
        };

        fetchProcessGlobalTemplate(jsonForProcess)
          .then((response) => {
            setCurrentDataObjectsContent(response.data["children"])
            setDataObjectsContent(response.data["children"]);
            setfilteredDataObject(response.data["children"]);
            setfilteredDataObjectCopy(response.data["children"]);
            setGlobalLoading(false);
          })
          .catch(function (error) {
            console.log("Error :: ", error);
            setGlobalLoading(false);
          });
      } else if (portalState === "Portals") {
        fetch("/mdm-rest/app/dataobjects", {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            "Authorization": jwtToken,
          },
          body: JSON.stringify({
            parent_id: appId,
            type: "AP",
            sort_order: "A",
            order_by: "1",
            records_to_fetch: "30",
            mode: "tree",
          }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (content) {
            if (content?.status?.subject === "No Data Objects found.") {
              setCurrentDataObjectsContent([])
              setDataObjectsContent([]);
              setfilteredDataObject([]);
              setfilteredDataObjectCopy([]);
            } else {
              if (content.data.data_objects !== undefined) {
                var jsonDataSend = {
                  data: content.data.data_objects,
                };

                var data = JSON.stringify(content.data.data_objects);

                let formId = getFormId()
                const jsonData = {
                  formId: activePage?.formId || formId.toString(),
                  data: `${data}`,
                };

                axios
                  .post("/idesign/getDataObjectsforMapping", jsonData, {
                    withCredentials: true,
                  })
                  .then(async (response) => {
                    if (response.data["children"]) {
                      if(response.data["children"]?.length > 1){
                      showAlertConfirmNotifications({
                        'open':true,
                        'showConfirm':'showNotification',
                        'alertType':'error',
                        'alertContentKey': "Only one parent table is allowed. Please define the parent-child relation with the system-generated parent table."
                      });
                    } else {
                      for (let child of response.data["children"]) {
                        response.data["children"] = await fetchingAllDataObjects(child)
                        setDataObjectsContent(response.data["children"]);
                        setfilteredDataObject(response.data["children"]);
                        setfilteredDataObjectCopy(response.data["children"]);
                        setCurrentDataObjectsContent(response.data["children"]);
                        setGlobalLoading(false);
                        window.updateDataObject = false;
                      }
                    } 
                    }
                    // setDataObjectsContent(response.data["children"]);
                    // setfilteredDataObject(response.data["children"]);
                    // setfilteredDataObjectCopy(response.data["children"]);
                    // setGlobalLoading(false);
                    // window.updateDataObject = false;
                  })
                  .catch(function (error) {
                    if (error.response) {
                    }
                    console.log("error is", error);
                    setGlobalLoading(false);
                  });
              }
            }
          })
          .catch((err) => {
            console.log("error is", err);
            setGlobalLoading(false);
          });
      } else if (portalState === "Processes") {
        // setIsLoading(true);
        let jsonForProcess = {
          formId: microFrontendData?.formDefId,
          processdefId: microFrontendData?.processId,
          processState: microFrontendData?.statusType,
          processName: microFrontendData?.processName,
        };

        fetchProcessModularData(jsonForProcess)
          .then((response) => {
            setCurrentDataObjectsContent(response.data["children"])
            setDataObjectsContent(response.data["children"]);
            setfilteredDataObject(response.data["children"]);
            setfilteredDataObjectCopy(response.data["children"]);
            setGlobalLoading(false);
          })
          .catch(function (error) {
            console.log("Error :: ", error);
            setGlobalLoading(false);
          });
      }
    }
  }

  // *************** CALLS TO MASKING ****************************************************//

  function fetchingMaskingForTextbox() {
    var remainingURL = "/idesign/fetchMaskingPattern";

    for (let [key, value] of maskingData) {
      var newPattern = {};
      newPattern["Title"] = key;
      newPattern["Value"] = value;
      //   ControlsMap[fetchedProperty].children.push(newPattern);
      ///  ControlsMap["MaskingPattern"].children.push(newPattern);
    }

    //   console.log("controlsMapMasking " ,ControlsMap["MaskingPattern"]);

    axios.post(remainingURL, { withCredentials: true }).then((response) => {
      if (response && response.data && response.status === 200) {
        let maskingMap = new Map();
        for (const [key, value] of Object.entries(response.data)) {
          // maskingMap.set(key, value);
          maskingData.set(key, value);

          var newPattern = {};
          newPattern["Title"] = key;
          newPattern["Value"] = value;
          maskingKeys.push(newPattern);
        }
        // setMaskingData(maskingMap);
      }
    });
  }

  function recursiveJson(jsonData, selectedID, elemType) {
    if (Array.isArray(jsonData)) {
      jsonData.map((item, index) => {
        if (Object.keys(item).includes("children")) {
          // var matched = recursiveJson(item, selectedID, elemType);
        } else {
          if (
            Object.values(jsonData)[0]["VariableName"] !== undefined &&
            !DataObjectsArray.includes(
              Object.values(jsonData)[0]["VariableName"]
            )
          ) {
            DataObjectsArray.push(Object.values(jsonData)[0]["VariableName"]);
          }

          if (Object.values(jsonData)[0]["VariableName"] !== undefined) {
            mappingDataObjectsMap.set(
              Object.values(jsonData)[0]["VariableName"],
              10
            );
          }
        }
      });
    } else {
      if (jsonData["VariableName"] !== undefined) {
        mappingDataObjectsMap.set(jsonData["VariableName"], 10);
      }
      if (jsonData["id"] !== selectedID) {
        recursiveJson(jsonData["children"], selectedID, elemType);
      } else if (jsonData["control_id"] !== selectedID) {
        recursiveJson(jsonData["children"], selectedID, elemType);
      }
    }
  }

  // console.log("abcdefghi 1", DataObjectsArray);

  const [alertState, setAlertShow] = useState(false);
  var alertMessage = {
    alertHeading: "",
    alertMessageBody: "",
  };

  let draggingElement = {};
  let draggedOnElement = {};
  let addressOfDropping = {
    sectionIndex: "",
    rowIndex: "",
    columnIndex: "",
    elementId: "",
  };
  let addressOfDropped = {
    sectionIndex: "",
    rowIndex: "",
    columnIndex: "",
    elementId: "",
  };
  let draggedOnElementJson = {};
  let draggingElementJson = {};
  let draggingElementindex = 0;
  let draggedElementindex = 0;

  var JsonOfReorderElem = {
    json: "",
    id: "",
    previousIndex: undefined,
    nextIndex: undefined,
    toBePlacedOnIndex: undefined,
    parentRow: undefined,
    absoluteParent: undefined,
  };

  function recursiveJsonForMapping(jsonData) {
    if (Array.isArray(jsonData)) {
      jsonData.map((item, index) => {
        if (item?.style && item?.style?.Mapping) {
          // if(item?.style){

          mappingControlsIdMap.add(item?.style?.MappingId);
          //   console.log("mappingItem ", item?.style?.Mapping);
          const mapCheck1 = item?.style ? item : {};
          const mapCheck2 = mapCheck1 ? (mapCheck1?.style ? mapCheck1?.style : {}) : {};
          var mapVar = mapCheck2 ? (mapCheck2?.Mapping ? mapCheck2?.Mapping : "") : "";
          // var mapVar = item?.style?.Mapping;
          // console.log("mappingItem ", mapVar.length);
          var count = 0;
          var newStr = "";

          for (var i = mapVar.length - 1; i >= 0; i--) {
            //    console.log("mappingItem ", mapVar.charAt(i));
            if (mapVar.charAt(i) === ".") {
              count++;
            }
            if (count === 2) {
              break;
            }
            newStr += mapVar.charAt(i);
          }

          var newStr2 = "";

          for (var i = newStr.length - 1; i >= 0; i--) {
            //    console.log("mappingItem ", mapVar.charAt(i));
            if (newStr.charAt(i) === ".") {
              continue;
            } else {
              newStr2 += newStr.charAt(i);
            }
          }

          //  console.log("mappingItem ", newStr2);
          mappingControlsMap.add(newStr2);

          // mappingControlsMap.add(item?.style?.Mapping);
        }

        // if (Object.keys(item).includes("children")) {
        //   // var matched = recursiveJsonForMapping(item);
        // } else {
        // }
      });
    } else {
      // if(jsonData["id"]!==selectedID){
      recursiveJsonForMapping(jsonData["children"]);
      // }
      // else if(jsonData["control_id"]!==selectedID){
      // recursiveJsonForMapping(jsonData["children"]);
      // }
    }
  }

  var flag47 = false;

  function recursiveJsonForImportSection(
    jsonData,
    itemId,
    currIndex,
    jsonDataPresent,
    jsonToBeAdded,
    propertyName,
    sheetName = "",
    isUploadedInSection = false,
    touchedId = ""
  ) {
    // console.log(" In Import Section In Import Section IformdesignerLayout ", jsonData);
    // console.log(" In Import Section In Import Section IformdesignerLayout ", itemId);

    if (Array.isArray(jsonData)) {
      jsonData.map((item, index) => {
        if (
          ((item.elem_type === "frame" &&
            (item.id === itemId || item?.frameIndex === itemId)) ||
            (item.id === itemId && item.elem_type === "tab")) &&
          sheetName === "" && !flag47
        ) {
          // jsonDataPresent.push(jsonToBeAdded);

          if (propertyName === "replace") {
            var newJSON;
            // jsonDataPresent.splice(index+1, 0, jsonToBeAdded);
            // jsonDataPresent.splice(index, 1);
            if (jsonData[index].sheetElementIndex) {
              const sheetElementIndex = jsonData[index].sheetElementIndex;
              const sheetIndex = jsonData[index].sheetIndex;
              const frameIndex = jsonData[index].frameIndex;
              const parent_id = jsonData[index].children[0].parent_id;
              const updateData = {
                sheetElementIndex,
                sheetIndex,
                frameIndex,
                parent_id,
              };

              newJSON = replaceJSONStucture(jsonToBeAdded, updateData, "tab");
              console.log("hao1", newJSON);
              jsonData.splice(index + 1, 0, newJSON);
              jsonData.splice(index, 1);
            } else {
              if (jsonData[index]?.children?.[0]?.parent_id) {
                jsonToBeAdded.children[0].parent_id =
                  jsonData[index].children[0].parent_id;
              }
              const newJson = updateTileIndex(
                jsonToBeAdded,
                jsonToBeAdded?.frameIndex
              );
              jsonData.splice(index + 1, 0, newJson);
              jsonData.splice(index, 1);
            }
          }
          if (propertyName === "new") {
            var newJSON;
            // jsonDataPresent.splice(index+1, 0, jsonToBeAdded);
            if (jsonData[index].sheetElementIndex) {
              const sheetElementIndex = jsonToBeAdded?.sheetElementIndex;
              const sheetIndex = jsonData[index].sheetIndex;
              const frameIndex = jsonData[index].frameIndex;
              // const parent_id = jsonData[index].children[0].parent_id;
              const updateData = {
                sheetElementIndex,
                sheetIndex,
                frameIndex,
                // parent_id
              };
              newJSON = replaceJSONStucture(jsonToBeAdded, updateData, "tab");
              console.log("hao1", newJSON);
              // jsonData.splice(index + 1, 0, newJSON);
              if(isUploadedInSection) {
                addElementInSection(item, newJSON || isUploadedInSection, itemId, touchedId)
                flag47 = true
              } else {
                jsonData.push(newJSON);
              }
            } else {
              // if(jsonData[index].children[0].parent_id){
              //   jsonToBeAdded.children[0].parent_id = jsonData[index].children[0].parent_id
              // }
              // jsonData.splice(index + 1, 0, jsonToBeAdded);
              const newJson = updateTileIndex(
                jsonToBeAdded,
                jsonToBeAdded?.frameIndex
              );

              if(isUploadedInSection) {
                addElementInSection(item, newJson || isUploadedInSection, itemId, touchedId)
                flag47 = true
              } else {
                jsonData.push(newJson);
              }
            }
            // jsonData.splice(index + 1, 0, jsonToBeAdded);
          }
          updatedComponentInFormState();

          // console.log(" In Import Section In Import Section IformdesignerLayout ", jsonData);
          // console.log(" In Import Section In Import Section IformdesignerLayout ", formState2);
        }
        if (item?.id === sheetName && sheetName !== "") {
          if (propertyName === "new") {
            if (sheetName?.includes("sheet")) {
              const sheetElementIndex = jsonToBeAdded?.sheetElementIndex;
              const sheetIndex = item?.sheetIndex;
              const frameIndex = item?.children[0]?.frameIndex;
              // const parent_id = jsonData[index].children[0].parent_id;
              const updateData = {
                sheetElementIndex,
                sheetIndex,
                frameIndex,
                // parent_id
              };
              newJSON = replaceJSONStucture(jsonToBeAdded, updateData, "tab");
              console.log("hao3", newJSON);
              item?.children?.push(newJSON);
            } else {
              const newJson = updateTileIndex(
                jsonToBeAdded,
                jsonToBeAdded?.frameIndex
              );
              item?.children?.push(newJson);
            }
          }
          updatedComponentInFormState();
        }
        if (
          item?.id === itemId &&
          sheetName === "" &&
          itemId?.includes("column")
        ) {
          if (propertyName === "new") {
            const sheetElementIndex = jsonToBeAdded?.sheetElementIndex;
            const sheetIndex = jsonToBeAdded?.sheetIndex;
            const frameIndex = jsonToBeAdded?.frameIndex;
            if (jsonToBeAdded?.sheetIndex)
              delete jsonToBeAdded["sheetElementIndex"];
            // const parent_id = jsonData[index].children[0].parent_id;
            const updateData = {
              sheetElementIndex,
              sheetIndex,
              frameIndex,
              // parent_id
            };
            newJSON = replaceJSONStucture(jsonToBeAdded, updateData, "tab");
            console.log("hao4", newJSON);
            item?.children?.push(newJSON);
          }
          updatedComponentInFormState();
        }

        if (Object.keys(item).includes("children")) {
          recursiveJsonForImportSection(
            item,
            itemId,
            currIndex + 1,
            jsonDataPresent,
            jsonToBeAdded,
            propertyName,
            sheetName,
            isUploadedInSection,
            touchedId
          );
        }
      });
    } else {
      recursiveJsonForImportSection(
        jsonData["children"],
        itemId,
        currIndex + 1,
        jsonDataPresent,
        jsonToBeAdded,
        propertyName,
        sheetName,
        isUploadedInSection,
        touchedId
      );
    }

    //     sendRequestForControl(extraDetails.frameIndex, 'delete', elemType, extraDetails)
    //     .then((response) => {
    //         if(response.data.status === '0'){
    //             if(openCanvasForSubform === 'subform'){
    //                 //updatedJson = removeAndUpdateIndex(subFormStateJson.current,elemId,elemType);
    //             } else {
    //                 console.log("updatedformState updatedformState ");
    //                 var updatedformState = removeAndUpdateIndex(formState2,elemId,elemType, 1, response.data);
    //                 updatedComponentInFormState();
    //                 //setFormState2(updatedformState);
    //             }

    //         }
    //         else{
    //             setAlertData({
    //                 'open':true,
    //                 'showConfirm':'showNotification',
    //                 'alertType':'error',
    //                 'alertContentMsg':'Failed to delete control. Please try again.',
    //                 'autoHideDuration':6000 ,
    //             })
    //         }
    // });
  }

function addElementInSection(item, newJson, itemId = "", touchedId = "") {
  let isNewJsonAdded = false;

  if(item?.children?.length) {
    if(itemId?.includes("tab") && touchedId?.includes("frame")){
      const sheetName = document.querySelector(`#${touchedId}`)?.closest(`[elem_type=tabChild]`)?.getAttribute("id");
      item.children.forEach(row => {
        if(row?.children?.length && !isNewJsonAdded && row?.id === sheetName) {
          row.children.forEach(col => {
            if(col.children && !col.children.length && !isNewJsonAdded) {
              col?.children?.push(newJson);
              isNewJsonAdded = true;
            }
            else if(col.children && col.children.length > 0 && !isNewJsonAdded && col.elem_type === "row") {
              col.children.forEach(child => {
                if(child.children && !child.children.length && !isNewJsonAdded) {
                  child?.children?.push(newJson);
                  isNewJsonAdded = true;
                }
              })
            }
          });
        }
        // if(row.children && !row.children.length && !isNewJsonAdded) {
        //   row.push(newJson);
        //   isNewJsonAdded = true;
        // }
      });
    }
    else{
      item.children.forEach(row => {
        if(row?.children?.length && !isNewJsonAdded) {
          row.children.forEach(col => {
            if(col.children && !col.children.length && !isNewJsonAdded) {
              col?.children?.push(newJson);
              isNewJsonAdded = true;
            }
            else if(col.children && col.children.length > 0 && !isNewJsonAdded && col.elem_type === "row") {
              col.children.forEach(child => {
                if(child.children && !child.children.length && !isNewJsonAdded) {
                  child?.children?.push(newJson);
                  isNewJsonAdded = true;
                }
              })
            }
          });
        }
        // if(row.children && !row.children.length && !isNewJsonAdded) {
        //   row.push(newJson);
        //   isNewJsonAdded = true;
        // }
      });
    }
    if(!isNewJsonAdded) { // all columns are filled, adding new row
      if(itemId?.includes("tab") && touchedId?.includes("frame")){
        const sheetName = document.querySelector(`#${touchedId}`)?.closest(`[elem_type=tabChild]`)?.getAttribute("id");
        item.children.forEach(row => {
          if(row?.children?.length && !isNewJsonAdded && row?.id === sheetName) {
            if(row.ColumnLayout){
              const newRow = [];
              var noOfCols = parseInt(row.ColumnLayout);
              for (let c = 0; c < (parseInt(noOfCols)); c++) {
                  var col = {};
                  col.id = createUniqueId('column');//newElement;
                  col.elem_type = 'column';
                  const w = 12 / parseInt(noOfCols);
                  col.w = getColumnLayout("web");
                  col.md = getColumnLayout( getCurrentDevice() || "web");
                  col.sm = getColumnLayout("tablet");
                  col.xs = getColumnLayout("mobile");
                  col.children = [];
                  col.style = {};
                  col.style["heightselect"] = "set";
                  col.frameIndex = item.frameIndex;
                  newRow.push(col);
              }
              if(newRow?.[0]?.children){
                newRow[0].children.push(newJson)
              }
              row.children[0].children = row?.children?.[0]?.children?.concat(newRow)
            }
          }})
      }
      else{
        const newRow = {};
        newRow.id = createUniqueId("row");
        newRow.elem_type = "row";
        newRow.frameIndex = item.frameIndex;
        newRow.children = [];
        newRow.parent_id = item.id;
  
        // const col = {};
        // col.id = createUniqueId('column');//newElement;
        // col.elem_type = 'column';
        // col.w = getColumnLayout("web");
        // col.md = getColumnLayout( getCurrentDevice() || "web");
        // col.sm = getColumnLayout("tablet");
        // col.xs = getColumnLayout("mobile");
        // col.children = [];
        // col.style = {};
        // col.style["heightselect"] = "set";
        // col.frameIndex = item.frameIndex;
        // newRow.children.push(col);
        var noOfCols = parseInt(item.ColumnLayout);
        for (let c = 0; c < (parseInt(noOfCols)); c++) {
            var col = {};
            col.id = createUniqueId('column');//newElement;
            col.elem_type = 'column';
            const w = 12 / parseInt(noOfCols);
            col.w = getColumnLayout("web");
            col.md = getColumnLayout( getCurrentDevice() || "web");
            col.sm = getColumnLayout("tablet");
            col.xs = getColumnLayout("mobile");
            col.children = [];
            col.style = {};
            col.style["heightselect"] = "set";
            col.frameIndex = item.frameIndex;
            newRow.children.push(col);
        }
        if(newRow.children?.[0]?.children){
          newRow.children[0].children.push(newJson)
        }
  
        item?.children?.push(newRow)
      }
    }
  }
}

  function getElementJson(formStatejson, controlId, elem_type) {
    if (formStatejson !== undefined && formStatejson !== null) {
      if (JsonOfReorderElem.json === "") {
        if (
          formStatejson.elem_type === "frame" ||
          formStatejson.elem_type === "section" ||
          formStatejson.elem_type === "sheet" ||
          formStatejson.elem_type === "headerframe"
        ) {
          JsonOfReorderElem.absoluteParent = formStatejson.id;
        }
      }
      if (formStatejson.id === controlId || formStatejson?.style?.CustomId === controlId) {
      } else {
        if (
          formStatejson.children !== undefined &&
          formStatejson.children !== null
        ) {
          var children = [];
          formStatejson.children.map(function (entry, index) {
            // console.log("traversing through ", entry.id, index);
            if (entry?.id === controlId || entry?.style?.CustomId === controlId) {
              //   console.log("control found inside ", formStatejson.id);
              if (entry?.elem_type === elem_type) {
                console.log(entry);
                JsonOfReorderElem.json = entry;
                JsonOfReorderElem.id = entry.id;
                JsonOfReorderElem.previousIndex = index;
                JsonOfReorderElem.parentRow = formStatejson.id;
              }
            } else {
              getElementJson(entry, controlId, elem_type);
            }
          });
        }
      }
    }
    return JsonOfReorderElem;
  }
  // //console.log(JsonOfReorderElem);

  function addElementToJson(formStatejson, controlId, elem_type) {
    if (formStatejson !== undefined && formStatejson !== null) {
      if (formStatejson.id === controlId) {
        //console.log(formStatejson.id);
      } else {
        if (
          formStatejson.children !== undefined &&
          formStatejson.children !== null
        ) {
          var children = [];
          formStatejson.children.map(function (entry, index) {
            if (entry.id === controlId) {
              // console.log("entry_Id:  "+entry.id, formStatejson.id, JsonOfReorderElem.parentRow , (formStatejson.id === JsonOfReorderElem.parentRow));
              if (entry.elem_type === elem_type) {
                const json = { ...JsonOfReorderElem.json };
                // console.log('previousIndex :: ',JsonOfReorderElem.previousIndex, 'current Index :: ',index);
                // json.id=createUniqueId(elem_type);
                // json.children[0].id=createUniqueId(json.children[0].elem_type);
                if (formStatejson.id === JsonOfReorderElem.parentRow) {
                  if (index >= JsonOfReorderElem.previousIndex) {
                    children.push(entry);
                    children.push(json);
                  } else {
                    children.push(json);
                    children.push(entry);
                  }
                } else {
                  children.push(json);
                  children.push(entry);
                }
                //console.log(json);
                //console.log(entry);
              }
            } else {
              var elseReturned = addElementToJson(entry, controlId, elem_type);
              children.push(elseReturned);
            }
          });
          formStatejson.children = children;
        }
      }
    }
    return formStatejson;
  }

  var draggedObjType = "";
  const [draggedFrom, setDraggedFrom] = useState("");

  // //console.log(JsonOfReorderElem);
  function getParentColumnId(controlId) {
    if (controlId) {
      const elem_type = document
        .getElementById(controlId)
        .getAttribute("elem_type");
      if (elem_type === "column") {
        //console.log(controlId);
        // document.getElementById(controlId).classList.add("LeftBorder");
        return controlId;
      } else {
        const parentId = document.getElementById(controlId).parentElement.id;
        getParentColumnId(parentId);
      }
    }
  }

  const currentObjDragged = useRef();

  const scroll = useCallback(_.debounce((unit) => {
    document.getElementById("mainCanvas").scrollTop += unit;
  }, 200, {leading: true, trailing: false, maxWait: 200}), []);

  useEffect(() => {
    if(currentObjDragged.current && currentObjDragged?.current?.alt === "Move Icon") {
      document.ondragover = function() {
        let ypos = window.event.clientY;
        let y = ypos - document.getElementById("mainCanvas")?.getBoundingClientRect().top;           
        let z = window.event.offsetY;
        // setTimeout(() => {
          if(z >= document.getElementById("mainCanvas")?.clientHeight - 50) {
              scroll(20);
          }
          setTimeout(() => {
            if(y <= 10)
              scroll(-20);
          },[100])
        // // },[100]);
        // setTimeout(() => {
        //   if(y < 20)
        //     scroll(-20);
        // },[100])
    } 
  }
  })

  // useEffect(() => {
  //   if(currentObjDragged.current && currentObjDragged?.current?.alt === "Move Icon") {
  //     document.ondragover = function() {
  //       let y = window.event.offsetY;           
  //       // setTimeout(() => {
  //         // if(y >= document.getElementById("mainCanvas")?.clientHeight - 50) {
  //         //     scroll(20);
  //         // }
  //       // // },[100]);

  //   } 
  // }
  // })

  function handleReorderStart(e, elemId, elemType, elemJson) {
    // console.clear();
    //console.log(">>> called handleReorderStart")
    
    draggedObjType = "notNew";
    currentObjDragged.current = e.target;
    // console.log(e.target.getAttribute("id"));
    // console.log(e.target.getAttribute("elem_type"));
    let controlId;
    if (elemId !== undefined) {
      controlId = elemId;
    } else {
      controlId = e.target.getAttribute("id");
    }
    // console.log('controlId :: '+controlId);
    let elem_type;
    if (elemType !== undefined) {
      elem_type = elemType;
    } else {
      elem_type = e.target.getAttribute("elem_type");
    }
    // console.log('elem_type :: '+elem_type);
    if(elemJson && openCanvasForSubform === "showDataAdditonSection") {
      e.stopPropagation();

      setOldControl({
        json: elemJson,
        id: elemJson.id,
        previousIndex: undefined,
        nextIndex: undefined,
        toBePlacedOnIndex: undefined,
        parentRow: undefined,
        absoluteParent: undefined,
      });
      // dispatch(updateRenderElement({ id: elemId, value: new Date() }));
    } else {
      const json = getElementJson(
        openCanvasForSubform === "subform"
          ? subFormStateJson.current
          : openCanvasForSubform === "advanceListviewFromScratch"
          ? fetchGridStates().advanceListviewStateJson
          : formState2,
        controlId,
        elem_type
      );

      setOldControl(json);
    }
    // console.log("DragStart getElementJson :: ", json);
    // setDraggedFrom("notNew");
  }

  function handleListviewControlSwapping(e, json_data) {
    e.preventDefault();
    e.stopPropagation();

    if (Object.keys(oldControl?.current?.json || {}).length === 0) {
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: "LISTVIEW_DROP_ERROR",
      });
    } else if(Object.keys(oldControl?.current?.json || {}).length) {
      if (
        e.target.id.includes("after_column") ||
        e.target.id.includes("before_column") ||
        e.currentTarget.id.includes("after_column") ||
        e.currentTarget.id.includes("before_column")
      ) {

        swapControlsInListview(
          currentListviewForSubform,
          oldControl?.current?.json?.sequenceIndex,
          json_data?.sequenceIndex,
          setOldControl,
          {
            isWithin: true,
            position:
              e.target.id.includes("after_column") || e.currentTarget.id.includes("after_column") ? "after" : "before"
          }
        );
      } else {
        swapControlsInListview(
          currentListviewForSubform,
          oldControl?.current?.json?.sequenceIndex,
          json_data?.sequenceIndex,
          setOldControl
        );
      }
    }
  }

  function handleReOrderDrag(e) {
    // //console.log("dragging over the elements");
    const controlId = e.target.getAttribute("id");
    const columnId = getParentColumnId(controlId);
    // //console.log(columnId);
    // console.log('Dragging over column :: ', columnId);
  }

  function handleDragLeave(e, addContainer, generatePage) {
    // //console.log("dragging over the elements");
    // const controlId = e.target.getAttribute("id");
    e.preventDefault();
    e.stopPropagation();

    console.log("Drag leave", e);
    // if(addContainer || generatePage){
    //   if(document.getElementById("emptyScreen")){
    //     document.getElementById("emptyScreen").style.display="unset"
    //   }
    // }
    // setDragCounter((prevCounter) => {
    //   if (prevCounter > 0) {
    //     console.log("Handled Drag Leave");
    //     // Call your handledragleave function here
    //     setEmptyScreen(true);
    //   }
    //   return 0;
    // });
    if(checkEmpty(formState2)){
      // dispatch(updateStateInRedux({name: "emptyScreen", key: containerId, value: true}));
      if(window.changeEmptyScreen)
      window.changeEmptyScreen(true)
    }
  }


  async function handleSectionDrop(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  let updateElementPosition = [];
  const getUpdatePositionElement = (formStateJson, controlId) => {
    if (formStateJson !== undefined && formStateJson !== null) {
      if (formStateJson.id === controlId) {
        updateElementPosition.push(formStateJson);
      } else {
        if (
          formStateJson.children !== undefined &&
          formStateJson.children !== null
        ) {
          var children = [];
          formStateJson.children.map(function (entry, index) {
            if (entry?.id === controlId) {
              updateElementPosition.push(entry);
            } else {
              getUpdatePositionElement(entry, controlId);
            }
          });
        }
      }
    }
    // return JsonOfReorderElem.json;
  };

  // const controlsMapping = {
  //   "section": ["Design Page","form","tabChild","wizard_h","wizard_v","sidenavigation","menu","tab_column"],
  //   "tab": ["column","Design Page","form"],
  //   "wizard_h": ["Design Page","form"],
  //   "wizard_v": ["Design Page","form"],
  //   "sidenavigation": ["Design Page","form"],
  //   "Menu": ["Design Page","form"],
  //   "toggle": ["column"],
  //   "checkbox": ["column"],
  //   "slider": ["column"],
  //   "iframe": ["column"],
  //   "radio": ["column"],
  //   "textbox": ["column"],
  //   "password": ["column"],
  //   "textarea": ["column"],
  //   "richtexteditor": ["column"],
  //   "datepick": ["column"],
  //   "listbox": ["column"],
  //   "combo": ["column"],
  //   "tile": ["column"],
  //   "picklist": ["column"],
  //   "button": ["column"],
  //   "link": ["column"],
  //   "label": ["column"],
  //   "paragraph": ["column"],
  //   "table": ["column"],
  //   "listview": ["column"],
  //   "advancelistview": ["column"],
  //   "image": ["column"],
  //   "imagecarousel": ["column"],
  //   "report": ["column"],
  //   "captcha": ["column"],
  // }
  // console.log(subFormStateJson.current,"subFormStateJson.current=======>>>>>",openCanvasForSubform,"fghjkl",activeSubForm)

  async function handleReorderDrop(e, elem_Type, json_data, isAboveWizard, isWizardHeader) {
    e.preventDefault();
    e.stopPropagation();    
    // setHoverColumn(false);
    if(currentDataObjectJson.current && Object.keys(currentDataObjectJson.current).length !== 0){
      dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: true}))
    }
    // dispatch(updateStateInRedux({name: "hoverColumn", key: containerId, value: false}));
    targetForDrop(e);
    var frameId1 = [];
    var frameId2;
    var frameId3;
    var flag4 = 0;
    var flag37 = 0;
    var tempFrameNo;
    var frameNo;
    var checkTabParentSection = 0;

    if (
      elem_Type === "Design Page" &&
      (currElemState.current === "Menu" ||
        currElemState.current === "wizard_h" ||
        currElemState.current === "wizard_v" ||
        currElemState.current === "sidenavigation")
    ) {
      formState2.containerControl = currElemState.current;
    }

    if (
      elem_Type === "frame" &&
      (currElemState.current === "" || currElemState.current === null) &&
      e?.target?.id?.includes("before_")
    ) {
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: "UploadSectionErrorMessage",
      });
      return;
    }

    if (openCanvasForSubform === "showDataAdditonSection") {
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: "UploadSectionErrorMessage",
      });
      return;
    }

    if (elem_Type === "frame" && currElemState.current) {
      if (openCanvasForSubform === "advanceListviewFromScratch") {
        frameId1 = findJsonNew(fetchGridStates().advanceListviewStateJson, elem_Type);
      } else if (openCanvasForSubform === "subform") {
        frameId1 = findJsonNew(subFormStateJson.current, elem_Type);
      } else {
        frameId1 = findJsonNew(formState2, elem_Type);
      }
      if (frameId1.length !== 0) {
        frameId2 = frameId1[0];
        if (e.target.id.includes("before_")) {
          frameId3 = e.target.id.replace("before_", "");
          if (frameId3 === frameId2) {
            flag4 = 1;
          } else {
            if (currElemState.current === "tab") {
              if (
                document
                  .getElementById(`${e?.target?.id}`)
                  .getAttribute("sheetElementIndex") === null
              ) {
                if (flag4 === 0) {
                  // flag37 = 1
                  if (
                    document
                      .getElementById(`${e?.target?.id}`)
                      .getAttribute("sheetElementIndex")
                  ) {
                    tempFrameNo = document
                      .getElementById(`${e?.target?.id}`)
                      .getAttribute("sheetElementIndex");
                  } else if (
                    document
                      .getElementById(`${e?.target?.id}`)
                      .getAttribute("frameIndex")
                  ) {
                    tempFrameNo = document
                      .getElementById(`${e?.target?.id}`)
                      .getAttribute("frameIndex");
                  }
                  if (tempFrameNo) {
                    flag37 = 1;
                    frameNo = tempFrameNo;
                    window.onRootControl = true;
                  }
                }
              } else if (
                document
                  .getElementById(`${e?.target?.id}`)
                  .getAttribute("sheetElementIndex")
              ) {
                showAlertConfirmNotifications({
                  open: true,
                  showConfirm: "showNotification",
                  alertType: "error",
                  alertContentKey: "Tab_no_drop_tab",
                });
                return;
              }
            } else {
              if (flag4 === 0) {
                // flag37 = 1
                if (
                  document
                    .getElementById(`${e?.target?.id}`)
                    .getAttribute("sheetElementIndex")
                ) {
                  tempFrameNo = document
                    .getElementById(`${e?.target?.id}`)
                    .getAttribute("sheetElementIndex");
                } else if (
                  document
                    .getElementById(`${e?.target?.id}`)
                    .getAttribute("frameIndex")
                ) {
                  tempFrameNo = document
                    .getElementById(`${e?.target?.id}`)
                    .getAttribute("frameIndex");
                }
                if (tempFrameNo) {
                  flag37 = 1;
                  frameNo = tempFrameNo;
                }
              }
            }
            // else if(flag4 === 0 && currElemState.current === "tab" && document.getElementById(`${e?.target?.id}`).getAttribute("sheetName")){
            //   showAlertConfirmNotifications({

            //     open: true,

            //     showConfirm: "showNotification",

            //     alertType: "error",

            //     alertContentKey: "Tab_no_drop_tab",

            //   });
            //   return
            // }
          }
        }
      }
    }
    // document.getElementsByClassName("LeftBorder")[0].classList.remove("LeftBorder");
    // console.clear();
    // if(e.target.getAttribute("id").parentElement.elem_type!==null){
    //     //console.log(e.target.getAttribute("id").parentElement.elem_type)
    // }
    // console.log("#Subform",subformDragged);
    const allPrimitiveControlList = [
      "textbox",
      "password",
      "textarea",
      "richtexteditor",
      "datepick",
      "slider",
      "listbox",
      "combo",
      "radio",
      "checkbox",
      "toggle",
      "tile",
      "doclist",
      "picklist",
      "button",
      "link",
      "label",
      "paragraph",
      "table",
      "listview",
      "advancelistview",
      "image",
      "imagecarousel",
      "report",
      "iframe",
      "captcha",
      "sheet",
      "CustomControl",
    ];

    if (subformDragged) {
      onDropOfSubform(e, json_data);
    } else if (currentSubFormInWizard && !(isWizardHeader || isAboveWizard)) {
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: "CONTROL_DROP_MESSAGE_ON_SUBFORM",
      });
    } else if (currElemState.current !== "" && currElemState.current !== null) {
      let elemType = e.target.getAttribute("elem_type");
      let isMenu =
        e.target.closest(`[elem_type=Menu]`) ||
        (openCanvasForSubform === "subform" &&
          currentButtonForSubform.current?.containerControl === "Menu") ||
        (openCanvasForSubform === "advanceListviewFromScratch" &&
          currentadvanceListview.current?.containerControl === "Menu");
      let isTabVerticle = e.target.closest(`[elem_type=sidenavigation]`);
      let isWizard =
        e.target.closest(`[elem_type=wizard_h]`) ||
        e.target.closest(`[elem_type=wizard_v]`) ||
        (openCanvasForSubform === "subform" &&
          (currentButtonForSubform.current?.containerControl === "wizard_v" ||
            currentButtonForSubform.current?.containerControl ===
              "wizard_h")) ||
        (openCanvasForSubform === "advanceListviewFromScratch" &&
          (currentadvanceListview.current?.containerControl === "wizard_v" ||
            currentadvanceListview.current?.containerControl === "wizard_h"));
      let isBefore =
        e?.target?.id?.includes("before_frame") ||
        e?.target?.id?.includes("after_row") ||
        false;

      if (e.target.closest(`[elem_type=tab]`)) {
        if (e.target.closest(`[elem_type=section]`))
          if (
            e.target.closest(`[elem_type=section]`)?.closest(`[elem_type=tab]`)
          )
            checkTabParentSection = 0;
          else checkTabParentSection = 1;
      }
      if (
        currElemState.current === "section" &&
        (elemType === "section" ||
          elemType === "frame" ||
          elemType === "tab" ||
          (elemType === "column" &&
            e.target.closest(`[elem_type=section]`) &&
            checkTabParentSection === 0) ||
          (elemType === "row" &&
            e.target.closest(`[elem_type=section]`) &&
            checkTabParentSection === 0)) &&
        flag4 === 0 &&
        flag37 === 0
      ) {
        setCurrentDataObjectJson(cloneDeep({}));
        dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "SECTION_DROP_MESSAGE",
        });
        return;
      } else if (
        (e?.target?.id?.includes("before_frame") ||
          e?.target?.id?.includes("before_tab")) &&
        allPrimitiveControlList?.includes(currElemState.current)
      ) {
        setCurrentDataObjectJson(cloneDeep({}));
        dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "CANT_DROP",
        });
        return;
      } else if (
        e?.target?.id?.includes("highlight_me") &&
        allPrimitiveControlList?.includes(currElemState.current)
      ) {
        setCurrentDataObjectJson(cloneDeep({}));
        dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "CANT_DROP",
        });
        return;
      } else if (
        currElemState.current !== "tab" &&
        currElemState.current !== "section" &&
        elem_Type === "frame" &&
        flag4 === 1
      ) {
        setCurrentDataObjectJson(cloneDeep({}));
        dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "Section_Tab_drop.",
        });
        return;
      } else if (
        currElemState.current === "advancelistview" &&
        openCanvasForSubform === "advanceListviewFromScratch"
      ) {
        setCurrentDataObjectJson(cloneDeep({}));
        dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "No_Drop_AdvnLw_In_AdvnLw",
        });
        return;
      } else if (
        currElemState.current !== "tab" &&
        currElemState.current !== "section" &&
        (elem_Type === "Menu" ||
          elem_Type === "wizard_h" ||
          elem_Type === "wizard_v" || elem_Type === "sidenavigation")
      ) {
        setCurrentDataObjectJson(cloneDeep({}));
        dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "CANT_DROP_WIZ",
        });
        return;
      } else if (
        currElemState.current === "tab" &&
        (elem_Type === "column" || isBefore) &&
        (isMenu || isWizard || isTabVerticle)
      ) {
        setCurrentDataObjectJson(cloneDeep({}));
        dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "Tab_no_drop_wizard",
        });
        return;
      } else if (currElemState.current === "tab" && (isMenu || isWizard)) {
        setCurrentDataObjectJson(cloneDeep({}));
        dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "Tab_no_drop_wizard",
        });
        return;
      } else if (
        currElemState.current === "tab" &&
        elem_Type === "sidenavigation"
      ) {
        setCurrentDataObjectJson(cloneDeep({}));
        dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "Tab_no_drop_tv",
        });
        return;
      } else if (
        currElemState.current === "tab" &&
        (elem_Type === "Menu" ||
          elem_Type === "wizard_h" ||
          elem_Type === "wizard_v")
      ) {
        setCurrentDataObjectJson(cloneDeep({}));
        dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "Tab cannot be dropped in Menu / Wizard.",
        });
        return;
      } else if (
        allPrimitiveControlList.includes(elemType) ||
        (elemType === "form" &&
          allPrimitiveControlList.includes(currElemState.current)) ||
        elemType === "tab" ||
        elemType === null
      ) {
        setCurrentDataObjectJson(cloneDeep({}));
        dispatch(updateStateInRedux({name: "dragDropDO", key: containerId, value: false}))
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: `${t("Please_Drop_Control_Inside_Section_Canvas")}`,
        });
        
      } else if (
        currElemState.current !== "section" &&
        currElemState.current !== "tab" &&
        currElemState.current !== "sidenavigation" &&
        currElemState.current !== "wizard_h" &&
        currElemState.current !== "wizard_v" &&
        currElemState.current !== "Menu" &&
        (elem_Type === "Design Page" || elemType === "form") &&
        flag4 === 0
      ) {
        drop(e, flag4, checkTabParentSection, flag37, frameNo);
        // showAlertConfirmNotifications({
        //   open: true,
        //   showConfirm: "showNotification",
        //   alertType: "error",
        //   alertContentKey: "CONTROLS_DROP_NO_CONTAINER",
        // });
      } else {
        if(e.target.getAttribute("elem_type")==="form" && (
           document.querySelector("[elem_type=wizard_h]") ||
           document.querySelector("[elem_type=wizard_v]") ||
           document.querySelector("[elem_type=sidenavigation]") 
         ) && !isAboveWizard){
          showAlertConfirmNotifications({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: "CONTROLS_DROP_NO_CONTAINER",
            });
            return;

        }
        else if((e.target.getAttribute("elem_type")==="form" || (e.target.getAttribute("elem_type") !== "Step" && e.target.getAttribute("elem_type") !=="SubStep" && e.target.getAttribute("elem_type") !== "MainMenu" && e.target.getAttribute("elem_type") !== "SubMenu" && e.target.getAttribute("elem_type") !== "SubChildMenu" && !e.target.getAttribute("id")?.includes("before_frame"))) && currElemState.current === 'section' && (
          document.querySelector("[elem_type=wizard_h]") ||
          document.querySelector("[elem_type=wizard_v]") ||
          document.querySelector("[elem_type=sidenavigation]") 
        ) && !isAboveWizard){
         showAlertConfirmNotifications({
             open: true,
             showConfirm: "showNotification",
             alertType: "error",
             alertContentKey: "CANT_DROP",
           });

       }
        else{
          drop(e, flag4,checkTabParentSection, flag37, frameNo, isAboveWizard);
        }
      }
    } else {
      if (
        (e.currentTarget.closest(
          `[elem_type=${oldControl.current?.json?.elem_type === 'tab' ? 'frame': oldControl.current?.json?.elem_type}]`
        ) || (e.currentTarget.id.includes("parentTabBox") && oldControl.current?.json?.elem_type === 'frame'))&& !e.currentTarget.id?.includes('before_')
      ) {
        let controlId,checkSameContainer = true,tabSectionSwap = false;
        if(oldControl.current?.json?.elem_type === 'tab' && elem_Type === "frame")
          tabSectionSwap = true;
        if(e.currentTarget.id.includes("parentTabBox") && oldControl.current?.json?.elem_type === 'frame') {
          controlId = e.currentTarget?.closest(`[elem_type=frameTab]`)?.getAttribute("parentframeid");
          tabSectionSwap = true;
        }
        else if(elem_Type === "frame" || elem_Type === "frameTab")
          controlId = e.currentTarget?.closest(`[elem_type=${oldControl.current?.json?.elem_type === 'tab' ? 'frame': oldControl.current?.json?.elem_type}]`)?.getAttribute("control_id")
        else{
          controlId = e.currentTarget?.closest(`[elem_type=${oldControl.current.json.elem_type}]`)?.getAttribute("id")
        }

        if(elem_Type === "column") {
          if(document.getElementById(e.currentTarget.id)?.closest(`[elem_type=frameTab]`)) {
            let parentId = document.getElementById(e.currentTarget.id)?.closest(`[elem_type=frameTab]`).getAttribute("control_id");
            const check1 = document.getElementById(e.currentTarget.id)?.closest(`[elem_type=section]`);
            const check2 = document.getElementById(e.currentTarget.id)?.closest(`[elem_type=section]`)?.closest(`[elem_type=frameTab]`)?.getAttribute('control_id') === parentId;
            const check3 = document.getElementById(oldControl.current.id)?.closest(`[elem_type=section]`)?.closest(`[elem_type=frameTab]`)?.getAttribute('control_id') === parentId;
            const previousSectionID = document.getElementById(oldControl.current.id)?.closest(`[elem_type=section]`)?.getAttribute("control_id");
            const newSectionID = document.getElementById(e.currentTarget.id)?.closest(`[elem_type=section]`)?.getAttribute("control_id");
            const newFrameTabId = document.getElementById(e.currentTarget.id)?.closest(`[elem_type=frameTab]`)?.getAttribute("control_id");
            const previousFrameTabId = document.getElementById(oldControl.current.id)?.closest(`[elem_type=frameTab]`)?.getAttribute("control_id");
            if(check1 && check2 && check3) {
              if(newSectionID === previousSectionID)
                checkSameContainer = true; 
              else checkSameContainer = false;
            }
            else if(previousFrameTabId === newFrameTabId  && newSectionID === previousSectionID) 
              checkSameContainer = true;
            else checkSameContainer = false;  
          }
          else if(document.getElementById(e.currentTarget.id)?.closest(`[elem_type=section]`)?.getAttribute("control_id") === document.getElementById(oldControl.current.id)?.closest(`[elem_type=section]`)?.getAttribute("control_id") && !document.getElementById(oldControl.current.id)?.closest(`[elem_type=frameTab]`))
            checkSameContainer = true; 
          else checkSameContainer = false;
        }
        if (controlId === oldControl.current.id) {
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: `${t("Same_Column_Swapping_Not_Allowed")}`,
          });
        } else if (controlId !== oldControl.current.absoluteParent && e.currentTarget.id?.includes('highlight_me')) {
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: `${t("Swapping not allowed")}`,
          });
        }
         else {
          if(checkSameContainer) {
            idMatched = undefined;
            let targetParent = getParentFromJson(
              openCanvasForSubform === "subform"
                ? subFormStateJson.current
                : openCanvasForSubform === "advanceListviewFromScratch"
                ? fetchGridStates().advanceListviewStateJson
                : formState2,
              controlId
            );
            console.log(
              targetParent,
              "controlId====>>>",
              controlId,
              "oldControl",
              oldControl.current
            );
            if (
              targetParent &&
              (targetParent.id === controlId ||
                targetParent.frameIndex === oldControl.current.json?.frameIndex ||
                targetParent.frameIndex ===
                  oldControl.current.json?.children[0]?.frameIndex ||
                (targetParent.sheetIndex === undefined
                  ? false
                  : targetParent.sheetIndex ===
                    oldControl.current.json?.children[0]?.sheetIndex))
            ) {
              console.log(
                formState2,
                "formState2====ifffffff",
                oldControl.current,
                "oldControl",
                targetParent
              );
              let isParentWizard = false;
              let isParentMenu = false;
              let isParentTab = false;
              const parentWizard = (eve) => {
                if (
                  eve.currentTarget.closest(`[elem_type=wizard_v]`) ||
                  eve.currentTarget.closest(`[elem_type=wizard_h]`) ||
                  (eve.currentTarget.closest(`[elem_type=sidenavigation]`) &&
                    !eve.currentTarget.closest(`[elem_type=tab]`)) ||
                  (openCanvasForSubform === "subform" &&
                    currentButtonForSubform.current?.containerControl ===
                      "wizard_h") ||
                  (openCanvasForSubform === "subform" &&
                    currentButtonForSubform.current?.containerControl ===
                      "wizard_v") ||
                  (openCanvasForSubform === "subform" &&
                    currentButtonForSubform.current?.containerControl ===
                      "sidenavigation")
                ) {
                  return true;
                } else {
                  return false;
                }
              };
  
              const parentMenu = () => {
                if (
                  e.currentTarget.closest(`[elem_type=Menu]`) ||
                  (openCanvasForSubform === "subform" &&
                    currentButtonForSubform.current?.containerControl === "Menu")
                ) {
                  return true;
                } else {
                  return false;
                }
              };
  
              const parentTab = () => {
                if (e.currentTarget.closest(`[elem_type=tab]`) && !e.currentTarget.id.includes("parentTabBox")) {
                  return true;
                } else {
                  return false;
                }
              };
  
              isParentWizard = parentWizard(e);
              isParentMenu = parentMenu();
              isParentTab = parentTab();
              let newPosition = null;
              if (isParentTab) {
                // let posControlesId = e.currentTarget.getAttribute("control_id")
                // getSelectedTabControled(targetParent,posControlesId)
                if (oldControl.current?.parentRow.includes("sheet")) {
                  newPosition = e.currentTarget.getAttribute("sheetElementIndex");
                } else {
                  updateElementPosition = [];
                  getUpdatePositionElement(targetParent, controlId);
                  newPosition =
                    updateElementPosition[0]?.children[0]?.sheetFrameElementIndex;
                  if (newPosition === null || newPosition === undefined) {
                    console.log(
                      updateElementPosition,
                      "updateElementPosition-----"
                    );
                    if (
                      updateElementPosition[0]?.children[0]?.elem_type === "tile"
                    ) {
                      console.log("okkkkkgf", updateElementPosition);
                      newPosition =
                        updateElementPosition[0]?.children[0]?.tileContents[0]
                          ?.sheetElementIndex;
                    } else {
                      newPosition =
                        updateElementPosition[0]?.children[0]?.sheetElementIndex;
                    }
                  }
                  console.log(
                    updateElementPosition,
                    "formStateJson====>>>>>>",
                    oldControl.current
                  );
                  // newPosition= e.currentTarget.closest("[elem_type=textbox]")?.getAttribute("sheetFrameElementIndex")
                }
              } else if (isParentWizard || isParentMenu) {
                if (isParentMenu) {
                  if (
                    openCanvasForSubform === "subform" &&
                    currentButtonForSubform.current?.containerControl === "Menu"
                  ) {
                    oldControl.current.stepIndex =
                      currentButtonForSubform.current?.stepIndex ||
                      currentButtonForSubform.current?.stepIndex === 0
                        ? currentButtonForSubform.current?.stepIndex
                        : "-1";
                    oldControl.current.substepIndex =
                      currentButtonForSubform.current?.subStepIndex ||
                      currentButtonForSubform.current?.subStepIndex === 0
                        ? currentButtonForSubform.current?.subStepIndex
                        : "-1";
                    oldControl.current.subChildMenuIndex =
                      currentButtonForSubform.current?.subChildMenuIndex ||
                      currentButtonForSubform.current?.subChildMenuIndex === 0
                        ? currentButtonForSubform.current?.subChildMenuIndex
                        : "-1";
                  } else {
                    const activeJsonString = document
                      .querySelector(".menuMain_Id")
                      .getAttribute("activeJson");
                    const activeJson = activeJsonString
                      ? JSON.parse(activeJsonString || null)
                      : {};
                    oldControl.current["stepIndex"] =
                      activeJson.MainMenuIndex || activeJson.MainMenuIndex === 0
                        ? activeJson.MainMenuIndex
                        : "-1";
                    oldControl.current["substepIndex"] =
                      activeJson.SubMenuIndex || activeJson.SubMenuIndex === 0
                        ? activeJson.SubMenuIndex
                        : "-1";
                    oldControl.current["subChildMenuIndex"] =
                      activeJson.subChildMenuIndex ||
                      activeJson.subChildMenuIndex === 0
                        ? activeJson.subChildMenuIndex
                        : "-1";
                  }
                } else {
                  oldControl.current["stepIndex"] =
                    (e.currentTarget.closest(`[elem_type=Step]`) &&
                      e.currentTarget
                        .closest(`[elem_type=Step]`)
                        .getAttribute("frameindex")) ||
                    (e.currentTarget.closest(`[elem_type=SubStep]`) &&
                      e.currentTarget
                        .closest(`[elem_type=SubStep]`)
                        .getAttribute("frameindex"));
                  oldControl.current["substepIndex"] =
                    e.currentTarget.closest(`[elem_type=SubStep]`) &&
                    e.currentTarget
                      .closest(`[elem_type=SubStep]`)
                      .getAttribute("elementindex");
                }
                if (
                  oldControl.current?.parentRow.includes("Step") ||
                  oldControl.current?.parentRow.includes("MainMenu") ||
                  oldControl.current?.parentRow.includes("SubMenu") ||
                  oldControl.current?.parentRow.includes("SubChildMenu")
                ) {
                  newPosition = e.currentTarget.getAttribute("frameindex");
                } else {
                  newPosition =
                    e.currentTarget
                      .querySelector("[elem_type=textbox]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=datepick]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=combo]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=checkbox]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=radio]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=button]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=textarea]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=multiSelect]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=label]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=paragraph]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=image]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=richtexteditor]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=toggle]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=imagecarousel]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=link]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=slider]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=doclist]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=email]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=password]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=listbox]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=report]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=table]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=captcha]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=listview]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=advancelistview]")
                      ?.getAttribute("elementindex") ||
                    e.currentTarget
                      .querySelector("[elem_type=tile_child]")
                      ?.getAttribute("elementindex");
                  if (newPosition === undefined || newPosition === null) {
                    updateElementPosition = [];
                    getUpdatePositionElement(targetParent, controlId);
                    newPosition =
                      updateElementPosition[0]?.children.length > 0
                        ? updateElementPosition[0]?.children[0].elementIndex
                        : undefined;
                  }
                }
              } else if(tabSectionSwap) {
                newPosition = e.currentTarget.getAttribute('frameindex');
              }  
              else if (oldControl.current?.parentRow === "RootControl") {
                newPosition = e.currentTarget.getAttribute("frameindex");
              } 
              else {
                newPosition =
                  e.currentTarget
                    .querySelector("[elem_type=textbox]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=datepick]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=combo]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=checkbox]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=radio]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=button]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=textarea]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=multiSelect]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=label]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=paragraph]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=image]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=richtexteditor]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=toggle]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=imagecarousel]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=link]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=slider]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=doclist]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=email]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=password]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=listbox]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=report]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=table]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=captcha]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=listview]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=advancelistview]")
                    ?.getAttribute("elementindex") ||
                  e.currentTarget
                    .querySelector("[elem_type=tile_child]")
                    ?.getAttribute("elementindex");
                if (newPosition === undefined || newPosition === null) {
                  updateElementPosition = [];
                  getUpdatePositionElement(targetParent, controlId);
                  newPosition =
                    updateElementPosition[0]?.children.length > 0
                      ? updateElementPosition[0]?.children[0].elementIndex
                      : undefined;
                }
              }
              console.log("vbnm,", newPosition);
              if (
                newPosition !== null &&
                newPosition !== undefined &&
                oldControl.current.json?.children.length > 0
              ) {
                updatePositionInform(
                  oldControl.current,
                  targetParent,
                  newPosition,
                  isParentTab,
                  isParentMenu,
                  isParentWizard,
                  openCanvasForSubform,
                  tabSectionSwap
                )
                  .then((response) => {
                    console.log("response====>>", response);
                    let resData = response?.data;
                    if (resData?.status === "0") {
                      const newJson = relocateControls(
                        openCanvasForSubform === "subform"
                          ? subFormStateJson.current
                          : openCanvasForSubform === "advanceListviewFromScratch"
                          ? fetchGridStates().advanceListviewStateJson
                          : formState2,
                        oldControl.current.id,
                        oldControl.current.json.elem_type,
                        controlId
                      );
                      if (openCanvasForSubform === "subform") {
                        setSubFormState({ ...newJson });
                      } else if (
                        openCanvasForSubform === "advanceListviewFromScratch"
                      ) {
                        dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...newJson },renderCanvas:true}));
                      } else {
                        setFormState2({ ...newJson });
                      }
                    } else if (resData?.status === 1) {
                      showAlertConfirmNotifications({
                        open: true,
                        showConfirm: "showNotification",
                        alertType: "error",
                        alertContentKey: `${t("Reopen_Form")}`,
                      });
                    }
                  })
                  .catch((err) => {
                    if (window?.callIdentity) {
                      delete window?.callIdentity;
                    }
                  });
              } else if(!tabSectionSwap){
                const newJson = relocateControls(
                  openCanvasForSubform === "subform"
                    ? subFormStateJson.current
                    : openCanvasForSubform === "advanceListviewFromScratch"
                    ? fetchGridStates().advanceListviewStateJson
                    : formState2,
                  oldControl.current.id,
                  oldControl.current.json.elem_type,
                  controlId,
                  true
                );  
                if (openCanvasForSubform === "subform") {
                  setSubFormState({ ...newJson });
                } else if (
                  openCanvasForSubform === "advanceListviewFromScratch"
                ) {
                  dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...newJson },renderCanvas:true}));
                } else {
                  setFormState2({ ...newJson });
                }
                // showAlertConfirmNotifications({
                //   open: true,
                //   showConfirm: "showNotification",
                //   alertType: "error",
                //   alertContentKey: `${t("translation:Both_column_should_contain_controls")}`,
                // });
              }
            } else {
              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: `${t("translation:Controle_cant_be_moved")}`,
              });
            }
            draggedObjType = "";
            setDraggedFrom("");
          } else {
            showAlertConfirmNotifications({
              open: true,
    
              showConfirm: "showNotification",
    
              alertType: "error",
    
              alertContentKey: "CANT_DROP",
            });
          }
          }
      }
    }
    // if(document.getElementById("emptyScreen") && (e.addContainer || e.generatePage)){
    //   document.getElementById("emptyScreen").style.display="unset"
    // }
    handleDragLeave(e)
    return true;
  }

  //As this is a recursive method, wherever you use this method to get the absolute parent of any elemnt,
  // just use only first 2 parameters
  let idMatched;
  const getParentFromJson = (formStateJson, childId, currentParent) => {
    if (Array.isArray(formStateJson)) {
      let result;
      formStateJson.map((json) => {
        if (idMatched !== true) {
          result = getParentFromJson(json, childId, currentParent);
        }
      });
      if (idMatched === true) {
        return result;
      }
    } else {
      if (
        formStateJson.elem_type === "frame" ||
        formStateJson.elem_type === "section" ||
        formStateJson.elem_type === "sheet" ||
        formStateJson.elem_type === "headerframe" ||
        formStateJson.elem_type === "tab"
      ) {
        if (idMatched !== true) {
          currentParent = formStateJson;
        }
      }
      if (formStateJson.id === childId) {
        idMatched = true;
        return currentParent;
      } else if (formStateJson.children) {
        return getParentFromJson(
          formStateJson.children,
          childId,
          currentParent
        );
      }
    }
  };

  const [selected, setSelected] = useState({
    id: "",
    tempStatus: "",
  });

  function addColumn(ev) {
    setCurrElem("column");
    const generatedColId = createUniqueId(currElemState.current);

    let emptyCol = {
      id: generatedColId,
      md: 4,
      sm: 4,
      w: 4,
      xs: 4,
      elem_type: "column",
      children: [],
    };

    const Id = ev.target.getAttribute("id");
    let colIndex;
    const Class = ev.target.getAttribute("class");
    var obj = formState2;

    // for (var key in obj) {
    //   if (key === "children") {
    //     var children = obj.children;
    //     for (var i = 0; i < children.length; i++) {
    //       if (Object.keys(children[i]).includes("children")) {
    //         for (var j = 0; j < children[i].children.length; j++) {
    //           var temp_children = children[i].children[j];
    //           if (Object.keys(temp_children).includes("children")) {
    //             var temp_children2 = temp_children.children;
    //             for (var k = 0; k < temp_children2.length; k++) {
    //               if (Object.keys(temp_children2[k]).includes("children")) {
    //                 var temp_children3 = temp_children2[k].children;
    //                 for (var l = 0; l < temp_children3.length; l++) {
    //                   //    if(Object.keys(temp_children3[l]).includes('children')){
    //                   //        var temp_children4 = temp_children3[l].children;
    //                   //        for(var m=0;m<temp_children4.length;m++){
    //                   if (temp_children3[l].id === Id) {
    //                     // temp_children3.splice(l, 0,{});
    //                     colIndex = l;
    //                   }
    //                   //        }
    //                   //    }
    //                 }
    //               }
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    // }

    // for (var key in obj) {
    //   // //console.log(colIndex);
    //   if (key === "children") {
    //     var children = obj.children;
    //     for (var i = 0; i < children.length; i++) {
    //       if (Object.keys(children[i]).includes("children")) {
    //         for (var j = 0; j < children[i].children.length; j++) {
    //           var temp_children = children[i].children[j];
    //           if (Object.keys(temp_children).includes("children")) {
    //             var temp_children2 = temp_children.children;
    //             for (var k = 0; k < temp_children2.length; k++) {
    //               if (Object.keys(temp_children2[k]).includes("children")) {
    //                 var temp_children3 = temp_children2[k].children;
    //                 //   for(var l=0;l<temp_children3.length;l++){
    //                 //    if(Object.keys(temp_children3[l]).includes('children')){
    //                 //        var temp_children4 = temp_children3[l].children;
    //                 //        for(var m=0;m<temp_children4.length;m++){
    //                 // if(temp_children3[l].id===Id){
    //                 temp_children3.splice(colIndex + 1, 0, emptyCol);
    //                 // //console.log(temp_children3);
    //                 // colIndex=l;
    //               }
    //               //        }
    //               //    }
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    // }

    setFormState2({ ...obj });
  }

  const applyChanges = (state, saveOldState, advanceListviewData) => {
    if (saveOldState === true) {
      setSubFormState(state);
      //    setFormState2(state);
      setSubFormID(selectedControl.current.id);
      setOpenCanvasForSubform("subform");
    } else if (saveOldState === "showDataAdditonSection") {
      setOpenCanvasForSubform("showDataAdditonSection");
      dispatch(updateGridContexts({name: "subFormListviewJson", key: containerId, value: state,renderCanvas:true}));

      //  setShowDataAdditionSection(state);
    } else if (saveOldState === "advanceListviewFromScratch") {
      // setSubFormState(formState2);
      // setFormState2(state);
      //   setSubFormState(state);
      dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: state, renderCanvas: true}));
      // setSubFormID(selectedControl.id);
      setSubAdvacnceListID(selectedControl.current.id);
      setOpenCanvasForSubform("advanceListviewFromScratch");
    } else {
      if(!props.previewmode) {
        var temp_undoList = [...undoList.current];
        // temp_undoList.push(...undoList.current);
        var temp_formdata = Object.assign({}, formState2);
        temp_formdata = JSON.stringify(temp_formdata);
        // setFormState2(temp_formdata)
        temp_undoList.push(temp_formdata);
        //console.log("nako", temp_formdata, temp_undoList)
        setUndoList(temp_undoList);
        //updatedComponentInFormState();
        // setFormState2(temp_formdata);
      }
    }
  };

  // function gridPopup(gridType, jsonForListview={}) {
  //   if (gridType === "advanceListviewPopupInPreview") {
  //     // console.log("ababbaba 1234 ",  jsonForListview);
  //     // console.log("ababbaba 1234 ",  jsonForListview.children[0].children[0].children[0].children[0].children[0].value);
  //     dispatch(updateContextsStates({
  //       key: containerId,
  //       data: {
  //         advanceListviewStateJson: jsonForListview,
  //         currentAdvanceListviewStateJson: jsonForListview,
  //         openCanvasForPreview: "advanceListviewPopupInPreview",
  //         openCanvasForPreviewAdvance: "advanceListviewPopupInPreview",
  //       }
  //     }));
  //     // dispatch(updateContexts({name: "advanceListviewStateJson", key: containerId, value: jsonForListview}));
  //     // dispatch(updateContexts({name: "currentAdvanceListviewStateJson", key: containerId, value: jsonForListview}));
  //     // dispatch(updateContexts({name: "openCanvasForPreview", key: containerId, value: "advanceListviewPopupInPreview"}));

  //     // dispatch(updateContexts({name: "openCanvasForPreviewAdvance", key: containerId, value: "advanceListviewPopupInPreview"}));

  //     // dispatch(setSubFormListviewJson(jsonForListview);

  //     //  advanceListviewStateJson(jsonForListview);
  //     if(loading) {
  //       loading(false);
  //     }
  //   } else {
  //     dispatch(updateContextsStates({
  //       key: containerId,
  //       data: { openCanvasForPreview: gridType, subFormListviewJson: jsonForListview }
  //     }));
  //     // dispatch(updateContexts({name: "openCanvasForPreview", key: containerId, value: gridType}));
  //     // dispatch(updateContexts({name: "subFormListviewJson", key: containerId, value: jsonForListview}));
  //   }
  // }

  function closeSubformOnPreview() {
    dispatch(updateGridContexts({name: "openCanvasForPreview", key: containerId, value: "",renderAdvListView: false, renderListView: true}));
  }

  function setOpenCanvasForSubformFn() {
    setOpenCanvasForSubform(
      subformStack[subformStack?.length ? subformStack.length - 2 : false]
    );

    setSubformStack((prev) => {
      const prevStack = [...prev];
      prevStack.pop();
      return prevStack;
    });
  }

  const redirectToStep = (subformJson = {}) => {
    if(subformJson.id) {
      setTimeout(() => {
        functions.setFocus(subformJson.id, undefined, true);
      }, 150);
    }
  }

  function handleSubForm(action) {
    let subformJson = {};
    if(openCanvasForSubform === "subform") {
      subformJson = subFormStateJson.current;
    } else if(openCanvasForSubform === "advanceListviewFromScratch") {
      subformJson = currentadvanceListview.current;
    } else if(openCanvasForSubform === "showDataAdditonSection") {
      subformJson = currentListviewForSubform;
    }
    subformJson = JSON.parse(JSON.stringify(subformJson));

    const previewMode = childComp !== "app" && childComp !== "reusableFunction" ? true : false;
    if(!previewMode) {
      dispatch(updateStateInRedux({name: "isButtonProperties", key: containerId, value: false}));
    }
    if (action === "Cancel") {
      var updatedParentFormState = recursiveJsonReaderForSubForm(
        formState2,
        selectedButtonEventId,
        spareSubForm,
        "subform"
      );
      populateFormStateFromJsonOnAction(JSON.stringify(getFormJsonFromStore()), "yes")
      //    setFormState2(subFormStateJson.current);
      // saveSubForm
      // setActiveSubForm(false);
      setOpenCanvasForSubformFn(false);
      setShowSubForm(false)
      setSubFormState({});
      setCurrentButtonForSubform(undefined);
      setSelectedControl({});
      window.selectedControlId_function({});

      redirectToStep(subformJson);
      // console.log('checking here 2582',selectedControl);
    } else if (action === "Save" || action === "Save & Close") {
      // setActiveSubForm(false);
      if(action === "Save"){
        setSpareSubForm(subFormStateJson.current)
      }
       // if(previewMode){
      //   var updatedParentFormState = recursiveJsonReaderForSubForm(
      //     formState2,
      //     selectedButtonEventId,
      //     subFormStateJson.current,
      //     "subform"
      //   );
      // }
      fetchAndUpdateJSON(formState2, selectedButtonEventId, subFormStateJson.current, "buttonsubform")

      // //console.log("Json after saving SubForm ::\n", subFormStateJson.current);
      var payload = {
        frameIndex: currentButtonForSubform.current?.frameIndex,
        elementIndex: currentButtonForSubform.current?.elementIndex,
        sheetElementIndex: currentButtonForSubform.current?.sheetElementIndex,
        sheetElementFrameIndex:
          currentButtonForSubform.current?.sheetElementFrameIndex,
        sheetFrameElementIndex:
          currentButtonForSubform.current?.sheetFrameElementIndex,
        sheetId: currentButtonForSubform.current?.sheetIndex,
        controlid: currentButtonForSubform.current?.id,
      };

      if (currentButtonForSubform.current?.containerControl === "Menu") {
        payload.stepIndex =
          currentButtonForSubform.current?.stepIndex ||
          currentButtonForSubform.current?.stepIndex === 0
            ? currentButtonForSubform.current?.stepIndex
            : "-1";
        payload.subStepIndex =
          currentButtonForSubform.current?.subStepIndex ||
          currentButtonForSubform.current?.subStepIndex === 0
            ? currentButtonForSubform.current?.subStepIndex
            : "-1";
        payload.subChildMenuIndex =
          currentButtonForSubform.current?.subChildMenuIndex ||
          currentButtonForSubform.current?.subChildMenuIndex === 0
            ? currentButtonForSubform.current?.subChildMenuIndex
            : "-1";
      }
      else if (
        currentButtonForSubform.current?.containerControl ===
          "wizard_h" ||
          currentButtonForSubform.current?.containerControl ===
          "wizard_v" ||
          currentButtonForSubform.current?.containerControl ===
          "sidenavigation"
      ) {
        payload.stepIndex = wizard_type_step || "-1";
        payload.subStepIndex = wizard_type_subStepIndex || "-1";
        payload.subChildMenuIndex =
          wizard_type_subChildMenuIndex.current || "-1";
      }
      saveSubForm(payload)
        .then((response) => {
          if(action !== "Save"){
            setCurrentButtonForSubform(undefined);
            setSubFormState(undefined);
            setCurrentadvanceListview(undefined);
            setShowSubForm(false)
          }
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "success",
            alertContentKey: "SaveSubFormSuccessMessage"
          });
          // setAdvListviewFromScratchJson(undefined);
          // console.log('Successfully saved subform');
          // setCurrentButtonForSubform(undefined);
        })
        .catch(function (error) {
          console.log("Error :: ", error);
        });
      
      if(action === "Save"){
        return
      }else{
        setCurrentButtonForSubform(undefined);
        setOpenCanvasForSubformFn(false);
        setSubFormState({});
        setSelectedControl({});
        window.selectedControlId_function({});
        redirectToStep(subformJson);
      }
      
      

      // console.log('checking here 2590',selectedControl);
    } else if (action === "Save listviewOverlay" || action === "Save & Close Advance") {
      //  var updatedParentFormState = recursiveJsonReaderForSubForm(subFormStateJson.current, subFormID, formState2, "listviewColumnList");
      if(action === "Save listviewOverlay"){
        dispatch(updateGridContexts({name: "spareAdvanceListviewStateJson", key: containerId, value: fetchGridStates().advanceListviewStateJson}));
        dispatch(updateGridContexts({name: "spareAdvListviewPopupStyle", key: containerId, value: currentadvanceListview?.current?.popupStyle}));
      } else if(action === "Save & Close Advance"){
        dispatch(updateGridContexts({name: "spareAdvanceListviewStateJson", key: containerId, value: undefined}));
        dispatch(updateGridContexts({name: "spareAdvListviewPopupStyle", key: containerId, value: undefined}));
        setDataClassAdvacnceListview(false);
      }
      dispatch(updateGridContexts({name: "showAdvListviewPopupProperties", key: containerId, value: false}));
      var updatedParentFormState = recursiveJsonReaderForSubForm(
        formState2,
        subAdvacnceListID,
        fetchGridStates().advanceListviewStateJson,
        "listviewFrameLayoutJson"
      );

      var payload = {
        frameIndex: currentadvanceListview.current?.frameIndex,
        elementIndex: currentadvanceListview.current?.elementIndex,
        sheetElementIndex: currentadvanceListview.current?.sheetElementIndex,
        sheetElementFrameIndex:
          currentadvanceListview.current?.sheetElementFrameIndex,
        sheetFrameElementIndex:
          currentadvanceListview.current?.sheetFrameElementIndex,
        sheetId: currentadvanceListview.current?.sheetIndex,
      };

      if (currentadvanceListview.current?.containerControl === "Menu") {
        payload.stepIndex =
          currentadvanceListview.current?.stepIndex ||
          currentadvanceListview.current?.stepIndex === 0
            ? currentadvanceListview.current?.stepIndex
            : "-1";
        payload.subStepIndex =
          currentadvanceListview.current?.subStepIndex ||
          currentadvanceListview.current?.subStepIndex === 0
            ? currentadvanceListview.current?.subStepIndex
            : "-1";
        payload.subChildMenuIndex =
          currentadvanceListview.current?.subChildMenuIndex ||
          currentadvanceListview.current?.subChildMenuIndex === 0
            ? currentadvanceListview.current?.subChildMenuIndex
            : "-1";
      } else if (
        currentadvanceListview.current?.containerControl ===
          "wizard_h" ||
        currentadvanceListview.current?.containerControl ===
          "wizard_v" ||
        currentadvanceListview.current?.containerControl ===
          "sidenavigation"
      ) {
        payload.stepIndex = wizard_type_step || "-1";
        payload.subStepIndex = wizard_type_subStepIndex || "-1";
        payload.subChildMenuIndex =
          wizard_type_subChildMenuIndex.current || "-1";
        }

      saveAdvanceListview(payload)
        .then((response) => {
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "success",
            alertContentKey: "SaveSubFormSuccessMessage"
          });
          // console.log('Successfully saved subform');
          // setCurrentadvanceListview(undefined);
        })
        .catch(function (error) {
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: "AdListview_Subfrom_Save_Failed",
          });
        });
      if(action === "Save listviewOverlay"){
      //   window.callSpecifiedFunctions(
      //     { },
      //     "",
      //     "",
      //     true  
      // );
        return 
      }
      else{
        setOpenCanvasForSubformFn(false);
        // dispatch(updateContexts({name: "advanceListviewStateJson", }));
        setSelectedControl({});
        window.selectedControlId_function({});
        redirectToStep(subformJson);
      }

      dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: undefined}));
      // // //console.log("listview overlay ::\n", formState2);
      // setFormState2(subFormStateJson.current);
      // setOpenCanvasForSubformFn(false);
      // setSelectedControl({});
      // console.log('checking here 2598',selectedControl);
    //   window.callSpecifiedFunctions(
    //     { },
    //     "",
    //     "",
    //     true  
    // );
    } else if (action === "Cancel Advance") {
      var updatedParentFormState = recursiveJsonReaderForSubForm(
        formState2,
        subAdvacnceListID,
        fetchGridStates().spareAdvanceListviewStateJson,
        "listviewFrameLayoutJson"
      );
      var updatedParentFormState1 = recursiveJsonReaderForSubForm(
        formState2,
        subAdvacnceListID,
        fetchGridStates().spareAdvListviewPopupStyle,
        "popupStyle"
      );
      populateFormStateFromJsonOnAction(JSON.stringify(formState2), "yes")
      setOpenCanvasForSubformFn(false);
      setCurrentadvanceListview(undefined)
      setSelectedControl({});
      window.selectedControlId_function({});
      dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: undefined}));
      dispatch(updateGridContexts({name: "showAdvListviewPopupProperties", key: containerId, value: false}));
      redirectToStep(subformJson);
      setDataClassAdvacnceListview(false);
    } else if (action === "Save Listview") {
      // if(Object.keys(advanceListviewStateJson).length === 0){
      //     console.log("advanceListviewStateJson12 yes", advanceListviewStateJson);
      // }else{
      //     console.log("advanceListviewStateJson12 no", advanceListviewStateJson);
      // }
      const currentListviewForSubformTemp = cloneDeep(
        currentListviewForSubform
      );

      updatedComponentInFormState(
        currentListviewForSubformTemp.id,
        currentListviewForSubformTemp
      );
      setCurrentListviewForSubform(undefined);
       showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "success",
            alertContentKey: "SaveSubFormSuccessMessage"
          });
 
      // if (fetchGridStates().advanceListviewStateJson === undefined) {
      setOpenCanvasForSubformFn(false);
      // } else if (
      //   fetchGridStates().advanceListviewStateJson !== undefined &&
      //   Object.keys(fetchGridStates().advanceListviewStateJson).length === 0
      // ) {
      //   setOpenCanvasForSubformFn(false);
      // } else {
      //   setOpenCanvasForSubform("advanceListviewFromScratch");
      // }
      redirectToStep(subformJson);

      // setDataClassAdvacnceListview();

      // setSelectedControl({});
    } else if (action === "Cancel Listview") {
      const fetchGridStatesObj = fetchGridStates();
      const listview_id = currentListviewForSubform.id;

      if (fetchGridStatesObj.advanceListviewStateJson === undefined || (
        fetchGridStatesObj.advanceListviewStateJson !== undefined &&
        Object.keys(fetchGridStatesObj.advanceListviewStateJson).length === 0
      )) {
        var updatedParentFormState1 = recursiveJsonReaderForSubForm(
          formState2,
          listview_id,
          fetchGridStatesObj.spareListviewPopupStyle,
          "popupStyle"
        );
      } else {
        var updatedParentFormState1 = recursiveJsonReaderForSubForm(
          fetchGridStatesObj.advanceListviewStateJson,
          listview_id,
          fetchGridStatesObj.spareListviewPopupStyle,
          "popupStyle"
        );
      }
      
      setOpenCanvasForSubformFn(false);
      setCurrentListviewForSubform(undefined);
      redirectToStep(subformJson);
    } else if (action === "Download") {
      downloadButtonJson(subFormStateJson.current, subFormStateJson.current?.pageStyle?.SubformTitle);
    }
    //  else if (action === "DownloadAdv" && currentadvanceListview?.current?.id) {
    //   const advListviewFrameLayoutJson = fetchGridStates().advanceListviewStateJson;
    //   downloadButtonJson(advListviewFrameLayoutJson, `${currentadvanceListview.current.id}_subform`);
    // }
    setIsButtonSubformOpen(false);
  }

  function changeUndoList() {
    // var temp_undolist.current = [];
    // temp_undolist.current = [...undoList.current];
    // temp_undolist.current.push(JSON.stringify(formState2));
    // setUndoList.current(temp_undolist.current);
    // setFormState2(formState2);
  }

  function unmapAllChildren(treeName){
    for(let item of treeName){
      item.isMapped = false
      if(item.children && item.children.length > 0){
        unmapAllChildren(item.children)
      }
    }

  }

  function searchItemAndUpdate(children, searchItem) {
    for (let item of children) {
      if (item.children) {
        searchItemAndUpdate(item.children, searchItem);
      }
      if (item.treeName === searchItem) {
        item.isMapped = false;
        if(item.children){
          unmapAllChildren(item.children)
        }
      }
    }
  }

  function deleteRow(rowJson){
    const isRowEmpty = findIfRowIsEmpty(rowJson);

    // if row is empty ie no controls are present
    if(isRowEmpty){
       if (
        (openCanvasForSubform === false || openCanvasForSubform === "advanceListviewFromScratch") &&
        fetchGridStates().advanceListviewStateJson
        ) 
        {
          var advFL;
          if (currentadvanceListview.current) {
            currentadvanceListview.current.listviewFrameLayoutJson = fetchGridStates().advanceListviewStateJson;
            advFL = currentadvanceListview.current?.listviewFrameLayoutJson;
          }
          else if (fetchGridStates().currentAdvanceListviewStateJson ) {
            advFL = fetchGridStates().currentAdvanceListviewStateJson?.listviewFrameLayoutJson;
          } 
          else {
            advFL = fetchGridStates().advanceListviewStateJson?.listviewFrameLayoutJson;
          }
        
          var latestJson2 = updateComponentInJson(advFL, rowJson.id , {});
          // console.log(subFormStateJson.current,'latessssssJson2',latestJson2,'controlData',controlData)

          dispatch(updateGridContexts({ name: "advanceListviewStateJson", key: containerId, value: { ...latestJson2 },renderCanvas:true}));
          dispatch(updateGridContexts({name: "currentAdvanceListviewStateJson", key: containerId, value:  {...fetchGridStates().currentAdvanceListviewStateJson, listviewFrameLayoutJson: { ...latestJson2 },renderCanvas:true}}));          

      }
      else{
        removeAndUpdateComponentInFormState( rowJson.id , rowJson.elem_type );
      }
    } 

    // if columns in the row have controls
    else{
      var newformBufferJson=removeAndUpdateComponentInJson(
        formState2,
        rowJson.id,
        rowJson.elem_type
      );
      newformBufferJson = JSON.stringify(newformBufferJson);
      populateFormStateFromJsonOnAction(newformBufferJson);

    }

  }

  async function deleteControl(ev, elemId, extraDetails, index, formstateCtrlX = "") {
    var elemType;
    if (extraDetails) elemType = extraDetails.elem_type;
    if((elemType === "Menu" || elemType === "tab") && extraDetails?.style?.["MobileNavStyle"] === "Bottom Navigation") {
      formState2.isBottomNavPresent = false;
    }
    let wizardStepIndex33, wizardSubStepIndex33, menuStepIndex33, menuSubStepIndex33, menuSubChildMenuIndex33, menuSubChildMenuSubStepIndex33;
    let sheetIndex33 = document?.getElementById(extraDetails?.id)?.closest(`[elem_type=tabChild]`)?.getAttribute("sheetIndex");
    // if(formState2.containerControl === "Menu" && (showFooterIcon || showIconState)){
    //   if(extraDetails?.stepIndex)
    //   delete extraDetails?.stepIndex
    // }
    // if(!showFooterIcon && !showIconState){
      if(formState2.containerControl === "wizard_h" || formState2.containerControl === "wizard_v" || formState2.containerControl === "sidenavigaation"){
        wizardStepIndex33 = document?.getElementById(extraDetails?.id)?.closest(`[elem_type=Step]`)?.getAttribute("stepindex");
        wizardSubStepIndex33 = document?.getElementById(extraDetails?.id)?.closest(`[elem_type=SubStep]`)?.getAttribute("substepindex");
      }
      if(formState2.containerControl === "Menu"){
        menuStepIndex33 = document?.getElementById(extraDetails?.id)?.closest(`[elem_type=MainMenu]`)?.getAttribute("stepindex");
        menuSubStepIndex33 = document?.getElementById(extraDetails?.id)?.closest(`[elem_type=SubMenu]`)?.getAttribute("substepindex");
        menuSubChildMenuIndex33 = document?.getElementById(extraDetails?.id)?.closest(`[elem_type=SubChildMenu]`)?.getAttribute("subchildmenuindex");
        menuSubChildMenuSubStepIndex33 = document?.getElementById(extraDetails?.id)?.closest(`[elem_type=SubChildMenu]`)?.getAttribute("substepindex");
      }
    // }    
    
    if(sheetIndex33 || sheetIndex33 === 0){
      if(extraDetails?.sheetIndex === undefined){
        extraDetails["sheetIndex"] = sheetIndex33;
      }
    }
    if(wizardStepIndex33 || wizardStepIndex33 === 0){
      if(extraDetails?.stepIndex === undefined){
        extraDetails["stepIndex"] = wizardStepIndex33;
      }
    }
    if(wizardSubStepIndex33 || wizardSubStepIndex33 === 0){
      if(extraDetails?.subStepIndex === undefined){
        extraDetails["subStepIndex"] = wizardSubStepIndex33;
      }
    }
    if(menuStepIndex33 || menuStepIndex33 === 0){
      if(extraDetails?.stepIndex === undefined){
        extraDetails["stepIndex"] = menuStepIndex33;
      }
    }
    if(menuSubStepIndex33 || menuSubStepIndex33 === 0){
      if(extraDetails?.subStepIndex === undefined){
        extraDetails["subStepIndex"] = menuSubStepIndex33;
      }
    }
    if(menuSubChildMenuIndex33 || menuSubChildMenuIndex33 === 0){
      if(extraDetails?.subChildMenuIndex === undefined){
        extraDetails["subChildMenuIndex"] = menuSubChildMenuIndex33;
      }
    }
    if(menuSubChildMenuSubStepIndex33 || menuSubChildMenuSubStepIndex33 === 0){
      if(extraDetails?.subStepIndex === undefined){
        extraDetails["subStepIndex"] = menuSubChildMenuSubStepIndex33;
      }
    }

    if(elemType==="row"){
      deleteRow(extraDetails);
      return ;
    }

    if (elemType?.["treeName"] && elemType?.["treeName"] !== undefined) {
      //    console.log("yes it is present");
      mappingDataObjectsMap.delete(elemType?.["treeName"]);
    }

    var hasChild;
    if (extraDetails.unBounded === "Y") {
      if (
        extraDetails.elem_type === "table" ||
        extraDetails.elem_type === "listview" ||
        extraDetails.elem_type === "advancelistView"
      ) {
        hasChild = true;
      } else {
        hasChild = false;
      }
    } else if (extraDetails.unBounded === "N") {
      hasChild = false;
    }
    // if(extraDetails?.children){
    //   if(extraDetails.children.length > 0 ){
    //     hasChild = true;
    //   }else{
    //     hasChild = false;
    //   }
    // }else{
    //   hasChild = false;
    // }

    if (extraDetails?.dataclass) {
      // extraDetails?.dataclass


      var jsonToSend = {
        mappedField: extraDetails?.dataclass,
        unbounded: extraDetails?.unBounded,
        // "isProcessVar":true
        isProcessVar:
          extraDetails.dataObjectType === "M"
            ? false
            : extraDetails.dataObjectType === "P"
            ? true
            : "",
        formId:
          microFrontendData?.formDefId ||
          microFrontendData?.defaultFormId ||
          activePage?.formId,
        hasChild: hasChild,
      };

      removeMapping(jsonToSend).then((response) => {
        mappingControlsIdMap.delete(extraDetails?.style?.MappingId);

      }).catch((err) => {
        console.log("Failed removeMapping", err)
      });
      searchItemAndUpdate(filteredDataObjectCopy, extraDetails?.dataclass);
      setMapValue("");
      setMapId("");
      // setShowMapButton(false);
      // setShowMapButton("");

      // setProcessVal("");
      // setMapBoundValue("");
      data["isMapped"] = false;
      setCurrentMappedDO((prev) => {
        const result = prev.filter((item) => item != extraDetails?.dataclass);
        return [...result];
      });
    }

    const Id = elemId;

    const parentMenu = () => {
      if (
        ev.currentTarget.closest(`[elem_type=Menu]`) ||
        (openCanvasForSubform === "subform" &&
          currentButtonForSubform.current?.containerControl === "Menu")
      ) {
        return true;
      } else {
        return false;
      }
    };

    const parentWizard = (eve) => {
      if (
        eve.currentTarget.closest(`[elem_type=wizard_v]`) ||
        eve.currentTarget.closest(`[elem_type=wizard_h]`) ||
        eve.currentTarget.closest(`[elem_type=subwizard_v]`) ||
        eve.currentTarget.closest(`[elem_type=subwizard_h]`) ||
        eve.currentTarget.closest(`[elem_type=subsidenavigation]`) ||
        (eve.currentTarget.closest(`[elem_type=sidenavigation]`) &&
          !eve.currentTarget.closest(`[elem_type=tab]`)) ||
        (openCanvasForSubform === "subform" &&
          currentButtonForSubform.current?.containerControl === "wizard_h") ||
        (openCanvasForSubform === "subform" &&
          currentButtonForSubform.current?.containerControl === "wizard_v") ||
        (openCanvasForSubform === "subform" &&
          currentButtonForSubform.current?.containerControl ===
            "sidenavigation")
      ) {
        return true;
      } else {
        return false;
      }
    };

    // console.log("Element ID Element ID Element ID Element ID  ", elemId);
    // console.log("Element ID Element ID Element ID Element IDpl ", extraDetails);

    //    console.log("wizardWizardtileControlTileControl ", parentWizard());
    //    extraDetails.insideWizard=parentWizard();

    if (
      ev.currentTarget.closest(`[elem_type=Menu]`) ||
      (openCanvasForSubform === "subform" &&
        currentButtonForSubform.current?.containerControl === "Menu")
    ) {
      if (
        extraDetails &&
        extraDetails.elem_type === "frame" &&
        extraDetails.insideMenu === undefined
      )
        extraDetails.insideMenu = parentMenu();

      if (
        extraDetails &&
        extraDetails.elem_type === "frame" &&
        extraDetails.stepIndex === undefined
      ) {
        if (
          openCanvasForSubform === "subform" &&
          currentButtonForSubform.current?.containerControl === "Menu"
        ) {
          extraDetails.stepIndex =
            currentButtonForSubform.current?.stepIndex ||
            currentButtonForSubform.current?.stepIndex === 0
              ? currentButtonForSubform.current?.stepIndex
              : "-1";
          extraDetails.substepIndex =
            currentButtonForSubform.current?.subStepIndex ||
            currentButtonForSubform.current?.subStepIndex === 0
              ? currentButtonForSubform.current?.subStepIndex
              : "-1";
          extraDetails.subChildMenuIndex =
            currentButtonForSubform.current?.subChildMenuIndex ||
            currentButtonForSubform.current?.subChildMenuIndex === 0
              ? currentButtonForSubform.current?.subChildMenuIndex
              : "-1";
        } else {
          extraDetails.stepIndex = document
            .querySelector(".menuMain_Id")
            .getAttribute("stepIndex");
          extraDetails.substepIndex = document
            .querySelector(".menuMain_Id")
            .getAttribute("substepIndex");
          extraDetails.subChildMenuIndex = document
            .querySelector(".menuMain_Id")
            .getAttribute("subChildMenuIndex");
        }
      }
      if (extraDetails.frameIndex === null) {
        extraDetails["frameIndex"] =
          ev.currentTarget
            ?.closest(`[elem_type=frame]`)
            ?.getAttribute("frameindex") ||
          ev.currentTarget
            ?.closest(`[elem_type=section]`)
            ?.getAttribute("frameindex");
      }
      extraDetails.extraDetails =
        ev.currentTarget.closest(`[id=menuMain_Id]`) &&
        ev.currentTarget
          .closest(`[id=menuMain_Id]`)
          .getAttribute("extraDetails");

      // targetElemState.insideMenu=parentMenu();
      // targetElemState.stepIndex=document.querySelector(".menuMain_Id").getAttribute("stepIndex");
      // targetElemState.substepIndex=document.querySelector(".menuMain_Id").getAttribute("substepIndex");
      // targetElemState.subChildMenuIndex=document.querySelector(".menuMain_Id").getAttribute("subChildMenuIndex");
      // if(targetElemState.frameIndex===null){
      //     targetElemState["frameIndex"]=ev.currentTarget?.closest(`[elem_type=frame]`)?.getAttribute("frameindex") || ev.currentTarget?.closest(`[elem_type=section]`)?.getAttribute("frameindex");
      // }
      // targetElemState.extraDetails=ev.currentTarget.closest(`[id=menuMain_Id]`) && ev.currentTarget.closest(`[id=menuMain_Id]`).getAttribute("extraDetails")
    } else {
      if (
        extraDetails &&
        extraDetails.elem_type === "frame" &&
        extraDetails.insideWizard === undefined
      )
        extraDetails.insideWizard = getStepIndex() && getStepIndex() !== "-1" && (formState2.containerControl === "wizard_h" || formState2.containerControl === "wizard_v" || formState2.containerControl === "sidenavigation");

      if (
        extraDetails &&
        extraDetails.elem_type === "frame" &&
        extraDetails.parentStep === undefined
      )
        extraDetails.parentStep =
          (ev.currentTarget.closest(`[elem_type=Step]`) &&
            ev.currentTarget
              .closest(`[elem_type=Step]`)
              .getAttribute("frameindex")) ||
          (ev.currentTarget.closest(`[elem_type=SubStep]`) &&
            ev.currentTarget
              .closest(`[elem_type=SubStep]`)
              .getAttribute("frameindex")) ||
          "";

      if (
        extraDetails &&
        extraDetails.elem_type === "frame" &&
        extraDetails.parentSubStep === undefined
      )
        extraDetails.parentSubStep =
          (ev.currentTarget.closest(`[elem_type=SubStep]`) &&
            ev.currentTarget
              .closest(`[elem_type=SubStep]`)
              .getAttribute("elementindex")) ||
          "-1";

      extraDetails.subChildMenuIndex = "-1";
      // targetElemState.insideWizard=parentWizard();
      // targetElemState.parentStep= (ev.currentTarget.closest(`[elem_type=Step]`) && ev.currentTarget.closest(`[elem_type=Step]`).getAttribute("frameindex")) ||
      //     (ev.currentTarget.closest(`[elem_type=SubStep]`) && ev.currentTarget.closest(`[elem_type=SubStep]`).getAttribute("frameindex")) || "" ;

      // targetElemState.parentSubStep=(ev.currentTarget.closest(`[elem_type=SubStep]`) && ev.currentTarget.closest(`[elem_type=SubStep]`).getAttribute("elementindex")) ||"";
    }

    /****************code start:- old code, deleting without deleting from backend ************************/
    // if(openCanvasForSubform === 'subform'){
    //     setSelectedControl({});
    //     console.log('checking here 2624',selectedControl);
    //     const Id= elemId;
    //     var finalrepopulated;

    //     const updatedJson = updateSheetElementIndex(formState2,Id,elemType);
    //     if(elemType!=='column' && elemType!=='row'){
    //         finalrepopulated = repopulateFrameIndex(subFormStateJson.current , Id, elemType);
    //         resetRepopulateFrameIndexVars();
    //     }
    //     const json = removeAndUpdateComponentInJson(subFormStateJson.current , Id, elemType);
    // }
    var finalrepopulated;
    if (elemType !== "column" && elemType !== "row") {
      // console.log('formState2 being passed :: ',formState2);
      // finalrepopulated = repopulateFrameIndex(formState2 , Id, elemType);
      // resetRepopulateFrameIndexVars();
    }
    // console.log('finalrepopulated :: ',finalrepopulated);
    // const json = removeAndUpdateComponentInJson(formState2 , Id, elemType);
    /****************code end:- old code ************************/

    /****************code start:- new code, deleting from backend 1st  ************************/
    if (elemType === "column" || elemType === "row") {
      var indexToBeDecreasedBy = 0;
      let isSubForm = false;
      if (openCanvasForSubform === "subform") {
        isSubForm = true;
      }
      let isAdvanceListview = false;
      if (openCanvasForSubform === "advanceListviewFromScratch") {
        isAdvanceListview = true;
      }

      let deleteDetails = {
        isSubForm: isSubForm,
        isAdvanceListview: isAdvanceListview,
        elemIndexSub: subformElementIndex,
      };
      if (extraDetails.children !== undefined) {
        if (extraDetails.children[0])
          if (extraDetails.children[0].tileContents)
            if (extraDetails.children[0].tileContents !== undefined) {
              if (extraDetails.children[0].tileContents.length !== 0) {
                // alert("you can't delete column with tiles first you have to delete all three tiles")
                setAlert({
                  open: true,
                  severity: "error",
                  severityMessage:
                    "you can't delete column with tiles first you have to delete all three tiles",
                });
                return;
              } else {
                if (
                  extraDetails.children.length === 1 &&
                  extraDetails.children[0].elem_type === "tile"
                ) {
                  extraDetails.children.splice(0, 1);
                }
              }
            }
      }
      // extraDetails.children.map((childControl, index) => {
      let count = 0;
      if(!extraDetails?.isAdvanceListview){
        extraDetails.isAdvanceListview = isAdvanceListview
      }
      let extraDetails1 = JSON.parse(JSON.stringify(extraDetails))
      if(extraDetails1.children[0]?.elem_type !== "column" && extraDetails1.children[0]?.elem_type !== "row"){
        for (let childControl of extraDetails1.children) {
          let response = await deleteColumn(childControl, count);
        }
      }else if(extraDetails1.children[0]?.elem_type === "column" || extraDetails1.children[0]?.elem_type === "row"){
        let response = {
          data: {
            status: 0
          }
        }
        // removeAndUpdateIndex(
        //   formState2,
        //   extraDetails1
        // );
        xyz(response, extraDetails1);
      }
      // });

      async function deleteColumn(childControl, index) {
        if (childControl) {
          if (
            extraDetails.parentStep &&
            // extraDetails.parentSubStep &&
            extraDetails.insideWizard
          ) {
            childControl["parentStep"] = extraDetails.parentStep;
            childControl["stepIndex"] = extraDetails.parentStep;
            if (extraDetails?.parentSubStep){
              childControl["parentSubStep"] = extraDetails.parentSubStep;
              childControl["subStepIndex"] = extraDetails.parentSubStep;
            }
            childControl["insideWizard"] = extraDetails.insideWizard;
            childControl["subStepIndex"] = extraDetails.parentSubStep;
          }
          if (extraDetails.insideMenu && extraDetails.stepIndex) {
            childControl["insideMenu"] = extraDetails.insideMenu;
            childControl["stepIndex"] = extraDetails.stepIndex;
            childControl["subStepIndex"] = extraDetails.substepIndex || extraDetails.subStepIndex;
            childControl["subChildMenuIndex"] = extraDetails.subChildMenuIndex;
          }
          if (index >= 1) {
            if (childControl?.sheetFrameElementIndex)
              childControl.sheetFrameElementIndex =
                parseInt(childControl?.sheetFrameElementIndex) - index;
            else if (childControl?.sheetElementIndex)
              childControl.sheetElementIndex =
                parseInt(childControl?.sheetElementIndex) - index;
            else if (childControl?.elementIndex)
              childControl.elementIndex =
                parseInt(childControl?.elementIndex) - index;
          }
          return sendRequestForControl(
            childControl.frameIndex,
            "delete",
            childControl.elem_type,
            childControl,
            deleteDetails
          ).then((response) => {
            xyz(response, childControl);
          }).catch((err) => {console.log(err);})
        }
      }

      async function xyz(response, childControl) {
        // .then((response) => {
        /*console.log('first-> response: ', response);*/
        if (response.data.status === 0) {
          // setDrawerPinned(false);
          // setOpenDrawer(false);
          setOpenProperties(false);
          setPropertyPinned(false);
          ++indexToBeDecreasedBy;
          // if (indexToBeDecreasedBy === extraDetails.children.length) {
            // console.log('second-> indexToBeDecreasedBy : ', indexToBeDecreasedBy);
            if (openCanvasForSubform === "subform") {
              updatedJson = removeAndUpdateIndex(
                subFormStateJson.current,
                childControl
              );
              setSubFormState(subFormStateJson.current)
            } else if (openCanvasForSubform === "advanceListviewFromScratch") {
              updatedJson = removeAndUpdateIndex(
                fetchGridStates().advanceListviewStateJson,
                childControl
              );
            } else if (openCanvasForSubform === "showDataAdditonSection") {
              updatedJson = removeAndUpdateIndex(
                currentListviewForSubform.listviewFrameLayoutJson,
                childControl
              );
            } else {
              var updatedJson = removeAndUpdateIndex(
                formstateCtrlX ? formstateCtrlX : formState2,
                childControl
              );
            }
          // }
          // if(formstateCtrlX)
          //   setFormState2({...formstateCtrlX})
          // else{
          //   updatedComponentInFormState();
          // }
          count++;
          if (extraDetails1.children.length === count) {
            if (openCanvasForSubform === "subform") {
              updatedJson = removeAndUpdateIndex(
                subFormStateJson.current,
                extraDetails
                // response.data
              );
              setSubFormState(subFormStateJson.current)

            } else if (openCanvasForSubform === "advanceListviewFromScratch") {
              updatedJson = removeAndUpdateIndex(
                fetchGridStates().advanceListviewStateJson,
                extraDetails
                // response.data
              );
            } else {
              var updatedJson = removeAndUpdateIndex(
                formstateCtrlX ? formstateCtrlX : formState2,
                extraDetails
                // response.data
              );
            }

          if(openCanvasForSubform !== "subform"){

            if(formstateCtrlX)
              setFormState2({...formstateCtrlX})
            else{
              updatedComponentInFormState();
            }
          }
          }
          console.log("theek hai", count, formState2, extraDetails1, extraDetails)
          // return true;
        } else if (response.data.status === 1) {
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: "Reopen_Form",
          });
        } else {
          setAlertData({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentMsg: "Failed to delete control. Please try again.",
            autoHideDuration: 6000,
          });
        }
        // });
      }

      if (extraDetails.children.length === 0) {
        if (openCanvasForSubform === "subform") {
          updatedJson = removeAndUpdateIndex(
            subFormStateJson.current,
            extraDetails
            // response.data
          );
          setSubFormState(subFormStateJson.current);
        } else if (openCanvasForSubform === "advanceListviewFromScratch") {
          updatedJson = removeAndUpdateIndex(
            fetchGridStates().advanceListviewStateJson,
            extraDetails
            // response.data
          );
        } else {
          var updatedJson = removeAndUpdateIndex(
            formstateCtrlX ? formstateCtrlX : formState2,
            extraDetails
            // response.data
          );
        }
        if(openCanvasForSubform !== "subform"){
          if(formstateCtrlX)
            setFormState2({...formstateCtrlX})
          else{
            updatedComponentInFormState();
          }
        }
      }
    } else if (elemType === "tile") {
      var indexToBeDecreasedBy = 0;
      // console.log("wizardWizardtileControlTileControl ", extraDetails);
      let isSubForm = false;
      if (openCanvasForSubform === "subform") {
        isSubForm = true;
      }
      let isAdvanceListview = false;
      if (openCanvasForSubform === "advanceListviewFromScratch") {
        isAdvanceListview = true;
      }

      let deleteDetails = {
        isSubForm: isSubForm,
        isAdvanceListview: isAdvanceListview,
        elemIndexSub: subformElementIndex,
      };
      // Object.values(extraDetails.tileContents).slice(0).reverse().map((tileContent, index)=>{
      // if(extraDetails.tileContents && index !== undefined){
      // if(extraDetails.tileContents.length === 3){
      //     extraDetails.tileContents[index].elementIndex = extraDetails.tileContents[index].elementIndex - extraDetails.tileContents[index].elementIndex + 1
      // }

      let tileContent = {};

      if (extraDetails?.tileContents?.[index])
        tileContent = { ...extraDetails, ...extraDetails.tileContents[index] };
      else tileContent = extraDetails;

      const tileGroupId = extraDetails.id;

      // const frameIndex = extraDetails.tileContents[index].frameIndex
      // sendRequestForControl(extraDetails.frameIndex, 'delete', elemType, extraDetails)
      sendRequestForControl(
        extraDetails.frameIndex,
        "delete",
        elemType,
        tileContent,
        deleteDetails
      )
        .then((response) => {
          if (response.data.status === 0) {
            // setDrawerPinned(false);
            // setOpenDrawer(false);
            setOpenProperties(false);
            setPropertyPinned(false);
            mappingControlsIdMap.delete(extraDetails?.style?.MappingId);
            indexToBeDecreasedBy++;
            if(extraDetails?.insideWizard){
              extraDetails.tileContents[index]["insideWizard"] = extraDetails?.insideWizard
            }
            if(extraDetails?.insideMenu){
              extraDetails.tileContents[index]["insideMenu"] = extraDetails?.insideMenu
            }
            // indexToBeDecreasedBy += extraDetails.tileContents.length;
            // if(indexToBeDecreasedBy === extraDetails.tileContents.length){
            if (openCanvasForSubform === "subform") {
              //updatedJson = removeAndUpdateIndex(subFormStateJson.current,elemId,elemType);
              if (extraDetails?.tileContents?.length === 1) {
                var updatedformState = removeAndUpdateIndex(
                  subFormStateJson.current,
                  extraDetails?.tileContents?.[index]
                );
                setSubFormState(subFormStateJson.current)
              } else {
                var updatedformState = removeAndUpdateIndex(
                  subFormStateJson.current,
                  extraDetails?.tileContents?.[index]
                );
                setSubFormState(subFormStateJson.current)
              }
              // updatedComponentInFormState();
            } else if (openCanvasForSubform === "advanceListviewFromScratch") {
              if (extraDetails?.tileContents?.length === 1) {
                var updatedformState = removeAndUpdateIndex(
                  fetchGridStates().advanceListviewStateJson,
                  extraDetails?.tileContents?.[index]
                );
              } else {
                var updatedformState = removeAndUpdateIndex(
                  fetchGridStates().advanceListviewStateJson,
                  extraDetails?.tileContents?.[index]
                );
              }
              updatedComponentInFormState();
            } else {
              // console.log("updatedformState updatedformState ");
              if (extraDetails?.tileContents?.length === 1) {
                var updatedformState = removeAndUpdateIndex(
                  formState2,
                  extraDetails?.tileContents?.[index]
                );
              } else {
                var updatedformState = removeAndUpdateIndex(
                  formstateCtrlX ? formstateCtrlX : formState2,
                  extraDetails?.tileContents?.[index]
                );
              }
              if(formstateCtrlX)
                setFormState2({...formstateCtrlX})
              else{
                updatedComponentInFormState();
              }
              //setFormState2(updatedformState);
            }
          } else if (response.data.status === 1) {
            showAlertConfirmNotifications({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: "Reopen_Form",
            });
          }
          // }
          else {
            setAlertData({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentMsg: "Failed to delete control. Please try again.",
              autoHideDuration: 6000,
            });
          }
          setCurrentDataObjectJson(cloneDeep({}));
        })
        .catch((err) => {
          setAlertData({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentMsg: "Failed to delete control. Please try again.",
            autoHideDuration: 6000,
          });
            loading(false)
        });
    } else if (extraDetails) {
      const menuElem = document.querySelector(".menuMain_Id");
      const isInsideMenu =
        openCanvasForSubform === "subform" &&
        currentButtonForSubform.current?.containerControl === "Menu";

      if (
        ev.currentTarget.closest(`[elem_type=Menu]`) ||
        menuElem ||
        isInsideMenu
      ) {
        if (isInsideMenu) {
          extraDetails.stepIndex =
            currentButtonForSubform.current?.stepIndex ||
            currentButtonForSubform.current?.stepIndex === 0
              ? currentButtonForSubform.current?.stepIndex
              : "-1";
          extraDetails.substepIndex =
            currentButtonForSubform.current?.subStepIndex ||
            currentButtonForSubform.current?.subStepIndex === 0
              ? currentButtonForSubform.current?.subStepIndex
              : "-1";
          extraDetails.subChildMenuIndex =
            currentButtonForSubform.current?.subChildMenuIndex ||
            currentButtonForSubform.current?.subChildMenuIndex === 0
              ? currentButtonForSubform.current?.subChildMenuIndex
              : "-1";
        } else {
          const activeJsonString = document
            .querySelector(".menuMain_Id")
            .getAttribute("activeJson");
          const activeJson = activeJsonString
            ? JSON.parse(activeJsonString || null)
            : {};

          extraDetails.stepIndex =
            activeJson.MainMenuIndex || activeJson.MainMenuIndex === 0
              ? activeJson.MainMenuIndex
              : "-1";
          extraDetails.substepIndex =
            activeJson.SubMenuIndex || activeJson.SubMenuIndex === 0
              ? activeJson.SubMenuIndex
              : "-1";
          extraDetails.subChildMenuIndex =
            activeJson.subChildMenuIndex || activeJson.subChildMenuIndex === 0
              ? activeJson.subChildMenuIndex
              : "-1";
        }
      }
      let isSubForm = false;
      if (openCanvasForSubform === "subform") {
        isSubForm = true;
      }
      let isAdvanceListview = false;
      if (openCanvasForSubform === "advanceListviewFromScratch") {
        isAdvanceListview = true;
      }
      let deleteDetails = {
        isSubForm: isSubForm,
        isAdvanceListview: isAdvanceListview,
        elemIndexSub: subformElementIndex,
      };
      if (extraDetails.elem_type) {
        if (
          extraDetails.elem_type === "wizard_h" ||
          extraDetails.elem_type === "wizard_v" ||
          extraDetails.elem_type === "sidenavigation" ||
          extraDetails.elem_type === "subwizard_h" ||
          extraDetails.elem_type === "subwizard_v" ||
          extraDetails.elem_type === "subsidenavigation"
        ) {
          extraDetails.insideWizard = true;
        }
        if (extraDetails.elem_type === "Menu" || isInsideMenu) {
          extraDetails.insideMenu = true;
        }
      }
      if (elemId.toLowerCase().includes("step") && extraDetails.insideWizard) {
        if (extraDetails.children.length > 1) {
          const controltype_pl = "step";
          const stepIndex_pl = extraDetails.children.findIndex(
            (step) => step.id === elemId
          );
          const extradetails_pl = { id: elemId, stepIndex: stepIndex_pl };

          sendRequestForControl(
            extraDetails.frameIndex,
            "delete",
            controltype_pl,
            extradetails_pl,
            undefined
          )
            .then((response) => {
              if (response.data.status === 0) {
                // setDrawerPinned(false);
                // setOpenDrawer(false);
                setOpenProperties(false);
                delete formState2.containerControl;
                setPropertyPinned(false);
                mappingControlsIdMap.delete(extradetails_pl?.style?.MappingId);
                if (openCanvasForSubform === "subform") {
                  var updatedformState = removeAndUpdateIndex(
                    subFormStateJson.current,
                    extraDetails
                  );
                  // updatedComponentInFormState();
                  setSubFormState(subFormStateJson.current)
                } else if (
                  openCanvasForSubform === "advanceListviewFromScratch"
                ) {
                  var updatedformState = removeAndUpdateIndex(
                    fetchGridStates().advanceListviewStateJson,
                    extraDetails
                  );
                  updatedComponentInFormState();
                } else {
                  // console.log("updatedformState updatedformState ");
                  if (
                    elemType === "tab" &&
                    !document
                      .getElementById(extraDetails.id)
                      ?.closest(`[elem_type=section]`)
                  ) {
                    const parentFrameId =
                      document
                        .querySelector(`#${elemId}`)
                        ?.parentElement?.getAttribute("parentframeid") ||
                      document
                        .querySelector(`#${elemId}`)
                        ?.parentElement?.getAttribute("parentFrameId") ||            document.querySelector(`#${elemId}`)?.getAttribute("parentFrameId");

                    extraDetails["id"] = parentFrameId;
                    sendRequestForControl(
                      response.data.frameIndex,
                      "delete",
                      "frame",
                      extraDetails
                    )
                      .then((res) => {
                        var updatedformState = removeAndUpdateIndex(
                          formState2,
                          res.data
                        );
                        updatedComponentInFormState();
                      })
                      .catch((err) => {
                        console.log(err);
                        loading(false)
                      });
                  } else {
                    var updatedformState = removeAndUpdateIndex(
                      formState2,
                      extraDetails
                    );
                    updatedComponentInFormState();
                  }

                  //setFormState2(updatedformState);
                }
              } else if (response.data.status === 1) {
                showAlertConfirmNotifications({
                  open: true,
                  showConfirm: "showNotification",
                  alertType: "error",
                  alertContentKey: "Reopen_Form",
                });
              } else {
                setAlertData({
                  open: true,
                  showConfirm: "showNotification",
                  alertType: "error",
                  alertContentMsg: "Failed to delete control. Please try again.",
                  autoHideDuration: 6000,
                });
              }
              setCurrentDataObjectJson(cloneDeep({}));
            })
            .catch((err) => {
              setAlertData({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentMsg: "Failed to delete control. Please try again.",
                autoHideDuration: 6000,
              });
              loading(false)
            });
        } else if (extraDetails.children.length === 1) {
          setAlertData({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentMsg: `${t("translation:Last_step_cannot_be_deleted")}`,
            autoHideDuration: 6000,
          });
        }
      } else {
        if(extraDetails?.isAboveWizard){
          formState2.isAboveWizard = false
          formState2.sectionAboveWizard = '';
        }
        if(!extraDetails?.isSubForm){
          extraDetails.isSubForm = openCanvasForSubform === "subform"
        }
        if(!extraDetails?.isAdvanceListview){
          extraDetails.isAdvanceListview = openCanvasForSubform === "advanceListviewFromScratch"
        }
        sendRequestForControl(
          extraDetails.frameIndex,
          "delete",
          elemType,
          extraDetails,
          deleteDetails
        )
          .then((response) => {
            if (response.data.status === 0) {
              // setDrawerPinned(false);
              // setOpenDrawer(false);
              if(extraDetails?.isfooter){
                formState2.isfooter=false;
                if(formState2.FixedPageBottomFooter){
                  delete formState2.FixedPageBottomFooter
                  delete formState2.HideScrollingFooter
                }
                // dispatch(updateStateInRedux({ name: "showFooterIcon", value: false }));
              }
              if(extraDetails?.isheader){
                formState2.isheader=false;
                // dispatch(updateStateInRedux({ name: "showIconState", value: false }));

              }
              setOpenProperties(false);
              setPropertyPinned(false);
              mappingControlsIdMap.delete(extraDetails?.style?.MappingId);
              if (openCanvasForSubform === "subform") {
                var updatedformState = removeAndUpdateIndex(
                  subFormStateJson.current,
                  extraDetails
                );
                // updatedComponentInFormState();
                setSubFormState(subFormStateJson.current)
              } else if (
                openCanvasForSubform === "advanceListviewFromScratch"
              ) {
                var updatedformState = removeAndUpdateIndex(
                  fetchGridStates().advanceListviewStateJson,
                  extraDetails
                );
                updatedComponentInFormState();
              } else {
                // console.log("updatedformState updatedformState ");
                if (
                  elemType === "tab" &&
                  !document
                    .getElementById(extraDetails.id)
                    ?.closest(`[elem_type=section]`)
                ) {
                  const parentFrameId =
                    document
                      .querySelector(`#${elemId}`)
                      ?.parentElement?.getAttribute("parentframeid") ||
                    document
                      .querySelector(`#${elemId}`)
                      ?.parentElement?.getAttribute("parentFrameId") ||
                      document.querySelector(`#${elemId}`)?.getAttribute("parentFrameId");

                  extraDetails["id"] = parentFrameId;
                  sendRequestForControl(
                    response.data.frameIndex,
                    "delete",
                    "frame",
                    extraDetails
                  )
                    .then((res) => {
                      var updatedformState = removeAndUpdateIndex(
                        formState2,
                        {...res.data,...extraDetails, isParentTab: true}
                      );
                      updatedComponentInFormState();
                    })
                    .catch((err) => {
                      console.log(err);
                      loading(false)
                    });
                } else {
                  if(elemType === "quickAction") {
                    if(formState2?.quickAction) {
                      delete formState2.quickAction;
                    }
                  } else {
                    var updatedformState = removeAndUpdateIndex(
                      formState2,
                      extraDetails,
                      // (showFooterIcon || showIconState)
                    );
                  }
                  updatedComponentInFormState();
                }

                //setFormState2(updatedformState);
              }
            } else if (response.data.status === 1) {
              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: "Reopen_Form",
              });
            } else {
              setAlertData({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentMsg: "Failed to delete control. Please try again.",
                autoHideDuration: 6000,
              });
            }
            setCurrentDataObjectJson(cloneDeep({}));

            function findNodeToDelete(childName, objects) {
              return objects?.map(obj => {
                if (obj.treeName === childName) {
                   return {...obj, isMapped : false};
                }

                if (obj.children) {
                  return { ...obj, children: findNodeToDelete(childName, obj.children) };
                }

                return obj;
              })
            }

            const newCurrentMappedDO = currentMappedDO.filter((data) => data !== extraDetails?.style?.MappingId)
            const deletedFilteredData = findNodeToDelete(extraDetails?.style?.MappingId, filteredDataObject)
            setCurrentMappedDO((prev) => {
              return [...newCurrentMappedDO];
            });
            setfilteredDataObject(deletedFilteredData)
            dispatch(updateContexts({name: "filteredDataObject", value: [...deletedFilteredData], key : containerId}))
            dispatch(updateContexts({name: "currentMappedDO",value: [...newCurrentMappedDO], key: containerId}));
          })
          .catch((err) => {
            setAlertData({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentMsg: "Failed to delete control. Please try again.",
              autoHideDuration: 6000,
            });
            loading(false)
          });
      }
    } else {
      setAlertData({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentMsg: "Unable to delete due to insufficient data",
        autoHideDuration: 6000,
      });
    }
    setSelectedControl({});
    window.selectedControlId_function({});

    /****************code end:- new code ************************/
  }
  // const [block, setBlockUI] = useState(false);

  var block = false;
  function blockUI(blockUIBoolean) {
    block = blockUIBoolean;
    // //console.log('blockUIBoolean :: '+blockUIBoolean);
    // if(!blockUIBoolean){
    //     setBlockUI(true);
    // } else {
    //     setBlockUI(false);
    // }
  }
  function getCurrentDevice() {
    const deviceFromDom = document
      .querySelector("#canvasId")
      ?.getAttribute("deviceMode");
    return deviceFromDom;
  }

  function computeLayout(dividend, dividor) {
    var quotient = Math.floor(dividend / dividor);
    if (quotient === 0) {
      quotient = 1;
    }
    if (dividend === 3 && dividor === 2) {
      quotient = 2;
    }
    if (dividend === 3 && dividor === 4) {
      quotient = 1;
    }
    return quotient;
  }

  function changeSectionLayout(columnLayout, formState, type) {
    blockUI(true);
    //console.time("time taken")
    //const startTime = performance.now();

    // it changes layout of the section acc to the column layout, make changes to section json
    var sectionWithNewLayout = changeLayoutOfElements(formState, columnLayout,type, type === "listview");
    var sectionId = sectionWithNewLayout.id;

    const deviceCurrent = getCurrentDevice();
    if (deviceCurrent === "web") {
      sectionWithNewLayout.w = columnLayout;
      // sectionWithNewLayout.sm = computeLayout(parseInt(columnLayout), 2);
      // sectionWithNewLayout.xs = computeLayout(parseInt(columnLayout), 4);
    } else if (deviceCurrent === "tablet") {
      sectionWithNewLayout.sm = columnLayout;
      // sectionWithNewLayout.xs = computeLayout(parseInt(columnLayout), 2);
    } else if (deviceCurrent === "mobile") {
      sectionWithNewLayout.xs = columnLayout;
    }

    // console.log("subFormStateJson.current ", columnLayout);
    // console.log("subFormStateJson.current ", formState);
    // console.log("subFormStateJson.current ", sectionWithNewLayout);
    // console.log("subFormStateJson.current ", sectionId);
    // console.log("subFormStateJson.current ", selected , selectedControl);
    // setSelectedControl(selectedControl);
    // setSelected()

    // if(openCanvasForSubform === "showDataAdditonSection"){

    //     console.log(" change column layout in section Listview ");
    //     var updatedFormState = updateFormStateStructure(subFormListviewJson, sectionId, sectionWithNewLayout);
    //     dispatch(updateContexts({name: "subFormListviewJson", ...updatedFormState});

    //     // const[subFormListviewJson, setSubFormListviewJson] = useState();

    //  }else{

    // console.log(" change column layout in section advance Listview ");
    if (type === "listview") {
      // it updates section json in formBuffer
      var updatedFormState = updateFormStateStructure(
        formState,
        sectionId,
        sectionWithNewLayout
      );
    } else {
      // it updates section json in formBuffer
      var updatedFormState = updateFormStateStructure(
        {...formState2},
        sectionId,
        sectionWithNewLayout
      );
      setFormState2({ ...updatedFormState });

      if(currentadvanceListview?.current && Object.keys(currentadvanceListview?.current)?.length> 0){
        setCurrentadvanceListview(currentadvanceListview?.current);

        dispatch(updateGridContexts({ name: "advanceListviewStateJson", key: containerId, value:  {...currentadvanceListview?.current?.listviewFrameLayoutJson},renderCanvas:true}));
      }
    }

    blockUI(false);
  }


  function getFormState2() {
    return formStateStore
      .getState()
      .data.find((json) => json.key === containerId)?.contexts?.formState2;
  }

  function changeCanvasLayout(columnLayout, view, prevView , form_buffer) {

    let returned_FrameLayoutJson = { };
    var formState2FromRedux = form_buffer || getFormState2();
    // var formState2FromRedux= (formStateStore.getState().data.find(json => json.key === containerId))?.contexts?.formState2;
    setDevice(view);

    if( openCanvasForSubform === "advanceListviewFromScratch" ){

      blockUI(true);
      
      var updatedFormState = updateFormStateStructureByElemType(
        fetchGridStates().advanceListviewStateJson,
        columnLayout,
        view,
        prevView
      );

      // if(updatedFormState?.currentDeviceOnApp){
        updatedFormState.currentDeviceOnApp = view;
      // }

      returned_FrameLayoutJson = updatedFormState;

      dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: updatedFormState, renderCanvas: true}));
      
      // setCurrentadvanceListview(updatedFormState);

    }
    else if (!isObjectEmpty(formState2FromRedux)) {
      blockUI(true);
      var updatedFormState = updateFormStateStructureByElemType(
        formState2FromRedux,
        columnLayout,
        view,
        prevView
      );

      // if(updatedFormState?.currentDeviceOnApp){
        updatedFormState.currentDeviceOnApp = view;
      // }

        returned_FrameLayoutJson = updatedFormState;
      // dispatch(updateContexts({ name: "formState2", value:{...updatedFormState}, key: containerId }));
      if(form_buffer){

      }
      else{
        setFormState2({ ...updatedFormState });
        blockUI(false);
      }
    }
    return returned_FrameLayoutJson;
  }

  function changeCanvasLayoutforlistview(formState2From_fn , columnLayout, view, prevView) {

    // var formState2FromRedux = getFormState2();

    setDevice(view);
   
    if (!isObjectEmpty(formState2From_fn)) {
      blockUI(true);

      var updatedFormState = updateFormStateStructureByElemType(
        formState2From_fn.listviewFrameLayoutJson,
        columnLayout,
        view,
        prevView
      );

      // if(updatedFormState?.currentDeviceOnApp){
        updatedFormState.currentDeviceOnApp = view;
      // }

      formState2From_fn.listviewFrameLayoutJson = {...updatedFormState};

      formState2From_fn.listviewFrameLayoutJson = {...updatedFormState};

      // dispatch(updateContexts({ name: "formState2", value:{...updatedFormState}, key: containerId }));
      // setFormState2({ ...updatedFormState });

      dispatch(
        updateGridContexts({
          name: "subFormListviewJson",
          key: props.containerId,
          value: formState2From_fn
        })
      );

      blockUI(false);
    }
  }

  async function saveFormState() {
    // setOpenLoader(true);
    // console.log("page...##*", formState2.formName, formState2.id, microFrontendData?.formDefId);
    if (microFrontendData?.formName && microFrontendData?.formId) {
      formState2.formName = microFrontendData?.formName;
      formState2.id = microFrontendData?.formId;
    }
    if (microFrontendData?.formDefId) {
      // formState2.formName=microFrontendData?.formName;
      formState2.id = microFrontendData?.formDefId;
    }
    // var response = await jsonElementOperation(formState2, "save", setFormState2)
    //   .then((response) => {
    //     // showAlertConfirmNotifications({
    //     //     'open':true,
    //     //     'showConfirm':'showNotification',
    //     //     'alertType':'success',
    //     //     'alertContentKey':'FORM_SAVED_SUCCESSFULLY'});
    //     setOpenLoader(false);
    //     setAlert1({
    //       open: true,
    //       severity: "success",
    //       severityMessage: `${t("translation:FORM_SAVED_SUCCESSFULLY")}`,
    //     });

    //     // window.setTimeout(() => {
    //     //   //   setQuery("success");
    //     //   setOpenLoader((prevOpenLoader) => {
    //     //     if (prevOpenLoader) {
    //     //       return false;
    //     //     } else {
    //     //       return prevOpenLoader;
    //     //     }
    //     //   });
    //     //   showAlertConfirmNotifications({
    //     //     'open':false,
    //     //     'showConfirm':'showNotification',
    //     //     'alertType':'success',
    //     //     'alertContentKey':'FORM_SAVED_SUCCESSFULLY'});
    //     // }, 500);
    //   })
    //   .catch(function (error) {
    //     // showAlertConfirmNotifications({
    //     //     'open':true,
    //     //     'showConfirm':'showNotification',
    //     //     'alertType':'error',
    //     //     'alertContentKey':'SaveFormFailureMessage'});
    //     // window.setTimeout(() => {
    //     //   //   setQuery("success");
    //     //   setOpenLoader((prevOpenLoader) => {
    //     //     if (prevOpenLoader) {
    //     //       return false;
    //     //     } else {
    //     //       return prevOpenLoader;
    //     //     }
    //     //   });
    //     // }, 500);
    //     setOpenLoader(false);
    //   });
  }

  const updateJson = {
    updatedComponentInFormState: updatedComponentInFormState,
    removeAndUpdateComponentInFormState: removeAndUpdateComponentInFormState,
    saveFormState: saveFormState,
  };

  // useAutosave(() => {
  //   if(!formMataData && !getGdToken() && props.childComp !== "preview") {
  //     if(window.location.href.includes("processDesigner"))
  //       window.callSpecifiedFunctions1(saveFormState,"","",true);
  //     else window.callSpecifiedFunctions({},"","",true);
  //   }
  // }, 5 * 60 * 1000);

  const mobileView = {
    //  background: "#F0F0F0",
    display: "flex",
    justifyContent: "center",
    paddingRight: `${propertyPinned ? "44px" : "5px"}`,
    // width:"900px"
  };

  // const setAlertData = (obj) => {
  //   alertData.current = obj;
  //   return (
  //     <>
  //     {
  //       alertData.current.open === true &&
  //       <CustomizedAlert
  //       alertData={alertData.current}
  //       // setOpenLoader={setOpenLoader}
  //       />
  //     }
  //     </>
  //   )
  // }

  axios.interceptors.response.use((response) => {
    
    return response;
}, (error) => {
    if (error?.response?.status === 504) {
      alert("Server is taking too long to respond. Please try again later or contact support for assistance."); 
    }
    else if(error?.response?.status === 401 && window.isDesigner) {
      functions.showSplitMessage("Invalid Authentication","Invalid Authentication.","error");
      if(explictLogoutRef.current)
        explictLogoutRef.current();
      // alert("Session has expired. Please log in again."); 
    }
    else return Promise.reject(error);
    
});
  const [alertResponseMessage, setAlertReponse] = useState();
  const [
    successAndErrorMessageControlsListBasedOnAttribute,
    setSuccessAndErrorMessageControlsListBasedOnAttribute,
  ] = useState({});
  const [widthOfCanvasArea, setWidthOfCanvas] = useState();

  function showAlertConfirmNotifications(dataTobeSet) {
    // console.log("::::::::::",dataTobeSet);
    setAlertData(dataTobeSet);
  }

  function setAlertResponseMessage(ev) {
    setAlertReponse(ev);
  }

  function handleSuccessAndErrorMessageControlsListBasedOnAttribute(
    jsonData,
    attributeName
  ) {
    const updatedColtrolsListForAttribute =
      findSuccessAndErrorMessageControlsBasedOnAttribute(
        jsonData,
        attributeName,
        []
      );
    setSuccessAndErrorMessageControlsListBasedOnAttribute((prev) => {
      return {
        ...prev,
        [attributeName]: updatedColtrolsListForAttribute,
      };
    });
  }

  // const[theme, setNewTheme1] = useState({});

  // function setNewTheme(theme){
  //     try {

  //         } catch (e) {

  //         }

  // }

  const handleClose3 = (event) => {
    setAlert1({ open: false });
  };

  function recursiveJsonReader(jsonData, selectedID, elemType) {
    if (Array.isArray(jsonData)) {
      jsonData.map((item, index) => {
        if (
          item?.["id"] === selectedID ||
          item?.["control_id"] === selectedID
        ) {
          //   console.log("selectedControl item:: " , item);
          if (item?.["elem_type"] !== undefined) setSelectedControl(item);
          window.selectedControlId_function(item);

          setShowProperties(true);
          setShowDataAdditionSection(false);
          return true;
        }
        if (
          item &&
          Object.keys(item) &&
          Object.keys(item).includes("children")
        ) {
          var matched = recursiveJsonReader(item, selectedID, elemType);
          if (matched === true) {
            return true;
          }
        }
      });
    } else {
      if (jsonData?.["id"] !== selectedID) {
        recursiveJsonReader(jsonData["children"], selectedID, elemType);
      } else if (jsonData?.["control_id"] !== selectedID) {
        recursiveJsonReader(jsonData["children"], selectedID, elemType);
      } else {
        setSelectedControl(jsonData);
        window.selectedControlId_function(jsonData);

        setShowProperties(true);
        setShowDataAdditionSection(false);
        return true;
      }
    }
  }

  function recursiveJsonReaderForSubForm(
    jsonData,
    subFormID,
    subFormJson,
    subKey
  ) {
    if (Array.isArray(jsonData)) {
      jsonData.map((item, index) => {
        if (item["id"] === subFormID) {
          item[subKey] = subFormJson;
          jsonData[index] = item;
          return jsonData;
        }
        if (Object.keys(item).includes("children")) {
          recursiveJsonReaderForSubForm(item, subFormID, subFormJson, subKey);
        }
      });
    } else {
      if (jsonData["id"] !== subFormID) {
        recursiveJsonReaderForSubForm(
          jsonData["children"],
          subFormID,
          subFormJson,
          subKey
        );
      } else {
        jsonData[subKey] = subFormJson;
        return jsonData;
      }
    }
    return jsonData
  }

  function setDefaultPageStyles(formData) {
    var defaultPageStyle = new Object(ThemeJSON.page, {});
    //   console.log("defaultPageStyle::",defaultPageStyle);
    try {
      var styleKeys = Object.keys(formData.style);
      Object.keys(defaultPageStyle).map((key) => {
        if (!styleKeys.includes(key)) {
          formData.style[key] = defaultPageStyle[key];
        }
      });
    } catch (e) {
      console.log(e);
    }
  }

  const [templateForm, setFormTemplate] = useState(false);

  window.max_ColumnValue = 0;
  window.max_RowValue = 0;

  const setMax_controlIdValue = (id, elem) => {
    const integerValue = id?.replace(/^\D+/g, "");

    if (elem === "column" && integerValue > window.max_ColumnValue) {
      window.max_ColumnValue = id?.replace(/^\D+/g, "");
    } else if (elem === "row" && integerValue > window.max_RowValue) {
      window.max_RowValue = id?.replace(/^\D+/g, "");
    }
  };

  // useEffect(()=>{
  //   if(checkEmpty(formState2) && !window.emptyScreen1) {
  //     if(window.changeEmptyScreen)
  //       window.changeEmptyScreen(true)
  //   }
  //     console.log("### ",formState2);
  // },[formState2]);

  // useEffect(() => {
  //   const iFrameWin = window?.parent?.document?.querySelector("[title='iframeExComp']")
  //   if(iFrameWin){
  //     window.functions = iFrameWin?.contentWindow?.functions;
  //   }
  // }, [window?.parent?.document.querySelector("[title='iframeExComp']"), externalFormOpen])

  // const passedContextValues={testClick,targetForDrop,drop,applyChanges,dragging,setDragging,deleteControl,changeSectionLayout,showProperties, setShowProperties, quickToolsClose,setQuickToolsClose,formState2,setFormState,
  //     updateColumnWidth,handleReorderStart,handleReorderDrop,selected,setSelected,addColumn,device,updateJson,showDataAdditionSection, setShowDataAdditionSection ,draggedObjType,customControlIdList,setCustomControlIdList,
  //     handleCustomControlId, changeCanvasLayout, setSelectedControl,draggedFrom,setDraggedFrom, openDrawer, setOpenDrawer, drawerPinned, setDrawerPinned, propertyPinned, setPropertyPinned, openProperties, setOpenProperties,
  //     showAlertConfirmNotifications, alertResponseMessage, setAlertResponseMessage, theme, setNewTheme, widthOfCanvasArea, setWidthOfCanvas,
  //     setSubFormState,openCanvasForSubform, templateForm, setFormTemplate ,activePage, setActivePage, activeSubForm, setActiveSubForm, activeApplication,
  //     showPagesSubForms ,setShowPagesSubForms, allPages, setAllPages ,allSubForms,setSubForms, setFormState2 , applicationScreenshot, setApplicationScreenshot ,setActiveApplication,
  //     handleValueForConditionalVisibility,
  //     valueForConditionalVisibility,toggleProperty, setToggleProperty
  //      };

  // const {contextValues,setContextValues} = useContext(AppContextMain);

  // useState(()=>{
  //   setContextValues(passedContextValues)
  // },[passedContextValues])

  const [openScale, setOpenScale] = useState(false);

  var widthValueForArabic = {
    position: "absolute",
    left: t("styles:leftNavigationPosition"),
    right: t("styles:rightNavigationPosition"),
    width: `calc(100% - 68px)`,
  };
  //********************************************** DRAG AND DROP OF SUBFORMS START ****************************************************** //

  const onDragStartOfSubform = (ev) => {
    // console.log("#Subform",ev.target?.getAttribute("subformId"));
    setSubformDragged(ev.target?.getAttribute("subformId"));
    // setShowPagesSubForms(false);
  };

  const onDragOfSubform = (ev) => {
    if (showPagesSubForms === true) {
      setShowPagesSubForms(false);
    }
  };

  const onDropOfSubform = (ev, json_data) => {
    ev.preventDefault();
    ev.stopPropagation();

    const parent = () => {
      if (
        ev.currentTarget.closest(`[elem_type=wizard_v]`) ||
        ev.currentTarget.closest(`[elem_type=wizard_h]`) ||
        ev.currentTarget.closest(`[elem_type=sidenavigation]`)
      ) {
        return true;
      } else {
        return false;
      }
    };

    const parentStep =
      (ev.currentTarget.closest(`[elem_type=Step]`) &&
        ev.currentTarget
          .closest(`[elem_type=Step]`)
          .getAttribute("frameindex")) ||
      (ev.currentTarget.closest(`[elem_type=SubStep]`) &&
        ev.currentTarget
          .closest(`[elem_type=SubStep]`)
          .getAttribute("frameindex")) ||
      "";

    const parentSubStep =
      (ev.currentTarget.closest(`[elem_type=SubStep]`) &&
        ev.currentTarget
          .closest(`[elem_type=SubStep]`)
          .getAttribute("elementindex")) ||
      "";

    // console.log("##Subform",ev?.target , ev?.currentTarget,parent(), json_data, parentStep ,parentSubStep);

    if (parentSubStep && parentStep) {
      json_data.children[parentStep].children[parentSubStep].subformId =
        subformDragged;
    } else if (parentStep) {
      json_data.children[parentStep].subformId = subformDragged;
    }
    const newJsonData = { ...json_data };

    updatedComponentInFormState(newJsonData.id, newJsonData);
    setSubformDragged(null);
  };

  // window.setFormState_outsideComponents = (newformState) => {
  //   setFormState2({ ...newformState });
  // };

  // window.setopenLoader_fromWindow = (val) => {
  //   setOpenLoader(val);
  // };

  //********************************************** DRAG AND DROP OF SUBFORMS END ****************************************************** //

  if (
    (document.querySelector(`div [elem_type=wizard_v]`) ||
      document.querySelector(`div [elem_type=wizard_h]`) ||
      document.querySelector(`div [elem_type=sidenavigation]`)) &&
    currentSubFormInWizard
  ) {
    applicationNameObj.formName = currentSubFormInWizard;
  }

  let imageBaseURL = currentUrl?.includes("openExtInterface") ? "" :
  childComp === "application" || activePage || activeSubForm || templateLoaded
    ? `${window.apb_backend_app_context}/idesign/getImage/${applicationNameObj.applicationName}/${templateLoaded ? "%20" : applicationNameObj.formName}/${window?.activeCabinet_formbuilder}/`
    : "";

  const parentWizardCheck = (childId) => {
    if (
      (
        document.getElementById(childId)?.closest(`[elem_type=wizard_v]`) ||
        document.getElementById(childId)?.closest(`[elem_type=wizard_h]`) ||
        document.getElementById(childId)?.closest(`[elem_type=sidenavigation]`)
      )  || 
      (
        (openCanvasForSubform === "subform" && currentButtonForSubform.current?.containerControl === "wizard_h") ||
        (openCanvasForSubform === "subform" && currentButtonForSubform.current?.containerControl === "wizard_v") ||
        (openCanvasForSubform === "subform" && currentButtonForSubform.current?.containerControl === "sidenavigation") 
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  const parentMenuCheck = (childId) => {
    if (document.getElementById(childId)?.closest(`[elem_type=Menu]`) || 
       (openCanvasForSubform === "subform" && currentButtonForSubform.current?.containerControl === "Menu")
       ) {
      return true;
    } else {
      return false;
    }
  };

  const parentTab = (childId) => {
    if(childId) 
      return document.getElementById(childId)?.closest(`[elem_type=tab]`) ? true : false;
    // return ev.target?.closest(`[elem_type=tab]`) ? true : false;
  };

  
  const [isLoginTypeVar, setIsLoginTypeVar] = useState("");

  function isLoginType() {
    const islogin = openingAsApplication?.islogin;
    if (islogin === "Y") {
      setIsLoginTypeVar(true);
    } else {
      setIsLoginTypeVar(false);
    }
  }

  useEffect(() => {
    isLoginType();
  }, [openingAsApplication?.islogin]);

  //********************************************** Redux dispatching START ****************************************************** //

  // console.log("takeScreenshot",applicationScreenshot );

  const dispatch = useDispatch();

  if(!getNonceValue()) {
    const metaTag = document.querySelector('meta[id="mui-meta"]');
      
    if (metaTag) {
      const value = metaTag.getAttribute('content');
      formStateStore.dispatch(updateStore({ name: "noncevalue", value: value}))
    }
  }


  const contextValues = {
    imageBaseURL,
    populateFormStateFromJsonOnAction,
    setFormstateChangedByUser:setFormstateChangedByUser, 
    applicationNameObj,
    loading: loading,
    activeMenuId,
    setActiveMenuId,
    subformStack,
    setSubformStack,
    currentListviewForSubform,
    handleListviewControlSwapping,
    setCurrentListviewForSubform,
    // devicePreview,
    // setDevicePreview,
    isTableBackdropOpen,
    setIsTableBackdropOpen,
    listviewFrameLayoutJsonClone_listviewMap: listviewFrameLayoutJsonClone_listviewMap.current,
    onDragStartOfSubform: onDragStartOfSubform,
    elementToCreate: elementToCreate,
    targetElemState: targetElemState,
    onDragOfSubform: onDragOfSubform,
    onDropOfSubform: onDropOfSubform,
    testClick: testClick,
    targetForDrop: targetForDrop,
    drop: drop,
    applyChanges: applyChanges,
    dragging: dragging,
    setDragging: setDragging,
    deleteControl: deleteControl,
    changeSectionLayout: changeSectionLayout,
    showProperties: showProperties.current,
    setShowProperties: setShowProperties,
    formState2: formState2,
    // setFormState: setFormState,
    updateColumnWidth: updateColumnWidth,
    handleReorderStart: handleReorderStart,
    handleReorderDrop: handleReorderDrop,
    selected: selected,
    setSelected: setSelected,
    addColumn: addColumn,
    device: device,
    updateJson: updateJson,
    // subFormListviewJson: subFormListviewJson,
    showDataAdditionSection: showDataAdditionSection,
    setShowDataAdditionSection: setShowDataAdditionSection,
    // setListViewAddRecordFrom: setListViewAddRecordFrom,
    // listViewAddRecordFrom: listViewAddRecordFrom,
    draggedObjType: draggedObjType,
    customControlIdList: customControlIdList,
    setCustomControlIdList: setCustomControlIdList,
    setCurrElem: setCurrElem,
    setSubFormState: setSubFormState,
    setFormState2: setFormState2,
    isPortal:isPortal,
    // formPageType : formPageType,
    handleCustomControlId: handleCustomControlId,
    changeCanvasLayout: changeCanvasLayout,
    changeCanvasLayoutforlistview: changeCanvasLayoutforlistview,
    selectedControl: selectedControl.current,
    setSelectedControl: setSelectedControl,
    draggedFrom: draggedFrom,
    setDraggedFrom: setDraggedFrom,
    openDrawer: openDrawer,
    setOpenDrawer: setOpenDrawer,
    drawerPinned: drawerPinned,
    setDrawerPinned: setDrawerPinned,
    propertyPinned: propertyPinned,
    setPropertyPinned: setPropertyPinned,
    openProperties: openProperties,
    setOpenProperties: setOpenProperties,
    showAlertConfirmNotifications: showAlertConfirmNotifications,
    alertResponseMessage: alertResponseMessage,
    setAlertResponseMessage: setAlertResponseMessage,
    // "theme":theme,
    // "setNewTheme":setNewTheme,
    widthOfCanvasArea: widthOfCanvasArea,
    setWidthOfCanvas: setWidthOfCanvas,
    isMenuSubMenuAdded: isMenuSubMenuAdded,
    setIsMenuSubMenuAdded: setIsMenuSubMenuAdded,
    dataObjectJson: dataObjectJson,
    setDataObjectJson: setDataObjectJson,
    dataObjects: dataObjects,
    setDataObjects: setDataObjects,
    isMicroSerciceChecks: isMicroSerciceChecks,
    setisMicroSerciceChecks: setisMicroSerciceChecks,
    // setCurrElem: setCurrElem,
    // setSubFormState: setSubFormState,
    templateForm: templateForm,
    // doclistRerenderCount,
    // setDoclistRerenderCount,
    setExternalFormOpen: setExternalFormOpen,
    setFormTemplate: setFormTemplate,
    activePage: activePage,
    setActivePage: setActivePage,
    activeSubForm: activeSubForm,
    setActiveSubForm: setActiveSubForm,
    activeApplication: activeApplication,
    showPagesSubForms: showPagesSubForms,
    setShowPagesSubForms: setShowPagesSubForms,
    allPages: allPages,
    setAllPages: setAllPages,
    allSubForms: allSubForms,
    setSubForms: setSubForms,
    // setFormState2: setFormState2,
    // applicationScreenshot: applicationScreenshot.current,
    setApplicationScreenshot: setApplicationScreenshot,
    setActiveApplication: setActiveApplication,
    mappingDataObjectsMap: mappingDataObjectsMap,
    DataObjectsArray: DataObjectsArray,
    handleValueForConditionalVisibility: handleValueForConditionalVisibility,
    valueForConditionalVisibility: valueForConditionalVisibility,
    openLoader: openLoader.current,
    setOpenLoader: setOpenLoader,
    toggleProperty: toggleProperty,
    setToggleProperty: setToggleProperty,
    loginErrorPage: loginErrorPage,
    setLoginErrorPage: setLoginErrorPage,
    globalTime: globalTime.current,
    setGlobalTime: setGlobalTime,
    sessionPopupTime: sessionPopupTime.current,
    setSessionPopupTime: setSessionPopupTime,
    sessionTime: sessionTime,
    setSessionTime: setSessionTime,
    formBuillderMode: formBuillderMode.current,
    // "setFormBuillderMode":setFormBuillderMode,
    successAndErrorMessageControlsListBasedOnAttribute:
      successAndErrorMessageControlsListBasedOnAttribute,
    handleSuccessAndErrorMessageControlsListBasedOnAttribute:
      handleSuccessAndErrorMessageControlsListBasedOnAttribute,
    builderMode: childComp,
    setFormBuillderMode: setFormBuillderMode,
    applicationData: applicationData,
    setApplicationData: setApplicationData,
    getElementJson: getElementJson,
    headerJSON: headerJSON,
    setHeaderJSON: setHeaderJSON,
    loggedInUserData: loggedInUserData,
    setLoggedInUserData: setLoggedInUserData,
    setMapValue: setMapValue,
    MapValue: MapValue,
    MapId: MapId,
    setMapId: setMapId,
    mappingControlsMap: mappingControlsMap,
    mappingControlsIdMap: mappingControlsIdMap,
    dataObjectsContent: dataObjectsContent,
    setDataObjectsContent: setDataObjectsContent,
    recursiveJsonForImportSection: recursiveJsonForImportSection,
    addColsToControlsForDataObjects: addColsToControlsForDataObjects,
    addColumnObj: addColumnObj,
    addRowObj: addRowObj,
    currentButtonForSubform: currentButtonForSubform.current,
    setCurrentButtonForSubform: setCurrentButtonForSubform,
    currentadvanceListview: currentadvanceListview.current,
    getDeviceFromProps_mf: getDeviceFromProps_mf,
    setCurrentadvanceListview: setCurrentadvanceListview,
    latestChangesSaved: latestChangesSaved.current,
    setLatestChangesSaved: setLatestChangesSaved,
    // gridPopup: gridPopup,
    // openCanvasForPreview: openCanvasForPreview,
    listviewColumnInfo: listviewColumnInfo,
    setlistviewColumnInfo: setlistviewColumnInfo,
    // listviewClearState: listviewClearState,
    // setListviewClearState: setListviewClearState,
    containerId: containerId,
    // selectedRowIndex: selectedRowIndex,
    // setSelectedRowIndex: setSelectedRowIndex,
    openQuickToolFor: openQuickToolFor.current,
    setOpenQuickToolFor: setOpenQuickToolFor,
    handleSubForm: handleSubForm,
    openCanvasForSubform: openCanvasForSubform,
    showSubForm: showSubForm,
    setShowSubForm: setShowSubForm,
    allNonFilledMandatoryFields: allNonFilledMandatoryFields,
    setAllNonFilledMandatoryFields: setAllNonFilledMandatoryFields,
    setAllNonFilledMandatoryFieldsFunc: setAllNonFilledMandatoryFieldsFunc,
    sectionInitiallyCollapsedState: sectionInitiallyCollapsedState.current,
    setSectionInitiallyCollapsedState: setSectionInitiallyCollapsedState,
    allGridControlsIds: allGridControlsIds,
    // currentAdvanceListview: currentAdvanceListview,
    // setCurrentAdvanceListview: setCurrentAdvanceListview,
    // setSubFormListviewJson: setSubFormListviewJson,
    // advanceListviewStateJson: advanceListviewStateJson,
    // setOpenCanvasForPreview: setOpenCanvasForPreview,
    // setAdvanceListviewStateJson: setAdvanceListviewStateJson,
    // spareAdvanceListviewStateJson: spareAdvanceListviewStateJson,
    // setSpareAdvanceListviewStateJson: setSpareAdvanceListviewStateJson,
    setOpenMF: setOpenMF,
    openMF: openMF,
    // tempCanWidth: tempCanWidth,
    // setTempCanWidth: setTempCanWidth,
    // setTempCanHeight: setTempCanHeight,
    loginHeaderHeight: loginHeaderHeight.current,
    setLoginHeaderHeight: setLoginHeaderHeight,
    canvasTop:canvasTop,
    setCanvasTop:setCanvasTop,
    // tempCanHeight: tempCanHeight,
    spareListviewStateJson: spareListviewStateJson,
    setSpareListviewStateJson: setSpareListviewStateJson,
    // selectedRowIndexAdvance: selectedRowIndexAdvance,
    // setSelectedRowIndexAdvance: setSelectedRowIndexAdvance,
    // currentAdvanceListviewStateJson: currentAdvanceListviewStateJson,
    // setcurrentAdvanceListviewStateJson: setcurrentAdvanceListviewStateJson,
    // openCanvasForPreviewAdvance: openCanvasForPreviewAdvance,
    // setOpenCanvasForPreviewAdvance: setOpenCanvasForPreviewAdvance,
    modeReadOrWrite: modeReadOrWrite,
    maskingData: maskingData,
    maskingKeys: maskingKeys,
    parentChildCustom: parentChildCustom,
    setParentChildCustom: setParentChildCustom,
    dataClassAdvacnceListview: dataClassAdvacnceListview,
    setDataClassAdvacnceListview: setDataClassAdvacnceListview,
    recursiveJsonForMapping: recursiveJsonForMapping,
    MapType: MapType,
    setMapType: setMapType,
    subFormStateJson: subFormStateJson.current,
    spareSubForm: spareSubForm,
    setSpareSubForm: setSpareSubForm,
    setSubform_obj: setSubform_obj,
    setCurrentDataObjectJson: setCurrentDataObjectJson,
    microFrontendComponentType: componentType,
    microFrontendData: microFrontendData,
    appId: appId,
    // formMataData: formMataData,
    isApp: isApp,
    processId: processId,
    statusType: statusType,
    openingAsApplication: openingAsApplication,
    setSelectedDataObject: setSelectedDataObject,
    selectedDataObject: selectedDataObject,
    setSelectedItem: setSelectedItem,
    selectedItem: selectedItem,
    setCurrentMappedDO: setCurrentMappedDO,
    currentMappedDO: currentMappedDO,
    webServiceResponse: webServiceResponse,
    setwebServiceResponse: setwebServiceResponse,
    filteredDataObject: filteredDataObject,
    setfilteredDataObject: setfilteredDataObject,
    setOpen1: setOpen1,
    setSeverity: setSeverity,
    setSeverityMessage: setSeverityMessage,
    transactionId: transactionId,
    setTransactionId: setTransactionId,
    setIsStep: setIsStep,
    isStep: isStep,
    setEventList: setEventList,
    eventList: eventList.current,
    setSelectedButtonEventId: setSelectedButtonEventId,
    selectedButtonEventId: selectedButtonEventId,
    // setAdvListviewFromScratchJson: setAdvListviewFromScratchJson,
    setSubformElementIndex: setSubformElementIndex,
    setfromQuickProps: setfromQuickProps,
    fromQuickProps: fromQuickProps,
    // hoverColumn: hoverColumn,
    // mandatoryControls: mandatoryControls,
    // setMandatoryControls: setMandatoryControls,
    setCopyElement: setCopyElement,
    copyElement: copyElement,
    setfilteredDataObjectCopy: setfilteredDataObjectCopy,
    filteredDataObjectCopy: filteredDataObjectCopy,
    setRecordCount: setRecordCount,
    recordCount: recordCount.current,
    // "containerId":containerId,
    appname: appname,
    // validateComponentInGrid: validateComponentInGrid,
    // setListviewMandatoryControls: setListviewMandatoryControls,
    // listviewMandatoryControls: listviewMandatoryControls,
    setTableRowData: setTableRowData,
    tableRowData: tableRowData,
    recursiveJsonReaderForSubForm: recursiveJsonReaderForSubForm,
    max_ColumnValue: window.max_ColumnValue,
    max_RowValue: window.max_RowValue,
    setMax_controlIdValue: setMax_controlIdValue,
    setUpdateDataObject: setUpdateDataObject,
    updateDataObject: updateDataObject,
    fetchDataObject: fetchDataObject,
    fetchProcessDataObject: fetchProcessDataObject,
    // currentAdvanceListviewJSON: currentAdvanceListviewJSON,
    // setCurrentAdvanceListviewJSON: setCurrentAdvanceListviewJSON,
    setIsButtonSubformOpen: setIsButtonSubformOpen,
    isButtonSubformOpen: isButtonSubformOpen,
    cabinetName: cabinetName,
    DocList_INI_Vars: DocList_INI_Vars.current,
    setAlertData: setAlertData,
    // setAdvSaveAndContinue: setAdvSaveAndContinue,
    // advSaveAndContinue: advSaveAndContinue,
    setCurrentSubFormInWizard,
    setGlobalLoading: setGlobalLoading,
    globalLoading: globalLoading,
    wizard_type_step: wizard_type_step,
    wizard_type_subStepIndex: wizard_type_subStepIndex,
    wizard_type_subChildMenuIndex: wizard_type_subChildMenuIndex.current,
    set_wizard_type_step: set_wizard_type_step,
    set_wizard_type_subStepIndex: set_wizard_type_subStepIndex,
    set_wizard_type_subChildMenuIndex: set_wizard_type_subChildMenuIndex,
    setGlobalLoadingMessage: setGlobalLoadingMessage,
    globalLoadingMessage: globalLoadingMessage,
    // setIsAboveSection: setIsAboveSection,
    // isAboveSection: isAboveSection,
    setListviewInfoUpdated: setListviewInfoUpdated,
    listviewInfoUpdated: listviewInfoUpdated,
    // setListviewModifyMode: setListviewModifyMode,
    // listviewModifyMode: listviewModifyMode,
    parentWizardCheck: parentWizardCheck,
    parentTab: parentTab,
    parentMenuCheck:parentMenuCheck,
    // selectedTableRow: selectedTableRow,
    // setselectedTableRowfunction: setselectedTableRowfunction,
    isTaskForm: microFrontendData?.componentType === "TF",
    QueryString: QueryString,
    themeOpen: themeOpen,
    setThemeOpen: setThemeOpen,
    themeResetDone:themeResetDone,
    setThemeResetDone:setThemeResetDone,
    fixedFooter:fixedFooter,
    setFixedFooter: setFixedFooter,
    setThemeResetValDone:setThemeResetValDone,
    themeResetValDone:themeResetValDone,
    isLoginTypeVar: openingAsApplication?.islogin === 'Y' ? true: false,
    setSelectionPage: setSelectionPage,
    selectionPage: selectionPage,
    updateDataObjectAfterCreate:updateDataObjectAfterCreate,
    landscapeView : props.landscapeView,
    homePage: homePage,
    setHomePage: setHomePage,
    t: t
  };
  
  const setContextOnSubFormLoad=()=>{
    let key = window.opener.newMicroFrontendData.store.containerInfo.containerId;
    let stateNew = window.opener.newMicroFrontendData.store.data.find(data => data?.key ===key);
    setListviewInfoUpdated(stateNew.contexts.listviewInfoUpdated)
    setUpdateDataObject(stateNew.contexts.updateDataObject)
    setCurrentSubFormInWizard(stateNew.contexts.currentSubFormInWizard)
    setGlobalLoading(stateNew.contexts.globalLoading)
    setGlobalLoadingMessage(stateNew.contexts.globalLoadingMessage)
    set_wizard_type_subStepIndex(stateNew.contexts.wizard_type_subStepIndex)
    set_wizard_type_subChildMenuIndex(stateNew.contexts.wizard_type_subChildMenuIndex)
    set_wizard_type_step(stateNew.contexts.wizard_type_step)
    setIsStep(stateNew.contexts.isStep)
    setfromQuickProps(stateNew.contexts.fromQuickProps);
    setSubformElementIndex(stateNew.contexts.subformElementIndex);
    setSelectedButtonEventId(stateNew.contexts.selectedButtonEventId)
    setEventList(stateNew.contexts.eventList)
    setCopyElement(stateNew.contexts.copyElement)
    setfilteredDataObjectCopy(stateNew.contexts.filteredDataObjectCopy)
    setRecordCount(stateNew.contexts.recordCount);
    setTableRowData(stateNew.contexts.tableRowData)
    setUpdateDataObject(stateNew.contexts.updateDataObject);
    setIsButtonSubformOpen(stateNew.contexts.isButtonSubformOpen)
    setCabinetName(stateNew.contexts.cabinetName)
    // setAlertData(stateNew.contexts.alertData)
    setOpeningAsApplication(stateNew.contexts.openingAsApplication);
    setThemeOpen(stateNew.contexts.themeOpen);
    QueryString= stateNew.contexts.QueryString;
    setThemeResetDone(stateNew.contexts.themeResetDone)
    setFixedFooter(stateNew.contexts.fixedFooter);
    setSelectionPage(stateNew.contexts.selectionPage);
    setThemeResetValDone(stateNew.contexts.themeResetValDone)
    setOpeningAsApplication(stateNew.contexts.openingAsApplication);
    setSeverityMessage(stateNew.contexts.severityMessage)
    setOpeningAsApplication(stateNew.contexts.openingAsApplication);
    setOpen1(stateNew.contexts.open1);
    setSeverity(stateNew.contexts.severity);
    setSelectedDataObject(stateNew.contexts.selectedDataObject)
    setSelectedItem(stateNew.contexts.selectedItem)
    setCurrentMappedDO(stateNew.contexts.currentMappedDO)
    setTransactionId(stateNew.contexts.transactionId)
    setwebServiceResponse(stateNew.contexts.webServiceResponse)
    setfilteredDataObject(stateNew.contexts.filteredDataObject)
    imageBaseURL = stateNew.contexts.imageBaseURL;
    applicationNameObj = stateNew.contexts.applicationNameObj;
    setActiveMenuId(stateNew.contexts.activeMenuId);
    setSubformStack(stateNew.contexts.subformStack);
    setCurrentListviewForSubform1(stateNew.contexts.currentListviewForSubform);
    setIsTableBackdropOpen(stateNew.contexts.isTableBackdropOpen)
    listviewFrameLayoutJsonClone_listviewMap.current = stateNew.contexts.listviewFrameLayoutJsonClone_listviewMap
    setDragging(stateNew.contexts.dragging);
    setShowProperties(stateNew.contexts.showProperties);
    setFormState2(stateNew.contexts.formState2);
    setSelected(stateNew.contexts.selected);
    setDeviceNew(stateNew.contexts.device);
    setShowDataAdditionSectionNew(stateNew.contexts.showDataAdditionSection);
    draggedObjType= stateNew.contexts.draggedObjType;
    setCustomControlIdList(stateNew.contexts.customControlIdList);
    isPortal=stateNew.contexts.isPortal;
    // formPageType= stateNew.contexts.formPageType;
    setSelectedControl(stateNew.contexts.selectedControl);
    setDraggedFrom(stateNew.contexts.draggedFrom);
    setOpenDrawer(stateNew.contexts.openDrawer);
    setDeviceNew(stateNew.contexts.device)
    setDrawerPinned(stateNew.contexts.drawerPinned);
    setPropertyPinned(stateNew.contexts.propertyPinned);
    setOpenProperties(stateNew.contexts.openProperties)
    setAlertResponseMessage(stateNew.contexts.alertResponseMessage)
    setWidthOfCanvas(stateNew.contexts.widthOfCanvasArea);
    setIsMenuSubMenuAdded(stateNew.contexts.isMenuSubMenuAdded);
    setDataObjectJson(stateNew.contexts.dataObjectJson);
    setDataObjects(stateNew.contexts.dataObjects);
    setisMicroSerciceChecks(stateNew.contexts.isMicroSerciceChecks);
    setFormTemplate(stateNew.contexts.templateForm);
    setExternalFormOpen(stateNew.contexts.externalFormOpen);
    setActivePage(stateNew.contexts.activePage);
    setActiveSubForm(stateNew.contexts.activeSubForm);
    setActiveApplication(stateNew.contexts.activeApplication);
    setShowPagesSubForms(stateNew.contexts.showPagesSubForms);
    setAllPages(stateNew.contexts.allPages);
    setSubForms(stateNew.contexts.allSubForms);
    setApplicationScreenshot(stateNew.contexts.applicationScreenshot);
    setActiveApplication(stateNew.contexts.activeApplication);
    setMappingDataObjectsMap(stateNew.contexts.mappingDataObjectsMap);
    setDataObjectsArray(stateNew.contexts.DataObjectsArray);
    setValueForConditionalVisibility(stateNew.contexts.valueForConditionalVisibility);
    setOpenLoader(stateNew.contexts.openLoader);
    setToggleProperty(stateNew.contexts.toggleProperty);
    setLoginErrorPage(stateNew.contexts.loginErrorPage);
    setGlobalTime(stateNew.contexts.globalTime);
    setSessionPopupTime(stateNew.contexts.sessionPopupTime);
    setSessionTime(stateNew.contexts.sessionTime)
    setFormBuillderMode(stateNew.contexts.formBuillderMode);
    setSuccessAndErrorMessageControlsListBasedOnAttribute(stateNew.contexts.successAndErrorMessageControlsListBasedOnAttribute);
    setFormBuillderMode(stateNew.contexts.formBuillderMode)
    setApplicationData(stateNew.contexts.applicationData);
    setHeaderJSON(stateNew.contexts.headerJSON)
    setLoggedInUserData(stateNew.contexts.loggedInUserData);
    setMapValue(stateNew.contexts.MapValue);
    setMapId(stateNew.contexts.MapId);
    setMappingControlsMap(stateNew.contexts.mappingControlsMap);
    setMappingControlsIdMap(stateNew.contexts.mappingControlsIdMap);
    setDataObjectsContent(stateNew.contexts.dataObjectsContent);
    setCurrentButtonForSubform(stateNew.contexts.currentButtonForSubform);
    setCurrentadvanceListview(stateNew.contexts.currentadvanceListview);
    setDeviceFromProps_mf(stateNew.contexts.getDeviceFromProps_mf);
    setLatestChangesSaved(stateNew.contexts.latestChangesSaved);
    setlistviewColumnInfo(stateNew.contexts.listviewColumnInfo);
    setOpenQuickToolFor(stateNew.contexts.openQuickToolFor);
    setOpenCanvasForSubformNew(stateNew.contexts.openCanvasForSubform);
    setShowSubForm(stateNew.contexts.showSubForm);
    setAllNonFilledMandatoryFields(stateNew.contexts.setAllNonFilledMandatoryFields);
    setSectionInitiallyCollapsedState(stateNew.contexts.sectionInitiallyCollapsedState)
    setAllGridControlsIds(stateNew.contexts.allGridControlsIds);
    setOpenMF(stateNew.contexts.openMF);
    setLoginHeaderHeight(stateNew.contexts.loginHeaderHeight)
    setCanvasTop(stateNew.contexts.canvasTop)
    setSpareListviewStateJson(stateNew.contexts.spareListviewStateJson);
    modeReadOrWrite=stateNew.contexts.modeReadOrWrite;
    setMaskingData(stateNew.contexts.maskingData);
    setMaskingKeys(stateNew.contexts.maskingKeys);
    setParentChildCustom(stateNew.contexts.parentChildCustom);
    setDataClassAdvacnceListview(stateNew.contexts.dataClassAdvacnceListview);
    setMapType(stateNew.contexts.MapType);
    setSubFormState(stateNew.contexts.subFormStateJson);
    setSpareSubForm(stateNew.contexts.spareSubForm);
    setSubform_obj(stateNew.contexts.subform_obj);
    setCurrentDataObjectJson(stateNew.contexts.currentDataObjectJson);
    setHomePage(stateNew.contexts.HomePage)
    let updateJson= stateNew.contexts.updateJson;
    // window.renderChild = renderChild
    window.updatedComponentInFormState2 = updatedComponentInFormState
    window.updatePartialJSON = updatePartialJSON
    window.childComp2 = childComp
    dispatch(updateContexts({name: "showAlertConfirmNotifications",value: showAlertConfirmNotifications, key: containerId}));
  
  }
  // const contexts = useSelector(
  //     state=>({
  //         contexts:state.contexts
  //     })
  //   );
  //if(Object.keys(formState2).length===0){
    if(!externalIformUrl?.includes("afb_subform"))
  dispatch(addContexts({ name: "contexts", contextValues, key: containerId }));
  //}
  // dispatch(setFormState1(formBuffer));
  // props.changeData({name:'description', value});

  //console.log("###formstate2", formState2);
  window.formBuffer = formState2;
  // console.log("###childComp: ",childComp,"###appname: ", appname , "###appId: ", appId );

  var canvasBack1 = {};
  var canvasBack2 = {};
  var canvasBack3 = {};

  // console.log("###formstate2StyleValue ", formState2.style);
  if (formState2?.style?.Breakpoint?.Desktop) {
    canvasBack1 = {
      // width: "1000px",
      // backgroundColor: "#FF0000",
      // opacity: "5%"
    };
  }

  if (formState2?.style?.Breakpoint?.Tab) {
    //  console.log("###formstate2StyleValue ", formState2?.style?.Breakpoint?.Tab);
    canvasBack2 = {
      width: "480px",
      backgroundColor: "#F900BF",
      opacity: "5%",
    };
  }

  if (formState2?.style?.Breakpoint?.Mobile) {
    // console.log("###formstate2StyleValue ", formState2?.style?.Breakpoint?.Mobile);
    canvasBack3 = {
      width: "768px",
      backgroundColor: "#9100FF",
      opacity: "3%",
    };
  }

  // const [iFormDesignerLayoutHeight, setIFormDesignerLayoutHeight] = useState(0);

  // useEffect(()=>{
  //     // const height=document.querySelector("#IFormDesignerLayout_id")?.getBoundingClientRect()?.top;
  //     // setIFormDesignerLayoutHeight(height);
  // },[])

  console.log("formState", formState2);

  // useEffect(()=>{
  //   const formstatefromRedux = formStateStore.getState()?.data?.find(json => json.key === containerId)?.contexts?.formState2;
  //   if(formstatefromRedux && !isObjectEmpty(formstatefromRedux) ){
  //     setFormState2(formstatefromRedux);
  //   }

  // },[formStateStore.getState()?.data?.find(json => json.key === containerId)?.contexts?.formState2])

  const updatedOnceFormState = useRef(false);

  useEffect(() => {
    if (
      updatedOnceFormState.current !== false &&
      formState2 &&
      !isObjectEmpty(formState2)
    ) {
      updatedOnceFormState.current = false;
    }
  }, [activePage]);

  // useEffect(()=>{
  //   if(updatedOnceFormState===false && formState2 && !isObjectEmpty(formState2) ){
  //     dispatch(updateContexts({ name: "formState2", value:formState2, key: containerId }));
  //     setOnceUpdatedFormState(true);
  //   }
  // },[ updatedOnceFormState,formState2])

  //********************************************** Redux dispatching END ****************************************************** //


  const loginHandler = () => {
    window.location.href =
    window.location.origin +
    ( isPortalLive
      ? process.env.REACT_APP_PUBLIC_URL
      : "/automationstudio" 
    );
  };

  const sessionlogoutHandler = () => {
    console.log("Session Logout Api Call");

    const authKey = JSON.parse(secureLocalStorage.getItem(window.isPortalLive ?  `launchpadKey_${applicationNameObj?.applicationName}` || `launchpadKey_bypass_${applicationNameObj?.applicationName}` || "launchpadKey" : "launchpadKey"))?.token ||
            undefined;

    // const authKey =
    //   JSON.parse(secureLocalStorage.getItem("launchpadKey"))?.token ||
    //   secureLocalStorage.getItem("Authorization") ||
    //   undefined;

    if (authKey) {
      // axios
      //   .get(`${window.location.origin}/bam-ws/app/applogout`, {
      //     headers: {
      //       // token: authKey,
      //       Authorization: authKey
      //     },
      //   })
      const logout_payLoad={
        "gdtoken":window.gdtoken_portal
      };

      axios.post("/viewform/disconnectUser",logout_payLoad,{withCredentials:true})
        .then((res) => {
          if (res?.data === "Success") {
            //window.location.href = window.location.origin + `/automationstudio`;
            console.log("Session Logout Api Success");
            // const timeout = setTimeout(() => {
            removeUserSession();
            removeTheme();
            // }, 200);
            // clearTimeout(timeout);����������������
          }
        })
        .catch((err) => {
          console.log("Session Logout Api Fail", err);
          // dispatch(logoutIsLoading(false));
        });
    }
  };

  const removeUserSession = () => {
    console.log("Remove Session Localstorage called");
    if(isPortalLive) {
      secureLocalStorage.removeItem(`launchpadKey_${applicationNameObj.applicationName}`);
      secureLocalStorage.removeItem(`launchpadKey_bypass_${applicationNameObj.applicationName}`);
    }
    else {
      secureLocalStorage.removeItem("launchpadKey");
    }
    secureLocalStorage.removeItem("modelerData");
    secureLocalStorage.removeItem("locale");
    secureLocalStorage.removeItem("cabinet");
    sessionStorage.removeItem("lastLoginTime");
  };

  const removeTheme = () => {
    console.log("Remove Session Theme called");
    // let token =
    //   JSON.parse(secureLocalStorage.getItem("launchpadKey"))?.token ||
    //   secureLocalStorage.getItem("Authorization") ||
    //   undefined;
      let token =
      JSON.parse(secureLocalStorage.getItem(isPortalLive ?  `launchpadKey_${applicationNameObj.applicationName}` || `launchpadKey_bypass_${applicationNameObj.applicationName}` || "launchpadKey" : "launchpadKey"))?.token ||
    secureSessionStorage.getItem("Authorization") ||
    undefined;
    let themeString = window.location.origin + "/oap-rest/app/theme";
    for (let i = 0; i < document.styleSheets.length; i++) {
      if (
        document.styleSheets[i]?.href?.includes(token) ||
        document.styleSheets[i]?.href?.includes(themeString)
      ) {
        document.styleSheets[i].disabled = true;
      }
    }
  };

  function openSessionMF() {
    const state=formStateStore.getState();
  if(containerId===undefined){
    containerId="default"
  }
 let nonceValue= state.data.find(json => json.key === containerId)?.noncevalue;

    let microProps = {
      uniqueNumber: nonceValue,
      ContainerId: "SessionContainerIform_builder",
      loginHandler: loginHandler,
      sessionLogoutHandler: sessionlogoutHandler,
      tokenKeyName: isPortalLive ? `launchpadKey_${applicationNameObj.applicationName}` || `launchpadKey_bypass_${applicationNameObj.applicationName}`: "launchpadKey",
      Component: "SessionMF",
      Module: "WCL",
      portalAppName : isPortalLive ? `${applicationNameObj.applicationName}` : (window.session_customLoginBtn_iforms && window.session_customLoginBtn_iforms().length > 0) ? window.session_customLoginBtn_iforms() : "" ,
      explictLogoutRef: explictLogoutRef,
      session_message: window.session_customMessage_iforms && window.session_customMessage_iforms().length > 0 ? window.session_customMessage_iforms() : "",
      Session_logout_button_label: window.session_customButtonLabel_iforms && window.session_customButtonLabel_iforms().length > 0 ? window.session_customButtonLabel_iforms() : ""
    };
    window?.loadSessionPopup(microProps);
  }

  useEffect(() => {

    //var opensesslaunchpad_key= JSON.parse( secureLocalStorage.getItem(`launchpadKey_${applicationNameObj.applicationName}`) )?.token;
    //var opensesslaunchoas= JSON.parse((secureLocalStorage.getItem("launchpadKey") || null))?.token;
    //var oepnsessautho = secureLocalStorage.getItem("Authorization");
    //console.log("openSessionMF launchpadKey_applicationName", opensesslaunchpad_key );
    //console.log("openSessionMF launchpadKey",  opensesslaunchoas);
    //console.log("openSessionMF Authorization",  oepnsessautho);

    const lauchpad_key_get =
    JSON.parse(secureLocalStorage.getItem(isPortalLive ?  `launchpadKey_${applicationNameObj.applicationName}` || "launchpadKey" : "launchpadKey"))?.token ||
    secureSessionStorage.getItem("Authorization") || undefined;

    if( document.querySelector("#SessionContainerIform_builder") && lauchpad_key_get && lauchpad_key_get!=="" && ( (loggedInUserData?.loggedInUserName && loggedInUserData?.lastLoggedInTime) || (openingAsApplication?.islogin === 'N') ) ) {
      openSessionMF();
    }
  }, [
    document.querySelector("script[src='/integration/integration.js']"),
    document.querySelector("#SessionContainerIform_builder"),
    isLoginTypeVar,
    activePage,
    activePage?.formId,
    loggedInUserData?.loggedInUserName,
    JSON.parse((secureLocalStorage.getItem("launchpadKey") || null))?.token,
    JSON.parse(secureLocalStorage.getItem(isPortalLive ?  `launchpadKey_${applicationNameObj.applicationName}` || "launchpadKey" : "launchpadKey"))?.token,
    JSON.parse(secureLocalStorage.getItem( `launchpadKey_${applicationNameObj.applicationName}` ) )?.token
  ]);

  

  window.isPortalLive = isPortalLive;
  window.isSubFormPresent = currentSubFormInWizard ? true : false;
  return (
    <>
      {
        (
          (
            appname &&
            childComp === "application" 
            // commenting below as opensessionmf should work on both login type and loginfree portals 
            // && openingAsApplication?.islogin &&
            // isLoginTypeVar &&
            // loggedInUserData?.loggedInUserName

          ) ||
          (
            window?.location?.href &&
            (
              window.location.href.includes("psh/pmWebDesigner") ||
              window.location.href.includes("psh/pmWebPreview")
            )
          )
        ) && 
        (
          <div id="SessionContainerIform_builder"></div>
        )
      }
      
      {/* <div id="SessionContainerIform_builder"></div> */}
      {childComp === "app" && (
        <div
          className={style.IFormDesignerLayout}
          id="IFormDesignerLayout_id"
          // onLoad={ ()=>{ focusElement( document.querySelector("#IFormDesignerLayout_id") , 0 ); }}
          // style={{height: `calc(100vh - ${iFormDesignerLayoutHeight}px)`}}
          dir={
            window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
              ? "rtl"
              : "ltr"
          }
        >
          <LOADER block={block} />
          <SimpleLoader open={openLoader.current} />

          <div
            // className={style.formControlsSection}
            className={style.newFormControlsDrawer}
          >
            {childComp === "app" && (
              <div className={style.leftFixedDiv}>
                <div className={style.leftNavigator}>
                    <LeftNavigation
                      setDragging={setDragging}
                      containerId={containerId}
                      handleDragging={handleDragging}
                      createNewElement={elementToCreate}
                      on_drag={handleDragStart}
                      formData={formState2}
                      selectedControl={selectedControl.current}
                      showProperties={showProperties.current}
                      hideProperties={hideProperties}
                      applyChanges={(obj, saveOldState) =>
                        applyChanges(obj, saveOldState)
                      }
                      unDo={undoList.current}
                      handleUndo={handleUndo}
                      handleRedo={handleRedo}
                      reDo={redoList.current}
                      presentState={presentState}
                      changeUndoList={() => changeUndoList()}
                      setSelectedControl={(obj) => setSelectedControl(obj)}
                      currentMappedDO={currentMappedDO}
                    />
                </div>
              </div>
            )}

            <div
              style={widthValueForArabic}
              //   style={{width:`calc(100% - 68px)`,position:"absolute",leftRight:"68px"}}
            >
              {showPagesSubForms === true && (
                <>
                  <div
                    className="shade-main_pagessubforms"
                    onClick={() => setShowPagesSubForms(false)}
                  ></div>
                  <PagesSubForms 
                    containerId={containerId} 
                    resetUndoList={resetUndoList} 
                    resetRedoList={resetRedoList} />
                </>
              )}

              {childComp === "app" && (
                <Header
                  formData={formState2}
                  themeList={themeDetails.current}
                  setThemeList={setThemeDetails}
                  applyChanges={(obj, saveOldState) =>
                    applyChanges(obj, saveOldState)
                  }
                  formdata={formState2}
                  device={device}
                  setDevice={setDevice}
                  handleUndoRedo={(operation) => handleUndoRedo(operation)}
                  undoRedoListLength={{
                    undoListLength: undoList.current.length,
                    redoListLength: redoList.current.length,
                  }}
                  containerId={containerId}
                  selectedControl={selectedControl}
                  appId={appId}
                  applicationData={microFrontendData}
                  openMicro={props.openMicro}
                  setOpenMicro={props.setOpenMicro}
                />
              )}

              <div fluid={"true"} className="mt-0">
                <div style={{ display: "flex" }}>
                {(childComp === "app"  || childComp === "subForm")&& (
                    <div
                      className={style.spaceForPinnedLeftNavigator}
                      style={{
                        width: drawerPinned ? "260px" : "0px",
                        transition: "width 0.5s ease-in-out",
                      }}
                    ></div>
                  )}

                  <div
                    //  style={cols_css}
                    className={style.CanvasStyle}
                    style={
                      device === "mobile" || device === "tablet"
                        ? mobileView
                        : 
                        translationStyles1 
                        ?
                        { paddingLeft: `${propertyPinned ? "44px" : "5px"}` } 
                        :
                        { paddingRight: `${propertyPinned ? "44px" : "5px"}` }
                    }
                  >
                    <Canvas
                      isSSO={isSSO}
                      landscapeView={props.landscapeView}
                      containerId={containerId}
                      validationResponse={validationResponse}
                      setValidationResponse={setValidationResponse}
                      previewmode={false}
                      device={device}
                      setDevice={setDevice}
                      OpenPicklistValidationModal={OpenPicklistValidationModal}
                      setOpenPicklistValidationModal={setOpenPicklistValidationModal}
                      customColumnLayout={customColumnLayout}
                      setCustomColumnLayout={setCustomColumnLayout}
                      handleReorderStart={handleReorderStart}
                      handleReOrderDrag={handleReOrderDrag}
                      handleDragLeave={handleDragLeave}
                      openScale={openScale}
                      setOpenScale={setOpenScale}
                      applyChanges={(obj, saveOldState) =>
                        applyChanges(obj, saveOldState)
                      }
                      handleReorderDrop={handleReorderDrop}
                      setDragging={setDragging}
                      handleRemoveGrid={handleRemoveGrid}
                      dragging={dragging}
                      formdata={formState2}
                      openCanvasForSubform={openCanvasForSubform}
                      handleSubForm={(action) => handleSubForm(action)}
                      selectedControl={selectedControl.current}
                      showDataAdditionSection={showDataAdditionSection}
                      subFormJson={subFormStateJson.current}
                      testClick={testClick}
                      advanceListviewStateJson={fetchGridStates().advanceListviewStateJson}
                      // subFormListviewJson={fetchGridStates()?.subFormListviewJson}
                      headerJSON={headerJSON}
                      emptyScreen={emptyScreen}
                      renderChild={renderChild}
                    />

                    {openScale ? (
                      <>
                        <div className={style.CanvasBackground1}></div>
                        <div
                          style={canvasBack2}
                          className={style.CanvasBackground2}
                        ></div>
                        <div
                          style={canvasBack3}
                          className={style.CanvasBackground3}
                        ></div>
                      </>
                    ) : null}
                  </div>

                  {childComp === "app" && (
                    <div
                      className={style.spaceForPinnedRightNavigator}
                      style={{
                        width: propertyPinned ? "250px" : "0px",
                        transition: "width 0.5s ease-in-out",
                      }}
                    ></div>
                  )}

                  {childComp === "app" && openProperties && (
                    <RightNavigation
                      containerId={containerId}
                      setDragging={setDragging}
                      handleDragging={handleDragging}
                      createNewElement={elementToCreate}
                      on_drag={handleDragStart}
                      formData={formState2}
                      subformState={subFormStateJson.current}
                      selectedControl={selectedControl.current}
                      showProperties={showProperties.current}
                      hideProperties={hideProperties}
                      applyChanges={(obj, saveOldState) =>
                        applyChanges(obj, saveOldState)
                      }
                      unDo={undoList.current}
                      handleUndo={handleUndo}
                      handleRedo={handleRedo}
                      reDo={redoList.current}
                      presentState={presentState}
                      changeUndoList={() => changeUndoList()}
                      microFrontendData={microFrontendData}
                    />
                  )}
                  {alert2.open === true && alert2.severity === "error" && (
                    <Snackbar
                      open={alert2.open}
                      autoHideDuration={3000}
                      onClose={handleClose2}
                      anchorOrigin={{ vertical: "top", horizontal: "center" }}
                      style={{top:"16px"}}
                    >
                      <Alert
                        severity={alert2.severity}
                        style={{
                          width: "290px",
                        backgroundColor:"#FE8E8E",
                        fontSize: 12,
                        fontFamily: "Open Sans",
                        color: "#000000",
                        letterSpacing: "0px",
                        }}
                      >
                        {alert2.severityMessage}
                      </Alert>
                    </Snackbar>
                  )}
                  {alert1.open === true && alert1.severity === "success" && (
                    <Snackbar
                      open={alert1.open}
                      autoHideDuration={2000}
                      onClose={handleClose3}
                      anchorOrigin={{ vertical: "top", horizontal: "center" }}
                      style={{top:"16px"}}
                    >
                      <Alert
                        severity={alert1.severity}
                        style={{
                          width: "290px",
                          backgroundColor: "#C9E29A",
                          color: "#000000",
                          fontFamily: "Open Sans",
                          fontSize: "13px",
                        }}
                      >
                        {alert1.severityMessage}
                      </Alert>
                    </Snackbar>
                  )}
                </div>
              </div>
            </div>
          </div>
          {
            alertData.open === true &&
            <CustomizedAlert
              alertData={alertData}
              // setOpenLoader={setOpenLoader}
            />
          }
        </div>
      )}

      {loginErrorPage ? (
        <InvalidAuthentication />
      ) : (
        ( childComp !== "app" && childComp !== "reusableFunction") && (
          <>
            <Canvas
              isSSO={isSSO}
              previewmode={true}
              containerId={containerId}
              handleReorderStart={handleReorderStart}
              validationResponse={validationResponse}
              setValidationResponse={setValidationResponse}
              // openCanvasForPreview={openCanvasForPreview}
              formdata={formState2}
              OpenPicklistValidationModal={OpenPicklistValidationModal}
              setOpenPicklistValidationModal={setOpenPicklistValidationModal}
              renderChild={renderChild}
              handleReOrderDrag={handleReOrderDrag}
              openScale={openScale}
              setOpenScale={setOpenScale}
              applyChanges={(obj, saveOldState) =>
                applyChanges(obj, saveOldState)
              }
              testClick={testClick}
              handleReorderDrop={handleReorderDrop}
              setDragging={setDragging}
              handleRemoveGrid={handleRemoveGrid}
              dragging={dragging}
              openCanvasForSubform={openCanvasForSubform}
              handleSubForm={(action) => handleSubForm(action)}
              selectedControl={selectedControl.current}
              showDataAdditionSection={showDataAdditionSection}
              subFormJson={subFormStateJson.current}
              advanceListviewStateJson={fetchGridStates().advanceListviewStateJson}
              // subFormListviewJson={fetchGridStates()?.subFormListviewJson}
              headerJSON={headerJSON}
              closeSubformOnPreview={closeSubformOnPreview}
              emptyScreen={emptyScreen}
              // openCanvasForPreviewAdvance={openCanvasForPreviewAdvance}
              // setOpenCanvasForPreviewAdvance={setOpenCanvasForPreviewAdvance}
            />
            {
            alertData.open === true &&
            <CustomizedAlert
              alertData={alertData}
              // setOpenLoader={setOpenLoader}
            />
            }
          </>
        )
      )}

      {childComp === "reusableFunction" && 
        <ReusableBusinessFunction containerId={containerId} {...props?.microFrontendData} />
      }
      
      {childComp === "marvinForm" && 
        <MarvinInputForm {...props?.microFrontendData} />
      }

      {childComp === "application" && (
        <GlobalTimer
          initialMinute={globalTime.current.min}
          initialSeconds={globalTime.current.sec}
          global={true}
        />
      )}
      {openSession && <SessionExpired open={true} onClose={handleClose} />}
      {open1 === true && severity === "success" && (
        <Snackbar
          open={alert1.open}
          autoHideDuration={3000}
          onClose={handleClose3}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          style={{top:"16px"}}
        >
          <Alert
            severity={alert1.severity}
            style={{
              width: "290px",
              backgroundColor: "#C9E29A",
              color: "#000000",
              fontFamily: "Open Sans",
              fontSize: "13px",
            }}
          >
            {severityMessage}
          </Alert>
        </Snackbar>
      )}
      {open1 === true &&
        severity === "error" &&
        severityMessage !== "Column name is blank. Please enter valid name" && (
          <Snackbar
            open={open1}
            autoHideDuration={
              severityMessage ===
              "Column name is blank. Please enter valid name"
                ? null
                : 6000
            }
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            style={{top:"16px"}}
          >
            <Alert
              severity={severity}
              style={{
                width: "290px",
                backgroundColor: "#D53D3D",
                color: "#FFFFFF",
                fontFamily: "Open Sans",
                fontSize: "13px",
              }}
            >
              {severityMessage}
            </Alert>
          </Snackbar>
        )}

      {open1 === true &&
        severity === "error" &&
        severityMessage === "Column name is blank. Please enter valid name" && (
          <Snackbar
            open={open1}
            autoHideDuration={null}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            style={{top:"16px"}}
          >
            <Alert
              onClose={handleClose}
              severity={severity}
              style={{
                width: "auto",
                backgroundColor: "#D53D3D",
                color: "#FFFFFF",
                fontFamily: "Open Sans",
                fontSize: "13px",
              }}
            >
              {severityMessage}
            </Alert>
          </Snackbar>
        )}
      
      {openDoclistViewerMicro && (
        <>
          <div onClick={() => dispatch(updateStateInRedux({name: "openDoclistViewerMicro", value: false}))} className={stylesDoc.shade_main}></div>
          <div className={stylesDoc.doclistViewer_popup}>
            <div
              style={{
                padding: "2px 8px",
                backgroundColor: "#f2f2f2",
                fontWeight: "bold",
                display: "flex",
                justifyContent: "end"
              }}
            >
              <span style={{ cursor: "pointer" }} onClick={() => dispatch(updateStateInRedux({name: "openDoclistViewerMicro", value: false}))}>
                X
              </span>
            </div>
            <div id="doclistViewerMicro_id_form" style={{ height: "100%" }}></div>
          </div>
        </>
      )}
      <div id="openDoclistUploadMicro"></div>
    </>
  );
};
export default IFormDesignerLayout;